webpackJsonp([0,3],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(0);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(569);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(564);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(230));
__export(__webpack_require__(229));
__export(__webpack_require__(45));
__export(__webpack_require__(25));
__export(__webpack_require__(141));
__export(__webpack_require__(44));
__export(__webpack_require__(231));
__export(__webpack_require__(18));
__export(__webpack_require__(232));
__export(__webpack_require__(142));
__export(__webpack_require__(143));
__export(__webpack_require__(235));
__export(__webpack_require__(144));
__export(__webpack_require__(145));
__export(__webpack_require__(46));
__export(__webpack_require__(234));
__export(__webpack_require__(238));
__export(__webpack_require__(147));
__export(__webpack_require__(239));
__export(__webpack_require__(237));
__export(__webpack_require__(236));
__export(__webpack_require__(146));
__export(__webpack_require__(233));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(565);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(108);

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var shared_1 = __webpack_require__(3);
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var PaginationConfig = (function () {
    function PaginationConfig(config) {
        this.config = config;
        config.boundaryLinks = true;
        config.maxSize = 5;
        config.pageSize = shared_1.ITEMS_PER_PAGE;
        config.size = 'sm';
    }
    return PaginationConfig;
}());
PaginationConfig = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbPaginationConfig])
], PaginationConfig);
exports.PaginationConfig = PaginationConfig;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(16);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var DeviceService = (function () {
    function DeviceService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/devices';
        this.resourceSearchUrl = 'api/_search/devices';
    }
    DeviceService.prototype.create = function (device) {
        var copy = Object.assign({}, device);
        copy.activationDate = this.dateUtils.toDate(device.activationDate);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    DeviceService.prototype.update = function (device) {
        var copy = Object.assign({}, device);
        copy.activationDate = this.dateUtils.toDate(device.activationDate);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    DeviceService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.activationDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.activationDate);
            return jsonResponse;
        });
    };
    DeviceService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    DeviceService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    DeviceService.prototype.addMany = function (devices) {
        var copy = Object.assign({}, devices);
        return this.http.post(this.resourceUrl + "/addMany", copy).map(function (res) {
            return res.json();
        });
    };
    DeviceService.prototype.deleteMany = function (devices) {
        var copy = Object.assign({}, devices);
        return this.http.post(this.resourceUrl + "/deleteMany", copy).map(function (res) {
            return res.json();
        });
    };
    DeviceService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    DeviceService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].activationDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].activationDate);
        }
        res._body = jsonResponse;
        return res;
    };
    DeviceService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return DeviceService;
}());
DeviceService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], DeviceService);
exports.DeviceService = DeviceService;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var SellerService = (function () {
    function SellerService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/sellers';
        this.resourceSearchUrl = 'api/_search/sellers';
    }
    SellerService.prototype.create = function (seller) {
        var copy = Object.assign({}, seller);
        copy.createDate = this.dateUtils.toDate(seller.createDate);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    SellerService.prototype.update = function (seller) {
        var copy = Object.assign({}, seller);
        copy.createDate = this.dateUtils.toDate(seller.createDate);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    SellerService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.createDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.createDate);
            return jsonResponse;
        });
    };
    SellerService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    SellerService.prototype.findAll = function () {
        var _this = this;
        var options = this.createRequestOption();
        console.log(options);
        return this.http.get(this.resourceUrl + "/all", options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    SellerService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    SellerService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    SellerService.prototype.touch = function (id) {
        return this.http.put(this.resourceUrl + "/touch/" + id, null);
    };
    SellerService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].createDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].createDate);
        }
        res._body = jsonResponse;
        return res;
    };
    SellerService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return SellerService;
}());
SellerService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], SellerService);
exports.SellerService = SellerService;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var ApplicationArtatechService = (function () {
    function ApplicationArtatechService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/applications';
        this.resourceSearchUrl = 'api/_search/applications';
    }
    ApplicationArtatechService.prototype.create = function (application) {
        var copy = Object.assign({}, application);
        copy.lastModificationDate = this.dateUtils.toDate(application.lastModificationDate);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ApplicationArtatechService.prototype.update = function (application) {
        var copy = Object.assign({}, application);
        copy.lastModificationDate = this.dateUtils.toDate(application.lastModificationDate);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ApplicationArtatechService.prototype.find = function (id) {
        var _this = this;
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.lastModificationDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.lastModificationDate);
            return jsonResponse;
        });
    };
    ApplicationArtatechService.prototype.findAll = function () {
        var _this = this;
        var options = this.createRequestOption();
        return this.http.get(this.resourceUrl + '/all', options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ApplicationArtatechService.prototype.query = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ApplicationArtatechService.prototype.findLocalFiles = function () {
        var options = this.createRequestOption();
        return this.http.get(this.resourceUrl + '/local', options);
    };
    ApplicationArtatechService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ApplicationArtatechService.prototype.search = function (req) {
        var _this = this;
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map(function (res) { return _this.convertResponse(res); });
    };
    ApplicationArtatechService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].lastModificationDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].lastModificationDate);
        }
        res._body = jsonResponse;
        return res;
    };
    ApplicationArtatechService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ApplicationArtatechService;
}());
ApplicationArtatechService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], ApplicationArtatechService);
exports.ApplicationArtatechService = ApplicationArtatechService;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var FeedService = (function () {
    function FeedService(http) {
        this.http = http;
        this.resourceUrl = 'api/feeds';
        this.resourceSearchUrl = 'api/_search/feeds';
    }
    FeedService.prototype.create = function (model) {
        var copy = Object.assign({}, model);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    FeedService.prototype.update = function (model) {
        var copy = Object.assign({}, model);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    FeedService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    FeedService.prototype.query = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options);
    };
    FeedService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    FeedService.prototype.search = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options);
    };
    FeedService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return FeedService;
}());
FeedService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], FeedService);
exports.FeedService = FeedService;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ImageResourceService = (function () {
    function ImageResourceService(http) {
        this.http = http;
        this.resourceUrl = 'api/image-resources';
        this.resourceSearchUrl = 'api/_search/image-resources';
    }
    ImageResourceService.prototype.create = function (imageResource) {
        var copy = Object.assign({}, imageResource);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ImageResourceService.prototype.update = function (imageResource) {
        var copy = Object.assign({}, imageResource);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ImageResourceService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    ImageResourceService.prototype.query = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options);
    };
    ImageResourceService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ImageResourceService.prototype.search = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options);
    };
    ImageResourceService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ImageResourceService;
}());
ImageResourceService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ImageResourceService);
exports.ImageResourceService = ImageResourceService;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var LogService = (function () {
    function LogService(http) {
        this.http = http;
        this.resourceUrl = 'api/logs';
        this.resourceSearchUrl = 'api/_search/logs';
    }
    LogService.prototype.create = function (log) {
        var copy = Object.assign({}, log);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    LogService.prototype.update = function (log) {
        var copy = Object.assign({}, log);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    LogService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    LogService.prototype.query = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options);
    };
    LogService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    LogService.prototype.search = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options);
    };
    LogService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return LogService;
}());
LogService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], LogService);
exports.LogService = LogService;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ModelImageService = (function () {
    function ModelImageService(http) {
        this.http = http;
        this.resourceUrl = 'api/model-images';
        this.resourceSearchUrl = 'api/_search/model-images';
    }
    ModelImageService.prototype.create = function (modelImage) {
        var copy = Object.assign({}, modelImage);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ModelImageService.prototype.update = function (modelImage) {
        var copy = Object.assign({}, modelImage);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ModelImageService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    ModelImageService.prototype.query = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options);
    };
    ModelImageService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ModelImageService.prototype.search = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options);
    };
    ModelImageService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ModelImageService;
}());
ModelImageService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ModelImageService);
exports.ModelImageService = ModelImageService;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ModelService = (function () {
    function ModelService(http) {
        this.http = http;
        this.resourceUrl = 'api/models';
        this.resourceSearchUrl = 'api/_search/models';
    }
    ModelService.prototype.create = function (model) {
        var copy = Object.assign({}, model);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ModelService.prototype.update = function (model) {
        var copy = Object.assign({}, model);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ModelService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    ModelService.prototype.query = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options);
    };
    ModelService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ModelService.prototype.search = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options);
    };
    ModelService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ModelService;
}());
ModelService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ModelService);
exports.ModelService = ModelService;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ResourceService = (function () {
    function ResourceService(http) {
        this.http = http;
        this.resourceUrl = 'api/resources';
        this.resourceSearchUrl = 'api/_search/resources';
    }
    ResourceService.prototype.create = function (resource) {
        var copy = Object.assign({}, resource);
        return this.http.post(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ResourceService.prototype.update = function (resource) {
        var copy = Object.assign({}, resource);
        return this.http.put(this.resourceUrl, copy).map(function (res) {
            return res.json();
        });
    };
    ResourceService.prototype.find = function (id) {
        return this.http.get(this.resourceUrl + "/" + id).map(function (res) {
            return res.json();
        });
    };
    ResourceService.prototype.query = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options);
    };
    ResourceService.prototype.delete = function (id) {
        return this.http.delete(this.resourceUrl + "/" + id);
    };
    ResourceService.prototype.search = function (req) {
        var options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options);
    };
    ResourceService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return ResourceService;
}());
ResourceService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ResourceService);
exports.ResourceService = ResourceService;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var Subject_1 = __webpack_require__(152);
var account_service_1 = __webpack_require__(141);
var Principal = (function () {
    function Principal(account) {
        this.account = account;
        this.authenticated = false;
        this.authenticationState = new Subject_1.Subject();
    }
    Principal.prototype.authenticate = function (identity) {
        this.userIdentity = identity;
        this.authenticated = identity !== null;
        this.authenticationState.next(this.userIdentity);
    };
    Principal.prototype.hasAnyAuthority = function (authorities) {
        if (!this.authenticated || !this.userIdentity || !this.userIdentity.authorities) {
            return Promise.resolve(false);
        }
        for (var i = 0; i < authorities.length; i++) {
            if (this.userIdentity.authorities.indexOf(authorities[i]) !== -1) {
                return Promise.resolve(true);
            }
        }
        return Promise.resolve(false);
    };
    Principal.prototype.hasAuthority = function (authority) {
        if (!this.authenticated) {
            return Promise.resolve(false);
        }
        return this.identity().then(function (id) {
            return Promise.resolve(id.authorities && id.authorities.indexOf(authority) !== -1);
        }, function () {
            return Promise.resolve(false);
        });
    };
    Principal.prototype.identity = function (force) {
        var _this = this;
        if (force === true) {
            this.userIdentity = undefined;
        }
        // check and see if we have retrieved the userIdentity data from the server.
        // if we have, reuse it by immediately resolving
        if (this.userIdentity) {
            return Promise.resolve(this.userIdentity);
        }
        // retrieve the userIdentity data from the server, update the identity object, and then resolve.
        return this.account.get().toPromise().then(function (account) {
            if (account) {
                _this.userIdentity = account;
                _this.authenticated = true;
            }
            else {
                _this.userIdentity = null;
                _this.authenticated = false;
            }
            _this.authenticationState.next(_this.userIdentity);
            return _this.userIdentity;
        }).catch(function (err) {
            _this.userIdentity = null;
            _this.authenticated = false;
            _this.authenticationState.next(_this.userIdentity);
            return null;
        });
    };
    Principal.prototype.isAuthenticated = function () {
        return this.authenticated;
    };
    Principal.prototype.isIdentityResolved = function () {
        return this.userIdentity !== undefined;
    };
    Principal.prototype.getAuthenticationState = function () {
        return this.authenticationState.asObservable();
    };
    Principal.prototype.getImageUrl = function () {
        return this.isIdentityResolved() ? this.userIdentity.imageUrl : null;
    };
    return Principal;
}());
Principal = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [account_service_1.AccountService])
], Principal);
exports.Principal = Principal;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var SellerDashboardService = (function () {
    function SellerDashboardService(http, dateUtils) {
        this.http = http;
        this.dateUtils = dateUtils;
        this.resourceUrl = 'api/dashboard/seller';
    }
    SellerDashboardService.prototype.load = function () {
        var _this = this;
        return this.http.get("" + this.resourceUrl).map(function (res) {
            var jsonResponse = res.json();
            jsonResponse.createDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.createDate);
            jsonResponse.lastModifiedDate = _this.dateUtils
                .convertDateTimeFromServer(jsonResponse.lastModifiedDate);
            return jsonResponse;
        });
    };
    SellerDashboardService.prototype.loadModels = function () {
        return this.http.get(this.resourceUrl + "/models");
    };
    SellerDashboardService.prototype.touch = function () {
        return this.http.put(this.resourceUrl + "/touch", null);
    };
    SellerDashboardService.prototype.loadDevices = function () {
        return this.http.get(this.resourceUrl + "/devices");
    };
    SellerDashboardService.prototype.loadFiles = function () {
        return this.http.get(this.resourceUrl + "/files");
    };
    SellerDashboardService.prototype.removeFile = function (id) {
        return this.http.delete(this.resourceUrl + "/file/" + id);
    };
    SellerDashboardService.prototype.removeImage = function (id, type) {
        return this.http.delete(this.resourceUrl + "/image/" + id + "/" + type);
    };
    SellerDashboardService.prototype.getModelImage = function (id) {
        return this.http.get(this.resourceUrl + "/model/" + id);
    };
    SellerDashboardService.prototype.convertResponse = function (res) {
        var jsonResponse = res.json();
        for (var i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].createDate = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].createDate);
        }
        res._body = jsonResponse;
        return res;
    };
    SellerDashboardService.prototype.createRequestOption = function (req) {
        var options = new http_1.BaseRequestOptions();
        if (req) {
            var params = new http_1.URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);
            options.search = params;
        }
        return options;
    };
    return SellerDashboardService;
}());
SellerDashboardService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http, ng_jhipster_1.DateUtils])
], SellerDashboardService);
exports.SellerDashboardService = SellerDashboardService;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(136));
__export(__webpack_require__(23));
__export(__webpack_require__(10));
__export(__webpack_require__(134));
__export(__webpack_require__(132));
__export(__webpack_require__(133));
__export(__webpack_require__(135));
__export(__webpack_require__(219));


/***/ }),
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Model = (function () {
    function Model(id, name, serilNumerShortcut, dpi, screenHeight, screenWidth, shutdownAnimationDescFile) {
        this.id = id;
        this.name = name;
        this.serilNumerShortcut = serilNumerShortcut;
        this.dpi = dpi;
        this.screenHeight = screenHeight;
        this.screenWidth = screenWidth;
        this.shutdownAnimationDescFile = shutdownAnimationDescFile;
    }
    return Model;
}());
exports.Model = Model;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(8);
var seller_model_1 = __webpack_require__(136);
var seller_service_1 = __webpack_require__(10);
var user_model_1 = __webpack_require__(147);
var SellerPopupService = (function () {
    function SellerPopupService(datePipe, modalService, router, sellerService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.sellerService = sellerService;
        this.isOpen = false;
    }
    SellerPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.sellerService.find(id).subscribe(function (seller) {
                seller.createDate = _this.datePipe.transform(seller.createDate, 'yyyy-MM-ddThh:mm');
                _this.sellerModalRef(component, seller);
            });
        }
        else {
            this.seller = new seller_model_1.Seller();
            this.seller.owner = new user_model_1.User();
            return this.sellerModalRef(component, this.seller);
        }
    };
    SellerPopupService.prototype.sellerModalRef = function (component, seller) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.seller = seller;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return SellerPopupService;
}());
SellerPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        seller_service_1.SellerService])
], SellerPopupService);
exports.SellerPopupService = SellerPopupService;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(139));
__export(__webpack_require__(222));
__export(__webpack_require__(225));
__export(__webpack_require__(223));
__export(__webpack_require__(227));
__export(__webpack_require__(226));
__export(__webpack_require__(228));
__export(__webpack_require__(43));
__export(__webpack_require__(140));
__export(__webpack_require__(224));


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng2_webstorage_1 = __webpack_require__(154);
var StateStorageService = (function () {
    function StateStorageService($sessionStorage) {
        this.$sessionStorage = $sessionStorage;
    }
    StateStorageService.prototype.getPreviousState = function () {
        return this.$sessionStorage.retrieve('previousState');
    };
    StateStorageService.prototype.resetPreviousState = function () {
        this.$sessionStorage.clear('previousState');
    };
    StateStorageService.prototype.storePreviousState = function (previousStateName, previousStateParams) {
        var previousState = { 'name': previousStateName, 'params': previousStateParams };
        this.$sessionStorage.store('previousState', previousState);
    };
    StateStorageService.prototype.getDestinationState = function () {
        return this.$sessionStorage.retrieve('destinationState');
    };
    StateStorageService.prototype.storeDestinationState = function (destinationState, destinationStateParams, fromState) {
        var destinationInfo = {
            'destination': {
                'name': destinationState.name,
                'data': destinationState.data,
            },
            'params': destinationStateParams,
            'from': {
                'name': fromState.name,
            }
        };
        this.$sessionStorage.store('destinationState', destinationInfo);
    };
    return StateStorageService;
}());
StateStorageService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng2_webstorage_1.SessionStorageService])
], StateStorageService);
exports.StateStorageService = StateStorageService;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(240);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(165));
__export(__webpack_require__(52));
__export(__webpack_require__(166));


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var ngx_uploader_1 = __webpack_require__(30);
var index_1 = __webpack_require__(27);
var NgFileDropDirective = (function () {
    function NgFileDropDirective(el, uploader) {
        this.el = el;
        this.uploader = uploader;
        this.onUpload = new core_1.EventEmitter();
        this.onPreviewData = new core_1.EventEmitter();
        this.onFileOver = new core_1.EventEmitter();
        this.onUploadRejected = new core_1.EventEmitter();
        this.beforeUpload = new core_1.EventEmitter();
        this.files = [];
    }
    NgFileDropDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.uploader._emitter.subscribe(function (data) {
            _this.onUpload.emit(data);
            if (data.done && _this.files && _this.files.length) {
                _this.files = [].filter.call(_this.files, function (f) { return f.name !== data.originalName; });
            }
        });
        this.uploader._previewEmitter.subscribe(function (data) {
            _this.onPreviewData.emit(data);
        });
        this.uploader._beforeEmitter.subscribe(function (uploadingFile) {
            _this.beforeUpload.emit(uploadingFile);
        });
        setTimeout(function () {
            if (_this.events instanceof core_1.EventEmitter) {
                _this.events.subscribe(function (data) {
                    if (data === 'startUpload') {
                        _this.uploader.uploadFilesInQueue();
                    }
                });
            }
        });
        this.initEvents();
    };
    NgFileDropDirective.prototype.ngOnChanges = function (changes) {
        if (!this.options || !changes) {
            return;
        }
        if (this.options.allowedExtensions) {
            this.options.allowedExtensions = this.options.allowedExtensions.map(function (ext) { return ext.toLowerCase(); });
        }
        this.options = new index_1.NgUploaderOptions(this.options);
        this.uploader.setOptions(this.options);
    };
    NgFileDropDirective.prototype.initEvents = function () {
        if (typeof this.el.nativeElement.addEventListener === 'undefined') {
            return;
        }
        this.el.nativeElement.addEventListener('drop', this.stopEvent, false);
        this.el.nativeElement.addEventListener('dragenter', this.stopEvent, false);
        this.el.nativeElement.addEventListener('dragover', this.stopEvent, false);
    };
    NgFileDropDirective.prototype.onDrop = function (e) {
        var _this = this;
        this.onFileOver.emit(false);
        this.files = Array.from(e.dataTransfer.files);
        if (!this.files || !this.files.length) {
            return;
        }
        if (this.options.filterExtensions && this.options.allowedExtensions && this.files && this.files.length) {
            this.files = [].filter.call(this.files, function (f) {
                var allowedExtensions = _this.options.allowedExtensions || [];
                if (allowedExtensions.indexOf(f.type.toLowerCase()) !== -1) {
                    return true;
                }
                var ext = f.name.split('.').pop();
                if (ext && allowedExtensions.indexOf(ext.toLowerCase()) !== -1) {
                    return true;
                }
                _this.onUploadRejected.emit({ file: f, reason: index_1.UploadRejected.EXTENSION_NOT_ALLOWED });
                return false;
            });
        }
        var maxSize = typeof this.options.maxSize !== 'undefined' ? this.options.maxSize : null;
        if (maxSize !== null && maxSize > 0) {
            this.files = [].filter.call(this.files, function (f) {
                if (maxSize) {
                    if (f.size <= maxSize) {
                        return true;
                    }
                }
                _this.onUploadRejected.emit({ file: f, reason: index_1.UploadRejected.MAX_SIZE_EXCEEDED });
                return false;
            });
        }
        var maxUploads = typeof this.options.maxUploads !== 'undefined' ? this.options.maxUploads : null;
        if (maxUploads !== null && (maxUploads > 0 && this.files.length > maxUploads)) {
            this.onUploadRejected.emit({ file: this.files.pop(), reason: index_1.UploadRejected.MAX_UPLOADS_EXCEEDED });
            this.files = [];
        }
        if (this.files && this.files.length) {
            this.uploader.addFilesToQueue(this.files);
        }
    };
    NgFileDropDirective.prototype.onDragOver = function (e) {
        if (!e) {
            return;
        }
        this.onFileOver.emit(true);
    };
    NgFileDropDirective.prototype.onDragLeave = function (e) {
        if (!e) {
            return;
        }
        this.onFileOver.emit(false);
    };
    NgFileDropDirective.prototype.stopEvent = function (e) {
        e.stopPropagation();
        e.preventDefault();
    };
    return NgFileDropDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", index_1.NgUploaderOptions)
], NgFileDropDirective.prototype, "options", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", core_1.EventEmitter)
], NgFileDropDirective.prototype, "events", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], NgFileDropDirective.prototype, "onUpload", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], NgFileDropDirective.prototype, "onPreviewData", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], NgFileDropDirective.prototype, "onFileOver", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], NgFileDropDirective.prototype, "onUploadRejected", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], NgFileDropDirective.prototype, "beforeUpload", void 0);
__decorate([
    core_1.HostListener('drop', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NgFileDropDirective.prototype, "onDrop", null);
__decorate([
    core_1.HostListener('dragover', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NgFileDropDirective.prototype, "onDragOver", null);
__decorate([
    core_1.HostListener('dragleave', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], NgFileDropDirective.prototype, "onDragLeave", null);
NgFileDropDirective = __decorate([
    core_1.Directive({
        selector: '[ngFileDrop]',
        providers: [
            ngx_uploader_1.NgUploaderService
        ]
    }),
    __param(0, core_1.Inject(core_1.ElementRef)),
    __param(1, core_1.Inject(ngx_uploader_1.NgUploaderService)),
    __metadata("design:paramtypes", [core_1.ElementRef,
        ngx_uploader_1.NgUploaderService])
], NgFileDropDirective);
exports.NgFileDropDirective = NgFileDropDirective;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var ngx_uploader_1 = __webpack_require__(30);
var index_1 = __webpack_require__(27);
var NgFileSelectDirective = (function () {
    function NgFileSelectDirective(el, uploader) {
        this.el = el;
        this.uploader = uploader;
        this.onUpload = new core_1.EventEmitter();
        this.onPreviewData = new core_1.EventEmitter();
        this.onUploadRejected = new core_1.EventEmitter();
        this.beforeUpload = new core_1.EventEmitter();
        this.files = [];
    }
    NgFileSelectDirective.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (!this.options || !changes) {
            return;
        }
        if (this.options.allowedExtensions) {
            this.options.allowedExtensions = this.options.allowedExtensions.map(function (ext) { return ext.toLowerCase(); });
        }
        this.uploader.setOptions(new index_1.NgUploaderOptions(this.options));
        this.uploader._emitter.subscribe(function (data) {
            _this.onUpload.emit(data);
            if (data.done && _this.files && _this.files.length) {
                _this.files = [].filter.call(_this.files, function (f) { return f.name !== data.originalName; });
            }
            if (data.done && _this.uploader.opts.fieldReset) {
                _this.el.nativeElement.value = '';
            }
        });
        this.uploader._previewEmitter.subscribe(function (data) {
            _this.onPreviewData.emit(data);
        });
        this.uploader._beforeEmitter.subscribe(function (uploadingFile) {
            _this.beforeUpload.emit(uploadingFile);
        });
        if (this.events instanceof core_1.EventEmitter) {
            this.events.subscribe(function (data) {
                if (data === 'startUpload') {
                    _this.uploader.uploadFilesInQueue();
                }
            });
        }
    };
    NgFileSelectDirective.prototype.onChange = function () {
        var _this = this;
        this.files = this.el.nativeElement.files;
        if (!this.files || !this.files.length) {
            return;
        }
        if (this.options.filterExtensions && this.options.allowedExtensions && this.files && this.files.length) {
            this.files = [].filter.call(this.files, function (f) {
                var allowedExtensions = _this.options.allowedExtensions || [];
                if (allowedExtensions.indexOf(f.type.toLowerCase()) !== -1) {
                    return true;
                }
                var ext = f.name.split('.').pop();
                if (ext && allowedExtensions.indexOf(ext.toLowerCase()) !== -1) {
                    return true;
                }
                _this.onUploadRejected.emit({ file: f, reason: index_1.UploadRejected.EXTENSION_NOT_ALLOWED });
                return false;
            });
        }
        var maxSize = typeof this.options.maxSize !== 'undefined' ? this.options.maxSize : null;
        if (maxSize !== null && maxSize > 0) {
            this.files = [].filter.call(this.files, function (f) {
                if (maxSize) {
                    if (f.size <= maxSize) {
                        return true;
                    }
                }
                _this.onUploadRejected.emit({ file: f, reason: index_1.UploadRejected.MAX_SIZE_EXCEEDED });
                return false;
            });
        }
        var maxUploads = typeof this.options.maxUploads !== 'undefined' ? this.options.maxUploads : null;
        if (maxUploads !== null && (maxUploads > 0 && this.files.length > maxUploads)) {
            this.onUploadRejected.emit({ file: this.files.pop(), reason: index_1.UploadRejected.MAX_UPLOADS_EXCEEDED });
            this.files = [];
        }
        if (this.files && this.files.length) {
            this.uploader.addFilesToQueue(this.files);
        }
    };
    return NgFileSelectDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", index_1.NgUploaderOptions)
], NgFileSelectDirective.prototype, "options", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", core_1.EventEmitter)
], NgFileSelectDirective.prototype, "events", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], NgFileSelectDirective.prototype, "onUpload", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], NgFileSelectDirective.prototype, "onPreviewData", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], NgFileSelectDirective.prototype, "onUploadRejected", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], NgFileSelectDirective.prototype, "beforeUpload", void 0);
__decorate([
    core_1.HostListener('change'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], NgFileSelectDirective.prototype, "onChange", null);
NgFileSelectDirective = __decorate([
    core_1.Directive({
        selector: '[ngFileSelect]',
        providers: [
            ngx_uploader_1.NgUploaderService
        ],
    }),
    __param(0, core_1.Inject(core_1.ElementRef)),
    __param(1, core_1.Inject(ngx_uploader_1.NgUploaderService)),
    __metadata("design:paramtypes", [core_1.ElementRef,
        ngx_uploader_1.NgUploaderService])
], NgFileSelectDirective);
exports.NgFileSelectDirective = NgFileSelectDirective;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var uploaded_file_class_1 = __webpack_require__(52);
var NgUploaderService = (function () {
    function NgUploaderService() {
        this._queue = [];
        this._emitter = new core_1.EventEmitter();
        this._previewEmitter = new core_1.EventEmitter();
        this._beforeEmitter = new core_1.EventEmitter();
    }
    NgUploaderService.prototype.setOptions = function (opts) {
        this.opts = opts;
    };
    NgUploaderService.prototype.uploadFilesInQueue = function () {
        var _this = this;
        this._queue.forEach(function (file) {
            if (file.uploading) {
                return;
            }
            _this.uploadFile(file);
        });
    };
    ;
    NgUploaderService.prototype.uploadFile = function (file) {
        var _this = this;
        var xhr = new XMLHttpRequest();
        var payload;
        if (this.opts.plainJson) {
            payload = JSON.stringify(this.opts.data);
        }
        else if (this.opts.multipart) {
            var form_1 = new FormData();
            Object.keys(this.opts.data).forEach(function (k) {
                form_1.append(k, _this.opts.data[k]);
            });
            form_1.append(this.opts.fieldName, file, file.name);
            payload = form_1;
        }
        else {
            payload = file;
        }
        var uploadingFile = new uploaded_file_class_1.UploadedFile(this.generateRandomIndex(), file.name, file.size, xhr);
        var queueIndex = this._queue.indexOf(file);
        var time = new Date().getTime();
        var load = 0;
        var speed = 0;
        var speedHumanized = null;
        xhr.upload.onprogress = function (e) {
            if (e.lengthComputable) {
                if (_this.opts.calculateSpeed) {
                    var diff = new Date().getTime() - time;
                    time += diff;
                    load = e.loaded - load;
                    speed = load / diff * 1000;
                    speed = parseInt(speed, 10);
                    speedHumanized = _this.humanizeBytes(speed);
                }
                var percent = Math.round(e.loaded / e.total * 100);
                if (speed === 0) {
                    uploadingFile.setProgress({
                        total: e.total,
                        loaded: e.loaded,
                        percent: percent
                    });
                }
                else {
                    uploadingFile.setProgress({
                        total: e.total,
                        loaded: e.loaded,
                        percent: percent,
                        speed: speed,
                        speedHumanized: speedHumanized
                    });
                }
                _this._emitter.emit(uploadingFile);
            }
        };
        xhr.upload.onabort = function () {
            uploadingFile.setAbort();
            _this._emitter.emit(uploadingFile);
        };
        xhr.upload.onerror = function () {
            uploadingFile.setError();
            _this._emitter.emit(uploadingFile);
        };
        xhr.onreadystatechange = function () {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                uploadingFile.onFinished(xhr.status, xhr.statusText, xhr.response);
                _this.removeFileFromQueue(queueIndex);
                _this._emitter.emit(uploadingFile);
            }
        };
        xhr.open(this.opts.method, this.opts.url, true);
        xhr.withCredentials = this.opts.withCredentials;
        if (this.opts.filenameHeader) {
            xhr.setRequestHeader(this.opts.filenameHeader, file.name);
        }
        if (this.opts.customHeaders) {
            Object.keys(this.opts.customHeaders).forEach(function (key) {
                xhr.setRequestHeader(key, _this.opts.customHeaders[key]);
            });
        }
        if (this.opts.authToken) {
            xhr.setRequestHeader('Authorization', this.opts.authTokenPrefix + " " + this.opts.authToken);
        }
        this._beforeEmitter.emit(uploadingFile);
        if (!uploadingFile.abort) {
            xhr.send(payload);
        }
        else {
            this.removeFileFromQueue(queueIndex);
        }
    };
    NgUploaderService.prototype.addFilesToQueue = function (files) {
        var _this = this;
        this.clearQueue();
        [].forEach.call(files, function (file) {
            if (!_this.inQueue(file)) {
                _this._queue.push(file);
            }
        });
        if (this.opts.previewUrl) {
            [].forEach.call(files, function (file) { return _this.createFileUrl(file); });
        }
        if (this.opts.autoUpload) {
            this.uploadFilesInQueue();
        }
    };
    NgUploaderService.prototype.createFileUrl = function (file) {
        var _this = this;
        var reader = new FileReader();
        reader.addEventListener('load', function () {
            _this._previewEmitter.emit(reader.result);
        });
        reader.readAsDataURL(file);
    };
    NgUploaderService.prototype.removeFileFromQueue = function (i) {
        this._queue.splice(i, 1);
    };
    NgUploaderService.prototype.clearQueue = function () {
        this._queue = [];
    };
    NgUploaderService.prototype.getQueueSize = function () {
        return this._queue.length;
    };
    NgUploaderService.prototype.inQueue = function (file) {
        var fileInQueue = this._queue.filter(function (f) { return f === file; });
        return fileInQueue.length ? true : false;
    };
    NgUploaderService.prototype.generateRandomIndex = function () {
        return Math.random().toString(36).substring(7);
    };
    NgUploaderService.prototype.humanizeBytes = function (bytes) {
        if (bytes === 0) {
            return '0 Byte';
        }
        var k = 1024;
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i] + '/s';
    };
    return NgUploaderService;
}());
NgUploaderService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], NgUploaderService);
exports.NgUploaderService = NgUploaderService;
exports.NgUploaderServiceProvider = {
    provide: NgUploaderService, useClass: NgUploaderService
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var DcsHealthService = (function () {
    function DcsHealthService(http) {
        this.http = http;
        this.separator = '.';
    }
    DcsHealthService.prototype.checkHealth = function () {
        return this.http.get('management/health').map(function (res) { return res.json(); });
    };
    DcsHealthService.prototype.transformHealthData = function (data) {
        var response = [];
        this.flattenHealthData(response, null, data);
        return response;
    };
    DcsHealthService.prototype.getBaseName = function (name) {
        if (name) {
            var split = name.split('.');
            return split[0];
        }
    };
    DcsHealthService.prototype.getSubSystemName = function (name) {
        if (name) {
            var split = name.split('.');
            split.splice(0, 1);
            var remainder = split.join('.');
            return remainder ? ' - ' + remainder : '';
        }
    };
    /* private methods */
    DcsHealthService.prototype.addHealthObject = function (result, isLeaf, healthObject, name) {
        var status;
        var error;
        var healthData = {
            'name': name,
            'error': error,
            'status': status
        };
        var details = {};
        var hasDetails = false;
        for (var key in healthObject) {
            if (healthObject.hasOwnProperty(key)) {
                var value = healthObject[key];
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                }
                else {
                    if (!this.isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            }
        }
        // Add the details
        if (hasDetails) {
            healthData.details = details;
        }
        // Only add nodes if they provide additional information
        if (isLeaf || hasDetails || healthData.error) {
            result.push(healthData);
        }
        return healthData;
    };
    DcsHealthService.prototype.flattenHealthData = function (result, path, data) {
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var value = data[key];
                if (this.isHealthObject(value)) {
                    if (this.hasSubSystem(value)) {
                        this.addHealthObject(result, false, value, this.getModuleName(path, key));
                        this.flattenHealthData(result, this.getModuleName(path, key), value);
                    }
                    else {
                        this.addHealthObject(result, true, value, this.getModuleName(path, key));
                    }
                }
            }
        }
        return result;
    };
    DcsHealthService.prototype.getModuleName = function (path, name) {
        var result;
        if (path && name) {
            result = path + this.separator + name;
        }
        else if (path) {
            result = path;
        }
        else if (name) {
            result = name;
        }
        else {
            result = '';
        }
        return result;
    };
    DcsHealthService.prototype.hasSubSystem = function (healthObject) {
        var result = false;
        for (var key in healthObject) {
            if (healthObject.hasOwnProperty(key)) {
                var value = healthObject[key];
                if (value && value.status) {
                    result = true;
                }
            }
        }
        return result;
    };
    DcsHealthService.prototype.isHealthObject = function (healthObject) {
        var result = false;
        for (var key in healthObject) {
            if (healthObject.hasOwnProperty(key)) {
                if (key === 'status') {
                    result = true;
                }
            }
        }
        return result;
    };
    return DcsHealthService;
}());
DcsHealthService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], DcsHealthService);
exports.DcsHealthService = DcsHealthService;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var shared_1 = __webpack_require__(3);
var UserModalService = (function () {
    function UserModalService(modalService, router, userService) {
        this.modalService = modalService;
        this.router = router;
        this.userService = userService;
        this.isOpen = false;
    }
    UserModalService.prototype.open = function (component, login) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (login) {
            this.userService.find(login).subscribe(function (user) { return _this.userModalRef(component, user); });
        }
        else {
            return this.userModalRef(component, new shared_1.User());
        }
    };
    UserModalService.prototype.userModalRef = function (component, user) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.user = user;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return UserModalService;
}());
UserModalService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        shared_1.UserService])
], UserModalService);
exports.UserModalService = UserModalService;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(8);
var application_artatech_model_1 = __webpack_require__(91);
var application_artatech_service_1 = __webpack_require__(11);
var ApplicationArtatechPopupService = (function () {
    function ApplicationArtatechPopupService(datePipe, modalService, router, applicationService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.applicationService = applicationService;
        this.isOpen = false;
    }
    ApplicationArtatechPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.applicationService.find(id).subscribe(function (application) {
                application.lastModificationDate = _this.datePipe.transform(application.lastModificationDate, 'yyyy-MM-ddThh:mm');
                _this.applicationModalRef(component, application);
            });
        }
        else {
            return this.applicationModalRef(component, new application_artatech_model_1.ApplicationArtatech());
        }
    };
    ApplicationArtatechPopupService.prototype.applicationModalRef = function (component, application) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.application = application;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return ApplicationArtatechPopupService;
}());
ApplicationArtatechPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        application_artatech_service_1.ApplicationArtatechService])
], ApplicationArtatechPopupService);
exports.ApplicationArtatechPopupService = ApplicationArtatechPopupService;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var common_1 = __webpack_require__(8);
var device_model_1 = __webpack_require__(98);
var device_service_1 = __webpack_require__(9);
var DevicePopupService = (function () {
    function DevicePopupService(datePipe, modalService, router, deviceService) {
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.router = router;
        this.deviceService = deviceService;
        this.isOpen = false;
    }
    DevicePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.deviceService.find(id).subscribe(function (device) {
                device.activationDate = _this.datePipe.transform(device.activationDate, 'yyyy-MM-ddThh:mm');
                _this.deviceModalRef(component, device);
            });
        }
        else {
            return this.deviceModalRef(component, new device_model_1.Device());
        }
    };
    DevicePopupService.prototype.deviceModalRef = function (component, device) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.device = device;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return DevicePopupService;
}());
DevicePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [common_1.DatePipe,
        ng_bootstrap_1.NgbModal,
        router_1.Router,
        device_service_1.DeviceService])
], DevicePopupService);
exports.DevicePopupService = DevicePopupService;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var feed_model_1 = __webpack_require__(104);
var feed_service_1 = __webpack_require__(12);
var FeedPopupService = (function () {
    function FeedPopupService(modalService, router, feedService) {
        this.modalService = modalService;
        this.router = router;
        this.feedService = feedService;
        this.isOpen = false;
    }
    FeedPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.feedService.find(id).subscribe(function (feed) {
                _this.feedModalRef(component, feed);
            });
        }
        else {
            return this.feedModalRef(component, new feed_model_1.Feed());
        }
    };
    FeedPopupService.prototype.feedModalRef = function (component, feed) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.feed = feed;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return FeedPopupService;
}());
FeedPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        feed_service_1.FeedService])
], FeedPopupService);
exports.FeedPopupService = FeedPopupService;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var image_resource_model_1 = __webpack_require__(37);
var image_resource_service_1 = __webpack_require__(13);
var ImageResourcePopupService = (function () {
    function ImageResourcePopupService(modalService, router, imageResourceService) {
        this.modalService = modalService;
        this.router = router;
        this.imageResourceService = imageResourceService;
        this.isOpen = false;
    }
    ImageResourcePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.imageResourceService.find(id).subscribe(function (imageResource) {
                _this.imageResourceModalRef(component, imageResource);
            });
        }
        else {
            return this.imageResourceModalRef(component, new image_resource_model_1.ImageResource());
        }
    };
    ImageResourcePopupService.prototype.imageResourceModalRef = function (component, imageResource) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.imageResource = imageResource;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return ImageResourcePopupService;
}());
ImageResourcePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        image_resource_service_1.ImageResourceService])
], ImageResourcePopupService);
exports.ImageResourcePopupService = ImageResourcePopupService;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ImageResource = (function () {
    function ImageResource(id, file, fileName, fileSize) {
        this.id = id;
        this.file = file;
        this.fileName = fileName;
        this.fileSize = fileSize;
    }
    return ImageResource;
}());
exports.ImageResource = ImageResource;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var log_model_1 = __webpack_require__(114);
var log_service_1 = __webpack_require__(14);
var LogPopupService = (function () {
    function LogPopupService(modalService, router, logService) {
        this.modalService = modalService;
        this.router = router;
        this.logService = logService;
        this.isOpen = false;
    }
    LogPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.logService.find(id).subscribe(function (log) {
                _this.logModalRef(component, log);
            });
        }
        else {
            return this.logModalRef(component, new log_model_1.Log());
        }
    };
    LogPopupService.prototype.logModalRef = function (component, log) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.log = log;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return LogPopupService;
}());
LogPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        log_service_1.LogService])
], LogPopupService);
exports.LogPopupService = LogPopupService;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var model_image_model_1 = __webpack_require__(120);
var model_image_service_1 = __webpack_require__(15);
var ModelImagePopupService = (function () {
    function ModelImagePopupService(modalService, router, modelImageService) {
        this.modalService = modalService;
        this.router = router;
        this.modelImageService = modelImageService;
        this.isOpen = false;
    }
    ModelImagePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.modelImageService.find(id).subscribe(function (modelImage) {
                _this.modelImageModalRef(component, modelImage);
            });
        }
        else {
            return this.modelImageModalRef(component, new model_image_model_1.ModelImage());
        }
    };
    ModelImagePopupService.prototype.modelImageModalRef = function (component, modelImage) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.modelImage = modelImage;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return ModelImagePopupService;
}());
ModelImagePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        model_image_service_1.ModelImageService])
], ModelImagePopupService);
exports.ModelImagePopupService = ModelImagePopupService;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var model_model_1 = __webpack_require__(22);
var model_service_1 = __webpack_require__(16);
var ModelPopupService = (function () {
    function ModelPopupService(modalService, router, modelService) {
        this.modalService = modalService;
        this.router = router;
        this.modelService = modelService;
        this.isOpen = false;
    }
    ModelPopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.modelService.find(id).subscribe(function (model) {
                _this.modelModalRef(component, model);
            });
        }
        else {
            return this.modelModalRef(component, new model_model_1.Model());
        }
    };
    ModelPopupService.prototype.modelModalRef = function (component, model) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.model = model;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return ModelPopupService;
}());
ModelPopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        model_service_1.ModelService])
], ModelPopupService);
exports.ModelPopupService = ModelPopupService;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var resource_model_1 = __webpack_require__(131);
var resource_service_1 = __webpack_require__(17);
var ResourcePopupService = (function () {
    function ResourcePopupService(modalService, router, resourceService) {
        this.modalService = modalService;
        this.router = router;
        this.resourceService = resourceService;
        this.isOpen = false;
    }
    ResourcePopupService.prototype.open = function (component, id) {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        if (id) {
            this.resourceService.find(id).subscribe(function (resource) {
                _this.resourceModalRef(component, resource);
            });
        }
        else {
            return this.resourceModalRef(component, new resource_model_1.Resource());
        }
    };
    ResourcePopupService.prototype.resourceModalRef = function (component, resource) {
        var _this = this;
        var modalRef = this.modalService.open(component, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.resource = resource;
        modalRef.result.then(function (result) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        }, function (reason) {
            _this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true });
            _this.isOpen = false;
        });
        return modalRef;
    };
    return ResourcePopupService;
}());
ResourcePopupService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal,
        router_1.Router,
        resource_service_1.ResourceService])
], ResourcePopupService);
exports.ResourcePopupService = ResourcePopupService;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var seller_popup_service_1 = __webpack_require__(23);
var seller_service_1 = __webpack_require__(10);
var language_helper_1 = __webpack_require__(143);
var SellerAddDialogComponent = (function () {
    function SellerAddDialogComponent(activeModal, jhiLanguageService, languageHelper, alertService, sellerService, eventManager) {
        var _this = this;
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.languageHelper = languageHelper;
        this.alertService = alertService;
        this.sellerService = sellerService;
        this.eventManager = eventManager;
        this.languageHelper.getAll().then(function (languages) {
            _this.languages = languages;
        });
        this.jhiLanguageService.setLocations(['seller', 'user-management']);
    }
    SellerAddDialogComponent.prototype.ngOnInit = function () {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    };
    SellerAddDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    SellerAddDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.seller.id !== undefined) {
            this.sellerService.update(this.seller)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.sellerService.create(this.seller)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    SellerAddDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'sellerListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    SellerAddDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    SellerAddDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    SellerAddDialogComponent.prototype.getSelected = function (selectedVals, option) {
        if (selectedVals) {
            for (var i = 0; i < selectedVals.length; i++) {
                if (option.id === selectedVals[i].id) {
                    return selectedVals[i];
                }
            }
        }
        return option;
    };
    return SellerAddDialogComponent;
}());
SellerAddDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-dialog',
        template: __webpack_require__(308)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        language_helper_1.JhiLanguageHelper,
        ng_jhipster_1.AlertService,
        seller_service_1.SellerService,
        ng_jhipster_1.EventManager])
], SellerAddDialogComponent);
exports.SellerAddDialogComponent = SellerAddDialogComponent;
var SellerAddPopupComponent = (function () {
    function SellerAddPopupComponent(route, sellerPopupService) {
        this.route = route;
        this.sellerPopupService = sellerPopupService;
    }
    SellerAddPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.sellerPopupService
                .open(SellerAddDialogComponent);
        });
    };
    SellerAddPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return SellerAddPopupComponent;
}());
SellerAddPopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-add-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        seller_popup_service_1.SellerPopupService])
], SellerAddPopupComponent);
exports.SellerAddPopupComponent = SellerAddPopupComponent;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var profile_info_model_1 = __webpack_require__(140);
var ProfileService = (function () {
    function ProfileService(http) {
        this.http = http;
        this.profileInfoUrl = 'api/profile-info';
    }
    ProfileService.prototype.getProfileInfo = function () {
        return this.http.get(this.profileInfoUrl)
            .map(function (res) {
            var data = res.json();
            var pi = new profile_info_model_1.ProfileInfo();
            pi.activeProfiles = data.activeProfiles;
            pi.ribbonEnv = data.ribbonEnv;
            pi.inProduction = data.activeProfiles.indexOf('prod') !== -1;
            pi.swaggerEnabled = data.activeProfiles.indexOf('swagger') !== -1;
            return pi;
        });
    };
    return ProfileService;
}());
ProfileService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], ProfileService);
exports.ProfileService = ProfileService;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var AuthServerProvider = (function () {
    function AuthServerProvider(http) {
        this.http = http;
    }
    AuthServerProvider.prototype.login = function (credentials) {
        var data = 'j_username=' + encodeURIComponent(credentials.username) +
            '&j_password=' + encodeURIComponent(credentials.password) +
            '&remember-me=' + credentials.rememberMe + '&submit=Login';
        var headers = new http_1.Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        return this.http.post('api/authentication', data, {
            headers: headers
        });
    };
    AuthServerProvider.prototype.logout = function () {
        var _this = this;
        // logout from the server
        return this.http.post('api/logout', {}).map(function (response) {
            // to get a new csrf token call the api
            _this.http.get('api/account').subscribe(function () { }, function () { });
            return response;
        });
    };
    return AuthServerProvider;
}());
AuthServerProvider = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], AuthServerProvider);
exports.AuthServerProvider = AuthServerProvider;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var core_2 = __webpack_require__(325);
var CSRFService = (function () {
    function CSRFService(cookieService) {
        this.cookieService = cookieService;
    }
    CSRFService.prototype.getCSRF = function (name) {
        name = "" + (name ? name : 'XSRF-TOKEN');
        return this.cookieService.get(name);
    };
    return CSRFService;
}());
CSRFService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [core_2.CookieService])
], CSRFService);
exports.CSRFService = CSRFService;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var login_component_1 = __webpack_require__(144);
var LoginModalService = (function () {
    function LoginModalService(modalService) {
        this.modalService = modalService;
        this.isOpen = false;
    }
    LoginModalService.prototype.open = function () {
        var _this = this;
        if (this.isOpen) {
            return;
        }
        this.isOpen = true;
        var modalRef = this.modalService.open(login_component_1.DcsLoginModalComponent);
        modalRef.result.then(function (result) {
            _this.isOpen = false;
        }, function (reason) {
            _this.isOpen = false;
        });
        return modalRef;
    };
    return LoginModalService;
}());
LoginModalService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbModal])
], LoginModalService);
exports.LoginModalService = LoginModalService;


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressDirective; });

// todo: progress element conflict with bootstrap.css
// todo: need hack: replace host element with div
var ProgressDirective = (function () {
    function ProgressDirective() {
        this.addClass = true;
        this.bars = [];
        this._max = 100;
    }
    Object.defineProperty(ProgressDirective.prototype, "max", {
        /** maximum total value of progress element */
        get: function () {
            return this._max;
        },
        set: function (v) {
            this._max = v;
            this.bars.forEach(function (bar) {
                bar.recalculatePercentage();
            });
        },
        enumerable: true,
        configurable: true
    });
    ProgressDirective.prototype.addBar = function (bar) {
        if (!this.animate) {
            bar.transition = 'none';
        }
        this.bars.push(bar);
    };
    ProgressDirective.prototype.removeBar = function (bar) {
        this.bars.splice(this.bars.indexOf(bar), 1);
    };
    ProgressDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'bs-progress, [progress]' },] },
    ];
    /** @nocollapse */
    ProgressDirective.ctorParameters = function () { return []; };
    ProgressDirective.propDecorators = {
        'animate': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'max': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['attr.max',] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'addClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.progress',] },],
    };
    return ProgressDirective;
}());

//# sourceMappingURL=progress.directive.js.map

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressbarConfig; });

var ProgressbarConfig = (function () {
    function ProgressbarConfig() {
        /** if `true` changing value of progress bar will be animated (note: not supported by Bootstrap 4) */
        this.animate = true;
        /** maximum total value of progress element */
        this.max = 100;
    }
    ProgressbarConfig.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    ProgressbarConfig.ctorParameters = function () { return []; };
    return ProgressbarConfig;
}());

//# sourceMappingURL=progressbar.config.js.map

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_directives_ng_file_drop__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_directives_ng_file_drop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_directives_ng_file_drop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_directives_ng_file_select__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_directives_ng_file_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_directives_ng_file_select__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__src_directives_ng_file_drop__) if(["NgUploaderOptions","UploadedFile","UploadRejected","NgUploaderModule","UPLOAD_DIRECTIVES","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__src_directives_ng_file_drop__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_1__src_directives_ng_file_select__) if(["NgUploaderOptions","UploadedFile","UploadRejected","NgUploaderModule","UPLOAD_DIRECTIVES","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_1__src_directives_ng_file_select__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_services_ngx_uploader__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_services_ngx_uploader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__src_services_ngx_uploader__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_2__src_services_ngx_uploader__) if(["NgUploaderOptions","UploadedFile","UploadRejected","NgUploaderModule","UPLOAD_DIRECTIVES","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_2__src_services_ngx_uploader__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_classes_index__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_classes_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__src_classes_index__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_3__src_classes_index__, "NgUploaderOptions")) __webpack_require__.d(__webpack_exports__, "NgUploaderOptions", function() { return __WEBPACK_IMPORTED_MODULE_3__src_classes_index__["NgUploaderOptions"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_3__src_classes_index__, "UploadedFile")) __webpack_require__.d(__webpack_exports__, "UploadedFile", function() { return __WEBPACK_IMPORTED_MODULE_3__src_classes_index__["UploadedFile"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_3__src_classes_index__, "UploadRejected")) __webpack_require__.d(__webpack_exports__, "UploadRejected", function() { return __WEBPACK_IMPORTED_MODULE_3__src_classes_index__["UploadRejected"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_module_ngx_uploader_module__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_module_ngx_uploader_module___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__src_module_ngx_uploader_module__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_4__src_module_ngx_uploader_module__, "NgUploaderModule")) __webpack_require__.d(__webpack_exports__, "NgUploaderModule", function() { return __WEBPACK_IMPORTED_MODULE_4__src_module_ngx_uploader_module__["NgUploaderModule"]; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPLOAD_DIRECTIVES", function() { return UPLOAD_DIRECTIVES; });







var UPLOAD_DIRECTIVES = [
    __WEBPACK_IMPORTED_MODULE_1__src_directives_ng_file_select__["NgFileSelectDirective"],
    __WEBPACK_IMPORTED_MODULE_0__src_directives_ng_file_drop__["NgFileDropDirective"]
];
//# sourceMappingURL=ngx-uploader.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(1);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(109);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UploadedFile = (function () {
    function UploadedFile(id, originalName, size, xhr) {
        this.xhr = xhr;
        this.id = id;
        this.originalName = originalName;
        this.size = size;
        this.progress = {
            loaded: 0,
            total: 0,
            percent: 0,
            speed: 0,
            speedHumanized: null
        };
        this.done = false;
        this.error = false;
        this.abort = false;
        this.startTime = new Date().getTime();
        this.endTime = 0;
        this.speedAverage = 0;
        this.speedAverageHumanized = null;
    }
    UploadedFile.prototype.abortUpload = function () {
        if (this.xhr) {
            this.xhr.abort();
        }
    };
    UploadedFile.prototype.setProgress = function (progress) {
        this.progress = progress;
    };
    UploadedFile.prototype.setError = function () {
        this.error = true;
        this.done = true;
    };
    UploadedFile.prototype.setAbort = function () {
        this.abort = true;
        this.done = true;
    };
    UploadedFile.prototype.onFinished = function (status, statusText, response) {
        this.endTime = new Date().getTime();
        this.speedAverage = this.size / (this.endTime - this.startTime) * 1000;
        this.speedAverage = parseInt(this.speedAverage, 10);
        this.speedAverageHumanized = this.humanizeBytes(this.speedAverage);
        this.status = status;
        this.statusText = statusText;
        this.response = response;
        this.done = true;
    };
    UploadedFile.prototype.humanizeBytes = function (bytes) {
        if (bytes === 0) {
            return '0 Byte';
        }
        var k = 1024;
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i] + '/s';
    };
    return UploadedFile;
}());
exports.UploadedFile = UploadedFile;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// DO NOT EDIT THIS FILE, EDIT THE WEBPACK COMMON CONFIG INSTEAD, WHICH WILL MODIFY THIS FILE
var _VERSION = '1.2.0'; // This value will be overwritten by webpack
var _DEBUG_INFO_ENABLED = true; // This value will be overwritten by webpack
_VERSION = "0.0.0";
_DEBUG_INFO_ENABLED = false;
exports.VERSION = _VERSION;
exports.DEBUG_INFO_ENABLED = _DEBUG_INFO_ENABLED;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var activate_service_1 = __webpack_require__(55);
var shared_1 = __webpack_require__(3);
var ActivateComponent = (function () {
    function ActivateComponent(jhiLanguageService, activate, loginModalService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.activate = activate;
        this.loginModalService = loginModalService;
        this.route = route;
        this.jhiLanguageService.setLocations(['activate']);
    }
    ActivateComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.activate.get(params['key']).subscribe(function () {
                _this.error = null;
                _this.success = 'OK';
            }, function () {
                _this.success = null;
                _this.error = 'ERROR';
            });
        });
    };
    ActivateComponent.prototype.login = function () {
        this.modalRef = this.loginModalService.open();
    };
    return ActivateComponent;
}());
ActivateComponent = __decorate([
    core_1.Component({
        selector: 'dcs-activate',
        template: __webpack_require__(252)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        activate_service_1.Activate,
        shared_1.LoginModalService,
        router_1.ActivatedRoute])
], ActivateComponent);
exports.ActivateComponent = ActivateComponent;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var Activate = (function () {
    function Activate(http) {
        this.http = http;
    }
    Activate.prototype.get = function (key) {
        var params = new http_1.URLSearchParams();
        params.set('key', key);
        return this.http.get('api/activate', {
            search: params
        }).map(function (res) { return res; });
    };
    return Activate;
}());
Activate = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], Activate);
exports.Activate = Activate;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(54));
__export(__webpack_require__(55));
__export(__webpack_require__(170));
__export(__webpack_require__(61));
__export(__webpack_require__(173));
__export(__webpack_require__(62));
__export(__webpack_require__(174));
__export(__webpack_require__(57));
__export(__webpack_require__(58));
__export(__webpack_require__(171));
__export(__webpack_require__(59));
__export(__webpack_require__(60));
__export(__webpack_require__(172));
__export(__webpack_require__(63));
__export(__webpack_require__(64));
__export(__webpack_require__(176));
__export(__webpack_require__(175));
__export(__webpack_require__(65));
__export(__webpack_require__(177));
__export(__webpack_require__(169));


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var password_reset_finish_service_1 = __webpack_require__(58);
var shared_1 = __webpack_require__(3);
var PasswordResetFinishComponent = (function () {
    function PasswordResetFinishComponent(jhiLanguageService, passwordResetFinish, loginModalService, route, elementRef, renderer) {
        this.jhiLanguageService = jhiLanguageService;
        this.passwordResetFinish = passwordResetFinish;
        this.loginModalService = loginModalService;
        this.route = route;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.jhiLanguageService.setLocations(['reset']);
    }
    PasswordResetFinishComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.key = params['key'];
        });
        this.resetAccount = {};
        this.keyMissing = !this.key;
    };
    PasswordResetFinishComponent.prototype.ngAfterViewInit = function () {
        if (this.elementRef.nativeElement.querySelector('#password') != null) {
            this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#password'), 'focus', []);
        }
    };
    PasswordResetFinishComponent.prototype.finishReset = function () {
        var _this = this;
        this.doNotMatch = null;
        this.error = null;
        if (this.resetAccount.password !== this.confirmPassword) {
            this.doNotMatch = 'ERROR';
        }
        else {
            this.passwordResetFinish.save({
                key: this.key,
                newPassword: this.resetAccount.password
            }).subscribe(function () {
                _this.success = 'OK';
            }, function () {
                _this.success = null;
                _this.error = 'ERROR';
            });
        }
    };
    PasswordResetFinishComponent.prototype.login = function () {
        this.modalRef = this.loginModalService.open();
    };
    return PasswordResetFinishComponent;
}());
PasswordResetFinishComponent = __decorate([
    core_1.Component({
        selector: 'dcs-password-reset-finish',
        template: __webpack_require__(253)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        password_reset_finish_service_1.PasswordResetFinish,
        shared_1.LoginModalService,
        router_1.ActivatedRoute,
        core_1.ElementRef, core_1.Renderer])
], PasswordResetFinishComponent);
exports.PasswordResetFinishComponent = PasswordResetFinishComponent;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var PasswordResetFinish = (function () {
    function PasswordResetFinish(http) {
        this.http = http;
    }
    PasswordResetFinish.prototype.save = function (keyAndPassword) {
        return this.http.post('api/account/reset_password/finish', keyAndPassword);
    };
    return PasswordResetFinish;
}());
PasswordResetFinish = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], PasswordResetFinish);
exports.PasswordResetFinish = PasswordResetFinish;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var password_reset_init_service_1 = __webpack_require__(60);
var PasswordResetInitComponent = (function () {
    function PasswordResetInitComponent(jhiLanguageService, passwordResetInit, elementRef, renderer) {
        this.jhiLanguageService = jhiLanguageService;
        this.passwordResetInit = passwordResetInit;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.jhiLanguageService.setLocations(['reset']);
    }
    PasswordResetInitComponent.prototype.ngOnInit = function () {
        this.resetAccount = {};
    };
    PasswordResetInitComponent.prototype.ngAfterViewInit = function () {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    };
    PasswordResetInitComponent.prototype.requestReset = function () {
        var _this = this;
        this.error = null;
        this.errorEmailNotExists = null;
        this.passwordResetInit.save(this.resetAccount.email).subscribe(function () {
            _this.success = 'OK';
        }, function (response) {
            _this.success = null;
            if (response.status === 400 && response.data === 'e-mail address not registered') {
                _this.errorEmailNotExists = 'ERROR';
            }
            else {
                _this.error = 'ERROR';
            }
        });
    };
    return PasswordResetInitComponent;
}());
PasswordResetInitComponent = __decorate([
    core_1.Component({
        selector: 'dcs-password-reset-init',
        template: __webpack_require__(254)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        password_reset_init_service_1.PasswordResetInit,
        core_1.ElementRef,
        core_1.Renderer])
], PasswordResetInitComponent);
exports.PasswordResetInitComponent = PasswordResetInitComponent;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var PasswordResetInit = (function () {
    function PasswordResetInit(http) {
        this.http = http;
    }
    PasswordResetInit.prototype.save = function (mail) {
        return this.http.post('api/account/reset_password/init', mail);
    };
    return PasswordResetInit;
}());
PasswordResetInit = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], PasswordResetInit);
exports.PasswordResetInit = PasswordResetInit;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var password_service_1 = __webpack_require__(62);
var PasswordComponent = (function () {
    function PasswordComponent(jhiLanguageService, passwordService, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.passwordService = passwordService;
        this.principal = principal;
        this.jhiLanguageService.setLocations(['password']);
    }
    PasswordComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.account = account;
        });
    };
    PasswordComponent.prototype.changePassword = function () {
        var _this = this;
        if (this.password !== this.confirmPassword) {
            this.error = null;
            this.success = null;
            this.doNotMatch = 'ERROR';
        }
        else {
            this.doNotMatch = null;
            this.passwordService.save(this.password).subscribe(function () {
                _this.error = null;
                _this.success = 'OK';
            }, function () {
                _this.success = null;
                _this.error = 'ERROR';
            });
        }
    };
    return PasswordComponent;
}());
PasswordComponent = __decorate([
    core_1.Component({
        selector: 'dcs-password',
        template: __webpack_require__(255)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        password_service_1.Password,
        shared_1.Principal])
], PasswordComponent);
exports.PasswordComponent = PasswordComponent;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var Password = (function () {
    function Password(http) {
        this.http = http;
    }
    Password.prototype.save = function (newPassword) {
        return this.http.post('api/account/change_password', newPassword);
    };
    return Password;
}());
Password = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], Password);
exports.Password = Password;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var sessions_service_1 = __webpack_require__(64);
var shared_1 = __webpack_require__(3);
var SessionsComponent = (function () {
    function SessionsComponent(jhiLanguageService, sessionsService, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.sessionsService = sessionsService;
        this.principal = principal;
        this.jhiLanguageService.setLocations(['sessions']);
    }
    SessionsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sessionsService.findAll().subscribe(function (sessions) { return _this.sessions = sessions; });
        this.principal.identity().then(function (account) {
            _this.account = account;
        });
    };
    SessionsComponent.prototype.invalidate = function (series) {
        var _this = this;
        this.sessionsService.delete(encodeURIComponent(series)).subscribe(function (response) {
            if (response.status === 200) {
                _this.error = null;
                _this.success = 'OK';
                _this.sessionsService.findAll().subscribe(function (sessions) { return _this.sessions = sessions; });
            }
            else {
                _this.success = null;
                _this.error = 'ERROR';
            }
        });
    };
    return SessionsComponent;
}());
SessionsComponent = __decorate([
    core_1.Component({
        selector: 'dcs-sessions',
        template: __webpack_require__(256)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        sessions_service_1.SessionsService,
        shared_1.Principal])
], SessionsComponent);
exports.SessionsComponent = SessionsComponent;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var SessionsService = (function () {
    function SessionsService(http) {
        this.http = http;
        this.resourceUrl = 'api/account/sessions/';
    }
    SessionsService.prototype.findAll = function () {
        return this.http.get(this.resourceUrl).map(function (res) { return res.json(); });
    };
    SessionsService.prototype.delete = function (series) {
        return this.http.delete("" + this.resourceUrl + series);
    };
    return SessionsService;
}());
SessionsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], SessionsService);
exports.SessionsService = SessionsService;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var SettingsComponent = (function () {
    function SettingsComponent(account, principal, languageService, languageHelper) {
        this.account = account;
        this.principal = principal;
        this.languageService = languageService;
        this.languageHelper = languageHelper;
        this.languageService.setLocations(['settings']);
    }
    SettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.settingsAccount = _this.copyAccount(account);
        });
        this.languageHelper.getAll().then(function (languages) {
            _this.languages = languages;
        });
    };
    SettingsComponent.prototype.save = function () {
        var _this = this;
        this.account.save(this.settingsAccount).subscribe(function () {
            _this.error = null;
            _this.success = 'OK';
            _this.principal.identity(true).then(function (account) {
                _this.settingsAccount = _this.copyAccount(account);
            });
            _this.languageService.getCurrent().then(function (current) {
                if (_this.settingsAccount.langKey !== current) {
                    _this.languageService.changeLanguage(_this.settingsAccount.langKey);
                }
            });
        }, function () {
            _this.success = null;
            _this.error = 'ERROR';
        });
    };
    SettingsComponent.prototype.copyAccount = function (account) {
        return {
            activated: account.activated,
            email: account.email,
            firstName: account.firstName,
            langKey: account.langKey,
            lastName: account.lastName,
            login: account.login,
            imageUrl: account.imageUrl
        };
    };
    return SettingsComponent;
}());
SettingsComponent = __decorate([
    core_1.Component({
        selector: 'dcs-settings',
        template: __webpack_require__(257)
    }),
    __metadata("design:paramtypes", [shared_1.AccountService,
        shared_1.Principal,
        ng_jhipster_1.JhiLanguageService,
        shared_1.JhiLanguageHelper])
], SettingsComponent);
exports.SettingsComponent = SettingsComponent;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(74);
var DeviceConfigurerServiceAdminModule = (function () {
    function DeviceConfigurerServiceAdminModule() {
    }
    return DeviceConfigurerServiceAdminModule;
}());
DeviceConfigurerServiceAdminModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            router_1.RouterModule.forRoot(_1.adminState, { useHash: true })
        ],
        declarations: [
            _1.AuditsComponent,
            _1.UserMgmtComponent,
            _1.UserDialogComponent,
            _1.UserDeleteDialogComponent,
            _1.UserMgmtDetailComponent,
            _1.UserMgmtDialogComponent,
            _1.UserMgmtDeleteDialogComponent,
            _1.LogsComponent,
            _1.DcsConfigurationComponent,
            _1.DcsHealthCheckComponent,
            _1.DcsHealthModalComponent,
            _1.DcsDocsComponent,
            _1.DcsMetricsMonitoringComponent,
            _1.DcsMetricsMonitoringModalComponent
        ],
        entryComponents: [
            _1.UserMgmtDialogComponent,
            _1.UserMgmtDeleteDialogComponent,
            _1.DcsHealthModalComponent,
            _1.DcsMetricsMonitoringModalComponent,
        ],
        providers: [
            _1.AuditsService,
            _1.DcsConfigurationService,
            _1.DcsHealthService,
            _1.DcsMetricsService,
            _1.LogsService,
            _1.UserResolvePagingParams,
            _1.UserResolve,
            _1.UserModalService
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceAdminModule);
exports.DeviceConfigurerServiceAdminModule = DeviceConfigurerServiceAdminModule;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(8);
var ng_jhipster_1 = __webpack_require__(1);
var audits_service_1 = __webpack_require__(68);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(7);
var AuditsComponent = (function () {
    function AuditsComponent(jhiLanguageService, auditsService, parseLinks, paginationConfig, datePipe) {
        this.jhiLanguageService = jhiLanguageService;
        this.auditsService = auditsService;
        this.parseLinks = parseLinks;
        this.paginationConfig = paginationConfig;
        this.datePipe = datePipe;
        this.jhiLanguageService.setLocations(['audits']);
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.page = 1;
        this.reverse = false;
        this.orderProp = 'timestamp';
    }
    AuditsComponent.prototype.getAudits = function () {
        return this.sortAudits(this.audits);
    };
    AuditsComponent.prototype.loadPage = function (page) {
        this.page = page;
        this.onChangeDate();
    };
    AuditsComponent.prototype.ngOnInit = function () {
        this.today();
        this.previousMonth();
        this.onChangeDate();
    };
    AuditsComponent.prototype.onChangeDate = function () {
        var _this = this;
        this.auditsService.query({ page: this.page - 1, size: this.itemsPerPage,
            fromDate: this.fromDate, toDate: this.toDate }).subscribe(function (res) {
            _this.audits = res.json();
            _this.links = _this.parseLinks.parse(res.headers.get('link'));
            _this.totalItems = +res.headers.get('X-Total-Count');
        });
    };
    AuditsComponent.prototype.previousMonth = function () {
        var dateFormat = 'yyyy-MM-dd';
        var fromDate = new Date();
        if (fromDate.getMonth() === 0) {
            fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
        }
        else {
            fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
        }
        this.fromDate = this.datePipe.transform(fromDate, dateFormat);
    };
    AuditsComponent.prototype.today = function () {
        var dateFormat = 'yyyy-MM-dd';
        // Today + 1 day - needed if the current day must be included
        var today = new Date();
        var date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        this.toDate = this.datePipe.transform(date, dateFormat);
    };
    AuditsComponent.prototype.sortAudits = function (audits) {
        var _this = this;
        audits = audits.slice(0).sort(function (a, b) {
            if (a[_this.orderProp] < b[_this.orderProp]) {
                return -1;
            }
            else if (true) {
                return 1;
            }
            else {
                return 0;
            }
        });
        return this.reverse ? audits.reverse() : audits;
    };
    return AuditsComponent;
}());
AuditsComponent = __decorate([
    core_1.Component({
        selector: 'dcs-audit',
        template: __webpack_require__(258)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        audits_service_1.AuditsService,
        ng_jhipster_1.ParseLinks,
        uib_pagination_config_1.PaginationConfig,
        common_1.DatePipe])
], AuditsComponent);
exports.AuditsComponent = AuditsComponent;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var AuditsService = (function () {
    function AuditsService(http) {
        this.http = http;
    }
    AuditsService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        params.set('fromDate', req.fromDate);
        params.set('toDate', req.toDate);
        params.set('page', req.page);
        params.set('size', req.size);
        params.set('sort', req.sort);
        var options = {
            search: params
        };
        return this.http.get('management/audits', options);
    };
    return AuditsService;
}());
AuditsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], AuditsService);
exports.AuditsService = AuditsService;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var configuration_service_1 = __webpack_require__(70);
var DcsConfigurationComponent = (function () {
    function DcsConfigurationComponent(jhiLanguageService, configurationService) {
        this.jhiLanguageService = jhiLanguageService;
        this.configurationService = configurationService;
        this.allConfiguration = null;
        this.configuration = null;
        this.jhiLanguageService.setLocations(['configuration']);
        this.configKeys = [];
        this.filter = '';
        this.orderProp = 'prefix';
        this.reverse = false;
    }
    DcsConfigurationComponent.prototype.keys = function (dict) {
        return (dict === undefined) ? [] : Object.keys(dict);
    };
    DcsConfigurationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.configurationService.get().subscribe(function (configuration) {
            _this.configuration = configuration;
            for (var _i = 0, configuration_1 = configuration; _i < configuration_1.length; _i++) {
                var config = configuration_1[_i];
                if (config.properties !== undefined) {
                    _this.configKeys.push(Object.keys(config.properties));
                }
            }
        });
        this.configurationService.getEnv().subscribe(function (configuration) {
            _this.allConfiguration = configuration;
        });
    };
    return DcsConfigurationComponent;
}());
DcsConfigurationComponent = __decorate([
    core_1.Component({
        selector: 'dcs-configuration',
        template: __webpack_require__(259)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        configuration_service_1.DcsConfigurationService])
], DcsConfigurationComponent);
exports.DcsConfigurationComponent = DcsConfigurationComponent;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var DcsConfigurationService = (function () {
    function DcsConfigurationService(http) {
        this.http = http;
    }
    DcsConfigurationService.prototype.get = function () {
        return this.http.get('management/configprops').map(function (res) {
            var properties = [];
            var propertiesObject = res.json();
            for (var key in propertiesObject) {
                if (propertiesObject.hasOwnProperty(key)) {
                    properties.push(propertiesObject[key]);
                }
            }
            return properties.sort(function (propertyA, propertyB) {
                return (propertyA.prefix === propertyB.prefix) ? 0 :
                    (propertyA.prefix < propertyB.prefix) ? -1 : 1;
            });
        });
    };
    DcsConfigurationService.prototype.getEnv = function () {
        return this.http.get('management/env').map(function (res) {
            var properties = {};
            var propertiesObject = res.json();
            for (var key in propertiesObject) {
                if (propertiesObject.hasOwnProperty(key)) {
                    var valsObject = propertiesObject[key];
                    var vals = [];
                    for (var valKey in valsObject) {
                        if (valsObject.hasOwnProperty(valKey)) {
                            vals.push({ key: valKey, val: valsObject[valKey] });
                        }
                    }
                    properties[key] = vals;
                }
            }
            return properties;
        });
    };
    return DcsConfigurationService;
}());
DcsConfigurationService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], DcsConfigurationService);
exports.DcsConfigurationService = DcsConfigurationService;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var DcsDocsComponent = (function () {
    function DcsDocsComponent(jhiLanguageService) {
        this.jhiLanguageService = jhiLanguageService;
        this.jhiLanguageService.setLocations(['global']);
    }
    return DcsDocsComponent;
}());
DcsDocsComponent = __decorate([
    core_1.Component({
        selector: 'dcs-docs',
        template: __webpack_require__(260)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService])
], DcsDocsComponent);
exports.DcsDocsComponent = DcsDocsComponent;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var health_service_1 = __webpack_require__(31);
var DcsHealthModalComponent = (function () {
    function DcsHealthModalComponent(healthService, activeModal) {
        this.healthService = healthService;
        this.activeModal = activeModal;
    }
    DcsHealthModalComponent.prototype.baseName = function (name) {
        return this.healthService.getBaseName(name);
    };
    DcsHealthModalComponent.prototype.subSystemName = function (name) {
        return this.healthService.getSubSystemName(name);
    };
    DcsHealthModalComponent.prototype.readableValue = function (value) {
        if (this.currentHealth.name !== 'diskSpace') {
            return value.toString();
        }
        // Should display storage space in an human readable unit
        var val = value / 1073741824;
        if (val > 1) {
            return val.toFixed(2) + ' GB';
        }
        else {
            return (value / 1048576).toFixed(2) + ' MB';
        }
    };
    return DcsHealthModalComponent;
}());
DcsHealthModalComponent = __decorate([
    core_1.Component({
        selector: 'dcs-health-modal',
        template: __webpack_require__(261)
    }),
    __metadata("design:paramtypes", [health_service_1.DcsHealthService, ng_bootstrap_1.NgbActiveModal])
], DcsHealthModalComponent);
exports.DcsHealthModalComponent = DcsHealthModalComponent;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var health_service_1 = __webpack_require__(31);
var health_modal_component_1 = __webpack_require__(72);
var DcsHealthCheckComponent = (function () {
    function DcsHealthCheckComponent(jhiLanguageService, modalService, healthService) {
        this.jhiLanguageService = jhiLanguageService;
        this.modalService = modalService;
        this.healthService = healthService;
        this.jhiLanguageService.setLocations(['health']);
    }
    DcsHealthCheckComponent.prototype.ngOnInit = function () {
        this.refresh();
    };
    DcsHealthCheckComponent.prototype.baseName = function (name) {
        return this.healthService.getBaseName(name);
    };
    DcsHealthCheckComponent.prototype.getBadgeClass = function (statusState) {
        if (statusState === 'UP') {
            return 'badge-success';
        }
        else {
            return 'badge-danger';
        }
    };
    DcsHealthCheckComponent.prototype.refresh = function () {
        var _this = this;
        this.updatingHealth = true;
        this.healthService.checkHealth().subscribe(function (health) {
            _this.healthData = _this.healthService.transformHealthData(health);
            _this.updatingHealth = false;
        }, function (error) {
            if (error.status === 503) {
                _this.healthData = _this.healthService.transformHealthData(error.json());
                _this.updatingHealth = false;
            }
        });
    };
    DcsHealthCheckComponent.prototype.showHealth = function (health) {
        var modalRef = this.modalService.open(health_modal_component_1.DcsHealthModalComponent);
        modalRef.componentInstance.currentHealth = health;
        modalRef.result.then(function (result) {
            // Left blank intentionally, nothing to do here
        }, function (reason) {
            // Left blank intentionally, nothing to do here
        });
    };
    DcsHealthCheckComponent.prototype.subSystemName = function (name) {
        return this.healthService.getSubSystemName(name);
    };
    return DcsHealthCheckComponent;
}());
DcsHealthCheckComponent = __decorate([
    core_1.Component({
        selector: 'dcs-health',
        template: __webpack_require__(262),
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        ng_bootstrap_1.NgbModal,
        health_service_1.DcsHealthService])
], DcsHealthCheckComponent);
exports.DcsHealthCheckComponent = DcsHealthCheckComponent;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(67));
__export(__webpack_require__(68));
__export(__webpack_require__(181));
__export(__webpack_require__(180));
__export(__webpack_require__(179));
__export(__webpack_require__(69));
__export(__webpack_require__(70));
__export(__webpack_require__(182));
__export(__webpack_require__(71));
__export(__webpack_require__(183));
__export(__webpack_require__(73));
__export(__webpack_require__(72));
__export(__webpack_require__(31));
__export(__webpack_require__(184));
__export(__webpack_require__(76));
__export(__webpack_require__(77));
__export(__webpack_require__(185));
__export(__webpack_require__(75));
__export(__webpack_require__(79));
__export(__webpack_require__(78));
__export(__webpack_require__(80));
__export(__webpack_require__(186));
__export(__webpack_require__(83));
__export(__webpack_require__(81));
__export(__webpack_require__(82));
__export(__webpack_require__(84));
__export(__webpack_require__(187));
__export(__webpack_require__(32));
__export(__webpack_require__(178));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Log = (function () {
    function Log(name, level) {
        this.name = name;
        this.level = level;
    }
    return Log;
}());
exports.Log = Log;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var log_model_1 = __webpack_require__(75);
var logs_service_1 = __webpack_require__(77);
var LogsComponent = (function () {
    function LogsComponent(jhiLanguageService, logsService) {
        this.jhiLanguageService = jhiLanguageService;
        this.logsService = logsService;
        this.filter = '';
        this.orderProp = 'name';
        this.reverse = false;
        this.jhiLanguageService.setLocations(['logs']);
    }
    LogsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.logsService.findAll().subscribe(function (loggers) { return _this.loggers = loggers; });
    };
    LogsComponent.prototype.changeLevel = function (name, level) {
        var _this = this;
        var log = new log_model_1.Log(name, level);
        this.logsService.changeLevel(log).subscribe(function () {
            _this.logsService.findAll().subscribe(function (loggers) { return _this.loggers = loggers; });
        });
    };
    return LogsComponent;
}());
LogsComponent = __decorate([
    core_1.Component({
        selector: 'dcs-logs',
        template: __webpack_require__(263),
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        logs_service_1.LogsService])
], LogsComponent);
exports.LogsComponent = LogsComponent;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var LogsService = (function () {
    function LogsService(http) {
        this.http = http;
    }
    LogsService.prototype.changeLevel = function (log) {
        return this.http.put('management/logs', log);
    };
    LogsService.prototype.findAll = function () {
        return this.http.get('management/logs').map(function (res) { return res.json(); });
    };
    return LogsService;
}());
LogsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], LogsService);
exports.LogsService = LogsService;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var DcsMetricsMonitoringModalComponent = (function () {
    function DcsMetricsMonitoringModalComponent(activeModal) {
        this.activeModal = activeModal;
        this.threadDumpAll = 0;
        this.threadDumpBlocked = 0;
        this.threadDumpRunnable = 0;
        this.threadDumpTimedWaiting = 0;
        this.threadDumpWaiting = 0;
    }
    DcsMetricsMonitoringModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.threadDump.forEach(function (value) {
            if (value.threadState === 'RUNNABLE') {
                _this.threadDumpRunnable += 1;
            }
            else if (value.threadState === 'WAITING') {
                _this.threadDumpWaiting += 1;
            }
            else if (value.threadState === 'TIMED_WAITING') {
                _this.threadDumpTimedWaiting += 1;
            }
            else if (value.threadState === 'BLOCKED') {
                _this.threadDumpBlocked += 1;
            }
        });
        this.threadDumpAll = this.threadDumpRunnable + this.threadDumpWaiting +
            this.threadDumpTimedWaiting + this.threadDumpBlocked;
    };
    DcsMetricsMonitoringModalComponent.prototype.getBadgeClass = function (threadState) {
        if (threadState === 'RUNNABLE') {
            return 'badge-success';
        }
        else if (threadState === 'WAITING') {
            return 'badge-info';
        }
        else if (threadState === 'TIMED_WAITING') {
            return 'badge-warning';
        }
        else if (threadState === 'BLOCKED') {
            return 'badge-danger';
        }
    };
    return DcsMetricsMonitoringModalComponent;
}());
DcsMetricsMonitoringModalComponent = __decorate([
    core_1.Component({
        selector: 'dcs-metrics-modal',
        template: __webpack_require__(264)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal])
], DcsMetricsMonitoringModalComponent);
exports.DcsMetricsMonitoringModalComponent = DcsMetricsMonitoringModalComponent;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var metrics_modal_component_1 = __webpack_require__(78);
var metrics_service_1 = __webpack_require__(80);
var DcsMetricsMonitoringComponent = (function () {
    function DcsMetricsMonitoringComponent(jhiLanguageService, modalService, metricsService) {
        this.jhiLanguageService = jhiLanguageService;
        this.modalService = modalService;
        this.metricsService = metricsService;
        this.metrics = {};
        this.cachesStats = {};
        this.servicesStats = {};
        this.updatingMetrics = true;
        this.JCACHE_KEY = 'jcache.statistics';
        this.jhiLanguageService.setLocations(['metrics']);
    }
    DcsMetricsMonitoringComponent.prototype.ngOnInit = function () {
        this.refresh();
    };
    DcsMetricsMonitoringComponent.prototype.refresh = function () {
        var _this = this;
        this.updatingMetrics = true;
        this.metricsService.getMetrics().subscribe(function (metrics) {
            _this.metrics = metrics;
            _this.updatingMetrics = false;
            _this.servicesStats = {};
            _this.cachesStats = {};
            Object.keys(metrics.timers).forEach(function (key) {
                var value = metrics.timers[key];
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    _this.servicesStats[key] = value;
                }
            });
            Object.keys(metrics.gauges).forEach(function (key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    var value = metrics.gauges[key].value;
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);
                    // Keep the name of the domain
                    _this.cachesStats[newKey] = {
                        'name': _this.JCACHE_KEY.length,
                        'value': value
                    };
                }
            });
        });
    };
    DcsMetricsMonitoringComponent.prototype.refreshThreadDumpData = function () {
        var _this = this;
        this.metricsService.threadDump().subscribe(function (data) {
            var modalRef = _this.modalService.open(metrics_modal_component_1.DcsMetricsMonitoringModalComponent, { size: 'lg' });
            modalRef.componentInstance.threadDump = data;
            modalRef.result.then(function (result) {
                // Left blank intentionally, nothing to do here
            }, function (reason) {
                // Left blank intentionally, nothing to do here
            });
        });
    };
    return DcsMetricsMonitoringComponent;
}());
DcsMetricsMonitoringComponent = __decorate([
    core_1.Component({
        selector: 'dcs-metrics',
        template: __webpack_require__(265),
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        ng_bootstrap_1.NgbModal,
        metrics_service_1.DcsMetricsService])
], DcsMetricsMonitoringComponent);
exports.DcsMetricsMonitoringComponent = DcsMetricsMonitoringComponent;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var DcsMetricsService = (function () {
    function DcsMetricsService(http) {
        this.http = http;
    }
    DcsMetricsService.prototype.getMetrics = function () {
        return this.http.get('management/metrics').map(function (res) { return res.json(); });
    };
    DcsMetricsService.prototype.threadDump = function () {
        return this.http.get('management/dump').map(function (res) { return res.json(); });
    };
    return DcsMetricsService;
}());
DcsMetricsService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], DcsMetricsService);
exports.DcsMetricsService = DcsMetricsService;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var user_modal_service_1 = __webpack_require__(32);
var UserMgmtDeleteDialogComponent = (function () {
    function UserMgmtDeleteDialogComponent(jhiLanguageService, userService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['user-management']);
    }
    UserMgmtDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    UserMgmtDeleteDialogComponent.prototype.confirmDelete = function (login) {
        var _this = this;
        this.userService.delete(login).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'userListModification',
                content: 'Deleted a user'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return UserMgmtDeleteDialogComponent;
}());
UserMgmtDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-user-mgmt-delete-dialog',
        template: __webpack_require__(266)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], UserMgmtDeleteDialogComponent);
exports.UserMgmtDeleteDialogComponent = UserMgmtDeleteDialogComponent;
var UserDeleteDialogComponent = (function () {
    function UserDeleteDialogComponent(route, userModalService) {
        this.route = route;
        this.userModalService = userModalService;
    }
    UserDeleteDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.userModalService.open(UserMgmtDeleteDialogComponent, params['login']);
        });
    };
    UserDeleteDialogComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return UserDeleteDialogComponent;
}());
UserDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-user-delete-dialog',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        user_modal_service_1.UserModalService])
], UserDeleteDialogComponent);
exports.UserDeleteDialogComponent = UserDeleteDialogComponent;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var UserMgmtDetailComponent = (function () {
    function UserMgmtDetailComponent(jhiLanguageService, userService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.route = route;
        this.jhiLanguageService.setLocations(['user-management']);
    }
    UserMgmtDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['login']);
        });
    };
    UserMgmtDetailComponent.prototype.load = function (login) {
        var _this = this;
        this.userService.find(login).subscribe(function (user) {
            _this.user = user;
        });
    };
    UserMgmtDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return UserMgmtDetailComponent;
}());
UserMgmtDetailComponent = __decorate([
    core_1.Component({
        selector: 'dcs-user-mgmt-detail',
        template: __webpack_require__(267)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        router_1.ActivatedRoute])
], UserMgmtDetailComponent);
exports.UserMgmtDetailComponent = UserMgmtDetailComponent;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var user_modal_service_1 = __webpack_require__(32);
var shared_1 = __webpack_require__(3);
var UserMgmtDialogComponent = (function () {
    function UserMgmtDialogComponent(activeModal, languageHelper, jhiLanguageService, userService, eventManager) {
        this.activeModal = activeModal;
        this.languageHelper = languageHelper;
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.eventManager = eventManager;
    }
    UserMgmtDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.languageHelper.getAll().then(function (languages) {
            _this.languages = languages;
        });
        this.jhiLanguageService.setLocations(['user-management']);
    };
    UserMgmtDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    UserMgmtDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.user.id !== null) {
            this.userService.update(this.user).subscribe(function (response) { return _this.onSaveSuccess(response); }, function () { return _this.onSaveError(); });
        }
        else {
            this.userService.create(this.user).subscribe(function (response) { return _this.onSaveSuccess(response); }, function () { return _this.onSaveError(); });
        }
    };
    UserMgmtDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'userListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    UserMgmtDialogComponent.prototype.onSaveError = function () {
        this.isSaving = false;
    };
    return UserMgmtDialogComponent;
}());
UserMgmtDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-user-mgmt-dialog',
        template: __webpack_require__(268)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        shared_1.JhiLanguageHelper,
        ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        ng_jhipster_1.EventManager])
], UserMgmtDialogComponent);
exports.UserMgmtDialogComponent = UserMgmtDialogComponent;
var UserDialogComponent = (function () {
    function UserDialogComponent(route, userModalService) {
        this.route = route;
        this.userModalService = userModalService;
    }
    UserDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['login']) {
                _this.modalRef = _this.userModalService.open(UserMgmtDialogComponent, params['login']);
            }
            else {
                _this.modalRef = _this.userModalService.open(UserMgmtDialogComponent);
            }
        });
    };
    UserDialogComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return UserDialogComponent;
}());
UserDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-user-dialog',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        user_modal_service_1.UserModalService])
], UserDialogComponent);
exports.UserDialogComponent = UserDialogComponent;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(7);
var UserMgmtComponent = (function () {
    function UserMgmtComponent(jhiLanguageService, userService, parseLinks, alertService, principal, eventManager, paginationUtil, paginationConfig, activatedRoute, router) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.userService = userService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.jhiLanguageService.setLocations(['user-management']);
    }
    UserMgmtComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
            _this.loadAll();
            _this.registerChangeInUsers();
        });
    };
    UserMgmtComponent.prototype.ngOnDestroy = function () {
        this.routeData.unsubscribe();
    };
    UserMgmtComponent.prototype.registerChangeInUsers = function () {
        var _this = this;
        this.eventManager.subscribe('userListModification', function (response) { return _this.loadAll(); });
    };
    UserMgmtComponent.prototype.setActive = function (user, isActivated) {
        var _this = this;
        user.activated = isActivated;
        this.userService.update(user).subscribe(function (response) {
            if (response.status === 200) {
                _this.error = null;
                _this.success = 'OK';
                _this.loadAll();
            }
            else {
                _this.success = null;
                _this.error = 'ERROR';
            }
        });
    };
    UserMgmtComponent.prototype.loadAll = function () {
        var _this = this;
        this.userService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    UserMgmtComponent.prototype.trackIdentity = function (index, item) {
        return item.id;
    };
    UserMgmtComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    UserMgmtComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    UserMgmtComponent.prototype.transition = function () {
        this.router.navigate(['/user-management'], {
            queryParams: {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    UserMgmtComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.users = data;
    };
    UserMgmtComponent.prototype.onError = function (error) {
        this.alertService.error(error.error, error.message, null);
    };
    return UserMgmtComponent;
}());
UserMgmtComponent = __decorate([
    core_1.Component({
        selector: 'dcs-user-mgmt',
        template: __webpack_require__(269)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.UserService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        ng_jhipster_1.EventManager, ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig,
        router_1.ActivatedRoute,
        router_1.Router])
], UserMgmtComponent);
exports.UserMgmtComponent = UserMgmtComponent;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
__webpack_require__(323);
var language_service_1 = __webpack_require__(155);
var ng_jhipster_1 = __webpack_require__(1);
var principal_service_1 = __webpack_require__(18);
var event_manager_service_1 = __webpack_require__(157);
var seller_dashboard_service_1 = __webpack_require__(19);
var alert_service_1 = __webpack_require__(156);
var SellerDashboardComponent = (function () {
    function SellerDashboardComponent(jhiLanguageService, principal, eventManager, sellerService, alertService, dataUtils, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.principal = principal;
        this.eventManager = eventManager;
        this.sellerService = sellerService;
        this.alertService = alertService;
        this.dataUtils = dataUtils;
        this.route = route;
        this.upload = false;
        this.jhiLanguageService.setLocations(['seller']);
    }
    SellerDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.account = account;
        });
        this.load();
        this.sellerService.loadModels().subscribe(function (res) {
            _this.models = res.json();
        }, function (res) { return _this.onError(res.json()); });
        this.loadFiles();
    };
    SellerDashboardComponent.prototype.load = function () {
        var _this = this;
        this.sellerService.load().subscribe(function (seller) {
            _this.seller = seller;
            console.log(seller);
        });
    };
    SellerDashboardComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    SellerDashboardComponent.prototype.loadFiles = function () {
        var _this = this;
        this.sellerService.loadFiles().subscribe(function (res) {
            _this.files = res.json();
        }, function (res) { return _this.onError(res.json()); });
    };
    SellerDashboardComponent.prototype.showUpload = function () {
        this.upload = true;
        console.log(this.upload);
    };
    SellerDashboardComponent.prototype.onNotify = function (closeUpload) {
        this.upload = !closeUpload;
        this.loadFiles();
    };
    SellerDashboardComponent.prototype.touch = function () {
        var _this = this;
        this.sellerService.touch().subscribe(function (response) {
            console.log(response);
            _this.alertService.success('deviceConfigurerServiceApp.seller.dashboard.touch.title', null, null);
            _this.load();
        });
    };
    SellerDashboardComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    SellerDashboardComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    SellerDashboardComponent.prototype.removeFile = function (resource) {
        var _this = this;
        var c = confirm("Czy napewno chcesz usunąć plik '" + resource.fileName + "'?");
        if (c) {
            this.sellerService.removeFile(resource.id).subscribe(function (res) {
                if (res.ok) {
                    _this.loadFiles();
                }
            }, function (res) { return _this.onError(res.json()); });
            ;
        }
    };
    return SellerDashboardComponent;
}());
SellerDashboardComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-dashboard',
        template: __webpack_require__(271),
        styles: [".upload-new-file {\n    width: 20rem\n    }"]
    }),
    __metadata("design:paramtypes", [language_service_1.JhiLanguageService,
        principal_service_1.Principal,
        event_manager_service_1.EventManager,
        seller_dashboard_service_1.SellerDashboardService,
        alert_service_1.AlertService,
        ng_jhipster_1.DataUtils,
        router_1.ActivatedRoute])
], SellerDashboardComponent);
exports.SellerDashboardComponent = SellerDashboardComponent;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(8);
var router_1 = __webpack_require__(2);
var ngx_uploader_1 = __webpack_require__(49);
var seller_dashboard_component_1 = __webpack_require__(85);
var seller_dashboard_service_1 = __webpack_require__(19);
var shared_module_1 = __webpack_require__(146);
var seller_dashboard_route_1 = __webpack_require__(195);
var seller_model_component_1 = __webpack_require__(198);
var seller_chart_component_1 = __webpack_require__(194);
var seller_model_image_component_1 = __webpack_require__(197);
var seller_file_component_1 = __webpack_require__(196);
var SellerDashboardModule = (function () {
    function SellerDashboardModule() {
    }
    return SellerDashboardModule;
}());
SellerDashboardModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_module_1.DeviceConfigurerServiceSharedModule,
            ngx_uploader_1.NgUploaderModule,
            common_1.CommonModule,
            router_1.RouterModule.forRoot(seller_dashboard_route_1.sellerDashboardRoute, { useHash: true })
        ],
        declarations: [
            seller_dashboard_component_1.SellerDashboardComponent,
            seller_model_component_1.SellerModelComponent,
            seller_chart_component_1.SellerChartComponent,
            seller_model_image_component_1.SellerModelImageComponent,
            seller_file_component_1.SellerFileComponent
        ],
        exports: [
            seller_dashboard_component_1.SellerDashboardComponent
        ],
        providers: [
            seller_dashboard_service_1.SellerDashboardService
        ]
    })
], SellerDashboardModule);
exports.SellerDashboardModule = SellerDashboardModule;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var application_artatech_popup_service_1 = __webpack_require__(33);
var application_artatech_service_1 = __webpack_require__(11);
var ApplicationArtatechDeleteDialogComponent = (function () {
    function ApplicationArtatechDeleteDialogComponent(jhiLanguageService, applicationService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.applicationService = applicationService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['application']);
    }
    ApplicationArtatechDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ApplicationArtatechDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.applicationService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'applicationListModification',
                content: 'Deleted an application'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return ApplicationArtatechDeleteDialogComponent;
}());
ApplicationArtatechDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-application-artatech-delete-dialog',
        template: __webpack_require__(275)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        application_artatech_service_1.ApplicationArtatechService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], ApplicationArtatechDeleteDialogComponent);
exports.ApplicationArtatechDeleteDialogComponent = ApplicationArtatechDeleteDialogComponent;
var ApplicationArtatechDeletePopupComponent = (function () {
    function ApplicationArtatechDeletePopupComponent(route, applicationPopupService) {
        this.route = route;
        this.applicationPopupService = applicationPopupService;
    }
    ApplicationArtatechDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.applicationPopupService
                .open(ApplicationArtatechDeleteDialogComponent, params['id']);
        });
    };
    ApplicationArtatechDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ApplicationArtatechDeletePopupComponent;
}());
ApplicationArtatechDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-application-artatech-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        application_artatech_popup_service_1.ApplicationArtatechPopupService])
], ApplicationArtatechDeletePopupComponent);
exports.ApplicationArtatechDeletePopupComponent = ApplicationArtatechDeletePopupComponent;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var application_artatech_service_1 = __webpack_require__(11);
var ApplicationArtatechDetailComponent = (function () {
    function ApplicationArtatechDetailComponent(jhiLanguageService, applicationService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.applicationService = applicationService;
        this.route = route;
        this.jhiLanguageService.setLocations(['application']);
    }
    ApplicationArtatechDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
    };
    ApplicationArtatechDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.applicationService.find(id).subscribe(function (application) {
            _this.application = application;
        });
    };
    ApplicationArtatechDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    ApplicationArtatechDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return ApplicationArtatechDetailComponent;
}());
ApplicationArtatechDetailComponent = __decorate([
    core_1.Component({
        selector: 'dcs-application-artatech-detail',
        template: __webpack_require__(276)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        application_artatech_service_1.ApplicationArtatechService,
        router_1.ActivatedRoute])
], ApplicationArtatechDetailComponent);
exports.ApplicationArtatechDetailComponent = ApplicationArtatechDetailComponent;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var application_artatech_popup_service_1 = __webpack_require__(33);
var application_artatech_service_1 = __webpack_require__(11);
var ApplicationArtatechDialogComponent = (function () {
    function ApplicationArtatechDialogComponent(activeModal, jhiLanguageService, alertService, applicationService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.applicationService = applicationService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['application']);
    }
    ApplicationArtatechDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.applicationService.findLocalFiles()
            .subscribe(function (res) {
            _this.localFiles = res.json();
            console.log(_this.localFiles);
        });
    };
    ApplicationArtatechDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ApplicationArtatechDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.application.id !== undefined) {
            this.applicationService.update(this.application)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.applicationService.create(this.application)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    ApplicationArtatechDialogComponent.prototype.onSelectLocal = function (event) {
        console.log(this.selected);
        this.application.downloadUrl = this.selected.downloadUrl;
        this.application.name = this.selected.name;
        this.application.packageName = this.selected.packageName;
    };
    ApplicationArtatechDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'applicationListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    ApplicationArtatechDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    ApplicationArtatechDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ApplicationArtatechDialogComponent;
}());
ApplicationArtatechDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-application-artatech-dialog',
        template: __webpack_require__(277)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        application_artatech_service_1.ApplicationArtatechService,
        ng_jhipster_1.EventManager])
], ApplicationArtatechDialogComponent);
exports.ApplicationArtatechDialogComponent = ApplicationArtatechDialogComponent;
var ApplicationArtatechPopupComponent = (function () {
    function ApplicationArtatechPopupComponent(route, applicationPopupService) {
        this.route = route;
        this.applicationPopupService = applicationPopupService;
    }
    ApplicationArtatechPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.applicationPopupService
                    .open(ApplicationArtatechDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.applicationPopupService
                    .open(ApplicationArtatechDialogComponent);
            }
        });
    };
    ApplicationArtatechPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ApplicationArtatechPopupComponent;
}());
ApplicationArtatechPopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-application-artatech-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        application_artatech_popup_service_1.ApplicationArtatechPopupService])
], ApplicationArtatechPopupComponent);
exports.ApplicationArtatechPopupComponent = ApplicationArtatechPopupComponent;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var application_artatech_service_1 = __webpack_require__(11);
var shared_1 = __webpack_require__(3);
var ApplicationArtatechComponent = (function () {
    function ApplicationArtatechComponent(jhiLanguageService, applicationService, alertService, eventManager, parseLinks, activatedRoute, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.applicationService = applicationService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.parseLinks = parseLinks;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.applications = [];
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.page = 0;
        this.links = {
            last: 0
        };
        this.predicate = 'id';
        this.reverse = true;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['application']);
    }
    ApplicationArtatechComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.applicationService.search({
                query: this.currentSearch,
                page: this.page,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.applicationService.query({
            page: this.page,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    ApplicationArtatechComponent.prototype.reset = function () {
        this.page = 0;
        this.applications = [];
        this.loadAll();
    };
    ApplicationArtatechComponent.prototype.loadPage = function (page) {
        this.page = page;
        this.loadAll();
    };
    ApplicationArtatechComponent.prototype.clear = function () {
        this.applications = [];
        this.links = {
            last: 0
        };
        this.page = 0;
        this.predicate = 'id';
        this.reverse = true;
        this.currentSearch = '';
        this.loadAll();
    };
    ApplicationArtatechComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.applications = [];
        this.links = {
            last: 0
        };
        this.page = 0;
        this.predicate = '_score';
        this.reverse = false;
        this.currentSearch = query;
        this.loadAll();
    };
    ApplicationArtatechComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInApplications();
    };
    ApplicationArtatechComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    ApplicationArtatechComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    ApplicationArtatechComponent.prototype.registerChangeInApplications = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('applicationListModification', function (response) { return _this.reset(); });
    };
    ApplicationArtatechComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    ApplicationArtatechComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        for (var i = 0; i < data.length; i++) {
            this.applications.push(data[i]);
        }
    };
    ApplicationArtatechComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ApplicationArtatechComponent;
}());
ApplicationArtatechComponent = __decorate([
    core_1.Component({
        selector: 'dcs-application-artatech',
        template: __webpack_require__(278)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        application_artatech_service_1.ApplicationArtatechService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.ParseLinks,
        router_1.ActivatedRoute,
        shared_1.Principal])
], ApplicationArtatechComponent);
exports.ApplicationArtatechComponent = ApplicationArtatechComponent;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ApplicationArtatech = (function () {
    function ApplicationArtatech(id, name, packageName, description, downloadUrl, md5, lastModificationDate, hash, hashType) {
        this.id = id;
        this.name = name;
        this.packageName = packageName;
        this.description = description;
        this.downloadUrl = downloadUrl;
        this.md5 = md5;
        this.lastModificationDate = lastModificationDate;
        this.hash = hash;
        this.hashType = hashType;
    }
    return ApplicationArtatech;
}());
exports.ApplicationArtatech = ApplicationArtatech;
var LocalFile = (function () {
    function LocalFile(localFileName, url) {
        this.localFileName = localFileName;
        this.url = url;
    }
    return LocalFile;
}());
exports.LocalFile = LocalFile;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(91));
__export(__webpack_require__(33));
__export(__webpack_require__(11));
__export(__webpack_require__(89));
__export(__webpack_require__(87));
__export(__webpack_require__(88));
__export(__webpack_require__(90));
__export(__webpack_require__(200));


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var device_popup_service_1 = __webpack_require__(34);
var device_service_1 = __webpack_require__(9);
var DeviceDeleteDialogComponent = (function () {
    function DeviceDeleteDialogComponent(jhiLanguageService, deviceService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.deviceService = deviceService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['device']);
    }
    DeviceDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    DeviceDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.deviceService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'deviceListModification',
                content: 'Deleted an device'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return DeviceDeleteDialogComponent;
}());
DeviceDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-device-delete-dialog',
        template: __webpack_require__(279)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        device_service_1.DeviceService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], DeviceDeleteDialogComponent);
exports.DeviceDeleteDialogComponent = DeviceDeleteDialogComponent;
var DeviceDeletePopupComponent = (function () {
    function DeviceDeletePopupComponent(route, devicePopupService) {
        this.route = route;
        this.devicePopupService = devicePopupService;
    }
    DeviceDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.devicePopupService
                .open(DeviceDeleteDialogComponent, params['id']);
        });
    };
    DeviceDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return DeviceDeletePopupComponent;
}());
DeviceDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-device-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        device_popup_service_1.DevicePopupService])
], DeviceDeletePopupComponent);
exports.DeviceDeletePopupComponent = DeviceDeletePopupComponent;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var device_service_1 = __webpack_require__(9);
var DeviceDetailComponent = (function () {
    function DeviceDetailComponent(jhiLanguageService, deviceService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.deviceService = deviceService;
        this.route = route;
        this.jhiLanguageService.setLocations(['device']);
    }
    DeviceDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
    };
    DeviceDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.deviceService.find(id).subscribe(function (device) {
            _this.device = device;
        });
    };
    DeviceDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    DeviceDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return DeviceDetailComponent;
}());
DeviceDetailComponent = __decorate([
    core_1.Component({
        selector: 'dcs-device-detail',
        template: __webpack_require__(280)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        device_service_1.DeviceService,
        router_1.ActivatedRoute])
], DeviceDetailComponent);
exports.DeviceDetailComponent = DeviceDetailComponent;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var device_popup_service_1 = __webpack_require__(34);
var device_service_1 = __webpack_require__(9);
var seller_1 = __webpack_require__(20);
var DeviceDialogComponent = (function () {
    function DeviceDialogComponent(activeModal, jhiLanguageService, alertService, deviceService, sellerService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.deviceService = deviceService;
        this.sellerService = sellerService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['device']);
    }
    DeviceDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.sellerService.query().subscribe(function (res) { _this.sellers = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    DeviceDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    DeviceDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.device.id !== undefined) {
            this.deviceService.update(this.device)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.deviceService.create(this.device)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    DeviceDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'deviceListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    DeviceDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    DeviceDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    DeviceDialogComponent.prototype.trackSellerById = function (index, item) {
        return item.id;
    };
    return DeviceDialogComponent;
}());
DeviceDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-device-dialog',
        template: __webpack_require__(281)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        device_service_1.DeviceService,
        seller_1.SellerService,
        ng_jhipster_1.EventManager])
], DeviceDialogComponent);
exports.DeviceDialogComponent = DeviceDialogComponent;
var DevicePopupComponent = (function () {
    function DevicePopupComponent(route, devicePopupService) {
        this.route = route;
        this.devicePopupService = devicePopupService;
    }
    DevicePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.devicePopupService
                    .open(DeviceDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.devicePopupService
                    .open(DeviceDialogComponent);
            }
        });
    };
    DevicePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return DevicePopupComponent;
}());
DevicePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-device-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        device_popup_service_1.DevicePopupService])
], DevicePopupComponent);
exports.DevicePopupComponent = DevicePopupComponent;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var device_service_1 = __webpack_require__(9);
var seller_1 = __webpack_require__(20);
var ng_jhipster_1 = __webpack_require__(1);
var DeviceImportComponent = (function () {
    function DeviceImportComponent(jhiLanguageService, router, alertService, deviceService, sellerService, eventManager, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.router = router;
        this.alertService = alertService;
        this.deviceService = deviceService;
        this.sellerService = sellerService;
        this.eventManager = eventManager;
        this.route = route;
        this.show = {
            danger: true,
            warning: true,
            info: true,
            success: true
        };
        this.devices = {
            sn: '',
            seller: null,
            force: false
        };
        this.jhiLanguageService.setLocations(['device']);
    }
    DeviceImportComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_ADMIN'];
        this.sellerService.query({
            page: 0,
            size: 99999,
            sort: ['name,' + 'asc', 'id']
        }).subscribe(function (res) {
            _this.sellers = res.json();
            console.log(_this.sellers);
        }, function (res) { return _this.onError(res.json()); });
        this.type = this.route.snapshot.data['type'];
    };
    DeviceImportComponent.prototype.save = function () {
        var _this = this;
        console.log(this.devices);
        if (confirm('Are you sure?')) {
            this.isSaving = true;
            if (this.type === 'import') {
                this.deviceService.addMany(this.devices)
                    .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
            }
            else if (this.type === 'delete') {
                this.deviceService.deleteMany(this.devices)
                    .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
            }
        }
    };
    DeviceImportComponent.prototype.onSaveSuccess = function (result) {
        this.isSaving = false;
        console.log(result);
        if (result.length > 0) {
            this.reports = result;
        }
        else {
            this.eventManager.broadcast({ name: 'deviceListModification', content: 'OK' });
            this.isSaving = false;
            this.clear();
        }
    };
    DeviceImportComponent.prototype.clear = function () {
        this.router.navigate(['/device']);
    };
    DeviceImportComponent.prototype.canShowStatus = function (status) {
        return true;
    };
    DeviceImportComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    DeviceImportComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    DeviceImportComponent.prototype.trackSellerById = function (index, item) {
        return item.id;
    };
    return DeviceImportComponent;
}());
DeviceImportComponent = __decorate([
    core_1.Component({
        selector: 'dcs-device-import',
        template: __webpack_require__(282)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        router_1.Router,
        ng_jhipster_1.AlertService,
        device_service_1.DeviceService,
        seller_1.SellerService,
        ng_jhipster_1.EventManager,
        router_1.ActivatedRoute])
], DeviceImportComponent);
exports.DeviceImportComponent = DeviceImportComponent;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var device_service_1 = __webpack_require__(9);
var shared_1 = __webpack_require__(3);
var DeviceComponent = (function () {
    function DeviceComponent(jhiLanguageService, deviceService, alertService, eventManager, parseLinks, activatedRoute, principal) {
        this.jhiLanguageService = jhiLanguageService;
        this.deviceService = deviceService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.parseLinks = parseLinks;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.devices = [];
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.page = 0;
        this.links = {
            last: 0
        };
        this.predicate = 'id';
        this.reverse = true;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['device']);
    }
    DeviceComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.deviceService.search({
                query: this.currentSearch,
                page: this.page,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.deviceService.query({
            page: this.page,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    DeviceComponent.prototype.reset = function () {
        this.page = 0;
        this.devices = [];
        this.loadAll();
    };
    DeviceComponent.prototype.loadPage = function (page) {
        this.page = page;
        this.loadAll();
    };
    DeviceComponent.prototype.clear = function () {
        this.devices = [];
        this.links = {
            last: 0
        };
        this.page = 0;
        this.predicate = 'id';
        this.reverse = true;
        this.currentSearch = '';
        this.loadAll();
    };
    DeviceComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.devices = [];
        this.links = {
            last: 0
        };
        this.page = 0;
        this.predicate = '_score';
        this.reverse = false;
        this.currentSearch = query;
        this.loadAll();
    };
    DeviceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInDevices();
    };
    DeviceComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    DeviceComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    DeviceComponent.prototype.registerChangeInDevices = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('deviceListModification', function (response) { return _this.reset(); });
    };
    DeviceComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    DeviceComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        for (var i = 0; i < data.length; i++) {
            this.devices.push(data[i]);
        }
    };
    DeviceComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return DeviceComponent;
}());
DeviceComponent = __decorate([
    core_1.Component({
        selector: 'dcs-device',
        template: __webpack_require__(283),
        styles: ["\n    .button-margin {\n        margin-left: 5px;\n    }\n    "]
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        device_service_1.DeviceService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.ParseLinks,
        router_1.ActivatedRoute,
        shared_1.Principal])
], DeviceComponent);
exports.DeviceComponent = DeviceComponent;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Device = (function () {
    function Device(id, sn, activated, activationDate, activatedFromIp, seller) {
        this.id = id;
        this.sn = sn;
        this.activated = activated;
        this.activationDate = activationDate;
        this.activatedFromIp = activatedFromIp;
        this.seller = seller;
        this.activated = false;
    }
    return Device;
}());
exports.Device = Device;
var DeviceReport = (function () {
    function DeviceReport(sn, message, status) {
        this.sn = sn;
        this.message = message;
        this.status = status;
    }
    return DeviceReport;
}());
exports.DeviceReport = DeviceReport;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(98));
__export(__webpack_require__(34));
__export(__webpack_require__(9));
__export(__webpack_require__(95));
__export(__webpack_require__(93));
__export(__webpack_require__(94));
__export(__webpack_require__(97));
__export(__webpack_require__(202));


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var feed_popup_service_1 = __webpack_require__(35);
var feed_service_1 = __webpack_require__(12);
var FeedDeleteDialogComponent = (function () {
    function FeedDeleteDialogComponent(feedService, activeModal, eventManager) {
        this.feedService = feedService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
    }
    FeedDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    FeedDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.feedService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'feedListModification',
                content: 'Deleted an feed'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return FeedDeleteDialogComponent;
}());
FeedDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-feed-delete-dialog',
        template: __webpack_require__(284)
    }),
    __metadata("design:paramtypes", [feed_service_1.FeedService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], FeedDeleteDialogComponent);
exports.FeedDeleteDialogComponent = FeedDeleteDialogComponent;
var FeedDeletePopupComponent = (function () {
    function FeedDeletePopupComponent(route, feedPopupService) {
        this.route = route;
        this.feedPopupService = feedPopupService;
    }
    FeedDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.feedPopupService
                .open(FeedDeleteDialogComponent, params['id']);
        });
    };
    FeedDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return FeedDeletePopupComponent;
}());
FeedDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-feed-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        feed_popup_service_1.FeedPopupService])
], FeedDeletePopupComponent);
exports.FeedDeletePopupComponent = FeedDeletePopupComponent;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var feed_service_1 = __webpack_require__(12);
var FeedDetailComponent = (function () {
    function FeedDetailComponent(eventManager, feedService, route) {
        this.eventManager = eventManager;
        this.feedService = feedService;
        this.route = route;
    }
    FeedDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
        this.registerChangeInFeeds();
    };
    FeedDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.feedService.find(id).subscribe(function (feed) {
            _this.feed = feed;
        });
    };
    FeedDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    FeedDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    };
    FeedDetailComponent.prototype.registerChangeInFeeds = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('feedListModification', function (response) { return _this.load(_this.feed.id); });
    };
    return FeedDetailComponent;
}());
FeedDetailComponent = __decorate([
    core_1.Component({
        selector: 'dcs-feed-detail',
        template: __webpack_require__(285)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        feed_service_1.FeedService,
        router_1.ActivatedRoute])
], FeedDetailComponent);
exports.FeedDetailComponent = FeedDetailComponent;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var feed_popup_service_1 = __webpack_require__(35);
var feed_service_1 = __webpack_require__(12);
var FeedDialogComponent = (function () {
    function FeedDialogComponent(activeModal, alertService, feedService, eventManager) {
        this.activeModal = activeModal;
        this.alertService = alertService;
        this.feedService = feedService;
        this.eventManager = eventManager;
    }
    FeedDialogComponent.prototype.ngOnInit = function () {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    };
    FeedDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    FeedDialogComponent.prototype.save = function () {
        this.isSaving = true;
        if (this.feed.id !== undefined) {
            this.subscribeToSaveResponse(this.feedService.update(this.feed));
        }
        else {
            this.subscribeToSaveResponse(this.feedService.create(this.feed));
        }
    };
    FeedDialogComponent.prototype.subscribeToSaveResponse = function (result) {
        var _this = this;
        result.subscribe(function (res) {
            return _this.onSaveSuccess(res);
        }, function (res) { return _this.onSaveError(res); });
    };
    FeedDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'feedListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    FeedDialogComponent.prototype.onSaveError = function (error) {
        try {
            error.json();
        }
        catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    };
    FeedDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return FeedDialogComponent;
}());
FeedDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-feed-dialog',
        template: __webpack_require__(286)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.AlertService,
        feed_service_1.FeedService,
        ng_jhipster_1.EventManager])
], FeedDialogComponent);
exports.FeedDialogComponent = FeedDialogComponent;
var FeedPopupComponent = (function () {
    function FeedPopupComponent(route, feedPopupService) {
        this.route = route;
        this.feedPopupService = feedPopupService;
    }
    FeedPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.feedPopupService
                    .open(FeedDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.feedPopupService
                    .open(FeedDialogComponent);
            }
        });
    };
    FeedPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return FeedPopupComponent;
}());
FeedPopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-feed-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        feed_popup_service_1.FeedPopupService])
], FeedPopupComponent);
exports.FeedPopupComponent = FeedPopupComponent;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var feed_service_1 = __webpack_require__(12);
var shared_1 = __webpack_require__(3);
var FeedComponent = (function () {
    function FeedComponent(feedService, alertService, eventManager, parseLinks, activatedRoute, principal) {
        this.feedService = feedService;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.parseLinks = parseLinks;
        this.activatedRoute = activatedRoute;
        this.principal = principal;
        this.feeds = [];
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.page = 0;
        this.links = {
            last: 0
        };
        this.predicate = 'id';
        this.reverse = true;
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
    }
    FeedComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.feedService.search({
                query: this.currentSearch,
                page: this.page,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.feedService.query({
            page: this.page,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    FeedComponent.prototype.reset = function () {
        this.page = 0;
        this.feeds = [];
        this.loadAll();
    };
    FeedComponent.prototype.loadPage = function (page) {
        this.page = page;
        this.loadAll();
    };
    FeedComponent.prototype.clear = function () {
        this.feeds = [];
        this.links = {
            last: 0
        };
        this.page = 0;
        this.predicate = 'id';
        this.reverse = true;
        this.currentSearch = '';
        this.loadAll();
    };
    FeedComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.feeds = [];
        this.links = {
            last: 0
        };
        this.page = 0;
        this.predicate = '_score';
        this.reverse = false;
        this.currentSearch = query;
        this.loadAll();
    };
    FeedComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInFeeds();
    };
    FeedComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    FeedComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    FeedComponent.prototype.registerChangeInFeeds = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('feedListModification', function (response) { return _this.reset(); });
    };
    FeedComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    FeedComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        for (var i = 0; i < data.length; i++) {
            this.feeds.push(data[i]);
        }
    };
    FeedComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return FeedComponent;
}());
FeedComponent = __decorate([
    core_1.Component({
        selector: 'dcs-feed',
        template: __webpack_require__(287)
    }),
    __metadata("design:paramtypes", [feed_service_1.FeedService,
        ng_jhipster_1.AlertService,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.ParseLinks,
        router_1.ActivatedRoute,
        shared_1.Principal])
], FeedComponent);
exports.FeedComponent = FeedComponent;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Feed = (function () {
    function Feed(id, name, location, index) {
        this.id = id;
        this.name = name;
        this.location = location;
        this.index = index;
    }
    return Feed;
}());
exports.Feed = Feed;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var image_resource_popup_service_1 = __webpack_require__(36);
var image_resource_service_1 = __webpack_require__(13);
var ImageResourceDeleteDialogComponent = (function () {
    function ImageResourceDeleteDialogComponent(jhiLanguageService, imageResourceService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.imageResourceService = imageResourceService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['imageResource']);
    }
    ImageResourceDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ImageResourceDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.imageResourceService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'imageResourceListModification',
                content: 'Deleted an imageResource'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return ImageResourceDeleteDialogComponent;
}());
ImageResourceDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-image-resource-delete-dialog',
        template: __webpack_require__(288)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        image_resource_service_1.ImageResourceService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], ImageResourceDeleteDialogComponent);
exports.ImageResourceDeleteDialogComponent = ImageResourceDeleteDialogComponent;
var ImageResourceDeletePopupComponent = (function () {
    function ImageResourceDeletePopupComponent(route, imageResourcePopupService) {
        this.route = route;
        this.imageResourcePopupService = imageResourcePopupService;
    }
    ImageResourceDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.imageResourcePopupService
                .open(ImageResourceDeleteDialogComponent, params['id']);
        });
    };
    ImageResourceDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ImageResourceDeletePopupComponent;
}());
ImageResourceDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-image-resource-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        image_resource_popup_service_1.ImageResourcePopupService])
], ImageResourceDeletePopupComponent);
exports.ImageResourceDeletePopupComponent = ImageResourceDeletePopupComponent;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var image_resource_service_1 = __webpack_require__(13);
var ImageResourceDetailComponent = (function () {
    function ImageResourceDetailComponent(jhiLanguageService, dataUtils, imageResourceService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.dataUtils = dataUtils;
        this.imageResourceService = imageResourceService;
        this.route = route;
        this.jhiLanguageService.setLocations(['imageResource']);
    }
    ImageResourceDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
    };
    ImageResourceDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.imageResourceService.find(id).subscribe(function (imageResource) {
            _this.imageResource = imageResource;
        });
    };
    ImageResourceDetailComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    ImageResourceDetailComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    ImageResourceDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    ImageResourceDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return ImageResourceDetailComponent;
}());
ImageResourceDetailComponent = __decorate([
    core_1.Component({
        selector: 'dcs-image-resource-detail',
        template: __webpack_require__(289)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.DataUtils,
        image_resource_service_1.ImageResourceService,
        router_1.ActivatedRoute])
], ImageResourceDetailComponent);
exports.ImageResourceDetailComponent = ImageResourceDetailComponent;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var image_resource_popup_service_1 = __webpack_require__(36);
var image_resource_service_1 = __webpack_require__(13);
var ImageResourceDialogComponent = (function () {
    function ImageResourceDialogComponent(activeModal, jhiLanguageService, dataUtils, alertService, imageResourceService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.dataUtils = dataUtils;
        this.alertService = alertService;
        this.imageResourceService = imageResourceService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['imageResource']);
    }
    ImageResourceDialogComponent.prototype.ngOnInit = function () {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    };
    ImageResourceDialogComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    ImageResourceDialogComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    ImageResourceDialogComponent.prototype.setFileData = function ($event, imageResource, field, isImage) {
        if ($event.target.files && $event.target.files[0]) {
            var $file_1 = $event.target.files[0];
            if (isImage && !/^image\//.test($file_1.type)) {
                return;
            }
            this.dataUtils.toBase64($file_1, function (base64Data) {
                imageResource[field] = base64Data;
                imageResource[field + "ContentType"] = $file_1.type;
            });
        }
    };
    ImageResourceDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ImageResourceDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.imageResource.id !== undefined) {
            this.imageResourceService.update(this.imageResource)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.imageResourceService.create(this.imageResource)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    ImageResourceDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'imageResourceListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    ImageResourceDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    ImageResourceDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ImageResourceDialogComponent;
}());
ImageResourceDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-image-resource-dialog',
        template: __webpack_require__(290)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.DataUtils,
        ng_jhipster_1.AlertService,
        image_resource_service_1.ImageResourceService,
        ng_jhipster_1.EventManager])
], ImageResourceDialogComponent);
exports.ImageResourceDialogComponent = ImageResourceDialogComponent;
var ImageResourcePopupComponent = (function () {
    function ImageResourcePopupComponent(route, imageResourcePopupService) {
        this.route = route;
        this.imageResourcePopupService = imageResourcePopupService;
    }
    ImageResourcePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.imageResourcePopupService
                    .open(ImageResourceDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.imageResourcePopupService
                    .open(ImageResourceDialogComponent);
            }
        });
    };
    ImageResourcePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ImageResourcePopupComponent;
}());
ImageResourcePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-image-resource-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        image_resource_popup_service_1.ImageResourcePopupService])
], ImageResourcePopupComponent);
exports.ImageResourcePopupComponent = ImageResourcePopupComponent;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var image_resource_service_1 = __webpack_require__(13);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(7);
var ImageResourceComponent = (function () {
    function ImageResourceComponent(jhiLanguageService, imageResourceService, parseLinks, alertService, principal, activatedRoute, dataUtils, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.imageResourceService = imageResourceService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.dataUtils = dataUtils;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['imageResource']);
    }
    ImageResourceComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.imageResourceService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.imageResourceService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    ImageResourceComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    ImageResourceComponent.prototype.transition = function () {
        this.router.navigate(['/image-resource'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    ImageResourceComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/image-resource', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ImageResourceComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/image-resource', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ImageResourceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInImageResources();
    };
    ImageResourceComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    ImageResourceComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    ImageResourceComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    ImageResourceComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    ImageResourceComponent.prototype.registerChangeInImageResources = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('imageResourceListModification', function (response) { return _this.loadAll(); });
    };
    ImageResourceComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    ImageResourceComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.imageResources = data;
    };
    ImageResourceComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ImageResourceComponent;
}());
ImageResourceComponent = __decorate([
    core_1.Component({
        selector: 'dcs-image-resource',
        template: __webpack_require__(291)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        image_resource_service_1.ImageResourceService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        ng_jhipster_1.DataUtils,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], ImageResourceComponent);
exports.ImageResourceComponent = ImageResourceComponent;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(37));
__export(__webpack_require__(36));
__export(__webpack_require__(13));
__export(__webpack_require__(107));
__export(__webpack_require__(105));
__export(__webpack_require__(106));
__export(__webpack_require__(108));
__export(__webpack_require__(208));


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var log_popup_service_1 = __webpack_require__(38);
var log_service_1 = __webpack_require__(14);
var LogDeleteDialogComponent = (function () {
    function LogDeleteDialogComponent(jhiLanguageService, logService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.logService = logService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['log']);
    }
    LogDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    LogDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.logService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'logListModification',
                content: 'Deleted an log'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return LogDeleteDialogComponent;
}());
LogDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-log-delete-dialog',
        template: __webpack_require__(292)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        log_service_1.LogService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], LogDeleteDialogComponent);
exports.LogDeleteDialogComponent = LogDeleteDialogComponent;
var LogDeletePopupComponent = (function () {
    function LogDeletePopupComponent(route, logPopupService) {
        this.route = route;
        this.logPopupService = logPopupService;
    }
    LogDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.logPopupService
                .open(LogDeleteDialogComponent, params['id']);
        });
    };
    LogDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return LogDeletePopupComponent;
}());
LogDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-log-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        log_popup_service_1.LogPopupService])
], LogDeletePopupComponent);
exports.LogDeletePopupComponent = LogDeletePopupComponent;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var log_service_1 = __webpack_require__(14);
var LogDetailComponent = (function () {
    function LogDetailComponent(jhiLanguageService, logService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.logService = logService;
        this.route = route;
        this.jhiLanguageService.setLocations(['log']);
    }
    LogDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
    };
    LogDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.logService.find(id).subscribe(function (log) {
            _this.log = log;
        });
    };
    LogDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    LogDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return LogDetailComponent;
}());
LogDetailComponent = __decorate([
    core_1.Component({
        selector: 'dcs-log-detail',
        template: __webpack_require__(293)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        log_service_1.LogService,
        router_1.ActivatedRoute])
], LogDetailComponent);
exports.LogDetailComponent = LogDetailComponent;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var log_popup_service_1 = __webpack_require__(38);
var log_service_1 = __webpack_require__(14);
var LogDialogComponent = (function () {
    function LogDialogComponent(activeModal, jhiLanguageService, alertService, logService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.logService = logService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['log']);
    }
    LogDialogComponent.prototype.ngOnInit = function () {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    };
    LogDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    LogDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.log.id !== undefined) {
            this.logService.update(this.log)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.logService.create(this.log)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    LogDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'logListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    LogDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    LogDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return LogDialogComponent;
}());
LogDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-log-dialog',
        template: __webpack_require__(294)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        log_service_1.LogService,
        ng_jhipster_1.EventManager])
], LogDialogComponent);
exports.LogDialogComponent = LogDialogComponent;
var LogPopupComponent = (function () {
    function LogPopupComponent(route, logPopupService) {
        this.route = route;
        this.logPopupService = logPopupService;
    }
    LogPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.logPopupService
                    .open(LogDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.logPopupService
                    .open(LogDialogComponent);
            }
        });
    };
    LogPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return LogPopupComponent;
}());
LogPopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-log-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        log_popup_service_1.LogPopupService])
], LogPopupComponent);
exports.LogPopupComponent = LogPopupComponent;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var log_service_1 = __webpack_require__(14);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(7);
var LogComponent = (function () {
    function LogComponent(jhiLanguageService, logService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.logService = logService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['log']);
    }
    LogComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.logService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.logService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    LogComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    LogComponent.prototype.transition = function () {
        this.router.navigate(['/log'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    LogComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/log', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    LogComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/log', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    LogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInLogs();
    };
    LogComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    LogComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    LogComponent.prototype.registerChangeInLogs = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('logListModification', function (response) { return _this.loadAll(); });
    };
    LogComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    LogComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.logs = data;
    };
    LogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return LogComponent;
}());
LogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-log',
        template: __webpack_require__(295)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        log_service_1.LogService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], LogComponent);
exports.LogComponent = LogComponent;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Log = (function () {
    function Log(id, value) {
        this.id = id;
        this.value = value;
    }
    return Log;
}());
exports.Log = Log;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(120));
__export(__webpack_require__(39));
__export(__webpack_require__(15));
__export(__webpack_require__(118));
__export(__webpack_require__(116));
__export(__webpack_require__(117));
__export(__webpack_require__(119));
__export(__webpack_require__(213));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var model_image_popup_service_1 = __webpack_require__(39);
var model_image_service_1 = __webpack_require__(15);
var ModelImageDeleteDialogComponent = (function () {
    function ModelImageDeleteDialogComponent(jhiLanguageService, modelImageService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.modelImageService = modelImageService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['modelImage']);
    }
    ModelImageDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ModelImageDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.modelImageService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'modelImageListModification',
                content: 'Deleted an modelImage'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return ModelImageDeleteDialogComponent;
}());
ModelImageDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model-image-delete-dialog',
        template: __webpack_require__(296)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        model_image_service_1.ModelImageService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], ModelImageDeleteDialogComponent);
exports.ModelImageDeleteDialogComponent = ModelImageDeleteDialogComponent;
var ModelImageDeletePopupComponent = (function () {
    function ModelImageDeletePopupComponent(route, modelImagePopupService) {
        this.route = route;
        this.modelImagePopupService = modelImagePopupService;
    }
    ModelImageDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.modelImagePopupService
                .open(ModelImageDeleteDialogComponent, params['id']);
        });
    };
    ModelImageDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ModelImageDeletePopupComponent;
}());
ModelImageDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model-image-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        model_image_popup_service_1.ModelImagePopupService])
], ModelImageDeletePopupComponent);
exports.ModelImageDeletePopupComponent = ModelImageDeletePopupComponent;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var model_image_service_1 = __webpack_require__(15);
var ModelImageDetailComponent = (function () {
    function ModelImageDetailComponent(jhiLanguageService, modelImageService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.modelImageService = modelImageService;
        this.route = route;
        this.jhiLanguageService.setLocations(['modelImage']);
    }
    ModelImageDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
    };
    ModelImageDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.modelImageService.find(id).subscribe(function (modelImage) {
            _this.modelImage = modelImage;
        });
    };
    ModelImageDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    ModelImageDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return ModelImageDetailComponent;
}());
ModelImageDetailComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model-image-detail',
        template: __webpack_require__(297)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        model_image_service_1.ModelImageService,
        router_1.ActivatedRoute])
], ModelImageDetailComponent);
exports.ModelImageDetailComponent = ModelImageDetailComponent;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var model_image_popup_service_1 = __webpack_require__(39);
var model_image_service_1 = __webpack_require__(15);
var image_resource_1 = __webpack_require__(109);
var seller_1 = __webpack_require__(20);
var model_1 = __webpack_require__(121);
var ModelImageDialogComponent = (function () {
    function ModelImageDialogComponent(activeModal, jhiLanguageService, alertService, modelImageService, imageResourceService, sellerService, modelService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.modelImageService = modelImageService;
        this.imageResourceService = imageResourceService;
        this.sellerService = sellerService;
        this.modelService = modelService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['modelImage']);
    }
    ModelImageDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.imageResourceService.query({ filter: 'modelimage-is-null' }).subscribe(function (res) {
            if (!_this.modelImage.shutdownscreen || !_this.modelImage.shutdownscreen.id) {
                _this.shutdownscreens = res.json();
            }
            else {
                _this.imageResourceService.find(_this.modelImage.shutdownscreen.id).subscribe(function (subRes) {
                    _this.shutdownscreens = [subRes].concat(res.json());
                }, function (subRes) { return _this.onError(subRes.json()); });
            }
        }, function (res) { return _this.onError(res.json()); });
        this.imageResourceService.query({ filter: 'modelimage-is-null' }).subscribe(function (res) {
            if (!_this.modelImage.shutdownscreenNoPower || !_this.modelImage.shutdownscreenNoPower.id) {
                _this.shutdownscreennopowers = res.json();
            }
            else {
                _this.imageResourceService.find(_this.modelImage.shutdownscreenNoPower.id).subscribe(function (subRes) {
                    _this.shutdownscreennopowers = [subRes].concat(res.json());
                }, function (subRes) { return _this.onError(subRes.json()); });
            }
        }, function (res) { return _this.onError(res.json()); });
        this.imageResourceService.query().subscribe(function (res) {
            _this.imageresources = res.json();
        }, function (res) { return _this.onError(res.json()); });
        this.sellerService.query().subscribe(function (res) { _this.sellers = res.json(); }, function (res) { return _this.onError(res.json()); });
        this.modelService.query().subscribe(function (res) { _this.models = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    ModelImageDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ModelImageDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.modelImage.id !== undefined) {
            this.modelImageService.update(this.modelImage)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.modelImageService.create(this.modelImage)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    ModelImageDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'modelImageListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    ModelImageDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    ModelImageDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    ModelImageDialogComponent.prototype.trackImageResourceById = function (index, item) {
        return item.id;
    };
    ModelImageDialogComponent.prototype.trackSellerById = function (index, item) {
        return item.id;
    };
    ModelImageDialogComponent.prototype.trackModelById = function (index, item) {
        return item.id;
    };
    return ModelImageDialogComponent;
}());
ModelImageDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model-image-dialog',
        template: __webpack_require__(298)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        model_image_service_1.ModelImageService,
        image_resource_1.ImageResourceService,
        seller_1.SellerService,
        model_1.ModelService,
        ng_jhipster_1.EventManager])
], ModelImageDialogComponent);
exports.ModelImageDialogComponent = ModelImageDialogComponent;
var ModelImagePopupComponent = (function () {
    function ModelImagePopupComponent(route, modelImagePopupService) {
        this.route = route;
        this.modelImagePopupService = modelImagePopupService;
    }
    ModelImagePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.modelImagePopupService
                    .open(ModelImageDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.modelImagePopupService
                    .open(ModelImageDialogComponent);
            }
        });
    };
    ModelImagePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ModelImagePopupComponent;
}());
ModelImagePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model-image-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        model_image_popup_service_1.ModelImagePopupService])
], ModelImagePopupComponent);
exports.ModelImagePopupComponent = ModelImagePopupComponent;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var model_image_service_1 = __webpack_require__(15);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(7);
var ModelImageComponent = (function () {
    function ModelImageComponent(jhiLanguageService, modelImageService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.modelImageService = modelImageService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['modelImage']);
    }
    ModelImageComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.modelImageService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.modelImageService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    ModelImageComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    ModelImageComponent.prototype.transition = function () {
        this.router.navigate(['/model-image'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    ModelImageComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/model-image', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ModelImageComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/model-image', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ModelImageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInModelImages();
    };
    ModelImageComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    ModelImageComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    ModelImageComponent.prototype.registerChangeInModelImages = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('modelImageListModification', function (response) { return _this.loadAll(); });
    };
    ModelImageComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    ModelImageComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.modelImages = data;
    };
    ModelImageComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ModelImageComponent;
}());
ModelImageComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model-image',
        template: __webpack_require__(299)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        model_image_service_1.ModelImageService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], ModelImageComponent);
exports.ModelImageComponent = ModelImageComponent;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ModelImage = (function () {
    function ModelImage(id, shutdownscreen, shutdownscreenNoPower, screensavers, seller, model) {
        this.id = id;
        this.shutdownscreen = shutdownscreen;
        this.shutdownscreenNoPower = shutdownscreenNoPower;
        this.screensavers = screensavers;
        this.seller = seller;
        this.model = model;
    }
    return ModelImage;
}());
exports.ModelImage = ModelImage;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(22));
__export(__webpack_require__(40));
__export(__webpack_require__(16));
__export(__webpack_require__(124));
__export(__webpack_require__(122));
__export(__webpack_require__(123));
__export(__webpack_require__(125));
__export(__webpack_require__(215));


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var model_popup_service_1 = __webpack_require__(40);
var model_service_1 = __webpack_require__(16);
var ModelDeleteDialogComponent = (function () {
    function ModelDeleteDialogComponent(jhiLanguageService, modelService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.modelService = modelService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['model']);
    }
    ModelDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ModelDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.modelService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'modelListModification',
                content: 'Deleted an model'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return ModelDeleteDialogComponent;
}());
ModelDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model-delete-dialog',
        template: __webpack_require__(300)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        model_service_1.ModelService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], ModelDeleteDialogComponent);
exports.ModelDeleteDialogComponent = ModelDeleteDialogComponent;
var ModelDeletePopupComponent = (function () {
    function ModelDeletePopupComponent(route, modelPopupService) {
        this.route = route;
        this.modelPopupService = modelPopupService;
    }
    ModelDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.modelPopupService
                .open(ModelDeleteDialogComponent, params['id']);
        });
    };
    ModelDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ModelDeletePopupComponent;
}());
ModelDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        model_popup_service_1.ModelPopupService])
], ModelDeletePopupComponent);
exports.ModelDeletePopupComponent = ModelDeletePopupComponent;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var model_service_1 = __webpack_require__(16);
var ModelDetailComponent = (function () {
    function ModelDetailComponent(jhiLanguageService, modelService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.modelService = modelService;
        this.route = route;
        this.jhiLanguageService.setLocations(['model']);
    }
    ModelDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
    };
    ModelDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.modelService.find(id).subscribe(function (model) {
            _this.model = model;
        });
    };
    ModelDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    ModelDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return ModelDetailComponent;
}());
ModelDetailComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model-detail',
        template: __webpack_require__(301)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        model_service_1.ModelService,
        router_1.ActivatedRoute])
], ModelDetailComponent);
exports.ModelDetailComponent = ModelDetailComponent;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var model_popup_service_1 = __webpack_require__(40);
var model_service_1 = __webpack_require__(16);
var ModelDialogComponent = (function () {
    function ModelDialogComponent(activeModal, jhiLanguageService, alertService, modelService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.alertService = alertService;
        this.modelService = modelService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['model']);
    }
    ModelDialogComponent.prototype.ngOnInit = function () {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
    };
    ModelDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ModelDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.model.id !== undefined) {
            this.modelService.update(this.model)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.modelService.create(this.model)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    ModelDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'modelListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    ModelDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    ModelDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ModelDialogComponent;
}());
ModelDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model-dialog',
        template: __webpack_require__(302)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.AlertService,
        model_service_1.ModelService,
        ng_jhipster_1.EventManager])
], ModelDialogComponent);
exports.ModelDialogComponent = ModelDialogComponent;
var ModelPopupComponent = (function () {
    function ModelPopupComponent(route, modelPopupService) {
        this.route = route;
        this.modelPopupService = modelPopupService;
    }
    ModelPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.modelPopupService
                    .open(ModelDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.modelPopupService
                    .open(ModelDialogComponent);
            }
        });
    };
    ModelPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ModelPopupComponent;
}());
ModelPopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        model_popup_service_1.ModelPopupService])
], ModelPopupComponent);
exports.ModelPopupComponent = ModelPopupComponent;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var model_service_1 = __webpack_require__(16);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(7);
var ModelComponent = (function () {
    function ModelComponent(jhiLanguageService, modelService, parseLinks, alertService, principal, activatedRoute, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.modelService = modelService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['model']);
    }
    ModelComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.modelService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.modelService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    ModelComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    ModelComponent.prototype.transition = function () {
        this.router.navigate(['/model'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    ModelComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/model', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ModelComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/model', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ModelComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInModels();
    };
    ModelComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    ModelComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    ModelComponent.prototype.registerChangeInModels = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('modelListModification', function (response) { return _this.loadAll(); });
    };
    ModelComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    ModelComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.models = data;
    };
    ModelComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ModelComponent;
}());
ModelComponent = __decorate([
    core_1.Component({
        selector: 'dcs-model',
        template: __webpack_require__(303)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        model_service_1.ModelService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], ModelComponent);
exports.ModelComponent = ModelComponent;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(131));
__export(__webpack_require__(41));
__export(__webpack_require__(17));
__export(__webpack_require__(129));
__export(__webpack_require__(127));
__export(__webpack_require__(128));
__export(__webpack_require__(130));
__export(__webpack_require__(217));


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var resource_popup_service_1 = __webpack_require__(41);
var resource_service_1 = __webpack_require__(17);
var ResourceDeleteDialogComponent = (function () {
    function ResourceDeleteDialogComponent(jhiLanguageService, resourceService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.resourceService = resourceService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['resource']);
    }
    ResourceDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ResourceDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.resourceService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'resourceListModification',
                content: 'Deleted an resource'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return ResourceDeleteDialogComponent;
}());
ResourceDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-resource-delete-dialog',
        template: __webpack_require__(304)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        resource_service_1.ResourceService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], ResourceDeleteDialogComponent);
exports.ResourceDeleteDialogComponent = ResourceDeleteDialogComponent;
var ResourceDeletePopupComponent = (function () {
    function ResourceDeletePopupComponent(route, resourcePopupService) {
        this.route = route;
        this.resourcePopupService = resourcePopupService;
    }
    ResourceDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.resourcePopupService
                .open(ResourceDeleteDialogComponent, params['id']);
        });
    };
    ResourceDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ResourceDeletePopupComponent;
}());
ResourceDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-resource-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        resource_popup_service_1.ResourcePopupService])
], ResourceDeletePopupComponent);
exports.ResourceDeletePopupComponent = ResourceDeletePopupComponent;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var resource_service_1 = __webpack_require__(17);
var ResourceDetailComponent = (function () {
    function ResourceDetailComponent(jhiLanguageService, dataUtils, resourceService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.dataUtils = dataUtils;
        this.resourceService = resourceService;
        this.route = route;
        this.jhiLanguageService.setLocations(['resource']);
    }
    ResourceDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
    };
    ResourceDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.resourceService.find(id).subscribe(function (resource) {
            _this.resource = resource;
        });
    };
    ResourceDetailComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    ResourceDetailComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    ResourceDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    ResourceDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return ResourceDetailComponent;
}());
ResourceDetailComponent = __decorate([
    core_1.Component({
        selector: 'dcs-resource-detail',
        template: __webpack_require__(305)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.DataUtils,
        resource_service_1.ResourceService,
        router_1.ActivatedRoute])
], ResourceDetailComponent);
exports.ResourceDetailComponent = ResourceDetailComponent;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var resource_popup_service_1 = __webpack_require__(41);
var resource_service_1 = __webpack_require__(17);
var seller_1 = __webpack_require__(20);
var ResourceDialogComponent = (function () {
    function ResourceDialogComponent(activeModal, jhiLanguageService, dataUtils, alertService, resourceService, sellerService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.dataUtils = dataUtils;
        this.alertService = alertService;
        this.resourceService = resourceService;
        this.sellerService = sellerService;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['resource']);
    }
    ResourceDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.sellerService.query().subscribe(function (res) { _this.sellers = res.json(); }, function (res) { return _this.onError(res.json()); });
    };
    ResourceDialogComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    ResourceDialogComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    ResourceDialogComponent.prototype.setFileData = function ($event, resource, field, isImage) {
        if ($event.target.files && $event.target.files[0]) {
            var $file_1 = $event.target.files[0];
            if (isImage && !/^image\//.test($file_1.type)) {
                return;
            }
            this.dataUtils.toBase64($file_1, function (base64Data) {
                resource[field] = base64Data;
                resource[field + "ContentType"] = $file_1.type;
            });
        }
    };
    ResourceDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    ResourceDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.resource.id !== undefined) {
            this.resourceService.update(this.resource)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.resourceService.create(this.resource)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    ResourceDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'resourceListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    ResourceDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    ResourceDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    ResourceDialogComponent.prototype.trackSellerById = function (index, item) {
        return item.id;
    };
    return ResourceDialogComponent;
}());
ResourceDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-resource-dialog',
        template: __webpack_require__(306)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.DataUtils,
        ng_jhipster_1.AlertService,
        resource_service_1.ResourceService,
        seller_1.SellerService,
        ng_jhipster_1.EventManager])
], ResourceDialogComponent);
exports.ResourceDialogComponent = ResourceDialogComponent;
var ResourcePopupComponent = (function () {
    function ResourcePopupComponent(route, resourcePopupService) {
        this.route = route;
        this.resourcePopupService = resourcePopupService;
    }
    ResourcePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.resourcePopupService
                    .open(ResourceDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.resourcePopupService
                    .open(ResourceDialogComponent);
            }
        });
    };
    ResourcePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return ResourcePopupComponent;
}());
ResourcePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-resource-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        resource_popup_service_1.ResourcePopupService])
], ResourcePopupComponent);
exports.ResourcePopupComponent = ResourcePopupComponent;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var resource_service_1 = __webpack_require__(17);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(7);
var ResourceComponent = (function () {
    function ResourceComponent(jhiLanguageService, resourceService, parseLinks, alertService, principal, activatedRoute, dataUtils, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.resourceService = resourceService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.dataUtils = dataUtils;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['resource']);
    }
    ResourceComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.resourceService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.resourceService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    ResourceComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    ResourceComponent.prototype.transition = function () {
        this.router.navigate(['/resource'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    ResourceComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/resource', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ResourceComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/resource', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    ResourceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInResources();
    };
    ResourceComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    ResourceComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    ResourceComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    ResourceComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    ResourceComponent.prototype.registerChangeInResources = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('resourceListModification', function (response) { return _this.loadAll(); });
    };
    ResourceComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    ResourceComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.resources = data;
    };
    ResourceComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return ResourceComponent;
}());
ResourceComponent = __decorate([
    core_1.Component({
        selector: 'dcs-resource',
        template: __webpack_require__(307)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        resource_service_1.ResourceService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        ng_jhipster_1.DataUtils,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], ResourceComponent);
exports.ResourceComponent = ResourceComponent;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Resource = (function () {
    function Resource(id, file, seller, fileName) {
        this.id = id;
        this.file = file;
        this.seller = seller;
        this.fileName = fileName;
    }
    return Resource;
}());
exports.Resource = Resource;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var seller_popup_service_1 = __webpack_require__(23);
var seller_service_1 = __webpack_require__(10);
var SellerDeleteDialogComponent = (function () {
    function SellerDeleteDialogComponent(jhiLanguageService, sellerService, activeModal, eventManager) {
        this.jhiLanguageService = jhiLanguageService;
        this.sellerService = sellerService;
        this.activeModal = activeModal;
        this.eventManager = eventManager;
        this.jhiLanguageService.setLocations(['seller']);
    }
    SellerDeleteDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    SellerDeleteDialogComponent.prototype.confirmDelete = function (id) {
        var _this = this;
        this.sellerService.delete(id).subscribe(function (response) {
            _this.eventManager.broadcast({
                name: 'sellerListModification',
                content: 'Deleted an seller'
            });
            _this.activeModal.dismiss(true);
        });
    };
    return SellerDeleteDialogComponent;
}());
SellerDeleteDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-delete-dialog',
        template: __webpack_require__(309)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        seller_service_1.SellerService,
        ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.EventManager])
], SellerDeleteDialogComponent);
exports.SellerDeleteDialogComponent = SellerDeleteDialogComponent;
var SellerDeletePopupComponent = (function () {
    function SellerDeletePopupComponent(route, sellerPopupService) {
        this.route = route;
        this.sellerPopupService = sellerPopupService;
    }
    SellerDeletePopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            _this.modalRef = _this.sellerPopupService
                .open(SellerDeleteDialogComponent, params['id']);
        });
    };
    SellerDeletePopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return SellerDeletePopupComponent;
}());
SellerDeletePopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-delete-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        seller_popup_service_1.SellerPopupService])
], SellerDeletePopupComponent);
exports.SellerDeletePopupComponent = SellerDeletePopupComponent;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var seller_service_1 = __webpack_require__(10);
var SellerDetailComponent = (function () {
    function SellerDetailComponent(jhiLanguageService, dataUtils, sellerService, route) {
        this.jhiLanguageService = jhiLanguageService;
        this.dataUtils = dataUtils;
        this.sellerService = sellerService;
        this.route = route;
        this.jhiLanguageService.setLocations(['seller']);
    }
    SellerDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription = this.route.params.subscribe(function (params) {
            _this.load(params['id']);
        });
    };
    SellerDetailComponent.prototype.load = function (id) {
        var _this = this;
        this.sellerService.find(id).subscribe(function (seller) {
            _this.seller = seller;
        });
    };
    SellerDetailComponent.prototype.touch = function () {
        var _this = this;
        this.sellerService.touch(this.seller.id).subscribe(function (seller) {
            _this.load(_this.seller.id);
        });
    };
    SellerDetailComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    SellerDetailComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    SellerDetailComponent.prototype.previousState = function () {
        window.history.back();
    };
    SellerDetailComponent.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return SellerDetailComponent;
}());
SellerDetailComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-detail',
        template: __webpack_require__(310)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.DataUtils,
        seller_service_1.SellerService,
        router_1.ActivatedRoute])
], SellerDetailComponent);
exports.SellerDetailComponent = SellerDetailComponent;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var seller_popup_service_1 = __webpack_require__(23);
var seller_service_1 = __webpack_require__(10);
var model_image_1 = __webpack_require__(115);
var shared_1 = __webpack_require__(3);
var device_1 = __webpack_require__(99);
var resource_1 = __webpack_require__(126);
var application_1 = __webpack_require__(92);
var SellerDialogComponent = (function () {
    function SellerDialogComponent(activeModal, jhiLanguageService, dataUtils, alertService, sellerService, modelImageService, userService, deviceService, resourceService, applicationService, eventManager) {
        this.activeModal = activeModal;
        this.jhiLanguageService = jhiLanguageService;
        this.dataUtils = dataUtils;
        this.alertService = alertService;
        this.sellerService = sellerService;
        this.modelImageService = modelImageService;
        this.userService = userService;
        this.deviceService = deviceService;
        this.resourceService = resourceService;
        this.applicationService = applicationService;
        this.eventManager = eventManager;
        this.availableProducts = [];
        this.shoppingBasket = [];
        this.jhiLanguageService.setLocations(['seller']);
        this.availableProducts.push(new Product('Blue Shoes', 3, 35));
        this.availableProducts.push(new Product('Good Jacket', 1, 90));
        this.availableProducts.push(new Product('Red Shirt', 5, 12));
        this.availableProducts.push(new Product('Blue Jeans', 4, 60));
    }
    SellerDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.modelImageService.query({ filter: 'seller-is-null' }).subscribe(function (res) {
            if (!_this.seller.shutdown || !_this.seller.shutdown.id) {
                _this.shutdowns = res.json();
            }
            else {
                _this.modelImageService.find(_this.seller.shutdown.id).subscribe(function (subRes) {
                    _this.shutdowns = [subRes].concat(res.json());
                }, function (subRes) { return _this.onError(subRes.json()); });
            }
        }, function (res) { return _this.onError(res.json()); });
        this.userService.query().subscribe(function (res) {
            _this.users = res.json();
        }, function (res) { return _this.onError(res.json()); });
        this.deviceService.query().subscribe(function (res) {
            _this.devices = res.json();
        }, function (res) { return _this.onError(res.json()); });
        this.resourceService.query().subscribe(function (res) {
            _this.resources = res.json();
        }, function (res) { return _this.onError(res.json()); });
        this.modelImageService.query().subscribe(function (res) {
            _this.modelimages = res.json();
        }, function (res) { return _this.onError(res.json()); });
        this.applicationService.findAll().subscribe(function (res) {
            _this.applications = res.json();
        }, function (res) { return _this.onError(res.json()); });
    };
    SellerDialogComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    SellerDialogComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    SellerDialogComponent.prototype.setFileData = function ($event, seller, field, isImage) {
        if ($event.target.files && $event.target.files[0]) {
            var $file_1 = $event.target.files[0];
            if (isImage && !/^image\//.test($file_1.type)) {
                return;
            }
            this.dataUtils.toBase64($file_1, function (base64Data) {
                seller[field] = base64Data;
                seller[field + "ContentType"] = $file_1.type;
            });
        }
    };
    SellerDialogComponent.prototype.clear = function () {
        this.activeModal.dismiss('cancel');
    };
    SellerDialogComponent.prototype.save = function () {
        var _this = this;
        this.isSaving = true;
        if (this.seller.id !== undefined) {
            if (this.seller.tutorialPackage === "")
                this.seller.tutorialPackage = null;
            if (this.seller.tutorialParam === "")
                this.seller.tutorialParam = null;
            this.sellerService.update(this.seller)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
        else {
            this.sellerService.create(this.seller)
                .subscribe(function (res) { return _this.onSaveSuccess(res); }, function (res) { return _this.onSaveError(res.json()); });
        }
    };
    SellerDialogComponent.prototype.onSelectTutorial = function (event) {
        this.seller.tutorialPackage = this.tutorial.packageName;
    };
    SellerDialogComponent.prototype.onSaveSuccess = function (result) {
        this.eventManager.broadcast({ name: 'sellerListModification', content: 'OK' });
        this.isSaving = false;
        this.activeModal.dismiss(result);
    };
    SellerDialogComponent.prototype.onSaveError = function (error) {
        this.isSaving = false;
        this.onError(error);
    };
    SellerDialogComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    SellerDialogComponent.prototype.trackModelImageById = function (index, item) {
        return item.id;
    };
    SellerDialogComponent.prototype.trackUserById = function (index, item) {
        return item.id;
    };
    SellerDialogComponent.prototype.trackDeviceById = function (index, item) {
        return item.id;
    };
    SellerDialogComponent.prototype.trackResourceById = function (index, item) {
        return item.id;
    };
    SellerDialogComponent.prototype.trackApplicationById = function (index, item) {
        return item.id;
    };
    SellerDialogComponent.prototype.getSelected = function (selectedVals, option) {
        if (selectedVals) {
            for (var i = 0; i < selectedVals.length; i++) {
                if (option.id === selectedVals[i].id) {
                    return selectedVals[i];
                }
            }
        }
        return option;
    };
    SellerDialogComponent.prototype.orderedProduct = function ($event) {
        var orderedProduct = $event.dragData;
        orderedProduct.quantity--;
    };
    SellerDialogComponent.prototype.addToBasket = function ($event) {
        var newProduct = $event.dragData;
        for (var indx in this.shoppingBasket) {
            var product = this.shoppingBasket[indx];
            if (product.name === newProduct.name) {
                product.quantity++;
                return;
            }
        }
        this.shoppingBasket.push(new Product(newProduct.name, 1, newProduct.cost));
        this.shoppingBasket.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        });
    };
    SellerDialogComponent.prototype.totalCost = function () {
        var cost = 0;
        for (var indx in this.shoppingBasket) {
            var product = this.shoppingBasket[indx];
            cost += (product.cost * product.quantity);
        }
        return cost;
    };
    return SellerDialogComponent;
}());
SellerDialogComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-dialog',
        template: __webpack_require__(311)
    }),
    __metadata("design:paramtypes", [ng_bootstrap_1.NgbActiveModal,
        ng_jhipster_1.JhiLanguageService,
        ng_jhipster_1.DataUtils,
        ng_jhipster_1.AlertService,
        seller_service_1.SellerService,
        model_image_1.ModelImageService,
        shared_1.UserService,
        device_1.DeviceService,
        resource_1.ResourceService,
        application_1.ApplicationArtatechService,
        ng_jhipster_1.EventManager])
], SellerDialogComponent);
exports.SellerDialogComponent = SellerDialogComponent;
var SellerPopupComponent = (function () {
    function SellerPopupComponent(route, sellerPopupService) {
        this.route = route;
        this.sellerPopupService = sellerPopupService;
    }
    SellerPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.routeSub = this.route.params.subscribe(function (params) {
            if (params['id']) {
                _this.modalRef = _this.sellerPopupService
                    .open(SellerDialogComponent, params['id']);
            }
            else {
                _this.modalRef = _this.sellerPopupService
                    .open(SellerDialogComponent);
            }
        });
    };
    SellerPopupComponent.prototype.ngOnDestroy = function () {
        this.routeSub.unsubscribe();
    };
    return SellerPopupComponent;
}());
SellerPopupComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-popup',
        template: ''
    }),
    __metadata("design:paramtypes", [router_1.ActivatedRoute,
        seller_popup_service_1.SellerPopupService])
], SellerPopupComponent);
exports.SellerPopupComponent = SellerPopupComponent;
var Product = (function () {
    function Product(name, quantity, cost) {
        this.name = name;
        this.quantity = quantity;
        this.cost = cost;
    }
    return Product;
}());


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var seller_service_1 = __webpack_require__(10);
var shared_1 = __webpack_require__(3);
var uib_pagination_config_1 = __webpack_require__(7);
var SellerComponent = (function () {
    function SellerComponent(jhiLanguageService, sellerService, parseLinks, alertService, principal, activatedRoute, dataUtils, router, eventManager, paginationUtil, paginationConfig) {
        var _this = this;
        this.jhiLanguageService = jhiLanguageService;
        this.sellerService = sellerService;
        this.parseLinks = parseLinks;
        this.alertService = alertService;
        this.principal = principal;
        this.activatedRoute = activatedRoute;
        this.dataUtils = dataUtils;
        this.router = router;
        this.eventManager = eventManager;
        this.paginationUtil = paginationUtil;
        this.paginationConfig = paginationConfig;
        this.itemsPerPage = shared_1.ITEMS_PER_PAGE;
        this.routeData = this.activatedRoute.data.subscribe(function (data) {
            _this.page = data['pagingParams'].page;
            _this.previousPage = data['pagingParams'].page;
            _this.reverse = data['pagingParams'].ascending;
            _this.predicate = data['pagingParams'].predicate;
        });
        this.currentSearch = activatedRoute.snapshot.params['search'] ? activatedRoute.snapshot.params['search'] : '';
        this.jhiLanguageService.setLocations(['seller']);
    }
    SellerComponent.prototype.loadAll = function () {
        var _this = this;
        if (this.currentSearch) {
            this.sellerService.search({
                query: this.currentSearch,
                size: this.itemsPerPage,
                sort: this.sort()
            }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
            return;
        }
        this.sellerService.query({
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.sort()
        }).subscribe(function (res) { return _this.onSuccess(res.json(), res.headers); }, function (res) { return _this.onError(res.json()); });
    };
    SellerComponent.prototype.loadPage = function (page) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    };
    SellerComponent.prototype.transition = function () {
        this.router.navigate(['/seller'], { queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                search: this.currentSearch,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }
        });
        this.loadAll();
    };
    SellerComponent.prototype.clear = function () {
        this.page = 0;
        this.currentSearch = '';
        this.router.navigate(['/seller', {
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    SellerComponent.prototype.search = function (query) {
        if (!query) {
            return this.clear();
        }
        this.page = 0;
        this.currentSearch = query;
        this.router.navigate(['/seller', {
                search: this.currentSearch,
                page: this.page,
                sort: this.predicate + ',' + (this.reverse ? 'asc' : 'desc')
            }]);
        this.loadAll();
    };
    SellerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loadAll();
        this.principal.identity().then(function (account) {
            _this.currentAccount = account;
        });
        this.registerChangeInSellers();
    };
    SellerComponent.prototype.ngOnDestroy = function () {
        this.eventManager.destroy(this.eventSubscriber);
    };
    SellerComponent.prototype.trackId = function (index, item) {
        return item.id;
    };
    SellerComponent.prototype.byteSize = function (field) {
        return this.dataUtils.byteSize(field);
    };
    SellerComponent.prototype.openFile = function (contentType, field) {
        return this.dataUtils.openFile(contentType, field);
    };
    SellerComponent.prototype.registerChangeInSellers = function () {
        var _this = this;
        this.eventSubscriber = this.eventManager.subscribe('sellerListModification', function (response) { return _this.loadAll(); });
    };
    SellerComponent.prototype.sort = function () {
        var result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
        if (this.predicate !== 'id') {
            result.push('id');
        }
        return result;
    };
    SellerComponent.prototype.onSuccess = function (data, headers) {
        this.links = this.parseLinks.parse(headers.get('link'));
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        // this.page = pagingParams.page;
        this.sellers = data;
    };
    SellerComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return SellerComponent;
}());
SellerComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller',
        template: __webpack_require__(312)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        seller_service_1.SellerService,
        ng_jhipster_1.ParseLinks,
        ng_jhipster_1.AlertService,
        shared_1.Principal,
        router_1.ActivatedRoute,
        ng_jhipster_1.DataUtils,
        router_1.Router,
        ng_jhipster_1.EventManager,
        ng_jhipster_1.PaginationUtil,
        uib_pagination_config_1.PaginationConfig])
], SellerComponent);
exports.SellerComponent = SellerComponent;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Seller = (function () {
    function Seller(id, name, tutorialPackage, tutorialParam, libraryMode, cleanApplications, createDate, lastModifiedDate, layout, shutdown, owner, devices, files, screensaver, applications) {
        this.id = id;
        this.name = name;
        this.tutorialPackage = tutorialPackage;
        this.tutorialParam = tutorialParam;
        this.libraryMode = libraryMode;
        this.cleanApplications = cleanApplications;
        this.createDate = createDate;
        this.lastModifiedDate = lastModifiedDate;
        this.layout = layout;
        this.shutdown = shutdown;
        this.owner = owner;
        this.devices = devices;
        this.files = files;
        this.screensaver = screensaver;
        this.applications = applications;
    }
    return Seller;
}());
exports.Seller = Seller;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(138);
var seller_dashboard_module_1 = __webpack_require__(86);
var DeviceConfigurerServiceHomeModule = (function () {
    function DeviceConfigurerServiceHomeModule() {
    }
    return DeviceConfigurerServiceHomeModule;
}());
DeviceConfigurerServiceHomeModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            router_1.RouterModule.forRoot([_1.HOME_ROUTE], { useHash: true }),
            seller_dashboard_module_1.SellerDashboardModule
        ],
        declarations: [
            _1.HomeComponent,
        ],
        entryComponents: [],
        providers: [],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceHomeModule);
exports.DeviceConfigurerServiceHomeModule = DeviceConfigurerServiceHomeModule;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(220));
__export(__webpack_require__(221));
__export(__webpack_require__(137));


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var ErrorComponent = (function () {
    function ErrorComponent(jhiLanguageService) {
        this.jhiLanguageService = jhiLanguageService;
        this.jhiLanguageService.setLocations(['error']);
    }
    ErrorComponent.prototype.ngOnInit = function () {
    };
    return ErrorComponent;
}());
ErrorComponent = __decorate([
    core_1.Component({
        selector: 'dcs-error',
        template: __webpack_require__(314)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService])
], ErrorComponent);
exports.ErrorComponent = ErrorComponent;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ProfileInfo = (function () {
    function ProfileInfo() {
    }
    return ProfileInfo;
}());
exports.ProfileInfo = ProfileInfo;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var AccountService = (function () {
    function AccountService(http) {
        this.http = http;
    }
    AccountService.prototype.get = function () {
        return this.http.get('api/account').map(function (res) { return res.json(); });
    };
    AccountService.prototype.save = function (account) {
        return this.http.post('api/account', account);
    };
    return AccountService;
}());
AccountService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], AccountService);
exports.AccountService = AccountService;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
    Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
    They are written in English to avoid character encoding issues (not a perfect solution)
*/
exports.LANGUAGES = [
    'en',
    'pl'
];


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(51);
var router_1 = __webpack_require__(2);
var ng2_translate_1 = __webpack_require__(244);
var language_constants_1 = __webpack_require__(142);
var JhiLanguageHelper = (function () {
    function JhiLanguageHelper(translateService, titleService, router) {
        this.translateService = translateService;
        this.titleService = titleService;
        this.router = router;
        this.init();
    }
    JhiLanguageHelper.prototype.getAll = function () {
        return Promise.resolve(language_constants_1.LANGUAGES);
    };
    /**
     * Update the window title using params in the following
     * order:
     * 1. titleKey parameter
     * 2. $state.$current.data.pageTitle (current state page title)
     * 3. 'global.title'
     */
    JhiLanguageHelper.prototype.updateTitle = function (titleKey) {
        var _this = this;
        if (!titleKey) {
            titleKey = this.getPageTitle(this.router.routerState.snapshot.root);
        }
        this.translateService.get(titleKey).subscribe(function (title) {
            _this.titleService.setTitle(title);
        });
    };
    JhiLanguageHelper.prototype.init = function () {
        var _this = this;
        this.translateService.onTranslationChange.subscribe(function (event) {
            _this.updateTitle();
        });
        this.translateService.onLangChange.subscribe(function (event) {
            _this.updateTitle();
        });
    };
    JhiLanguageHelper.prototype.getPageTitle = function (routeSnapshot) {
        var pageTitle = routeSnapshot.data['pageTitle'];
        var title = (routeSnapshot.data && pageTitle) ? pageTitle : 'deviceConfigurerServiceApp';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    };
    return JhiLanguageHelper;
}());
JhiLanguageHelper = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng2_translate_1.TranslateService, platform_browser_1.Title, router_1.Router])
], JhiLanguageHelper);
exports.JhiLanguageHelper = JhiLanguageHelper;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_bootstrap_1 = __webpack_require__(4);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var login_service_1 = __webpack_require__(145);
var state_storage_service_1 = __webpack_require__(25);
var DcsLoginModalComponent = (function () {
    function DcsLoginModalComponent(eventManager, languageService, loginService, stateStorageService, elementRef, renderer, router, activeModal) {
        this.eventManager = eventManager;
        this.languageService = languageService;
        this.loginService = loginService;
        this.stateStorageService = stateStorageService;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.router = router;
        this.activeModal = activeModal;
        this.credentials = {};
    }
    DcsLoginModalComponent.prototype.ngOnInit = function () {
        this.languageService.addLocation('login');
    };
    DcsLoginModalComponent.prototype.ngAfterViewInit = function () {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#username'), 'focus', []);
    };
    DcsLoginModalComponent.prototype.cancel = function () {
        this.credentials = {
            username: null,
            password: null,
            rememberMe: true
        };
        this.authenticationError = false;
        this.activeModal.dismiss('cancel');
    };
    DcsLoginModalComponent.prototype.login = function () {
        var _this = this;
        this.loginService.login({
            username: this.username,
            password: this.password,
            rememberMe: this.rememberMe
        }).then(function () {
            _this.authenticationError = false;
            _this.activeModal.dismiss('login success');
            if (_this.router.url === '/register' || (/activate/.test(_this.router.url)) ||
                _this.router.url === '/finishReset' || _this.router.url === '/requestReset') {
                _this.router.navigate(['/']);
            }
            _this.eventManager.broadcast({
                name: 'authenticationSuccess',
                content: 'Sending Authentication Success'
            });
            // // previousState was set in the authExpiredInterceptor before being redirected to login modal.
            // // since login is succesful, go to stored previousState and clear previousState
            var previousState = _this.stateStorageService.getPreviousState();
            if (previousState) {
                _this.stateStorageService.resetPreviousState();
                _this.router.navigate([previousState.name], { queryParams: previousState.params });
            }
        }).catch(function () {
            _this.authenticationError = true;
        });
    };
    DcsLoginModalComponent.prototype.register = function () {
        this.activeModal.dismiss('to state register');
        this.router.navigate(['/register']);
    };
    DcsLoginModalComponent.prototype.requestResetPassword = function () {
        this.activeModal.dismiss('to state requestReset');
        this.router.navigate(['/reset', 'request']);
    };
    return DcsLoginModalComponent;
}());
DcsLoginModalComponent = __decorate([
    core_1.Component({
        selector: 'dcs-login-modal',
        template: __webpack_require__(318)
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.EventManager,
        ng_jhipster_1.JhiLanguageService,
        login_service_1.LoginService,
        state_storage_service_1.StateStorageService,
        core_1.ElementRef,
        core_1.Renderer,
        router_1.Router,
        ng_bootstrap_1.NgbActiveModal])
], DcsLoginModalComponent);
exports.DcsLoginModalComponent = DcsLoginModalComponent;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var principal_service_1 = __webpack_require__(18);
var auth_session_service_1 = __webpack_require__(44);
var LoginService = (function () {
    function LoginService(languageService, principal, authServerProvider) {
        this.languageService = languageService;
        this.principal = principal;
        this.authServerProvider = authServerProvider;
    }
    LoginService.prototype.login = function (credentials, callback) {
        var _this = this;
        var cb = callback || function () { };
        return new Promise(function (resolve, reject) {
            _this.authServerProvider.login(credentials).subscribe(function (data) {
                _this.principal.identity(true).then(function (account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        _this.languageService.changeLanguage(account.langKey);
                    }
                    resolve(data);
                });
                return cb();
            }, function (err) {
                _this.logout();
                reject(err);
                return cb(err);
            });
        });
    };
    LoginService.prototype.logout = function () {
        this.authServerProvider.logout().subscribe();
        this.principal.authenticate(null);
    };
    return LoginService;
}());
LoginService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        principal_service_1.Principal,
        auth_session_service_1.AuthServerProvider])
], LoginService);
exports.LoginService = LoginService;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(8);
var cookies_service_1 = __webpack_require__(328);
var _1 = __webpack_require__(3);
var DeviceConfigurerServiceSharedModule = (function () {
    function DeviceConfigurerServiceSharedModule() {
    }
    return DeviceConfigurerServiceSharedModule;
}());
DeviceConfigurerServiceSharedModule = __decorate([
    core_1.NgModule({
        imports: [
            _1.DeviceConfigurerServiceSharedLibsModule,
            _1.DeviceConfigurerServiceSharedCommonModule,
        ],
        declarations: [
            _1.DcsLoginModalComponent,
            _1.HasAnyAuthorityDirective
        ],
        providers: [
            cookies_service_1.CookieService,
            _1.LoginService,
            _1.LoginModalService,
            _1.AccountService,
            _1.StateStorageService,
            _1.Principal,
            _1.CSRFService,
            _1.AuthServerProvider,
            _1.AuthService,
            _1.UserService,
            common_1.DatePipe,
        ],
        entryComponents: [_1.DcsLoginModalComponent],
        exports: [
            _1.DeviceConfigurerServiceSharedCommonModule,
            _1.DcsLoginModalComponent,
            _1.HasAnyAuthorityDirective,
            common_1.DatePipe
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceSharedModule);
exports.DeviceConfigurerServiceSharedModule = DeviceConfigurerServiceSharedModule;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var User = (function () {
    function User(id, login, firstName, lastName, email, activated, langKey, authorities, createdBy, createdDate, lastModifiedBy, lastModifiedDate, password) {
        this.id = id ? id : null;
        this.login = login ? login : null;
        this.firstName = firstName ? firstName : null;
        this.lastName = lastName ? lastName : null;
        this.email = email ? email : null;
        this.activated = activated ? activated : false;
        this.langKey = langKey ? langKey : null;
        this.authorities = authorities ? authorities : null;
        this.createdBy = createdBy ? createdBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
        this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
        this.password = password ? password : null;
    }
    return User;
}());
exports.User = User;


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_directive__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ng2_bootstrap_config__ = __webpack_require__(151);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BarComponent; });



// todo: number pipe
// todo: use query from progress?
var BarComponent = (function () {
    function BarComponent(progress) {
        this.percent = 0;
        this.progress = progress;
    }
    Object.defineProperty(BarComponent.prototype, "value", {
        /** current value of progress bar */
        get: function () {
            return this._value;
        },
        set: function (v) {
            if (!v && v !== 0) {
                return;
            }
            this._value = v;
            this.recalculatePercentage();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarComponent.prototype, "setBarWidth", {
        get: function () {
            this.recalculatePercentage();
            return this.isBs3 ? '' : this.percent;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(BarComponent.prototype, "isBs3", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_ng2_bootstrap_config__["a" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    BarComponent.prototype.ngOnInit = function () {
        this.progress.addBar(this);
    };
    BarComponent.prototype.ngOnDestroy = function () {
        this.progress.removeBar(this);
    };
    BarComponent.prototype.recalculatePercentage = function () {
        this.percent = +(100 * this.value / this.progress.max).toFixed(2);
        var totalPercentage = this.progress.bars.reduce(function (total, bar) {
            return total + bar.percent;
        }, 0);
        if (totalPercentage > 100) {
            this.percent -= totalPercentage - 100;
        }
    };
    BarComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'bar',
                    template: "\n  <div class=\"progress-bar\"\n    style=\"min-width: 0;\"\n    role=\"progressbar\"\n    [ngClass]=\"type && 'progress-bar-' + type + ' bg-' + type\"\n    [ngStyle]=\"{width: (isBs3 ? (percent < 100 ? percent : 100) + '%' : '100%'), transition: transition}\"\n    aria-valuemin=\"0\"\n    [attr.aria-valuenow]=\"value\"\n    [attr.aria-valuetext]=\"percent.toFixed(0) + '%'\"\n    [attr.aria-valuemax]=\"max\"><ng-content></ng-content></div>\n"
                },] },
    ];
    /** @nocollapse */
    BarComponent.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__progress_directive__["a" /* ProgressDirective */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ]; };
    BarComponent.propDecorators = {
        'type': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'setBarWidth': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['style.width.%',] },],
    };
    return BarComponent;
}());

//# sourceMappingURL=bar.component.js.map

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progressbar_config__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(248);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressbarComponent; });



var ProgressbarComponent = (function () {
    function ProgressbarComponent(config) {
        this.isStacked = false;
        Object.assign(this, config);
    }
    Object.defineProperty(ProgressbarComponent.prototype, "value", {
        /** current value of progress bar. Could be a number or array of objects like {"value":15,"type":"info","label":"15 %"} */
        set: function (value) {
            this.isStacked = Array.isArray(value);
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ProgressbarComponent.prototype, "isBs3", {
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* isBs3 */])();
        },
        enumerable: true,
        configurable: true
    });
    ProgressbarComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'progressbar',
                    template: "\n    <div progress [animate]=\"animate\" [max]=\"max\" [style.width]=\"!isBs3 ? '100%' : 'auto'\">\n      <bar [type]=\"type\" [value]=\"_value\" *ngIf=\"!isStacked\">\n          <ng-content></ng-content>\n      </bar>\n      <template [ngIf]=\"isStacked\">\n        <bar *ngFor=\"let item of _value\" [type]=\"item.type\" [value]=\"item.value\">{{item.label}}</bar>\n      </template>\n    </div>\n  ",
                    styles: ["\n    :host {\n      width: 100%;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    ProgressbarComponent.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__progressbar_config__["a" /* ProgressbarConfig */], },
    ]; };
    ProgressbarComponent.propDecorators = {
        'animate': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'max': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'type': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return ProgressbarComponent;
}());

//# sourceMappingURL=progressbar.component.js.map

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return win; });
/* unused harmony export document */
/* unused harmony export location */
/* unused harmony export gc */
/* unused harmony export performance */
/* unused harmony export Event */
/* unused harmony export MouseEvent */
/* unused harmony export KeyboardEvent */
/* unused harmony export EventTarget */
/* unused harmony export History */
/* unused harmony export Location */
/* unused harmony export EventListener */
/*tslint:disable */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * JS version of browser APIs. This library can only run in the browser.
 */
var win = typeof window !== 'undefined' && window || {};

var document = win.document;
var location = win.location;
var gc = win['gc'] ? function () { return win['gc'](); } : function () { return null; };
var performance = win['performance'] ? win['performance'] : null;
var Event = win['Event'];
var MouseEvent = win['MouseEvent'];
var KeyboardEvent = win['KeyboardEvent'];
var EventTarget = win['EventTarget'];
var History = win['History'];
var Location = win['Location'];
var EventListener = win['EventListener'];
//# sourceMappingURL=browser.js.map

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_browser__ = __webpack_require__(150);
/* harmony export (immutable) */ __webpack_exports__["a"] = isBs3;

var guessedVersion;
function _guessBsVersion() {
    if (typeof document === 'undefined') {
        return null;
    }
    var spanEl = document.createElement('span');
    spanEl.innerText = 'test bs version';
    document.body.appendChild(spanEl);
    spanEl.classList.add('d-none');
    var rect = spanEl.getBoundingClientRect();
    document.body.removeChild(spanEl);
    if (!rect) {
        return 'bs3';
    }
    return rect.top === 0 ? 'bs4' : 'bs3';
}
// todo: in ngx-bootstrap, bs4 will became a default one
function isBs3() {
    if (typeof __WEBPACK_IMPORTED_MODULE_0__facade_browser__["a" /* window */] === 'undefined') {
        return true;
    }
    if (typeof __WEBPACK_IMPORTED_MODULE_0__facade_browser__["a" /* window */].__theme === 'undefined') {
        if (guessedVersion) {
            return guessedVersion === 'bs3';
        }
        guessedVersion = _guessBsVersion();
        return guessedVersion === 'bs3';
    }
    return __WEBPACK_IMPORTED_MODULE_0__facade_browser__["a" /* window */].__theme !== 'bs4';
}
//# sourceMappingURL=ng2-bootstrap-config.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(12);

/***/ }),
/* 153 */,
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(570);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(756);

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(764);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(768);

/***/ }),
/* 158 */,
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
__webpack_require__(327);
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(51);
var ng2_webstorage_1 = __webpack_require__(154);
var progressbar_1 = __webpack_require__(245);
var shared_1 = __webpack_require__(3);
var home_module_1 = __webpack_require__(137);
var admin_module_1 = __webpack_require__(66);
var account_module_1 = __webpack_require__(168);
var entity_module_1 = __webpack_require__(203);
var layouts_1 = __webpack_require__(24);
var http_provider_1 = __webpack_require__(191);
var uib_pagination_config_1 = __webpack_require__(7);
var layouts_2 = __webpack_require__(24);
var dashboard_module_1 = __webpack_require__(193);
//import {DndModule} from 'ng2-dnd/ng2-dnd';
var DeviceConfigurerServiceAppModule = (function () {
    function DeviceConfigurerServiceAppModule() {
    }
    return DeviceConfigurerServiceAppModule;
}());
DeviceConfigurerServiceAppModule = __decorate([
    core_1.NgModule({
        imports: [
            platform_browser_1.BrowserModule,
            layouts_1.LayoutRoutingModule,
            ng2_webstorage_1.Ng2Webstorage.forRoot({ prefix: 'jhi', separator: '-' }),
            shared_1.DeviceConfigurerServiceSharedModule,
            home_module_1.DeviceConfigurerServiceHomeModule,
            admin_module_1.DeviceConfigurerServiceAdminModule,
            account_module_1.DeviceConfigurerServiceAccountModule,
            entity_module_1.DeviceConfigurerServiceEntityModule,
            dashboard_module_1.DashboardModule,
            progressbar_1.ProgressbarModule.forRoot(),
        ],
        declarations: [
            layouts_2.DcsMainComponent,
            layouts_2.NavbarComponent,
            layouts_2.ErrorComponent,
            layouts_2.PageRibbonComponent,
            layouts_2.ActiveMenuDirective,
            layouts_2.FooterComponent
        ],
        providers: [
            layouts_2.ProfileService,
            { provide: Window, useValue: window },
            { provide: Document, useValue: document },
            http_provider_1.customHttpProvider(),
            uib_pagination_config_1.PaginationConfig,
            shared_1.UserRouteAccessService
        ],
        bootstrap: [layouts_2.DcsMainComponent]
    })
], DeviceConfigurerServiceAppModule);
exports.DeviceConfigurerServiceAppModule = DeviceConfigurerServiceAppModule;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var app_constants_1 = __webpack_require__(53);
function ProdConfig() {
    // disable debug data on prod profile to improve performance
    if (!app_constants_1.DEBUG_INFO_ENABLED) {
        core_1.enableProdMode();
    }
}
exports.ProdConfig = ProdConfig;


/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(563);

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NgUploaderOptions = (function () {
    function NgUploaderOptions(obj) {
        function use(source, defaultValue) {
            return obj && source !== undefined ? source : defaultValue;
        }
        this.url = use(obj.url, '');
        this.cors = use(obj.cors, true);
        this.withCredentials = use(obj.withCredentials, false);
        this.multiple = use(obj.multiple, true);
        this.maxUploads = use(obj.maxUploads, 10);
        this.data = use(obj.data, {});
        this.autoUpload = use(obj.autoUpload, true);
        this.multipart = use(obj.multipart, true);
        this.method = use(obj.method, 'POST');
        this.customHeaders = use(obj.customHeaders, {});
        this.encodeHeaders = use(obj.encodeHeaders, false);
        this.filenameHeader = use(obj.filenameHeader, undefined);
        this.authTokenPrefix = use(obj.authTokenPrefix, 'Bearer');
        this.authToken = use(obj.authToken, undefined);
        this.fieldName = use(obj.fieldName, 'file');
        this.fieldReset = use(obj.fieldReset, true);
        this.previewUrl = use(obj.previewUrl, false);
        this.calculateSpeed = use(obj.calculateSpeed, true);
        this.filterExtensions = use(obj.filterExtensions, false);
        this.allowedExtensions = use(obj.allowedExtensions, []);
        this.maxSize = use(obj.maxSize, undefined);
        this.plainJson = use(obj.plainJson, false);
    }
    return NgUploaderOptions;
}());
exports.NgUploaderOptions = NgUploaderOptions;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UploadRejected = (function () {
    function UploadRejected() {
    }
    Object.defineProperty(UploadRejected, "EXTENSION_NOT_ALLOWED", {
        get: function () { return 'ExtensionNotAllowed'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UploadRejected, "MAX_SIZE_EXCEEDED", {
        get: function () { return 'MaxSizeExceeded'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UploadRejected, "MAX_UPLOADS_EXCEEDED", {
        get: function () { return 'MaxUploadsExceeded'; },
        enumerable: true,
        configurable: true
    });
    return UploadRejected;
}());
exports.UploadRejected = UploadRejected;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var ng_file_drop_1 = __webpack_require__(28);
var ng_file_select_1 = __webpack_require__(29);
var NgUploaderModule = (function () {
    function NgUploaderModule() {
    }
    return NgUploaderModule;
}());
NgUploaderModule = __decorate([
    core_1.NgModule({
        declarations: [
            ng_file_drop_1.NgFileDropDirective,
            ng_file_select_1.NgFileSelectDirective
        ],
        exports: [
            ng_file_drop_1.NgFileDropDirective,
            ng_file_select_1.NgFileSelectDirective
        ]
    })
], NgUploaderModule);
exports.NgUploaderModule = NgUploaderModule;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(56);
var DeviceConfigurerServiceAccountModule = (function () {
    function DeviceConfigurerServiceAccountModule() {
    }
    return DeviceConfigurerServiceAccountModule;
}());
DeviceConfigurerServiceAccountModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            router_1.RouterModule.forRoot(_1.accountState, { useHash: true })
        ],
        declarations: [
            _1.ActivateComponent,
            _1.PasswordComponent,
            _1.PasswordStrengthBarComponent,
            _1.PasswordResetInitComponent,
            _1.PasswordResetFinishComponent,
            _1.SessionsComponent,
            _1.SettingsComponent
        ],
        providers: [
            _1.SessionsService,
            _1.Activate,
            _1.Password,
            _1.PasswordResetInit,
            _1.PasswordResetFinish
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceAccountModule);
exports.DeviceConfigurerServiceAccountModule = DeviceConfigurerServiceAccountModule;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _1 = __webpack_require__(56);
var ACCOUNT_ROUTES = [
    _1.activateRoute,
    _1.passwordRoute,
    _1.passwordResetFinishRoute,
    _1.passwordResetInitRoute,
    _1.sessionsRoute,
    _1.settingsRoute
];
exports.accountState = [{
        path: '',
        children: ACCOUNT_ROUTES
    }];


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(3);
var activate_component_1 = __webpack_require__(54);
exports.activateRoute = {
    path: 'activate',
    component: activate_component_1.ActivateComponent,
    data: {
        authorities: [],
        pageTitle: 'activate.title'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(3);
var password_reset_finish_component_1 = __webpack_require__(57);
exports.passwordResetFinishRoute = {
    path: 'reset/finish',
    component: password_reset_finish_component_1.PasswordResetFinishComponent,
    data: {
        authorities: [],
        pageTitle: 'global.menu.account.password'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(3);
var password_reset_init_component_1 = __webpack_require__(59);
exports.passwordResetInitRoute = {
    path: 'reset/request',
    component: password_reset_init_component_1.PasswordResetInitComponent,
    data: {
        authorities: [],
        pageTitle: 'global.menu.account.password'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var PasswordStrengthBarComponent = (function () {
    function PasswordStrengthBarComponent(renderer, elementRef) {
        this.renderer = renderer;
        this.elementRef = elementRef;
        this.colors = ['#F00', '#F90', '#FF0', '#9F0', '#0F0'];
    }
    PasswordStrengthBarComponent.prototype.measureStrength = function (p) {
        var force = 0;
        var regex = /[$-/:-?{-~!"^_`\[\]]/g; // "
        var lowerLetters = /[a-z]+/.test(p);
        var upperLetters = /[A-Z]+/.test(p);
        var numbers = /[0-9]+/.test(p);
        var symbols = regex.test(p);
        var flags = [lowerLetters, upperLetters, numbers, symbols];
        var passedMatches = flags.filter(function (isMatchedFlag) {
            return isMatchedFlag === true;
        }).length;
        force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
        force += passedMatches * 10;
        // penality (short password)
        force = (p.length <= 6) ? Math.min(force, 10) : force;
        // penality (poor variety of characters)
        force = (passedMatches === 1) ? Math.min(force, 10) : force;
        force = (passedMatches === 2) ? Math.min(force, 20) : force;
        force = (passedMatches === 3) ? Math.min(force, 40) : force;
        return force;
    };
    ;
    PasswordStrengthBarComponent.prototype.getColor = function (s) {
        var idx = 0;
        if (s <= 10) {
            idx = 0;
        }
        else if (s <= 20) {
            idx = 1;
        }
        else if (s <= 30) {
            idx = 2;
        }
        else if (s <= 40) {
            idx = 3;
        }
        else {
            idx = 4;
        }
        return { idx: idx + 1, col: this.colors[idx] };
    };
    ;
    Object.defineProperty(PasswordStrengthBarComponent.prototype, "passwordToCheck", {
        set: function (password) {
            if (password) {
                var c = this.getColor(this.measureStrength(password));
                var element = this.elementRef.nativeElement;
                if (element.className) {
                    this.renderer.setElementClass(element, element.className, false);
                }
                var lis = element.getElementsByTagName('li');
                for (var i = 0; i < lis.length; i++) {
                    if (i < c.idx) {
                        this.renderer.setElementStyle(lis[i], 'backgroundColor', c.col);
                    }
                    else {
                        this.renderer.setElementStyle(lis[i], 'backgroundColor', '#DDD');
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    return PasswordStrengthBarComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], PasswordStrengthBarComponent.prototype, "passwordToCheck", null);
PasswordStrengthBarComponent = __decorate([
    core_1.Component({
        selector: 'dcs-password-strength-bar',
        template: "\n        <div id=\"strength\">\n            <small jhiTranslate=\"global.messages.validate.newpassword.strength\">Password strength:</small>\n            <ul id=\"strengthBar\">\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n                <li class=\"point\"></li>\n            </ul>\n        </div>",
        styles: [
            __webpack_require__(319)
        ]
    }),
    __metadata("design:paramtypes", [core_1.Renderer, core_1.ElementRef])
], PasswordStrengthBarComponent);
exports.PasswordStrengthBarComponent = PasswordStrengthBarComponent;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(3);
var password_component_1 = __webpack_require__(61);
exports.passwordRoute = {
    path: 'password',
    component: password_component_1.PasswordComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.menu.account.password'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Session = (function () {
    function Session(series, tokenDate, ipAddress, userAgent) {
        this.series = series;
        this.tokenDate = tokenDate;
        this.ipAddress = ipAddress;
        this.userAgent = userAgent;
    }
    return Session;
}());
exports.Session = Session;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(3);
var sessions_component_1 = __webpack_require__(63);
exports.sessionsRoute = {
    path: 'sessions',
    component: sessions_component_1.SessionsComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.menu.account.sessions'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(3);
var settings_component_1 = __webpack_require__(65);
exports.settingsRoute = {
    path: 'settings',
    component: settings_component_1.SettingsComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'global.menu.account.settings'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _1 = __webpack_require__(74);
var shared_1 = __webpack_require__(3);
var ADMIN_ROUTES = [
    _1.auditsRoute,
    _1.configurationRoute,
    _1.docsRoute,
    _1.healthRoute,
    _1.logsRoute
].concat(_1.userMgmtRoute, [
    _1.metricsRoute
]);
exports.adminState = [{
        path: '',
        data: {
            authorities: ['ROLE_ADMIN']
        },
        canActivate: [shared_1.UserRouteAccessService],
        children: ADMIN_ROUTES
    }].concat(_1.userDialogRoute);


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AuditData = (function () {
    function AuditData(remoteAddress, sessionId) {
        this.remoteAddress = remoteAddress;
        this.sessionId = sessionId;
    }
    return AuditData;
}());
exports.AuditData = AuditData;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Audit = (function () {
    function Audit(data, principal, timestamp, type) {
        this.data = data;
        this.principal = principal;
        this.timestamp = timestamp;
        this.type = type;
    }
    return Audit;
}());
exports.Audit = Audit;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var audits_component_1 = __webpack_require__(67);
exports.auditsRoute = {
    path: 'audits',
    component: audits_component_1.AuditsComponent,
    data: {
        pageTitle: 'audits.title'
    }
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var configuration_component_1 = __webpack_require__(69);
exports.configurationRoute = {
    path: 'dcs-configuration',
    component: configuration_component_1.DcsConfigurationComponent,
    data: {
        pageTitle: 'configuration.title'
    }
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var docs_component_1 = __webpack_require__(71);
exports.docsRoute = {
    path: 'docs',
    component: docs_component_1.DcsDocsComponent,
    data: {
        pageTitle: 'global.menu.admin.apidocs'
    }
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var health_component_1 = __webpack_require__(73);
exports.healthRoute = {
    path: 'dcs-health',
    component: health_component_1.DcsHealthCheckComponent,
    data: {
        pageTitle: 'health.title'
    }
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var logs_component_1 = __webpack_require__(76);
exports.logsRoute = {
    path: 'logs',
    component: logs_component_1.LogsComponent,
    data: {
        pageTitle: 'logs.title'
    }
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var metrics_component_1 = __webpack_require__(79);
exports.metricsRoute = {
    path: 'dcs-metrics',
    component: metrics_component_1.DcsMetricsMonitoringComponent,
    data: {
        pageTitle: 'metrics.title'
    }
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var user_management_component_1 = __webpack_require__(84);
var user_management_detail_component_1 = __webpack_require__(82);
var user_management_dialog_component_1 = __webpack_require__(83);
var user_management_delete_dialog_component_1 = __webpack_require__(81);
var shared_1 = __webpack_require__(3);
var UserResolve = (function () {
    function UserResolve(principal) {
        this.principal = principal;
    }
    UserResolve.prototype.canActivate = function () {
        var _this = this;
        return this.principal.identity().then(function (account) { return _this.principal.hasAnyAuthority(['ROLE_ADMIN']); });
    };
    return UserResolve;
}());
UserResolve = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [shared_1.Principal])
], UserResolve);
exports.UserResolve = UserResolve;
var UserResolvePagingParams = (function () {
    function UserResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    UserResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return UserResolvePagingParams;
}());
UserResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], UserResolvePagingParams);
exports.UserResolvePagingParams = UserResolvePagingParams;
exports.userMgmtRoute = [
    {
        path: 'user-management',
        component: user_management_component_1.UserMgmtComponent,
        resolve: {
            'pagingParams': UserResolvePagingParams
        },
        data: {
            pageTitle: 'userManagement.home.title'
        }
    },
    {
        path: 'user-management/:login',
        component: user_management_detail_component_1.UserMgmtDetailComponent,
        data: {
            pageTitle: 'userManagement.home.title'
        }
    }
];
exports.userDialogRoute = [
    {
        path: 'user-management-new',
        component: user_management_dialog_component_1.UserDialogComponent,
        outlet: 'popup'
    },
    {
        path: 'user-management/:login/edit',
        component: user_management_dialog_component_1.UserDialogComponent,
        outlet: 'popup'
    },
    {
        path: 'user-management/:login/delete',
        component: user_management_delete_dialog_component_1.UserDeleteDialogComponent,
        outlet: 'popup'
    }
];


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var layouts_1 = __webpack_require__(24);
exports.navbarRoute = {
    path: '',
    component: layouts_1.NavbarComponent,
    outlet: 'navbar'
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ng_jhipster_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(50);
var auth_session_service_1 = __webpack_require__(44);
var login_modal_service_1 = __webpack_require__(46);
var AuthExpiredInterceptor = (function (_super) {
    __extends(AuthExpiredInterceptor, _super);
    function AuthExpiredInterceptor(injector, stateStorageService) {
        var _this = _super.call(this) || this;
        _this.injector = injector;
        _this.stateStorageService = stateStorageService;
        return _this;
    }
    AuthExpiredInterceptor.prototype.requestIntercept = function (options) {
        return options;
    };
    AuthExpiredInterceptor.prototype.responseIntercept = function (observable) {
        var _this = this;
        var self = this;
        return observable.catch(function (error) {
            if (error.status === 401 && error.text() !== '' && error.json().path && error.json().path.indexOf('/api/account') === -1) {
                var authServerProvider = self.injector.get(auth_session_service_1.AuthServerProvider);
                var destination = _this.stateStorageService.getDestinationState();
                var to = destination.destination;
                var toParams = destination.params;
                authServerProvider.logout();
                if (to.name === 'accessdenied') {
                    self.stateStorageService.storePreviousState(to.name, toParams);
                }
                var loginServiceModal = self.injector.get(login_modal_service_1.LoginModalService);
                loginServiceModal.open();
            }
            return Observable_1.Observable.throw(error);
        });
    };
    return AuthExpiredInterceptor;
}(ng_jhipster_1.HttpInterceptor));
exports.AuthExpiredInterceptor = AuthExpiredInterceptor;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ng_jhipster_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(50);
var ErrorHandlerInterceptor = (function (_super) {
    __extends(ErrorHandlerInterceptor, _super);
    function ErrorHandlerInterceptor(eventManager) {
        var _this = _super.call(this) || this;
        _this.eventManager = eventManager;
        return _this;
    }
    ErrorHandlerInterceptor.prototype.requestIntercept = function (options) {
        return options;
    };
    ErrorHandlerInterceptor.prototype.responseIntercept = function (observable) {
        var _this = this;
        return observable.catch(function (error) {
            if (!(error.status === 401 && (error.text() === '' ||
                (error.json().path && error.json().path.indexOf('/api/account') === 0)))) {
                _this.eventManager.broadcast({ name: 'deviceConfigurerServiceApp.httpError', content: error });
            }
            return Observable_1.Observable.throw(error);
        });
    };
    return ErrorHandlerInterceptor;
}(ng_jhipster_1.HttpInterceptor));
exports.ErrorHandlerInterceptor = ErrorHandlerInterceptor;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var ng_jhipster_1 = __webpack_require__(1);
var state_storage_service_1 = __webpack_require__(25);
var auth_expired_interceptor_1 = __webpack_require__(189);
var errorhandler_interceptor_1 = __webpack_require__(190);
var notification_interceptor_1 = __webpack_require__(192);
function interceptableFactory(backend, defaultOptions, injector, stateStorageService, eventManager) {
    return new ng_jhipster_1.InterceptableHttp(backend, defaultOptions, [
        new auth_expired_interceptor_1.AuthExpiredInterceptor(injector, stateStorageService),
        // Other interceptors can be added here
        new errorhandler_interceptor_1.ErrorHandlerInterceptor(eventManager),
        new notification_interceptor_1.NotificationInterceptor()
    ]);
}
exports.interceptableFactory = interceptableFactory;
;
function customHttpProvider() {
    return {
        provide: http_1.Http,
        useFactory: interceptableFactory,
        deps: [
            http_1.XHRBackend,
            http_1.RequestOptions,
            core_1.Injector,
            state_storage_service_1.StateStorageService,
            ng_jhipster_1.EventManager
        ]
    };
}
exports.customHttpProvider = customHttpProvider;
;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ng_jhipster_1 = __webpack_require__(1);
var Observable_1 = __webpack_require__(50);
var NotificationInterceptor = (function (_super) {
    __extends(NotificationInterceptor, _super);
    function NotificationInterceptor() {
        return _super.call(this) || this;
    }
    NotificationInterceptor.prototype.requestIntercept = function (options) {
        return options;
    };
    NotificationInterceptor.prototype.responseIntercept = function (observable) {
        return observable.catch(function (error) {
            var arr = Array.from(error.headers._headers);
            var headers = [];
            var i;
            for (i = 0; i < arr.length; i++) {
                if (arr[i][0].endsWith('app-alert') || arr[i][0].endsWith('app-params')) {
                    headers.push(arr[i][0]);
                }
            }
            headers.sort();
            var alertKey = headers.length >= 1 ? error.headers.get(headers[0]) : null;
            if (typeof alertKey === 'string') {
            }
            return Observable_1.Observable.throw(error);
        });
    };
    return NotificationInterceptor;
}(ng_jhipster_1.HttpInterceptor));
exports.NotificationInterceptor = NotificationInterceptor;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(8);
var seller_dashboard_module_1 = __webpack_require__(86);
var DashboardModule = (function () {
    function DashboardModule() {
    }
    return DashboardModule;
}());
DashboardModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule,
            seller_dashboard_module_1.SellerDashboardModule
        ],
        declarations: []
    })
], DashboardModule);
exports.DashboardModule = DashboardModule;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var seller_dashboard_service_1 = __webpack_require__(19);
var SellerChartComponent = (function () {
    function SellerChartComponent(sellerService) {
        this.sellerService = sellerService;
        this.activeDevices = 0;
        this.activeDevicesPerc = 0;
    }
    SellerChartComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sellerService.loadDevices().subscribe(function (res) {
            _this.devices = res.json();
            _this.allDevices = _this.devices.length;
            for (var _i = 0, _a = _this.devices; _i < _a.length; _i++) {
                var device = _a[_i];
                if (device.activated === true)
                    _this.activeDevices += 1;
            }
            _this.activeDevicesPerc = Math.round(_this.activeDevices / _this.allDevices * 100);
        });
    };
    SellerChartComponent.prototype.getStyle = function () {
        return this.activeDevicesPerc + "%";
    };
    return SellerChartComponent;
}());
SellerChartComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-chart',
        template: __webpack_require__(270),
        styles: []
    }),
    __metadata("design:paramtypes", [seller_dashboard_service_1.SellerDashboardService])
], SellerChartComponent);
exports.SellerChartComponent = SellerChartComponent;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var seller_dashboard_component_1 = __webpack_require__(85);
exports.sellerDashboardRoute = [
    {
        path: 'dashboard',
        component: seller_dashboard_component_1.SellerDashboardComponent,
        data: {
            authorities: ['ROLE_SELLER'],
            pageTitle: 'deviceConfigurerServiceApp.seller.dashboard.title'
        }
    },
];


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var csrf_service_1 = __webpack_require__(45);
var ngx_uploader_1 = __webpack_require__(49);
var SellerFileComponent = (function () {
    function SellerFileComponent(zone, csrfService) {
        this.zone = zone;
        this.csrfService = csrfService;
        this.notify = new core_1.EventEmitter();
        this.progress = false;
        this.sizeLimit = 20;
        this.sizeLimitBytes = this.sizeLimit * 1024 * 1024; // 10MB
    }
    SellerFileComponent.prototype.ngOnInit = function () {
        this.options = new ngx_uploader_1.NgUploaderOptions({
            url: '/api/dashboard/seller/upload/file',
            filterExtensions: true,
            allowedExtensions: ['pdf', 'epub', 'mobi', 'doc'],
            // maxSize: 2097152,
            autoUpload: false,
            calculateSpeed: true,
            fieldName: "file",
            fieldReset: true,
            maxUploads: 20,
            method: 'POST',
            multipart: true,
            // previewUrl: true,
            customHeaders: {
                'X-XSRF-TOKEN': this.csrfService.getCSRF()
            },
        });
        this.inputUploadEvents = new core_1.EventEmitter();
    };
    SellerFileComponent.prototype.ngOnDestroy = function () {
    };
    SellerFileComponent.prototype.startUpload = function () {
        this.inputUploadEvents.emit('startUpload');
    };
    SellerFileComponent.prototype.beforeUpload = function (uploadingFile, arg) {
        if (uploadingFile.size > this.sizeLimitBytes) {
            uploadingFile.setAbort();
            console.warn("File to big " + uploadingFile.size);
            this.errorMessage = 'deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.error.fileToBig';
        }
        else {
            this.progress = true;
        }
    };
    SellerFileComponent.prototype.fileChanged = function (event) {
        var file;
        if ((file = event.target.files[0])) {
            this.fileName = file.name;
            if (file.size > this.sizeLimitBytes) {
                this.errorMessage = 'deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.error.fileToBig';
            }
            else {
                this.errorMessage = null;
            }
        }
    };
    SellerFileComponent.prototype.handleUpload = function (data) {
        var _this = this;
        setTimeout(function () {
            _this.zone.run(function () {
                _this.response = data;
                if (data && data.response && data.status == 200) {
                    _this.response = JSON.parse(data.response);
                    //this.image = JSON.parse( data.response );
                    _this.progress = false;
                    //console.log( this.response )
                    _this.fileName = null;
                    _this.close();
                }
                else {
                    console.log(_this.response);
                }
            });
        });
    };
    SellerFileComponent.prototype.fileOverBase = function (e) {
        this.hasBaseDropZoneOver = e;
    };
    SellerFileComponent.prototype.close = function () {
        this.notify.emit(true);
    };
    SellerFileComponent.prototype.formatSizeLimit = function () {
        var sizeLimit = (this.sizeLimit / 1024 / 1024).toPrecision(1);
        return sizeLimit;
    };
    return SellerFileComponent;
}());
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], SellerFileComponent.prototype, "notify", void 0);
SellerFileComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-file',
        template: __webpack_require__(272),
        styles: ["\n    .device-img {\n        width: 15rem;\n        height: 22rem;\n        margin-top: 2rem;\n        margina-left: 3rem;\n    }\n    .drag-n-drop-container {\n        border: dotted 3px black ;\n        width: 100%;\n        height: 22rem;\n        text-align: center;\n        padding: 1rem\n    }\n    .hidden { display:none }\n    .file-over { border: dotted 3px red; }\n    "]
    }),
    __param(0, core_1.Inject(core_1.NgZone)),
    __metadata("design:paramtypes", [core_1.NgZone, csrf_service_1.CSRFService])
], SellerFileComponent);
exports.SellerFileComponent = SellerFileComponent;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var core_1 = __webpack_require__(0);
var ngx_uploader_1 = __webpack_require__(49);
var model_model_1 = __webpack_require__(22);
var image_resource_model_1 = __webpack_require__(37);
var csrf_service_1 = __webpack_require__(45);
var Subject_1 = __webpack_require__(152);
var seller_dashboard_service_1 = __webpack_require__(19);
var alert_service_1 = __webpack_require__(156);
var SellerModelImageComponent = (function () {
    function SellerModelImageComponent(zone, sellerService, alertService, csrfService) {
        this.zone = zone;
        this.sellerService = sellerService;
        this.alertService = alertService;
        this.csrfService = csrfService;
        this.subscriber = new Subject_1.Subject();
        this.reload = new core_1.EventEmitter();
        this.sizeLimit = 5;
        this.sizeLimitBytes = this.sizeLimit * 1024 * 1024; // 10MB
        this.showProgress = false;
    }
    SellerModelImageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.options = new ngx_uploader_1.NgUploaderOptions({
            url: '/api/dashboard/seller/model/' + this.model.id + '/upload/image/' + this.type,
            filterExtensions: true,
            allowedExtensions: ['png', 'jpg', 'jpeg'],
            // maxSize: 2097152,
            autoUpload: false,
            calculateSpeed: true,
            fieldName: this.type,
            fieldReset: true,
            maxUploads: 20,
            method: 'POST',
            multipart: true,
            // previewUrl: true,
            customHeaders: {
                'X-XSRF-TOKEN': this.csrfService.getCSRF()
            },
        });
        this.subscriber.subscribe(function (imageData) {
            _this.imageData = imageData;
            _this.inputUploadEvents.emit('startUpload');
        });
        this.inputUploadEvents = new core_1.EventEmitter();
    };
    SellerModelImageComponent.prototype.ngOnDestroy = function () {
        this.subscriber.unsubscribe();
    };
    SellerModelImageComponent.prototype.startUpload = function () {
        this.inputUploadEvents.emit('startUpload');
    };
    SellerModelImageComponent.prototype.beforeUpload = function (uploadingFile, arg) {
        if (uploadingFile.size > this.sizeLimitBytes) {
            uploadingFile.setAbort();
            this.errorMessage = 'deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.error.fileToBig';
        }
        else if (this.model.screenHeight !== this.imageData.height || this.model.screenWidth !== this.imageData.width) {
            console.log(this.imageData);
            uploadingFile.setAbort();
            this.errorMessage = 'deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.error.improperImageResolution';
        }
        else {
            this.showProgress = true;
        }
    };
    SellerModelImageComponent.prototype.handleUpload = function (data) {
        var _this = this;
        setTimeout(function () {
            _this.zone.run(function () {
                _this.response = data;
                console.log(_this.response);
                if (data && data.response && data.status == 200) {
                    _this.response = JSON.parse(data.response);
                    _this.image = JSON.parse(data.response);
                }
            });
        });
    };
    SellerModelImageComponent.prototype.fileChanged = function (event) {
        var _URL = window.URL;
        var whObservable = this.subscriber;
        //console.log( event.target.files[ 0 ] );
        var file, img;
        if ((file = event.target.files[0])) {
            img = new Image();
            img.onload = function () {
                var imageData = new ImageData;
                imageData.height = this.height;
                imageData.width = this.width;
                whObservable.next(imageData);
            };
            img.src = _URL.createObjectURL(file);
        }
    };
    SellerModelImageComponent.prototype.handlePreviewData = function (data) {
        this.previewData = data;
    };
    SellerModelImageComponent.prototype.fileOverBase = function (e) {
        this.hasBaseDropZoneOver = e;
    };
    SellerModelImageComponent.prototype.getFile = function () {
        return "data:image/png;base64," + this.image.file;
    };
    SellerModelImageComponent.prototype.removeImage = function () {
        //console.log(this.image)
        var _this = this;
        var c = confirm("Are you sure to remove the image?");
        if (c) {
            this.sellerService.removeImage(this.image.id, this.type).subscribe(function (res) {
                if (res.ok) {
                    _this.reload.emit(true);
                }
            }, function (res) { return _this.onError(res.json()); });
            ;
        }
    };
    SellerModelImageComponent.prototype.onError = function (error) {
        this.alertService.error(error.message, null, null);
    };
    return SellerModelImageComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", image_resource_model_1.ImageResource)
], SellerModelImageComponent.prototype, "image", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", model_model_1.Model)
], SellerModelImageComponent.prototype, "model", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SellerModelImageComponent.prototype, "type", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], SellerModelImageComponent.prototype, "description", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], SellerModelImageComponent.prototype, "reload", void 0);
SellerModelImageComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-model-image',
        template: __webpack_require__(273),
        styles: ["\n    .device-img {\n        width: 15rem;\n        height: 22rem;\n        margin-top: 2rem;\n        margina-left: 3rem;\n    }\n    .drag-n-drop-container {\n        border: dotted 3px black ;\n        width: 15rem;\n        height: 22rem;\n        text-align: center;\n        padding: 1rem\n    }\n    .hidden { display:none }\n    .file-over { border: dotted 3px red; }\n    .upload-button{\n        width: 200px;\n        display: block;\n        outline: none;\n        border-radius: 10px;\n        background: #111;\n        color: #fff;\n        text-transform: uppercase;\n        font-weight: bold;\n        font-size: 1rem;\n        text-align: center;\n        padding: 10px 50px;\n        border: 1px solid #111;\n        margin: 20px 3rem 1rem 0\n\n}\n    "]
    }),
    __param(0, core_1.Inject(core_1.NgZone)),
    __metadata("design:paramtypes", [core_1.NgZone,
        seller_dashboard_service_1.SellerDashboardService,
        alert_service_1.AlertService,
        csrf_service_1.CSRFService])
], SellerModelImageComponent);
exports.SellerModelImageComponent = SellerModelImageComponent;
var ImageData = (function () {
    function ImageData(width, height) {
        this.width = width;
        this.height = height;
    }
    return ImageData;
}());
exports.ImageData = ImageData;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var model_model_1 = __webpack_require__(22);
var seller_dashboard_service_1 = __webpack_require__(19);
var event_manager_service_1 = __webpack_require__(157);
var principal_service_1 = __webpack_require__(18);
var language_service_1 = __webpack_require__(155);
var SellerModelComponent = (function () {
    function SellerModelComponent(jhiLanguageService, principal, eventManager, sellerService) {
        this.jhiLanguageService = jhiLanguageService;
        this.principal = principal;
        this.eventManager = eventManager;
        this.sellerService = sellerService;
        this.jhiLanguageService.setLocations(['seller', 'model', 'modelImage']);
    }
    SellerModelComponent.prototype.ngOnInit = function () {
        this.loadModelImage();
    };
    SellerModelComponent.prototype.getScreensaver = function () {
        if (!this.modelImage || !this.modelImage.screensavers || this.modelImage.screensavers.length == 0)
            return null;
        return this.modelImage.screensavers[0];
    };
    SellerModelComponent.prototype.onReload = function (reload) {
        this.loadModelImage();
    };
    SellerModelComponent.prototype.loadModelImage = function () {
        var _this = this;
        this.sellerService.getModelImage(this.model.id).subscribe(function (res) {
            //console.log( res );
            _this.modelImage = res.json();
        });
    };
    return SellerModelComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", model_model_1.Model)
], SellerModelComponent.prototype, "model", void 0);
SellerModelComponent = __decorate([
    core_1.Component({
        selector: 'dcs-seller-model',
        template: __webpack_require__(274),
        styles: []
    }),
    __metadata("design:paramtypes", [language_service_1.JhiLanguageService,
        principal_service_1.Principal,
        event_manager_service_1.EventManager,
        seller_dashboard_service_1.SellerDashboardService])
], SellerModelComponent);
exports.SellerModelComponent = SellerModelComponent;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(92);
var ENTITY_STATES = _1.applicationRoute.concat(_1.applicationPopupRoute);
var DeviceConfigurerServiceApplicationArtatechModule = (function () {
    function DeviceConfigurerServiceApplicationArtatechModule() {
    }
    return DeviceConfigurerServiceApplicationArtatechModule;
}());
DeviceConfigurerServiceApplicationArtatechModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ApplicationArtatechComponent,
            _1.ApplicationArtatechDetailComponent,
            _1.ApplicationArtatechDialogComponent,
            _1.ApplicationArtatechDeleteDialogComponent,
            _1.ApplicationArtatechPopupComponent,
            _1.ApplicationArtatechDeletePopupComponent,
        ],
        entryComponents: [
            _1.ApplicationArtatechComponent,
            _1.ApplicationArtatechDialogComponent,
            _1.ApplicationArtatechPopupComponent,
            _1.ApplicationArtatechDeleteDialogComponent,
            _1.ApplicationArtatechDeletePopupComponent,
        ],
        providers: [
            _1.ApplicationArtatechService,
            _1.ApplicationArtatechPopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceApplicationArtatechModule);
exports.DeviceConfigurerServiceApplicationArtatechModule = DeviceConfigurerServiceApplicationArtatechModule;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var application_artatech_component_1 = __webpack_require__(90);
var application_artatech_detail_component_1 = __webpack_require__(88);
var application_artatech_dialog_component_1 = __webpack_require__(89);
var application_artatech_delete_dialog_component_1 = __webpack_require__(87);
exports.applicationRoute = [
    {
        path: 'application-artatech',
        component: application_artatech_component_1.ApplicationArtatechComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.application.home.title'
        }
    }, {
        path: 'application-artatech/:id',
        component: application_artatech_detail_component_1.ApplicationArtatechDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.application.home.title'
        }
    }
];
exports.applicationPopupRoute = [
    {
        path: 'application-artatech-new',
        component: application_artatech_dialog_component_1.ApplicationArtatechPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.application.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'application-artatech/:id/edit',
        component: application_artatech_dialog_component_1.ApplicationArtatechPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.application.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'application-artatech/:id/delete',
        component: application_artatech_delete_dialog_component_1.ApplicationArtatechDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.application.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(99);
var device_import_component_1 = __webpack_require__(96);
var ENTITY_STATES = _1.deviceRoute.concat(_1.devicePopupRoute);
var DeviceConfigurerServiceDeviceModule = (function () {
    function DeviceConfigurerServiceDeviceModule() {
    }
    return DeviceConfigurerServiceDeviceModule;
}());
DeviceConfigurerServiceDeviceModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.DeviceComponent,
            _1.DeviceDetailComponent,
            _1.DeviceDialogComponent,
            _1.DeviceDeleteDialogComponent,
            _1.DevicePopupComponent,
            _1.DeviceDeletePopupComponent,
            device_import_component_1.DeviceImportComponent
        ],
        entryComponents: [
            _1.DeviceComponent,
            _1.DeviceDialogComponent,
            _1.DevicePopupComponent,
            _1.DeviceDeleteDialogComponent,
            _1.DeviceDeletePopupComponent,
        ],
        providers: [
            _1.DeviceService,
            _1.DevicePopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceDeviceModule);
exports.DeviceConfigurerServiceDeviceModule = DeviceConfigurerServiceDeviceModule;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var device_component_1 = __webpack_require__(97);
var device_detail_component_1 = __webpack_require__(94);
var device_dialog_component_1 = __webpack_require__(95);
var device_delete_dialog_component_1 = __webpack_require__(93);
var device_import_component_1 = __webpack_require__(96);
exports.deviceRoute = [
    {
        path: 'device',
        component: device_component_1.DeviceComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.device.home.title'
        }
    }, {
        path: 'device/import',
        component: device_import_component_1.DeviceImportComponent,
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'deviceConfigurerServiceApp.device.home.title',
            type: 'import'
        }
    }, {
        path: 'device/delete',
        component: device_import_component_1.DeviceImportComponent,
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'deviceConfigurerServiceApp.device.home.title',
            type: 'delete'
        }
    }, {
        path: 'device/:id',
        component: device_detail_component_1.DeviceDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.device.home.title'
        }
    }
];
exports.devicePopupRoute = [
    {
        path: 'device-new',
        component: device_dialog_component_1.DevicePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.device.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'device/:id/edit',
        component: device_dialog_component_1.DevicePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.device.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'device/:id/delete',
        component: device_delete_dialog_component_1.DeviceDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.device.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var log_module_1 = __webpack_require__(210);
var application_artatech_module_1 = __webpack_require__(199);
var device_module_1 = __webpack_require__(201);
var image_resource_module_1 = __webpack_require__(207);
var model_module_1 = __webpack_require__(214);
var model_image_module_1 = __webpack_require__(212);
var resource_module_1 = __webpack_require__(216);
var seller_module_1 = __webpack_require__(218);
var feed_module_1 = __webpack_require__(204);
/* jhipster-needle-add-entity-module-import - JHipster will add entity modules imports here */
var DeviceConfigurerServiceEntityModule = (function () {
    function DeviceConfigurerServiceEntityModule() {
    }
    return DeviceConfigurerServiceEntityModule;
}());
DeviceConfigurerServiceEntityModule = __decorate([
    core_1.NgModule({
        imports: [
            log_module_1.DeviceConfigurerServiceLogModule,
            application_artatech_module_1.DeviceConfigurerServiceApplicationArtatechModule,
            device_module_1.DeviceConfigurerServiceDeviceModule,
            image_resource_module_1.DeviceConfigurerServiceImageResourceModule,
            model_module_1.DeviceConfigurerServiceModelModule,
            model_image_module_1.DeviceConfigurerServiceModelImageModule,
            resource_module_1.DeviceConfigurerServiceResourceModule,
            seller_module_1.DeviceConfigurerServiceSellerModule,
            feed_module_1.DeviceConfigurerServiceFeedModule,
        ],
        declarations: [],
        entryComponents: [],
        providers: [],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceEntityModule);
exports.DeviceConfigurerServiceEntityModule = DeviceConfigurerServiceEntityModule;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(206);
var ENTITY_STATES = _1.feedRoute.concat(_1.feedPopupRoute);
var DeviceConfigurerServiceFeedModule = (function () {
    function DeviceConfigurerServiceFeedModule() {
    }
    return DeviceConfigurerServiceFeedModule;
}());
DeviceConfigurerServiceFeedModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.FeedComponent,
            _1.FeedDetailComponent,
            _1.FeedDialogComponent,
            _1.FeedDeleteDialogComponent,
            _1.FeedPopupComponent,
            _1.FeedDeletePopupComponent,
        ],
        entryComponents: [
            _1.FeedComponent,
            _1.FeedDialogComponent,
            _1.FeedPopupComponent,
            _1.FeedDeleteDialogComponent,
            _1.FeedDeletePopupComponent,
        ],
        providers: [
            _1.FeedService,
            _1.FeedPopupService,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceFeedModule);
exports.DeviceConfigurerServiceFeedModule = DeviceConfigurerServiceFeedModule;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(3);
var feed_component_1 = __webpack_require__(103);
var feed_detail_component_1 = __webpack_require__(101);
var feed_dialog_component_1 = __webpack_require__(102);
var feed_delete_dialog_component_1 = __webpack_require__(100);
exports.feedRoute = [
    {
        path: 'feed',
        component: feed_component_1.FeedComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.feed.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }, {
        path: 'feed/:id',
        component: feed_detail_component_1.FeedDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.feed.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];
exports.feedPopupRoute = [
    {
        path: 'feed-new',
        component: feed_dialog_component_1.FeedPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.feed.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'feed/:id/edit',
        component: feed_dialog_component_1.FeedPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.feed.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    },
    {
        path: 'feed/:id/delete',
        component: feed_delete_dialog_component_1.FeedDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.feed.home.title'
        },
        canActivate: [shared_1.UserRouteAccessService],
        outlet: 'popup'
    }
];


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(104));
__export(__webpack_require__(35));
__export(__webpack_require__(12));
__export(__webpack_require__(102));
__export(__webpack_require__(100));
__export(__webpack_require__(101));
__export(__webpack_require__(103));
__export(__webpack_require__(205));


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(109);
var ENTITY_STATES = _1.imageResourceRoute.concat(_1.imageResourcePopupRoute);
var DeviceConfigurerServiceImageResourceModule = (function () {
    function DeviceConfigurerServiceImageResourceModule() {
    }
    return DeviceConfigurerServiceImageResourceModule;
}());
DeviceConfigurerServiceImageResourceModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ImageResourceComponent,
            _1.ImageResourceDetailComponent,
            _1.ImageResourceDialogComponent,
            _1.ImageResourceDeleteDialogComponent,
            _1.ImageResourcePopupComponent,
            _1.ImageResourceDeletePopupComponent,
        ],
        entryComponents: [
            _1.ImageResourceComponent,
            _1.ImageResourceDialogComponent,
            _1.ImageResourcePopupComponent,
            _1.ImageResourceDeleteDialogComponent,
            _1.ImageResourceDeletePopupComponent,
        ],
        providers: [
            _1.ImageResourceService,
            _1.ImageResourcePopupService,
            _1.ImageResourceResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceImageResourceModule);
exports.DeviceConfigurerServiceImageResourceModule = DeviceConfigurerServiceImageResourceModule;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var image_resource_component_1 = __webpack_require__(108);
var image_resource_detail_component_1 = __webpack_require__(106);
var image_resource_dialog_component_1 = __webpack_require__(107);
var image_resource_delete_dialog_component_1 = __webpack_require__(105);
var ImageResourceResolvePagingParams = (function () {
    function ImageResourceResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    ImageResourceResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return ImageResourceResolvePagingParams;
}());
ImageResourceResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], ImageResourceResolvePagingParams);
exports.ImageResourceResolvePagingParams = ImageResourceResolvePagingParams;
exports.imageResourceRoute = [
    {
        path: 'image-resource',
        component: image_resource_component_1.ImageResourceComponent,
        resolve: {
            'pagingParams': ImageResourceResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.imageResource.home.title'
        }
    }, {
        path: 'image-resource/:id',
        component: image_resource_detail_component_1.ImageResourceDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.imageResource.home.title'
        }
    }
];
exports.imageResourcePopupRoute = [
    {
        path: 'image-resource-new',
        component: image_resource_dialog_component_1.ImageResourcePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.imageResource.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'image-resource/:id/edit',
        component: image_resource_dialog_component_1.ImageResourcePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.imageResource.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'image-resource/:id/delete',
        component: image_resource_delete_dialog_component_1.ImageResourceDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.imageResource.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(114));
__export(__webpack_require__(38));
__export(__webpack_require__(14));
__export(__webpack_require__(112));
__export(__webpack_require__(110));
__export(__webpack_require__(111));
__export(__webpack_require__(113));
__export(__webpack_require__(211));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(209);
var ENTITY_STATES = _1.logRoute.concat(_1.logPopupRoute);
var DeviceConfigurerServiceLogModule = (function () {
    function DeviceConfigurerServiceLogModule() {
    }
    return DeviceConfigurerServiceLogModule;
}());
DeviceConfigurerServiceLogModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.LogComponent,
            _1.LogDetailComponent,
            _1.LogDialogComponent,
            _1.LogDeleteDialogComponent,
            _1.LogPopupComponent,
            _1.LogDeletePopupComponent,
        ],
        entryComponents: [
            _1.LogComponent,
            _1.LogDialogComponent,
            _1.LogPopupComponent,
            _1.LogDeleteDialogComponent,
            _1.LogDeletePopupComponent,
        ],
        providers: [
            _1.LogService,
            _1.LogPopupService,
            _1.LogResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceLogModule);
exports.DeviceConfigurerServiceLogModule = DeviceConfigurerServiceLogModule;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var log_component_1 = __webpack_require__(113);
var log_detail_component_1 = __webpack_require__(111);
var log_dialog_component_1 = __webpack_require__(112);
var log_delete_dialog_component_1 = __webpack_require__(110);
var LogResolvePagingParams = (function () {
    function LogResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    LogResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return LogResolvePagingParams;
}());
LogResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], LogResolvePagingParams);
exports.LogResolvePagingParams = LogResolvePagingParams;
exports.logRoute = [
    {
        path: 'log',
        component: log_component_1.LogComponent,
        resolve: {
            'pagingParams': LogResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.log.home.title'
        }
    }, {
        path: 'log/:id',
        component: log_detail_component_1.LogDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.log.home.title'
        }
    }
];
exports.logPopupRoute = [
    {
        path: 'log-new',
        component: log_dialog_component_1.LogPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.log.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'log/:id/edit',
        component: log_dialog_component_1.LogPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.log.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'log/:id/delete',
        component: log_delete_dialog_component_1.LogDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.log.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(115);
var ENTITY_STATES = _1.modelImageRoute.concat(_1.modelImagePopupRoute);
var DeviceConfigurerServiceModelImageModule = (function () {
    function DeviceConfigurerServiceModelImageModule() {
    }
    return DeviceConfigurerServiceModelImageModule;
}());
DeviceConfigurerServiceModelImageModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ModelImageComponent,
            _1.ModelImageDetailComponent,
            _1.ModelImageDialogComponent,
            _1.ModelImageDeleteDialogComponent,
            _1.ModelImagePopupComponent,
            _1.ModelImageDeletePopupComponent,
        ],
        entryComponents: [
            _1.ModelImageComponent,
            _1.ModelImageDialogComponent,
            _1.ModelImagePopupComponent,
            _1.ModelImageDeleteDialogComponent,
            _1.ModelImageDeletePopupComponent,
        ],
        providers: [
            _1.ModelImageService,
            _1.ModelImagePopupService,
            _1.ModelImageResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceModelImageModule);
exports.DeviceConfigurerServiceModelImageModule = DeviceConfigurerServiceModelImageModule;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var model_image_component_1 = __webpack_require__(119);
var model_image_detail_component_1 = __webpack_require__(117);
var model_image_dialog_component_1 = __webpack_require__(118);
var model_image_delete_dialog_component_1 = __webpack_require__(116);
var ModelImageResolvePagingParams = (function () {
    function ModelImageResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    ModelImageResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return ModelImageResolvePagingParams;
}());
ModelImageResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], ModelImageResolvePagingParams);
exports.ModelImageResolvePagingParams = ModelImageResolvePagingParams;
exports.modelImageRoute = [
    {
        path: 'model-image',
        component: model_image_component_1.ModelImageComponent,
        resolve: {
            'pagingParams': ModelImageResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.modelImage.home.title'
        }
    }, {
        path: 'model-image/:id',
        component: model_image_detail_component_1.ModelImageDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.modelImage.home.title'
        }
    }
];
exports.modelImagePopupRoute = [
    {
        path: 'model-image-new',
        component: model_image_dialog_component_1.ModelImagePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.modelImage.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'model-image/:id/edit',
        component: model_image_dialog_component_1.ModelImagePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.modelImage.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'model-image/:id/delete',
        component: model_image_delete_dialog_component_1.ModelImageDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.modelImage.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(121);
var ENTITY_STATES = _1.modelRoute.concat(_1.modelPopupRoute);
var DeviceConfigurerServiceModelModule = (function () {
    function DeviceConfigurerServiceModelModule() {
    }
    return DeviceConfigurerServiceModelModule;
}());
DeviceConfigurerServiceModelModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ModelComponent,
            _1.ModelDetailComponent,
            _1.ModelDialogComponent,
            _1.ModelDeleteDialogComponent,
            _1.ModelPopupComponent,
            _1.ModelDeletePopupComponent,
        ],
        entryComponents: [
            _1.ModelComponent,
            _1.ModelDialogComponent,
            _1.ModelPopupComponent,
            _1.ModelDeleteDialogComponent,
            _1.ModelDeletePopupComponent,
        ],
        providers: [
            _1.ModelService,
            _1.ModelPopupService,
            _1.ModelResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceModelModule);
exports.DeviceConfigurerServiceModelModule = DeviceConfigurerServiceModelModule;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var model_component_1 = __webpack_require__(125);
var model_detail_component_1 = __webpack_require__(123);
var model_dialog_component_1 = __webpack_require__(124);
var model_delete_dialog_component_1 = __webpack_require__(122);
var ModelResolvePagingParams = (function () {
    function ModelResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    ModelResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return ModelResolvePagingParams;
}());
ModelResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], ModelResolvePagingParams);
exports.ModelResolvePagingParams = ModelResolvePagingParams;
exports.modelRoute = [
    {
        path: 'model',
        component: model_component_1.ModelComponent,
        resolve: {
            'pagingParams': ModelResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.model.home.title'
        }
    }, {
        path: 'model/:id',
        component: model_detail_component_1.ModelDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.model.home.title'
        }
    }
];
exports.modelPopupRoute = [
    {
        path: 'model-new',
        component: model_dialog_component_1.ModelPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.model.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'model/:id/edit',
        component: model_dialog_component_1.ModelPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.model.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'model/:id/delete',
        component: model_delete_dialog_component_1.ModelDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.model.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(126);
var ENTITY_STATES = _1.resourceRoute.concat(_1.resourcePopupRoute);
var DeviceConfigurerServiceResourceModule = (function () {
    function DeviceConfigurerServiceResourceModule() {
    }
    return DeviceConfigurerServiceResourceModule;
}());
DeviceConfigurerServiceResourceModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true })
        ],
        declarations: [
            _1.ResourceComponent,
            _1.ResourceDetailComponent,
            _1.ResourceDialogComponent,
            _1.ResourceDeleteDialogComponent,
            _1.ResourcePopupComponent,
            _1.ResourceDeletePopupComponent,
        ],
        entryComponents: [
            _1.ResourceComponent,
            _1.ResourceDialogComponent,
            _1.ResourcePopupComponent,
            _1.ResourceDeleteDialogComponent,
            _1.ResourceDeletePopupComponent,
        ],
        providers: [
            _1.ResourceService,
            _1.ResourcePopupService,
            _1.ResourceResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceResourceModule);
exports.DeviceConfigurerServiceResourceModule = DeviceConfigurerServiceResourceModule;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var resource_component_1 = __webpack_require__(130);
var resource_detail_component_1 = __webpack_require__(128);
var resource_dialog_component_1 = __webpack_require__(129);
var resource_delete_dialog_component_1 = __webpack_require__(127);
var ResourceResolvePagingParams = (function () {
    function ResourceResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    ResourceResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return ResourceResolvePagingParams;
}());
ResourceResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], ResourceResolvePagingParams);
exports.ResourceResolvePagingParams = ResourceResolvePagingParams;
exports.resourceRoute = [
    {
        path: 'resource',
        component: resource_component_1.ResourceComponent,
        resolve: {
            'pagingParams': ResourceResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.resource.home.title'
        }
    }, {
        path: 'resource/:id',
        component: resource_detail_component_1.ResourceDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.resource.home.title'
        }
    }
];
exports.resourcePopupRoute = [
    {
        path: 'resource-new',
        component: resource_dialog_component_1.ResourcePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.resource.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'resource/:id/edit',
        component: resource_dialog_component_1.ResourcePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.resource.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'resource/:id/delete',
        component: resource_delete_dialog_component_1.ResourceDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.resource.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var admin_module_1 = __webpack_require__(66);
var _1 = __webpack_require__(20);
var seller_add_dialog_component_1 = __webpack_require__(42);
var seller_add_dialog_component_2 = __webpack_require__(42);
var ENTITY_STATES = _1.sellerRoute.concat(_1.sellerPopupRoute);
var DeviceConfigurerServiceSellerModule = (function () {
    function DeviceConfigurerServiceSellerModule() {
    }
    return DeviceConfigurerServiceSellerModule;
}());
DeviceConfigurerServiceSellerModule = __decorate([
    core_1.NgModule({
        imports: [
            shared_1.DeviceConfigurerServiceSharedModule,
            admin_module_1.DeviceConfigurerServiceAdminModule,
            router_1.RouterModule.forRoot(ENTITY_STATES, { useHash: true }),
        ],
        declarations: [
            _1.SellerComponent,
            _1.SellerDetailComponent,
            _1.SellerDialogComponent,
            _1.SellerDeleteDialogComponent,
            _1.SellerPopupComponent,
            _1.SellerDeletePopupComponent,
            seller_add_dialog_component_1.SellerAddDialogComponent,
            seller_add_dialog_component_2.SellerAddPopupComponent
        ],
        entryComponents: [
            _1.SellerComponent,
            _1.SellerDialogComponent,
            _1.SellerPopupComponent,
            _1.SellerDeleteDialogComponent,
            _1.SellerDeletePopupComponent,
            seller_add_dialog_component_1.SellerAddDialogComponent,
            seller_add_dialog_component_2.SellerAddPopupComponent
        ],
        providers: [
            _1.SellerService,
            _1.SellerPopupService,
            _1.SellerResolvePagingParams,
        ],
        schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA]
    })
], DeviceConfigurerServiceSellerModule);
exports.DeviceConfigurerServiceSellerModule = DeviceConfigurerServiceSellerModule;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var seller_component_1 = __webpack_require__(135);
var seller_detail_component_1 = __webpack_require__(133);
var seller_dialog_component_1 = __webpack_require__(134);
var seller_delete_dialog_component_1 = __webpack_require__(132);
var seller_add_dialog_component_1 = __webpack_require__(42);
var SellerResolvePagingParams = (function () {
    function SellerResolvePagingParams(paginationUtil) {
        this.paginationUtil = paginationUtil;
    }
    SellerResolvePagingParams.prototype.resolve = function (route, state) {
        var page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        var sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
        return {
            page: this.paginationUtil.parsePage(page),
            predicate: this.paginationUtil.parsePredicate(sort),
            ascending: this.paginationUtil.parseAscending(sort)
        };
    };
    return SellerResolvePagingParams;
}());
SellerResolvePagingParams = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [ng_jhipster_1.PaginationUtil])
], SellerResolvePagingParams);
exports.SellerResolvePagingParams = SellerResolvePagingParams;
exports.sellerRoute = [
    {
        path: 'seller',
        component: seller_component_1.SellerComponent,
        resolve: {
            'pagingParams': SellerResolvePagingParams
        },
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.seller.home.title'
        }
    }, {
        path: 'seller/:id',
        component: seller_detail_component_1.SellerDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.seller.home.title'
        }
    }
];
exports.sellerPopupRoute = [
    {
        path: 'seller-new',
        component: seller_add_dialog_component_1.SellerAddPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.seller.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'seller/:id/edit',
        component: seller_dialog_component_1.SellerPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.seller.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'seller/:id/delete',
        component: seller_delete_dialog_component_1.SellerDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'deviceConfigurerServiceApp.seller.home.title'
        },
        outlet: 'popup'
    }
];


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var shared_1 = __webpack_require__(3);
var HomeComponent = (function () {
    function HomeComponent(jhiLanguageService, principal, loginModalService, eventManager, router) {
        this.jhiLanguageService = jhiLanguageService;
        this.principal = principal;
        this.loginModalService = loginModalService;
        this.eventManager = eventManager;
        this.router = router;
        this.jhiLanguageService.setLocations(['home']);
    }
    HomeComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.principal.identity().then(function (account) {
            _this.account = account;
            if (_this.account.authorities.indexOf('ROLE_SELLER') >= 0) {
                _this.router.navigate(['/dashboard']);
            }
        });
        this.registerAuthenticationSuccess();
    };
    HomeComponent.prototype.registerAuthenticationSuccess = function () {
        var _this = this;
        this.eventManager.subscribe('authenticationSuccess', function (message) {
            _this.principal.identity().then(function (account) {
                _this.account = account;
            });
        });
    };
    HomeComponent.prototype.isAuthenticated = function () {
        return this.principal.isAuthenticated();
    };
    HomeComponent.prototype.login = function () {
        this.modalRef = this.loginModalService.open();
    };
    return HomeComponent;
}());
HomeComponent = __decorate([
    core_1.Component({
        selector: 'dcs-home',
        template: __webpack_require__(313),
        styles: [
            __webpack_require__(320)
        ]
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.JhiLanguageService,
        shared_1.Principal,
        shared_1.LoginModalService,
        ng_jhipster_1.EventManager,
        router_1.Router])
], HomeComponent);
exports.HomeComponent = HomeComponent;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(3);
var _1 = __webpack_require__(138);
exports.HOME_ROUTE = {
    path: '',
    component: _1.HomeComponent,
    data: {
        authorities: [],
        pageTitle: 'home.title'
    },
    canActivate: [shared_1.UserRouteAccessService]
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared_1 = __webpack_require__(3);
var error_component_1 = __webpack_require__(139);
exports.errorRoute = [
    {
        path: 'error',
        component: error_component_1.ErrorComponent,
        data: {
            authorities: [],
            pageTitle: 'error.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    },
    {
        path: 'accessdenied',
        component: error_component_1.ErrorComponent,
        data: {
            authorities: [],
            pageTitle: 'error.title'
        },
        canActivate: [shared_1.UserRouteAccessService]
    }
];


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var FooterComponent = (function () {
    function FooterComponent() {
    }
    return FooterComponent;
}());
FooterComponent = __decorate([
    core_1.Component({
        selector: 'dcs-footer',
        template: __webpack_require__(315)
    })
], FooterComponent);
exports.FooterComponent = FooterComponent;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var app_route_1 = __webpack_require__(188);
var _1 = __webpack_require__(24);
var LAYOUT_ROUTES = [
    app_route_1.navbarRoute
].concat(_1.errorRoute);
var LayoutRoutingModule = (function () {
    function LayoutRoutingModule() {
    }
    return LayoutRoutingModule;
}());
LayoutRoutingModule = __decorate([
    core_1.NgModule({
        imports: [
            router_1.RouterModule.forRoot(LAYOUT_ROUTES, { useHash: true })
        ],
        exports: [
            router_1.RouterModule
        ]
    })
], LayoutRoutingModule);
exports.LayoutRoutingModule = LayoutRoutingModule;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var shared_1 = __webpack_require__(3);
var DcsMainComponent = (function () {
    function DcsMainComponent(jhiLanguageHelper, router, $storageService) {
        this.jhiLanguageHelper = jhiLanguageHelper;
        this.router = router;
        this.$storageService = $storageService;
    }
    DcsMainComponent.prototype.getPageTitle = function (routeSnapshot) {
        var title = (routeSnapshot.data && routeSnapshot.data['pageTitle']) ? routeSnapshot.data['pageTitle'] : 'deviceConfigurerServiceApp';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    };
    DcsMainComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.router.events.subscribe(function (event) {
            if (event instanceof router_1.NavigationEnd) {
                _this.jhiLanguageHelper.updateTitle(_this.getPageTitle(_this.router.routerState.snapshot.root));
            }
            if (event instanceof router_1.RoutesRecognized) {
                var params = {};
                var destinationData = {};
                var destinationName = '';
                var destinationEvent = event.state.root.firstChild.children[0];
                if (destinationEvent !== undefined) {
                    params = destinationEvent.params;
                    destinationData = destinationEvent.data;
                    destinationName = destinationEvent.url[0].path;
                }
                var from = { name: _this.router.url.slice(1) };
                var destination = { name: destinationName, data: destinationData };
                _this.$storageService.storeDestinationState(destination, params, from);
            }
        });
    };
    return DcsMainComponent;
}());
DcsMainComponent = __decorate([
    core_1.Component({
        selector: 'dcs-main',
        template: __webpack_require__(316)
    }),
    __metadata("design:paramtypes", [shared_1.JhiLanguageHelper,
        router_1.Router,
        shared_1.StateStorageService])
], DcsMainComponent);
exports.DcsMainComponent = DcsMainComponent;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng2_translate_1 = __webpack_require__(26);
var ActiveMenuDirective = (function () {
    function ActiveMenuDirective(el, renderer, translateService) {
        this.el = el;
        this.renderer = renderer;
        this.translateService = translateService;
    }
    ActiveMenuDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.translateService.onLangChange.subscribe(function (event) {
            _this.updateActiveFlag(event.lang);
        });
        this.updateActiveFlag(this.translateService.currentLang);
    };
    ActiveMenuDirective.prototype.updateActiveFlag = function (selectedLanguage) {
        if (this.dcsActiveMenu === selectedLanguage) {
            this.renderer.setElementClass(this.el.nativeElement, 'active', true);
        }
        else {
            this.renderer.setElementClass(this.el.nativeElement, 'active', false);
        }
    };
    return ActiveMenuDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], ActiveMenuDirective.prototype, "dcsActiveMenu", void 0);
ActiveMenuDirective = __decorate([
    core_1.Directive({
        selector: '[dcsActiveMenu]'
    }),
    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer, ng2_translate_1.TranslateService])
], ActiveMenuDirective);
exports.ActiveMenuDirective = ActiveMenuDirective;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var ng_jhipster_1 = __webpack_require__(1);
var profile_service_1 = __webpack_require__(43); // FIXME barrel doesnt work here
var shared_1 = __webpack_require__(3);
var app_constants_1 = __webpack_require__(53);
var NavbarComponent = (function () {
    function NavbarComponent(loginService, languageHelper, languageService, principal, loginModalService, profileService, router, eventManager) {
        this.loginService = loginService;
        this.languageHelper = languageHelper;
        this.languageService = languageService;
        this.principal = principal;
        this.loginModalService = loginModalService;
        this.profileService = profileService;
        this.router = router;
        this.eventManager = eventManager;
        this.version = app_constants_1.DEBUG_INFO_ENABLED ? 'v' + app_constants_1.VERSION : '';
        this.isNavbarCollapsed = true;
        this.languageService.addLocation('home');
    }
    NavbarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.languageHelper.getAll().then(function (languages) {
            _this.languages = languages;
        });
        this.profileService.getProfileInfo().subscribe(function (profileInfo) {
            _this.inProduction = profileInfo.inProduction;
            _this.swaggerEnabled = profileInfo.swaggerEnabled;
        });
        this.principal.identity().then(function (account) {
            _this.account = account;
            if (account !== null) {
                _this.changeLanguage(account.langKey);
            }
        });
        this.registerAuthenticationSuccess();
    };
    NavbarComponent.prototype.registerAuthenticationSuccess = function () {
        var _this = this;
        this.eventManager.subscribe('authenticationSuccess', function (message) {
            _this.principal.identity().then(function (account) {
                _this.account = account;
                if (account !== null) {
                    _this.changeLanguage(account.langKey);
                }
            });
        });
    };
    NavbarComponent.prototype.changeLanguage = function (languageKey) {
        this.languageService.changeLanguage(languageKey);
    };
    NavbarComponent.prototype.collapseNavbar = function () {
        this.isNavbarCollapsed = true;
    };
    NavbarComponent.prototype.isAuthenticated = function () {
        return this.principal.isAuthenticated();
    };
    NavbarComponent.prototype.login = function () {
        this.modalRef = this.loginModalService.open();
    };
    NavbarComponent.prototype.logout = function () {
        this.router.navigate(['']);
        this.collapseNavbar();
        this.loginService.logout();
        this.account = null;
    };
    NavbarComponent.prototype.toggleNavbar = function () {
        this.isNavbarCollapsed = !this.isNavbarCollapsed;
    };
    NavbarComponent.prototype.getImageUrl = function () {
        return this.isAuthenticated() ? this.principal.getImageUrl() : null;
    };
    return NavbarComponent;
}());
NavbarComponent = __decorate([
    core_1.Component({
        selector: 'dcs-navbar',
        template: __webpack_require__(317),
        styles: [
            __webpack_require__(321)
        ]
    }),
    __metadata("design:paramtypes", [shared_1.LoginService,
        shared_1.JhiLanguageHelper,
        ng_jhipster_1.JhiLanguageService,
        shared_1.Principal,
        shared_1.LoginModalService,
        profile_service_1.ProfileService,
        router_1.Router,
        ng_jhipster_1.EventManager])
], NavbarComponent);
exports.NavbarComponent = NavbarComponent;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var profile_service_1 = __webpack_require__(43);
var PageRibbonComponent = (function () {
    function PageRibbonComponent(profileService) {
        this.profileService = profileService;
    }
    PageRibbonComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.profileService.getProfileInfo().subscribe(function (profileInfo) {
            _this.profileInfo = profileInfo;
            _this.ribbonEnv = profileInfo.ribbonEnv;
        });
    };
    return PageRibbonComponent;
}());
PageRibbonComponent = __decorate([
    core_1.Component({
        selector: 'dcs-page-ribbon',
        template: "<div class=\"ribbon\" *ngIf=\"ribbonEnv\"><a href=\"\" jhiTranslate=\"global.ribbon.{{ribbonEnv}}\">{{ribbonEnv}}</a></div>",
        styles: [
            __webpack_require__(322)
        ]
    }),
    __metadata("design:paramtypes", [profile_service_1.ProfileService])
], PageRibbonComponent);
exports.PageRibbonComponent = PageRibbonComponent;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng2_translate_1 = __webpack_require__(26);
var ng_jhipster_1 = __webpack_require__(1);
var DcsAlertErrorComponent = (function () {
    function DcsAlertErrorComponent(alertService, eventManager, translateService) {
        var _this = this;
        this.alertService = alertService;
        this.eventManager = eventManager;
        this.translateService = translateService;
        this.alerts = [];
        this.cleanHttpErrorListener = eventManager.subscribe('deviceConfigurerServiceApp.httpError', function (response) {
            var i;
            var httpResponse = response.content;
            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    _this.addErrorAlert('Server not reachable', 'error.server.not.reachable');
                    break;
                case 400:
                    var arr = Array.from(httpResponse.headers._headers);
                    var headers = [];
                    for (i = 0; i < arr.length; i++) {
                        if (arr[i][0].endsWith('app-error') || arr[i][0].endsWith('app-params')) {
                            headers.push(arr[i][0]);
                        }
                    }
                    headers.sort();
                    var errorHeader = httpResponse.headers.get(headers[0]);
                    var entityKey = httpResponse.headers.get(headers[1]);
                    if (errorHeader) {
                        var entityName = translateService.instant('global.menu.entities.' + entityKey);
                        _this.addErrorAlert(errorHeader, errorHeader, { entityName: entityName });
                    }
                    else if (httpResponse.text() !== '' && httpResponse.json() && httpResponse.json().fieldErrors) {
                        var fieldErrors = httpResponse.json().fieldErrors;
                        for (i = 0; i < fieldErrors.length; i++) {
                            var fieldError = fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = translateService.instant('deviceConfigurerServiceApp.' +
                                fieldError.objectName + '.' + convertedField);
                            _this.addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, { fieldName: fieldName });
                        }
                    }
                    else if (httpResponse.text() !== '' && httpResponse.json() && httpResponse.json().message) {
                        _this.addErrorAlert(httpResponse.json().message, httpResponse.json().message, httpResponse.json());
                    }
                    else {
                        _this.addErrorAlert(httpResponse.text());
                    }
                    break;
                case 404:
                    _this.addErrorAlert('Not found', 'error.url.not.found');
                    break;
                default:
                    if (httpResponse.text() !== '' && httpResponse.json() && httpResponse.json().message) {
                        _this.addErrorAlert(httpResponse.json().message);
                    }
                    else {
                        _this.addErrorAlert(JSON.stringify(httpResponse)); // Fixme find a way to parse httpResponse
                    }
            }
        });
    }
    DcsAlertErrorComponent.prototype.ngOnDestroy = function () {
        if (this.cleanHttpErrorListener !== undefined && this.cleanHttpErrorListener !== null) {
            this.eventManager.destroy(this.cleanHttpErrorListener);
            this.alerts = [];
        }
    };
    DcsAlertErrorComponent.prototype.addErrorAlert = function (message, key, data) {
        key = key && key !== null ? key : message;
        this.alerts.push(this.alertService.addAlert({
            type: 'danger',
            msg: key,
            params: data,
            timeout: 5000,
            toast: this.alertService.isToast(),
            scoped: true
        }, this.alerts));
    };
    return DcsAlertErrorComponent;
}());
DcsAlertErrorComponent = __decorate([
    core_1.Component({
        selector: 'dcs-alert-error',
        template: "\n        <div class=\"alerts\" role=\"alert\">\n            <div *ngFor=\"let alert of alerts\"  [ngClass]=\"{'alert.position': true, 'toast': alert.toast}\">\n                <ngb-alert type=\"{{alert.type}}\" close=\"alert.close(alerts)\"><pre>{{ alert.msg }}</pre></ngb-alert>\n            </div>\n        </div>"
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.AlertService, ng_jhipster_1.EventManager, ng2_translate_1.TranslateService])
], DcsAlertErrorComponent);
exports.DcsAlertErrorComponent = DcsAlertErrorComponent;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var ng_jhipster_1 = __webpack_require__(1);
var DcsAlertComponent = (function () {
    function DcsAlertComponent(alertService) {
        this.alertService = alertService;
    }
    DcsAlertComponent.prototype.ngOnInit = function () {
        this.alerts = this.alertService.get();
    };
    DcsAlertComponent.prototype.ngOnDestroy = function () {
        this.alerts = [];
    };
    return DcsAlertComponent;
}());
DcsAlertComponent = __decorate([
    core_1.Component({
        selector: 'dcs-alert',
        template: "\n        <div class=\"alerts\" role=\"alert\">\n            <div *ngFor=\"let alert of alerts\" [ngClass]=\"{'alert.position': true, 'toast': alert.toast}\">\n                <ngb-alert [type]=\"alert.type\" (close)=\"alert.close(alerts)\"><pre [innerHTML]=\"alert.msg\"></pre></ngb-alert>\n            </div>\n        </div>"
    }),
    __metadata("design:paramtypes", [ng_jhipster_1.AlertService])
], DcsAlertComponent);
exports.DcsAlertComponent = DcsAlertComponent;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var login_modal_service_1 = __webpack_require__(46);
var principal_service_1 = __webpack_require__(18);
var state_storage_service_1 = __webpack_require__(25);
var AuthService = (function () {
    function AuthService(principal, stateStorageService, loginModalService, router) {
        this.principal = principal;
        this.stateStorageService = stateStorageService;
        this.loginModalService = loginModalService;
        this.router = router;
    }
    AuthService.prototype.authorize = function (force) {
        var authReturn = this.principal.identity(force).then(authThen.bind(this));
        return authReturn;
        function authThen() {
            var _this = this;
            var isAuthenticated = this.principal.isAuthenticated();
            var toStateInfo = this.stateStorageService.getDestinationState().destination;
            // an authenticated user can't access to login and register pages
            if (isAuthenticated && (toStateInfo.name === 'register')) {
                this.router.navigate(['']);
                return false;
            }
            // recover and clear previousState after external login redirect (e.g. oauth2)
            var fromStateInfo = this.stateStorageService.getDestinationState().from;
            var previousState = this.stateStorageService.getPreviousState();
            if (isAuthenticated && !fromStateInfo.name && previousState) {
                this.stateStorageService.resetPreviousState();
                this.router.navigate([previousState.name], { queryParams: previousState.params });
                return false;
            }
            if (toStateInfo.data.authorities && toStateInfo.data.authorities.length > 0) {
                return this.principal.hasAnyAuthority(toStateInfo.data.authorities).then(function (hasAnyAuthority) {
                    if (!hasAnyAuthority) {
                        if (isAuthenticated) {
                            // user is signed in but not authorized for desired state
                            _this.router.navigate(['accessdenied']);
                        }
                        else {
                            // user is not authenticated. Show the state they wanted before you
                            // send them to the login service, so you can return them when you're done
                            var toStateParamsInfo = _this.stateStorageService.getDestinationState().params;
                            _this.stateStorageService.storePreviousState(toStateInfo.name, toStateParamsInfo);
                            // now, send them to the signin state so they can log in
                            _this.router.navigate(['accessdenied']).then(function () {
                                _this.loginModalService.open();
                            });
                        }
                    }
                    return hasAnyAuthority;
                });
            }
            return true;
        }
    };
    return AuthService;
}());
AuthService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [principal_service_1.Principal,
        state_storage_service_1.StateStorageService,
        login_modal_service_1.LoginModalService,
        router_1.Router])
], AuthService);
exports.AuthService = AuthService;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var principal_service_1 = __webpack_require__(18);
/**
 * @whatItDoes Conditionally includes an HTML element if current user has any
 * of the authorities passed as the `expression`.
 *
 * @howToUse
 * ```
 *     <some-element *jhiHasAnyAuthority="'ROLE_ADMIN'">...</some-element>
 *
 *     <some-element *jhiHasAnyAuthority="['ROLE_ADMIN', 'ROLE_USER']">...</some-element>
 * ```
 */
var HasAnyAuthorityDirective = (function () {
    function HasAnyAuthorityDirective(principal, templateRef, viewContainerRef) {
        this.principal = principal;
        this.templateRef = templateRef;
        this.viewContainerRef = viewContainerRef;
    }
    Object.defineProperty(HasAnyAuthorityDirective.prototype, "dcsHasAnyAuthority", {
        set: function (value) {
            var _this = this;
            this.authorities = typeof value === 'string' ? [value] : value;
            this.updateView();
            // Get notified each time authentication state changes.
            this.principal.getAuthenticationState().subscribe(function (identity) { return _this.updateView(); });
        },
        enumerable: true,
        configurable: true
    });
    HasAnyAuthorityDirective.prototype.updateView = function () {
        var _this = this;
        this.principal.hasAnyAuthority(this.authorities).then(function (result) {
            if (result) {
                _this.viewContainerRef.createEmbeddedView(_this.templateRef);
            }
            else {
                _this.viewContainerRef.clear();
            }
        });
    };
    return HasAnyAuthorityDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], HasAnyAuthorityDirective.prototype, "dcsHasAnyAuthority", null);
HasAnyAuthorityDirective = __decorate([
    core_1.Directive({
        selector: '[dcsHasAnyAuthority]'
    }),
    __metadata("design:paramtypes", [principal_service_1.Principal, core_1.TemplateRef, core_1.ViewContainerRef])
], HasAnyAuthorityDirective);
exports.HasAnyAuthorityDirective = HasAnyAuthorityDirective;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(2);
var _1 = __webpack_require__(3);
var UserRouteAccessService = (function () {
    function UserRouteAccessService(router, auth) {
        this.router = router;
        this.auth = auth;
    }
    UserRouteAccessService.prototype.canActivate = function (route) {
        return this.auth.authorize(false).then(function (canActivate) { return canActivate; });
    };
    return UserRouteAccessService;
}());
UserRouteAccessService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [router_1.Router, _1.AuthService])
], UserRouteAccessService);
exports.UserRouteAccessService = UserRouteAccessService;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.ITEMS_PER_PAGE = 20;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var FindLanguageFromKeyPipe = (function () {
    function FindLanguageFromKeyPipe() {
        this.languages = {
            'ca': 'Català',
            'cs': 'Český',
            'da': 'Dansk',
            'de': 'Deutsch',
            'el': 'Ελληνικά',
            'en': 'English',
            'es': 'Español',
            'et': 'Eesti',
            'fr': 'Français',
            'gl': 'Galego',
            'hu': 'Magyar',
            'hi': 'हिंदी',
            'hy': 'Հայերեն',
            'it': 'Italiano',
            'ja': '日本語',
            'ko': '한국어',
            'mr': 'मराठी',
            'nl': 'Nederlands',
            'pl': 'Polski',
            'pt-br': 'Português (Brasil)',
            'pt-pt': 'Português',
            'ro': 'Română',
            'ru': 'Русский',
            'sk': 'Slovenský',
            'sr': 'Srpski',
            'sv': 'Svenska',
            'ta': 'தமிழ்',
            'tr': 'Türkçe',
            'vi': 'Tiếng Việt',
            'zh-cn': '中文（简体）',
            'zh-tw': '繁體中文'
        };
    }
    FindLanguageFromKeyPipe.prototype.transform = function (lang) {
        return this.languages[lang];
    };
    return FindLanguageFromKeyPipe;
}());
FindLanguageFromKeyPipe = __decorate([
    core_1.Pipe({ name: 'findLanguageFromKey' })
], FindLanguageFromKeyPipe);
exports.FindLanguageFromKeyPipe = FindLanguageFromKeyPipe;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(51);
var ng2_translate_1 = __webpack_require__(26);
var ng_jhipster_1 = __webpack_require__(1);
var _1 = __webpack_require__(3);
function alertServiceProvider(sanitizer, translateService) {
    // set below to true to make alerts look like toast
    var isToast = false;
    return new ng_jhipster_1.AlertService(sanitizer, isToast, translateService);
}
exports.alertServiceProvider = alertServiceProvider;
var DeviceConfigurerServiceSharedCommonModule = (function () {
    function DeviceConfigurerServiceSharedCommonModule() {
    }
    return DeviceConfigurerServiceSharedCommonModule;
}());
DeviceConfigurerServiceSharedCommonModule = __decorate([
    core_1.NgModule({
        imports: [
            _1.DeviceConfigurerServiceSharedLibsModule
        ],
        declarations: [
            _1.FindLanguageFromKeyPipe,
            _1.DcsAlertComponent,
            _1.DcsAlertErrorComponent
        ],
        providers: [
            _1.JhiLanguageHelper,
            {
                provide: ng_jhipster_1.AlertService,
                useFactory: alertServiceProvider,
                deps: [core_1.Sanitizer, ng2_translate_1.TranslateService]
            },
            platform_browser_1.Title
        ],
        exports: [
            _1.DeviceConfigurerServiceSharedLibsModule,
            _1.FindLanguageFromKeyPipe,
            _1.DcsAlertComponent,
            _1.DcsAlertErrorComponent
        ]
    })
], DeviceConfigurerServiceSharedCommonModule);
exports.DeviceConfigurerServiceSharedCommonModule = DeviceConfigurerServiceSharedCommonModule;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = __webpack_require__(0);
var forms_1 = __webpack_require__(324);
var http_1 = __webpack_require__(5);
var common_1 = __webpack_require__(8);
var ng_bootstrap_1 = __webpack_require__(4);
var ng_jhipster_1 = __webpack_require__(1);
var angular2_infinite_scroll_1 = __webpack_require__(326);
var DeviceConfigurerServiceSharedLibsModule = (function () {
    function DeviceConfigurerServiceSharedLibsModule() {
    }
    return DeviceConfigurerServiceSharedLibsModule;
}());
DeviceConfigurerServiceSharedLibsModule = __decorate([
    core_1.NgModule({
        imports: [
            ng_bootstrap_1.NgbModule.forRoot(),
            ng_jhipster_1.NgJhipsterModule.forRoot({
                i18nEnabled: true,
                defaultI18nLang: 'pl'
            }),
            angular2_infinite_scroll_1.InfiniteScrollModule
        ],
        exports: [
            forms_1.FormsModule,
            http_1.HttpModule,
            common_1.CommonModule,
            ng_bootstrap_1.NgbModule,
            ng_jhipster_1.NgJhipsterModule,
            angular2_infinite_scroll_1.InfiniteScrollModule
        ]
    })
], DeviceConfigurerServiceSharedLibsModule);
exports.DeviceConfigurerServiceSharedLibsModule = DeviceConfigurerServiceSharedLibsModule;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Account = (function () {
    function Account(activated, authorities, email, firstName, langKey, lastName, login, imageUrl) {
        this.activated = activated;
        this.authorities = authorities;
        this.email = email;
        this.firstName = firstName;
        this.langKey = langKey;
        this.lastName = lastName;
        this.login = login;
        this.imageUrl = imageUrl;
    }
    return Account;
}());
exports.Account = Account;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(5);
var UserService = (function () {
    function UserService(http) {
        this.http = http;
        this.resourceUrl = 'api/users';
    }
    UserService.prototype.create = function (user) {
        return this.http.post(this.resourceUrl, user);
    };
    UserService.prototype.update = function (user) {
        return this.http.put(this.resourceUrl, user);
    };
    UserService.prototype.find = function (login) {
        return this.http.get(this.resourceUrl + "/" + login).map(function (res) { return res.json(); });
    };
    UserService.prototype.query = function (req) {
        var params = new http_1.URLSearchParams();
        if (req) {
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
        }
        var options = {
            search: params
        };
        return this.http.get(this.resourceUrl, options);
    };
    UserService.prototype.delete = function (login) {
        return this.http.delete(this.resourceUrl + "/" + login);
    };
    return UserService;
}());
UserService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [http_1.Http])
], UserService);
exports.UserService = UserService;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)();
// imports


// module
exports.push([module.i, "ul#strengthBar{display:inline;list-style:none;margin:0;margin-left:15px;padding:0;vertical-align:2px}.point:last{margin:0!important}.point{background:#ddd;border-radius:2px;display:inline-block;height:5px;margin-right:1px;width:20px}", ""]);

// exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)();
// imports


// module
exports.push([module.i, ".hipster{display:inline-block;width:347px;height:120px;background-size:contain}.home{height:400px}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.hipster{background-size:contain}}", ""]);

// exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)();
// imports


// module
exports.push([module.i, ".navbar-version{font-size:10px;color:#ccc}.jh-navbar{background-color:#353d47;padding:.2em 1em}.jh-navbar .profile-image{margin:-10px 0;height:40px;width:140px;border-radius:50%}.jh-navbar .dropdown-item.active,.jh-navbar .dropdown-item.active:focus,.jh-navbar .dropdown-item.active:hover{background-color:#353d47}.jh-navbar .dropdown-toggle:after{margin-left:.15em}.jh-navbar ul.navbar-nav{padding:.5em}.jh-navbar .navbar-nav .nav-item{margin-left:1.5rem}.jh-navbar a.nav-link{font-weight:400}.jh-navbar .jh-navbar-toggler{color:#ccc;font-size:1.5em;padding:10px}.jh-navbar .jh-navbar-toggler:hover{color:#fff}@media screen and (max-width:992px){.jh-logo-container{width:100%}}.navbar-title{display:inline-block;vertical-align:middle}.navbar-brand.logo{padding:5px 15px}.logo .logo-img{height:45px;display:inline-block;vertical-align:middle;width:140px}.logo-img{height:100%;background-size:contain;width:100%}", ""]);

// exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)();
// imports


// module
exports.push([module.i, ".ribbon{background-color:rgba(170,0,0,.5);left:-3.5em;moz-transform:rotate(-45deg);ms-transform:rotate(-45deg);o-transform:rotate(-45deg);webkit-transform:rotate(-45deg);transform:rotate(-45deg);overflow:hidden;position:absolute;top:40px;white-space:nowrap;width:15em;z-index:9999;opacity:.75}.ribbon,.ribbon a{pointer-events:none}.ribbon a{color:#fff;display:block;font-weight:400;margin:1px 0;padding:10px 50px;text-align:center;text-decoration:none;text-shadow:0 0 5px #444}", ""]);

// exports


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__(26);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "translateLoaderFactory", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["translateLoaderFactory"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateModule", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateModule"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslatePipe", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslatePipe"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "MissingTranslationHandler", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["MissingTranslationHandler"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateLoader", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateLoader"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateStaticLoader", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateStaticLoader"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateService", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateService"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateParser", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateParser"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DefaultTranslateParser", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["DefaultTranslateParser"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TranslateDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__index__["TranslateDirective"]; });



/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bar_component__ = __webpack_require__(148);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BarComponent", function() { return __WEBPACK_IMPORTED_MODULE_0__bar_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_directive__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressDirective", function() { return __WEBPACK_IMPORTED_MODULE_1__progress_directive__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__progressbar_component__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressbarComponent", function() { return __WEBPACK_IMPORTED_MODULE_2__progressbar_component__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progressbar_module__ = __webpack_require__(246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressbarModule", function() { return __WEBPACK_IMPORTED_MODULE_3__progressbar_module__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progressbar_config__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressbarConfig", function() { return __WEBPACK_IMPORTED_MODULE_4__progressbar_config__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bar_component__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__progress_directive__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__progressbar_component__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__progressbar_config__ = __webpack_require__(48);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProgressbarModule; });






var ProgressbarModule = (function () {
    function ProgressbarModule() {
    }
    ProgressbarModule.forRoot = function () {
        return { ngModule: ProgressbarModule, providers: [__WEBPACK_IMPORTED_MODULE_5__progressbar_config__["a" /* ProgressbarConfig */]] };
    };
    ProgressbarModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                    imports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"]],
                    declarations: [__WEBPACK_IMPORTED_MODULE_3__progress_directive__["a" /* ProgressDirective */], __WEBPACK_IMPORTED_MODULE_2__bar_component__["a" /* BarComponent */], __WEBPACK_IMPORTED_MODULE_4__progressbar_component__["a" /* ProgressbarComponent */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_3__progress_directive__["a" /* ProgressDirective */], __WEBPACK_IMPORTED_MODULE_2__bar_component__["a" /* BarComponent */], __WEBPACK_IMPORTED_MODULE_4__progressbar_component__["a" /* ProgressbarComponent */]]
                },] },
    ];
    /** @nocollapse */
    ProgressbarModule.ctorParameters = function () { return []; };
    return ProgressbarModule;
}());

//# sourceMappingURL=progressbar.module.js.map

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export OnChange */
/*tslint:disable:no-invalid-this */
function OnChange(defaultValue) {
    var sufix = 'Change';
    return function OnChangeHandler(target, propertyKey) {
        var _key = " __" + propertyKey + "Value";
        Object.defineProperty(target, propertyKey, {
            get: function () { return this[_key]; },
            set: function (value) {
                var prevValue = this[_key];
                this[_key] = value;
                if (prevValue !== value && this[propertyKey + sufix]) {
                    this[propertyKey + sufix].emit(value);
                }
            }
        });
    };
}
/* tslint:enable */
//# sourceMappingURL=decorators.js.map

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decorators__ = __webpack_require__(247);
/* unused harmony reexport OnChange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linked_list_class__ = __webpack_require__(249);
/* unused harmony reexport LinkedList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng2_bootstrap_config__ = __webpack_require__(151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__ng2_bootstrap_config__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trigger_class__ = __webpack_require__(250);
/* unused harmony reexport Trigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_class__ = __webpack_require__(251);
/* unused harmony reexport Utils */





//# sourceMappingURL=index.js.map

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LinkedList */
var LinkedList = (function () {
    function LinkedList() {
        this.length = 0;
        this.asArray = [];
        // Array methods overriding END
    }
    LinkedList.prototype.getNode = function (position) {
        if (this.length === 0 || position < 0 || position >= this.length) {
            throw new Error('Position is out of the list');
        }
        var current = this.head;
        for (var index = 0; index < position; index++) {
            current = current.next;
        }
        return current;
    };
    LinkedList.prototype.createInternalArrayRepresentation = function () {
        var outArray = [];
        var current = this.head;
        while (current) {
            outArray.push(current.value);
            current = current.next;
        }
        this.asArray = outArray;
    };
    LinkedList.prototype.get = function (position) {
        if (this.length === 0 || position < 0 || position >= this.length) {
            return void 0;
        }
        var current = this.head;
        for (var index = 0; index < position; index++) {
            current = current.next;
        }
        return current.value;
    };
    LinkedList.prototype.add = function (value, position) {
        if (position === void 0) { position = this.length; }
        if (position < 0 || position > this.length) {
            throw new Error('Position is out of the list');
        }
        var node = {
            value: value,
            next: undefined,
            previous: undefined
        };
        if (this.length === 0) {
            this.head = node;
            this.tail = node;
            this.current = node;
        }
        else {
            if (position === 0) {
                // first node
                node.next = this.head;
                this.head.previous = node;
                this.head = node;
            }
            else if (position === this.length) {
                // last node
                this.tail.next = node;
                node.previous = this.tail;
                this.tail = node;
            }
            else {
                // node in middle
                var currentPreviousNode = this.getNode(position - 1);
                var currentNextNode = currentPreviousNode.next;
                currentPreviousNode.next = node;
                currentNextNode.previous = node;
                node.previous = currentPreviousNode;
                node.next = currentNextNode;
            }
        }
        this.length++;
        this.createInternalArrayRepresentation();
    };
    LinkedList.prototype.remove = function (position) {
        if (position === void 0) { position = 0; }
        if (this.length === 0 || position < 0 || position >= this.length) {
            throw new Error('Position is out of the list');
        }
        if (position === 0) {
            // first node
            this.head = this.head.next;
            if (this.head) {
                // there is no second node
                this.head.previous = undefined;
            }
            else {
                // there is no second node
                this.tail = undefined;
            }
        }
        else if (position === this.length - 1) {
            // last node
            this.tail = this.tail.previous;
            this.tail.next = undefined;
        }
        else {
            // middle node
            var removedNode = this.getNode(position);
            removedNode.next.previous = removedNode.previous;
            removedNode.previous.next = removedNode.next;
        }
        this.length--;
        this.createInternalArrayRepresentation();
    };
    LinkedList.prototype.set = function (position, value) {
        if (this.length === 0 || position < 0 || position >= this.length) {
            throw new Error('Position is out of the list');
        }
        var node = this.getNode(position);
        node.value = value;
        this.createInternalArrayRepresentation();
    };
    LinkedList.prototype.toArray = function () {
        return this.asArray;
    };
    LinkedList.prototype.findAll = function (fn) {
        var current = this.head;
        var result = [];
        for (var index = 0; index < this.length; index++) {
            if (fn(current.value, index)) {
                result.push({ index: index, value: current.value });
            }
            current = current.next;
        }
        return result;
    };
    // Array methods overriding start
    LinkedList.prototype.push = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        args.forEach(function (arg) {
            _this.add(arg);
        });
        return this.length;
    };
    LinkedList.prototype.pop = function () {
        if (this.length === 0) {
            return undefined;
        }
        var last = this.tail;
        this.remove(this.length - 1);
        return last.value;
    };
    LinkedList.prototype.unshift = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        args.reverse();
        args.forEach(function (arg) {
            _this.add(arg, 0);
        });
        return this.length;
    };
    LinkedList.prototype.shift = function () {
        if (this.length === 0) {
            return undefined;
        }
        var lastItem = this.head.value;
        this.remove();
        return lastItem;
    };
    LinkedList.prototype.forEach = function (fn) {
        var current = this.head;
        for (var index = 0; index < this.length; index++) {
            fn(current.value, index);
            current = current.next;
        }
    };
    LinkedList.prototype.indexOf = function (value) {
        var current = this.head;
        var position = 0;
        for (var index = 0; index < this.length; index++) {
            if (current.value === value) {
                position = index;
                break;
            }
            current = current.next;
        }
        return position;
    };
    LinkedList.prototype.some = function (fn) {
        var current = this.head;
        var result = false;
        while (current && !result) {
            if (fn(current.value)) {
                result = true;
                break;
            }
            current = current.next;
        }
        return result;
    };
    LinkedList.prototype.every = function (fn) {
        var current = this.head;
        var result = true;
        while (current && result) {
            if (!fn(current.value)) {
                result = false;
            }
            current = current.next;
        }
        return result;
    };
    LinkedList.prototype.toString = function () {
        return '[Linked List]';
    };
    LinkedList.prototype.find = function (fn) {
        var current = this.head;
        var result;
        for (var index = 0; index < this.length; index++) {
            if (fn(current.value, index)) {
                result = current.value;
                break;
            }
            current = current.next;
        }
        return result;
    };
    LinkedList.prototype.findIndex = function (fn) {
        var current = this.head;
        var result;
        for (var index = 0; index < this.length; index++) {
            if (fn(current.value, index)) {
                result = index;
                break;
            }
            current = current.next;
        }
        return result;
    };
    return LinkedList;
}());

//# sourceMappingURL=linked-list.class.js.map

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Trigger */
/**
 * @copyright Valor Software
 * @copyright Angular ng-bootstrap team
 */
var Trigger = (function () {
    function Trigger(open, close) {
        this.open = open;
        this.close = close || open;
    }
    Trigger.prototype.isManual = function () { return this.open === 'manual' || this.close === 'manual'; };
    return Trigger;
}());

//# sourceMappingURL=trigger.class.js.map

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_browser__ = __webpack_require__(150);
/* unused harmony export Utils */

var Utils = (function () {
    function Utils() {
    }
    Utils.reflow = function (element) {
        (function (bs) { return bs; })(element.offsetHeight);
    };
    // source: https://github.com/jquery/jquery/blob/master/src/css/var/getStyles.js
    Utils.getStyles = function (elem) {
        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) {
            view = __WEBPACK_IMPORTED_MODULE_0__facade_browser__["a" /* window */];
        }
        return view.getComputedStyle(elem);
    };
    return Utils;
}());

//# sourceMappingURL=utils.class.js.map

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"col-md-8 offset-md-2\">\n            <h1 jhiTranslate=\"activate.title\">Activation</h1>\n\n            <div class=\"alert alert-success\" *ngIf=\"success\">\n                <span jhiTranslate=\"activate.messages.success\">\n                    <strong>Your user has been activated.</strong> Please\n                    <a class=\"alert-link\" (click)=\"login()\" jhiTranslate=\"global.messages.info.authenticated.link\">sign\n                        in</a>.\n                </span>\n            </div>\n\n            <div class=\"alert alert-danger\" *ngIf=\"error\" jhiTranslate=\"activate.messages.error\">\n                <strong>Your user could not be activated.</strong> Please use the registration form to sign up.\n            </div>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"col-md-4 col-md-offset-4\">\n            <h1 jhiTranslate=\"reset.finish.title\">Reset password</h1>\n\n            <div class=\"alert alert-danger\" jhiTranslate=\"reset.finish.messages.keymissing\" *ngIf=\"keyMissing\">\n                <strong>The password reset key is missing.</strong>\n            </div>\n\n            <div class=\"alert alert-warning\" *ngIf=\"!success && !keyMissing\">\n                <p jhiTranslate=\"reset.finish.messages.info\">Choose a new password</p>\n            </div>\n\n            <div class=\"alert alert-danger\" *ngIf=\"error\">\n                <p jhiTranslate=\"reset.finish.messages.error\">Your password couldn't be reset. Remember a password\n                    request is only valid for 24 hours.</p>\n            </div>\n\n            <p class=\"alert alert-success\" *ngIf=\"success\">\n                <span jhiTranslate=\"reset.finish.messages.success\"><strong>Your password has been reset.</strong> Please </span>\n                <a class=\"alert-link\" (click)=\"login()\" jhiTranslate=\"global.messages.info.authenticated.link\">sign\n                    in</a>.\n            </p>\n\n            <div class=\"alert alert-danger\" *ngIf=\"doNotMatch\" jhiTranslate=\"global.messages.error.dontmatch\">\n                The password and its confirmation do not match!\n            </div>\n\n            <div *ngIf=\"!keyMissing\">\n                <form *ngIf=\"!success\" name=\"form\" role=\"form\" (ngSubmit)=\"finishReset()\" #passwordForm=\"ngForm\">\n                    <div class=\"form-group\">\n                        <label class=\"form-control-label\" for=\"password\" jhiTranslate=\"global.form.newpassword\">New\n                            password</label>\n                        <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\"\n                               #passwordInput=\"ngModel\"\n                               placeholder=\"{{'global.form.newpassword.placeholder' | translate}}\"\n                               [(ngModel)]=\"resetAccount.password\" minlength=4 maxlength=50 required>\n                        <div *ngIf=\"passwordInput.dirty && passwordInput.invalid\">\n                            <small class=\"form-text text-danger\"\n                                   *ngIf=\"passwordInput.errors.required\"\n                                   jhiTranslate=\"global.messages.validate.newpassword.required\">\n                                Your password is required.\n                            </small>\n                            <small class=\"form-text text-danger\"\n                                   *ngIf=\"passwordInput.errors.minlength\"\n                                   jhiTranslate=\"global.messages.validate.newpassword.minlength\">\n                                Your password is required to be at least 4 characters.\n                            </small>\n                            <small class=\"form-text text-danger\"\n                                   *ngIf=\"passwordInput.errors.maxlength\"\n                                   jhiTranslate=\"global.messages.validate.newpassword.maxlength\">\n                                Your password cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                        <dcs-password-strength-bar\n                            [passwordToCheck]=\"resetAccount.password\"></dcs-password-strength-bar>\n                    </div>\n\n                    <div class=\"form-group\">\n                        <label class=\"form-control-label\" for=\"confirmPassword\"\n                               jhiTranslate=\"global.form.confirmpassword\">New password confirmation</label>\n                        <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\"\n                               #confirmPasswordInput=\"ngModel\"\n                               placeholder=\"{{'global.form.confirmpassword.placeholder' | translate}}\"\n                               [(ngModel)]=\"confirmPassword\" minlength=4 maxlength=50 required>\n                        <div *ngIf=\"confirmPasswordInput.dirty && confirmPasswordInput.invalid\">\n                            <small class=\"form-text text-danger\"\n                                   *ngIf=\"confirmPasswordInput.errors.required\"\n                                   jhiTranslate=\"global.messages.validate.confirmpassword.required\">\n                                Your password confirmation is required.\n                            </small>\n                            <small class=\"form-text text-danger\"\n                                   *ngIf=\"confirmPasswordInput.errors.minlength\"\n                                   jhiTranslate=\"global.messages.validate.confirmpassword.minlength\">\n                                Your password confirmation is required to be at least 4 characters.\n                            </small>\n                            <small class=\"form-text text-danger\"\n                                   *ngIf=\"confirmPasswordInput.errors.maxlength\"\n                                   jhiTranslate=\"global.messages.validate.confirmpassword.maxlength\">\n                                Your password confirmation cannot be longer than 50 characters.\n                            </small>\n                        </div>\n                    </div>\n                    <button type=\"submit\" [disabled]=\"passwordForm.form.invalid\" class=\"btn btn-primary\"\n                            jhiTranslate=\"reset.finish.form.button\">Reset Password\n                    </button>\n                </form>\n            </div>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"col-md-8 offset-md-2\">\n            <h1 jhiTranslate=\"reset.request.title\">Reset your password</h1>\n\n            <div class=\"alert alert-danger\" jhiTranslate=\"reset.request.messages.notfound\" *ngIf=\"errorEmailNotExists\">\n                <strong>E-Mail address isn't registered!</strong> Please check and try again.\n            </div>\n\n            <div class=\"alert alert-warning\" *ngIf=\"!success\">\n                <p jhiTranslate=\"reset.request.messages.info\">Enter the e-mail address you used to register.</p>\n            </div>\n\n            <div class=\"alert alert-success\" *ngIf=\"success == 'OK'\">\n                <p jhiTranslate=\"reset.request.messages.success\">Check your e-mails for details on how to reset your\n                    password.</p>\n            </div>\n\n            <form *ngIf=\"!success\" name=\"form\" role=\"form\" (ngSubmit)=\"requestReset()\" #resetRequestForm=\"ngForm\">\n                <div class=\"form-group\">\n                    <label class=\"form-control-label\" for=\"email\" jhiTranslate=\"global.form.email\">E-mail</label>\n                    <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\"\n                           placeholder=\"{{'global.form.email.placeholder' | translate}}\"\n                           [(ngModel)]=\"resetAccount.email\" minlength=5 maxlength=100 #emailInput=\"ngModel\" required>\n                    <div *ngIf=\"emailInput.dirty && emailInput.invalid\">\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"emailInput.errors.required\"\n                               jhiTranslate=\"global.messages.validate.email.required\">\n                            Your e-mail is required.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"emailInput.errors.email\" jhiTranslate=\"global.messages.validate.email.invalid\">\n                            Your e-mail is invalid.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"emailInput.errors.minlength\"\n                               jhiTranslate=\"global.messages.validate.email.minlength\">\n                            Your e-mail is required to be at least 5 characters.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"emailInput.errors.maxlength\"\n                               jhiTranslate=\"global.messages.validate.email.maxlength\">\n                            Your e-mail cannot be longer than 100 characters.\n                        </small>\n                    </div>\n                </div>\n                <button type=\"submit\" [disabled]=\"resetRequestForm.form.invalid\" class=\"btn btn-primary\"\n                        jhiTranslate=\"reset.request.form.button\">Reset\n                </button>\n            </form>\n\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"col-md-8 offset-md-2\">\n            <h2 jhiTranslate=\"password.title\" translateValues=\"{username: '{{account.login}}'}\" *ngIf=\"account\">Password\n                for [<b>{{account.login}}</b>]</h2>\n\n            <div class=\"alert alert-success\" *ngIf=\"success\" jhiTranslate=\"password.messages.success\">\n                <strong>Password changed!</strong>\n            </div>\n            <div class=\"alert alert-danger\" *ngIf=\"error\" jhiTranslate=\"password.messages.error\">\n                <strong>An error has occurred!</strong> The password could not be changed.\n            </div>\n\n            <div class=\"alert alert-danger\" *ngIf=\"doNotMatch\" jhiTranslate=\"global.messages.error.dontmatch\">\n                The password and its confirmation do not match!\n            </div>\n\n            <form name=\"form\" role=\"form\" (ngSubmit)=\"changePassword()\" #passwordForm=\"ngForm\">\n\n                <div class=\"form-group\">\n                    <label class=\"form-control-label\" for=\"password\" jhiTranslate=\"global.form.newpassword\">New\n                        password</label>\n                    <input type=\"password\" class=\"form-control\" id=\"password\" name=\"password\" #passwordInput=\"ngModel\"\n                           placeholder=\"{{'global.form.newpassword.placeholder' | translate}}\"\n                           [(ngModel)]=\"password\" minlength=4 maxlength=50 required>\n                    <div *ngIf=\"passwordInput.dirty && passwordInput.invalid\">\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"passwordInput.errors.required\"\n                               jhiTranslate=\"global.messages.validate.newpassword.required\">\n                            Your password is required.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"passwordInput.errors.minlength\"\n                               jhiTranslate=\"global.messages.validate.newpassword.minlength\">\n                            Your password is required to be at least 4 characters.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"passwordInput.errors.maxlength\"\n                               jhiTranslate=\"global.messages.validate.newpassword.maxlength\">\n                            Your password cannot be longer than 50 characters.\n                        </small>\n                    </div>\n                    <dcs-password-strength-bar [passwordToCheck]=\"password\"></dcs-password-strength-bar>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"form-control-label\" for=\"confirmPassword\" jhiTranslate=\"global.form.confirmpassword\">New\n                        password confirmation</label>\n                    <input type=\"password\" class=\"form-control\" id=\"confirmPassword\" name=\"confirmPassword\"\n                           #confirmPasswordInput=\"ngModel\"\n                           placeholder=\"{{'global.form.confirmpassword.placeholder' | translate}}\"\n                           [(ngModel)]=\"confirmPassword\" minlength=4 maxlength=50 required>\n                    <div *ngIf=\"confirmPasswordInput.dirty && confirmPasswordInput.invalid\">\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"confirmPasswordInput.errors.required\"\n                               jhiTranslate=\"global.messages.validate.confirmpassword.required\">\n                            Your confirmation password is required.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"confirmPasswordInput.errors.minlength\"\n                               jhiTranslate=\"global.messages.validate.confirmpassword.minlength\">\n                            Your confirmation password is required to be at least 4 characters.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"confirmPasswordInput.errors.maxlength\"\n                               jhiTranslate=\"global.messages.validate.confirmpassword.maxlength\">\n                            Your confirmation password cannot be longer than 50 characters.\n                        </small>\n                    </div>\n                </div>\n\n                <button type=\"submit\" [disabled]=\"passwordForm.form.invalid\" class=\"btn btn-primary\"\n                        jhiTranslate=\"password.form.button\">Save\n                </button>\n            </form>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2 jhiTranslate=\"sessions.title\" translateValues=\"{username: '{{account.login}}'}\" *ngIf=\"account\">Active sessions\n        for [<b>{{account.login}}</b>]</h2>\n\n    <div class=\"alert alert-success\" *ngIf=\"success\" jhiTranslate=\"sessions.messages.success\">\n        <strong>Session invalidated!</strong>\n    </div>\n    <div class=\"alert alert-danger\" *ngIf=\"error\" jhiTranslate=\"sessions.messages.error\">\n        <strong>An error has occured!</strong> The session could not be invalidated.\n    </div>\n\n    <div class=\"table-responsive\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr>\n                <th jhiTranslate=\"sessions.table.ipaddress\">IP Address</th>\n                <th jhiTranslate=\"sessions.table.useragent\">User agent</th>\n                <th jhiTranslate=\"sessions.table.date\">Date</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let session of sessions\">\n                <td>{{session.ipAddress}}</td>\n                <td>{{session.userAgent}}</td>\n                <td>{{session.tokenDate | date:'longDate'}}</td>\n                <td>\n                    <button type=\"submit\"\n                            class=\"btn btn-primary\"\n                            (click)=\"invalidate(session.series)\" jhiTranslate=\"sessions.table.button\">\n                        Invalidate\n                    </button>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"col-md-8 offset-md-2\">\n            <h2 jhiTranslate=\"settings.title\" translateValues=\"{username: '{{settingsAccount.login}}'}\"\n                *ngIf=\"settingsAccount\">User settings for [<b>{{settingsAccount.login}}</b>]</h2>\n\n            <div class=\"alert alert-success\" *ngIf=\"success\" jhiTranslate=\"settings.messages.success\">\n                <strong>Settings saved!</strong>\n            </div>\n\n            <jhi-alert-error></jhi-alert-error>\n\n            <form name=\"form\" role=\"form\" (ngSubmit)=\"save()\" #settingsForm=\"ngForm\" *ngIf=\"settingsAccount\" novalidate>\n\n                <div class=\"form-group\">\n                    <label class=\"form-control-label\" for=\"firstName\" jhiTranslate=\"settings.form.firstname\">First\n                        Name</label>\n                    <input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\"\n                           placeholder=\"{{'settings.form.firstname.placeholder' | translate}}\"\n                           [(ngModel)]=\"settingsAccount.firstName\" minlength=1 maxlength=50 #firstNameInput=\"ngModel\"\n                           required>\n                    <div *ngIf=\"firstNameInput.dirty && firstNameInput.invalid\">\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"firstNameInput.errors.required\"\n                               jhiTranslate=\"settings.messages.validate.firstname.required\">\n                            Your first name is required.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"firstNameInput.errors.minlength\"\n                               jhiTranslate=\"settings.messages.validate.firstname.minlength\">\n                            Your first name is required to be at least 1 character.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"firstNameInput.errors.maxlength\"\n                               jhiTranslate=\"settings.messages.validate.firstname.maxlength\">\n                            Your first name cannot be longer than 50 characters.\n                        </small>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"form-control-label\" for=\"lastName\" jhiTranslate=\"settings.form.lastname\">Last\n                        Name</label>\n                    <input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\"\n                           placeholder=\"{{'settings.form.lastname.placeholder' | translate}}\"\n                           [(ngModel)]=\"settingsAccount.lastName\" minlength=1 maxlength=50 #lastNameInput=\"ngModel\"\n                           required>\n                    <div *ngIf=\"lastNameInput.dirty && lastNameInput.invalid\">\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"lastNameInput.errors.required\"\n                               jhiTranslate=\"settings.messages.validate.lastname.required\">\n                            Your last name is required.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"lastNameInput.errors.minlength\"\n                               jhiTranslate=\"settings.messages.validate.lastname.minlength\">\n                            Your last name is required to be at least 1 character.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"lastNameInput.errors.maxlength\"\n                               jhiTranslate=\"settings.messages.validate.lastname.maxlength\">\n                            Your last name cannot be longer than 50 characters.\n                        </small>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"form-control-label\" for=\"email\" jhiTranslate=\"global.form.email\">E-mail</label>\n                    <input type=\"email\" class=\"form-control\" id=\"email\" name=\"email\"\n                           placeholder=\"{{'global.form.email.placeholder' | translate}}\"\n                           [(ngModel)]=\"settingsAccount.email\" minlength=5 maxlength=100 #emailInput=\"ngModel\" required>\n                    <div *ngIf=\"emailInput.dirty && emailInput.invalid\">\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"emailInput.errors.required\"\n                               jhiTranslate=\"global.messages.validate.email.required\">\n                            Your e-mail is required.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"emailInput.errors.email\" jhiTranslate=\"global.messages.validate.email.invalid\">\n                            Your e-mail is invalid.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"emailInput.errors.minlength\"\n                               jhiTranslate=\"global.messages.validate.email.minlength\">\n                            Your e-mail is required to be at least 5 characters.\n                        </small>\n                        <small class=\"form-text text-danger\"\n                               *ngIf=\"emailInput.errors.maxlength\"\n                               jhiTranslate=\"global.messages.validate.email.maxlength\">\n                            Your e-mail cannot be longer than 100 characters.\n                        </small>\n                    </div>\n                </div>\n                <div class=\"form-group\" *ngIf=\"languages && languages.length > 0\">\n                    <label for=\"langKey\" jhiTranslate=\"settings.form.language\">Language</label>\n                    <select class=\"form-control\" id=\"langKey\" name=\"langKey\" [(ngModel)]=\"settingsAccount.langKey\">\n                        <option *ngFor=\"let language of languages\" [value]=\"language\">{{language |\n                            findLanguageFromKey}}\n                        </option>\n                    </select>\n                </div>\n                <button type=\"submit\" [disabled]=\"settingsForm.form.invalid\" class=\"btn btn-primary\"\n                        jhiTranslate=\"settings.form.button\">Save\n                </button>\n            </form>\n        </div>\n    </div>\n\n</div>\n"

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"audits\">\n    <h2 jhiTranslate=\"audits.title\">Audits</h2>\n\n    <div class=\"row\">\n        <div class=\"col-md-5\">\n            <h4 jhiTranslate=\"audits.filter.title\">Filter by date</h4>\n            <p class=\"d-flex\">\n                <span jhiTranslate=\"audits.filter.from\" class=\"input-group-addon\">from</span>\n                <input type=\"date\" class=\"form-control\" name=\"start\" [(ngModel)]=\"fromDate\" (ngModelChange)=\"onChangeDate($event)\" required/>\n                <span jhiTranslate=\"audits.filter.to\" class=\"input-group-addon\">to</span>\n                <input type=\"date\" class=\"form-control\" name=\"end\" [(ngModel)]=\"toDate\" (ngModelChange)=\"onChangeDate($event)\" required/>\n            </p>\n        </div>\n    </div>\n\n    <div class=\"table-responsive\">\n        <table class=\"table table-condensed table-striped table-bordered\">\n            <thead>\n            <tr>\n                <th (click)=\"orderProp = 'timestamp'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.date\">Date</span></th>\n                <th (click)=\"orderProp = 'principal'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.principal\">User</span></th>\n                <th (click)=\"orderProp = 'type'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.status\">State</span></th>\n                <th (click)=\"orderProp = 'data.message'; reverse=!reverse\"><span jhiTranslate=\"audits.table.header.data\">Extra data</span></th>\n            </tr>\n            </thead>\n            <tr *ngFor=\"let audit of getAudits()\">\n                <td><span>{{audit.timestamp| date:'medium'}}</span></td>\n                <td><small>{{audit.principal}}</small></td>\n                <td>{{audit.type}}</td>\n                <td>\n                    <span *ngIf=\"audit.data\" ng-show=\"audit.data.message\">{{audit.data.message}}</span>\n                    <span *ngIf=\"audit.data\" ng-show=\"audit.data.remoteAddress\"><span jhiTranslate=\"audits.table.data.remoteAddress\">Remote Address</span> {{audit.data.remoteAddress}}</span>\n                </td>\n            </tr>\n        </table>\n    </div>\n    <div *ngIf=\"audits\">\n        <div class=\"row justify-content-center\">\n            <jhi-item-count [page]=\"page\" [total]=\"totalItems\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count>\n        </div>\n        <div class=\"row justify-content-center\">\n            <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"allConfiguration && configuration\">\n    <h2 jhiTranslate=\"configuration.title\">Configuration</h2>\n\n    <span jhiTranslate=\"configuration.filter\">Filter (by prefix)</span> <input type=\"text\" [(ngModel)]=\"filter\" class=\"form-control\">\n    <label>Spring configuration</label>\n    <table class=\"table table-striped table-bordered table-responsive d-table\">\n        <thead>\n        <tr>\n            <th class=\"w-40\" (click)=\"orderProp = 'prefix'; reverse=!reverse\"><span jhiTranslate=\"configuration.table.prefix\">Prefix</span></th>\n            <th class=\"w-60\" (click)=\"orderProp = 'properties'; reverse=!reverse\"><span jhiTranslate=\"configuration.table.properties\">Properties</span></th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr *ngFor=\"let entry of (configuration | pureFilter:filter:'prefix' | orderBy:orderProp:reverse)\">\n            <td><span>{{entry.prefix}}</span></td>\n            <td>\n                <div class=\"row\" *ngFor=\"let key of keys(entry.properties)\">\n                    <div class=\"col-md-4\">{{key}}</div>\n                    <div class=\"col-md-8\">\n                        <span class=\"float-right badge badge-default break\">{{entry.properties[key]}}</span>\n                    </div>\n                </div>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n    <div *ngFor=\"let key of keys(allConfiguration)\">\n        <label><span>{{key}}</span></label>\n        <table class=\"table table-sm table-striped table-bordered table-responsive d-table\">\n            <thead>\n            <tr>\n                <th class=\"w-40\">Property</th>\n                <th class=\"w-60\">Value</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let item of allConfiguration[key]\">\n                <td class=\"break\">{{item.key}}</td>\n                <td class=\"break\">\n                    <span class=\"float-right badge badge-default break\">{{item.val}}</span>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = "<iframe src=\"swagger-ui/index.html\" width=\"100%\" height=\"900\" seamless\n    target=\"_top\" title=\"Swagger UI\" class=\"border-0\"></iframe>\n"

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <h4 class=\"modal-title\" id=\"showHealthLabel\">\n\t\t{{'health.indicator.' + baseName(currentHealth.name) | translate}}\n        {{subSystemName(currentHealth.name)}}\n    </h4>\n    <button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" (click)=\"activeModal.dismiss('closed')\"><span aria-hidden=\"true\">&times;</span>\n    </button>\n</div>\n<div class=\"modal-body pad\">\n    <div *ngIf=\"currentHealth.details\">\n        <h5 jhiTranslate=\"health.details.properties\">Properties</h5>\n        <div class=\"table-responsive\">\n            <table class=\"table table-striped\">\n                <thead>\n                    <tr>\n                        <th class=\"text-left\" jhiTranslate=\"health.details.name\">Name</th>\n                        <th class=\"text-left\" jhiTranslate=\"health.details.value\">Value</th>\n                    </tr>\n                </thead>\n                <tbody>\n                    <tr *ngFor=\"let entry of currentHealth.details | keys\">\n                        <td class=\"text-left\">{{entry.key}}</td>\n                        <td class=\"text-left\">{{readableValue(entry.value)}}</td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n    </div>\n    <div *ngIf=\"currentHealth.error\">\n        <h4 jhiTranslate=\"health.details.error\">Error</h4>\n            <pre>{{currentHealth.error}}</pre>\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <button data-dismiss=\"modal\" class=\"btn btn-secondary float-left\" type=\"button\" (click)=\"activeModal.dismiss('closed')\">Done</button>\n</div>\n"

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"health.title\">Health Checks</span>\n        <button class=\"btn btn-primary float-right\" (click)=\"refresh()\">\n            <span class=\"fa fa-refresh\"></span> <span jhiTranslate=\"health.refresh.button\">Refresh</span>\n        </button>\n    </h2>\n    <div class=\"table-responsive\">\n        <table id=\"healthCheck\" class=\"table table-striped\">\n            <thead>\n                <tr>\n                    <th jhiTranslate=\"health.table.service\">Service Name</th>\n                    <th class=\"text-center\" jhiTranslate=\"health.table.status\">Status</th>\n                    <th class=\"text-center\" jhiTranslate=\"health.details.details\">Details</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr *ngFor=\"let health of healthData\">\n                    <td>{{'health.indicator.' + baseName(health.name) | translate}} {{subSystemName(health.name)}}</td>\n                    <td class=\"text-center\">\n                        <span class=\"badge\" [ngClass]=\"getBadgeClass(health.status)\" jhiTranslate=\"{{'health.status.' + health.status}}\">\n                            {{health.status}}\n                        </span>\n                    </td>\n                    <td class=\"text-center\">\n                        <a class=\"hand\" (click)=\"showHealth(health)\" *ngIf=\"health.details || health.error\">\n                            <i class=\"fa fa-eye\"></i>\n                        </a>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = "<div class=\"table-responsive\" *ngIf=\"loggers\">\n    <h2 jhiTranslate=\"logs.title\">Logs</h2>\n\n    <p jhiTranslate=\"logs.nbloggers\" translateValues=\"{total: '{{ loggers.length }}'}\">There are {{ loggers.length }} loggers.</p>\n\n    <span jhiTranslate=\"logs.filter\">Filter</span> <input type=\"text\" [(ngModel)]=\"filter\" class=\"form-control\">\n\n    <table class=\"table table-condensed table-striped table-bordered\">\n        <thead>\n        <tr title=\"click to order\">\n            <th (click)=\"orderProp = 'name'; reverse=!reverse\"><span jhiTranslate=\"logs.table.name\">Name</span></th>\n            <th (click)=\"orderProp = 'level'; reverse=!reverse\"><span jhiTranslate=\"logs.table.level\">Level</span></th>\n        </tr>\n        </thead>\n\n        <tr *ngFor=\"let logger of (loggers | pureFilter:filter:'name' | orderBy:orderProp:reverse)\">\n            <td><small>{{logger.name | slice:0:140}}</small></td>\n            <td>\n                <button (click)=\"changeLevel(logger.name, 'TRACE')\" [ngClass]=\"(logger.level=='TRACE') ? 'btn-danger' : 'btn-secondary'\" class=\"btn btn-sm\">TRACE</button>\n                <button (click)=\"changeLevel(logger.name, 'DEBUG')\" [ngClass]=\"(logger.level=='DEBUG') ? 'btn-warning' : 'btn-secondary'\" class=\"btn btn-sm\">DEBUG</button>\n                <button (click)=\"changeLevel(logger.name, 'INFO')\" [ngClass]=\"(logger.level=='INFO') ? 'btn-info' : 'btn-secondary'\" class=\"btn btn-sm\">INFO</button>\n                <button (click)=\"changeLevel(logger.name, 'WARN')\" [ngClass]=\"(logger.level=='WARN') ? 'btn-success' : 'btn-secondary'\" class=\"btn btn-sm\">WARN</button>\n                <button (click)=\"changeLevel(logger.name, 'ERROR')\" [ngClass]=\"(logger.level=='ERROR') ? 'btn-primary' : 'btn-secondary'\" class=\"btn btn-sm\">ERROR</button>\n            </td>\n        </tr>\n    </table>\n</div>\n"

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = "<!-- Modal used to display the threads dump -->\n<div class=\"modal-header\">\n    <h4 class=\"modal-title\" jhiTranslate=\"metrics.jvm.threads.dump.title\">Threads dump</h4>\n    <button type=\"button\" class=\"close\" (click)=\"activeModal.dismiss('closed')\">&times;</button>\n</div>\n<div class=\"modal-body\">\n    <span class=\"badge badge-primary\" (click)=\"threadDumpFilter = {}\">All&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpAll}}</span></span>&nbsp;\n    <span class=\"badge badge-success\" (click)=\"threadDumpFilter = {threadState: 'RUNNABLE'}\">Runnable&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpRunnable}}</span></span>&nbsp;\n    <span class=\"badge badge-info\" (click)=\"threadDumpFilter = {threadState: 'WAITING'}\">Waiting&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpWaiting}}</span></span>&nbsp;\n    <span class=\"badge badge-warning\" (click)=\"threadDumpFilter = {threadState: 'TIMED_WAITING'}\">Timed Waiting&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpTimedWaiting}}</span></span>&nbsp;\n    <span class=\"badge badge-danger\" (click)=\"threadDumpFilter = {threadState: 'BLOCKED'}\">Blocked&nbsp;<span class=\"badge badge-pill badge-default\">{{threadDumpBlocked}}</span></span>&nbsp;\n    <div class=\"mt-2\">&nbsp;</div>\n    Filter\n    <input type=\"text\" [(ngModel)]=\"threadDumpFilter\" class=\"form-control\">\n    <div class=\"pad\" *ngFor=\"let entry of threadDump | pureFilter:threadDumpFilter:'lockName' | keys\">\n        <h6>\n            <span class=\"badge\" [ngClass]=\"getBadgeClass(entry.value.threadState)\">{{entry.value.threadState}}</span>&nbsp;{{entry.value.threadName}} (ID {{entry.value.threadId}})\n            <a (click)=\"entry.show = !entry.show\" href=\"javascript:void(0);\">\n               <span [hidden]=\"entry.show\" jhiTranslate=\"metrics.jvm.threads.dump.show\">Show StackTrace</span>\n               <span [hidden]=\"!entry.show\" jhiTranslate=\"metrics.jvm.threads.dump.hide\">Hide StackTrace</span>\n            </a>\n        </h6>\n        <div class=\"card\" [hidden]=\"!entry.show\">\n            <div class=\"card-block\">\n                <div *ngFor=\"let st of entry.value.stackTrace | keys\" class=\"break\">\n                    <samp>{{st.value.className}}.{{st.value.methodName}}(<code>{{st.value.fileName}}:{{st.value.lineNumber}}</code>)</samp>\n                    <span class=\"mt-1\"></span>\n                </div>\n            </div>\n        </div>\n        <table class=\"table table-sm table-responsive\">\n            <thead>\n                <tr>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.blockedtime\">Blocked Time</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.blockedcount\">Blocked Count</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.waitedtime\">Waited Time</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.jvm.threads.dump.waitedcount\">Waited Count</th>\n                    <th jhiTranslate=\"metrics.jvm.threads.dump.lockname\">Lock Name</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td>{{entry.value.blockedTime}}</td>\n                    <td>{{entry.value.blockedCount}}</td>\n                    <td>{{entry.value.waitedTime}}</td>\n                    <td>{{entry.value.waitedCount}}</td>\n                    <td><code>{{entry.value.lockName}}</code></td>\n                </tr>\n            </tbody>\n        </table>\n\n    </div>\n</div>\n<div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-secondary pull-left\" data-dismiss=\"modal\" (click)=\"activeModal.dismiss('closed')\">Done</button>\n</div>\n"

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"metrics.title\">Application Metrics</span>\n        <button class=\"btn btn-primary float-right\" (click)=\"refresh()\">\n            <span class=\"fa fa-refresh\"></span> <span jhiTranslate=\"metrics.refresh.button\">Refresh</span>\n        </button>\n    </h2>\n\n    <h3 jhiTranslate=\"metrics.jvm.title\">JVM Metrics</h3>\n    <div class=\"row\" *ngIf=\"!updatingMetrics\">\n        <div class=\"col-md-4\">\n            <b jhiTranslate=\"metrics.jvm.memory.title\">Memory</b>\n            <p><span jhiTranslate=\"metrics.jvm.memory.total\">Total Memory</span> ({{metrics.gauges['jvm.memory.total.used'].value / 1000000 | number:'1.0-0'}}M / {{metrics.gauges['jvm.memory.total.max'].value / 1000000 | number:'1.0-0'}}M)</p>\n            <ngb-progressbar type=\"success\" [max]=\"metrics.gauges['jvm.memory.total.max'].value\" [value]=\"metrics.gauges['jvm.memory.total.used'].value\" [striped]=\"true\" [animated]=\"true\">\n                <span>{{metrics.gauges['jvm.memory.total.used'].value * 100 / metrics.gauges['jvm.memory.total.max'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n            <p><span jhiTranslate=\"metrics.jvm.memory.heap\">Heap Memory</span> ({{metrics.gauges['jvm.memory.heap.used'].value / 1000000 | number:'1.0-0'}}M / {{metrics.gauges['jvm.memory.heap.max'].value / 1000000 | number:'1.0-0'}}M)</p>\n            <ngb-progressbar [max]=\"metrics.gauges['jvm.memory.heap.max'].value\" [value]=\"metrics.gauges['jvm.memory.heap.used'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                <span>{{metrics.gauges['jvm.memory.heap.used'].value * 100 / metrics.gauges['jvm.memory.heap.max'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n            <p><span jhiTranslate=\"metrics.jvm.memory.nonheap\">Non-Heap Memory</span> ({{metrics.gauges['jvm.memory.non-heap.used'].value / 1000000 | number:'1.0-0'}}M / {{metrics.gauges['jvm.memory.non-heap.committed'].value / 1000000 | number:'1.0-0'}}M)</p>\n            <ngb-progressbar [max]=\"metrics.gauges['jvm.memory.non-heap.committed'].value\" [value]=\"metrics.gauges['jvm.memory.non-heap.used'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                <span>{{metrics.gauges['jvm.memory.non-heap.used'].value * 100 / metrics.gauges['jvm.memory.non-heap.committed'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n        </div>\n        <div class=\"col-md-4\">\n            <b jhiTranslate=\"metrics.jvm.threads.title\">Threads</b> (Total: {{metrics.gauges['jvm.threads.count'].value}}) <a class=\"hand\" (click)=\"refreshThreadDumpData()\" data-toggle=\"modal\" data-target=\"#threadDump\"><i class=\"fa fa-eye\"></i></a>\n            <p><span jhiTranslate=\"metrics.jvm.threads.runnable\">Runnable</span> {{metrics.gauges['jvm.threads.runnable.count'].value}}</p>\n            <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.runnable.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                <span>{{metrics.gauges['jvm.threads.runnable.count'].value * 100 / metrics.gauges['jvm.threads.count'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n            <p><span jhiTranslate=\"metrics.jvm.threads.timedwaiting\">Timed Waiting</span> ({{metrics.gauges['jvm.threads.timed_waiting.count'].value}})</p>\n            <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.timed_waiting.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"warning\">\n                <span>{{metrics.gauges['jvm.threads.timed_waiting.count'].value * 100 / metrics.gauges['jvm.threads.count'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n            <p><span jhiTranslate=\"metrics.jvm.threads.waiting\">Waiting</span> ({{metrics.gauges['jvm.threads.waiting.count'].value}})</p>\n            <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.waiting.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"warning\">\n                <span>{{metrics.gauges['jvm.threads.waiting.count'].value * 100 / metrics.gauges['jvm.threads.count'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n            <p><span jhiTranslate=\"metrics.jvm.threads.blocked\">Blocked</span> ({{metrics.gauges['jvm.threads.blocked.count'].value}})</p>\n            <ngb-progressbar [value]=\"metrics.gauges['jvm.threads.blocked.count'].value\" [max]=\"metrics.gauges['jvm.threads.count'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                <span>{{metrics.gauges['jvm.threads.blocked.count'].value * 100 / metrics.gauges['jvm.threads.count'].value  | number:'1.0-0'}}%</span>\n            </ngb-progressbar>\n        </div>\n        <div class=\"col-md-4\">\n            <b jhiTranslate=\"metrics.jvm.gc.title\">Garbage collections</b>\n            <div class=\"row\"  *ngIf=\"metrics.gauges['jvm.garbage.PS-MarkSweep.count']\">\n                <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.marksweepcount\">Mark Sweep count</div>\n                <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-MarkSweep.count'].value}}</div>\n            </div>\n            <div class=\"row\" *ngIf=\"metrics.gauges['jvm.garbage.PS-MarkSweep.time']\">\n                <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.marksweeptime\">Mark Sweep time</div>\n                <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-MarkSweep.time'].value}}ms</div>\n            </div>\n            <div class=\"row\" *ngIf=\"metrics.gauges['jvm.garbage.PS-Scavenge.time']\">\n                <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.scavengecount\">Scavenge count</div>\n                <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-Scavenge.time'].value}}</div>\n            </div>\n            <div class=\"row\" *ngIf=\"metrics.gauges['jvm.garbage.PS-Scavenge.time']\">\n                <div class=\"col-md-9\" jhiTranslate=\"metrics.jvm.gc.scavengetime\">Scavenge time</div>\n                <div class=\"col-md-3 text-right\">{{metrics.gauges['jvm.garbage.PS-Scavenge.time'].value}}ms</div>\n            </div>\n        </div>\n    </div>\n    <div class=\"well well-lg\" *ngIf=\"updatingMetrics\" jhiTranslate=\"metrics.updating\">Updating...</div>\n\n    <h3 jhiTranslate=\"metrics.jvm.http.title\">HTTP requests (events per second)</h3>\n    <p *ngIf=\"metrics.counters\">\n        <span jhiTranslate=\"metrics.jvm.http.active\">Active requests</span> <b>{{metrics.counters['com.codahale.metrics.servlet.InstrumentedFilter.activeRequests'].count | number:'1.0-0'}}</b> - <span jhiTranslate=\"metrics.jvm.http.total\">Total requests</span> <b>{{metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count | number:'1.0-0'}}</b>\n    </p>\n    <div class=\"table-responsive\" *ngIf=\"!updatingMetrics\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr>\n                <th jhiTranslate=\"metrics.jvm.http.table.code\">Code</th>\n                <th jhiTranslate=\"metrics.jvm.http.table.count\">Count</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.jvm.http.table.mean\">Mean</th>\n                <th class=\"text-right\"><span jhiTranslate=\"metrics.jvm.http.table.average\">Average</span> (1 min)</th>\n                <th class=\"text-right\"><span jhiTranslate=\"metrics.jvm.http.table.average\">Average</span> (5 min)</th>\n                <th class=\"text-right\"><span jhiTranslate=\"metrics.jvm.http.table.average\">Average</span> (15 min)</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr>\n                <td jhiTranslate=\"metrics.jvm.http.code.ok\">OK</td>\n                <td>\n                    <ngb-progressbar [max]=\"metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count\" [value]=\"metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].count\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                        <span>{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].count}}</span>\n                    </ngb-progressbar>\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].mean_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].m1_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].m5_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok'].m15_rate | number:'1.0-2'}}\n                </td>\n            </tr>\n            <tr>\n                <td jhiTranslate=\"metrics.jvm.http.code.notfound\">Not Found</td>\n                <td>\n                    <ngb-progressbar [max]=\"metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count\" [value]=\"metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].count\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                        <span>{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].count}}</span>\n                    </ngb-progressbar>\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].mean_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].m1_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].m5_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound'].m15_rate | number:'1.0-2'}}\n                </td>\n            </tr>\n            <tr>\n                <td jhiTranslate=\"metrics.jvm.http.code.servererror\">Server error</td>\n                <td>\n                    <ngb-progressbar [max]=\"metrics.timers['com.codahale.metrics.servlet.InstrumentedFilter.requests'].count\" [value]=\"metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].count\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                        <span>{{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].count}}</span>\n                    </ngb-progressbar>\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].mean_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].m1_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].m5_rate | number:'1.0-2'}}\n                </td>\n                <td class=\"text-right\">\n                    {{metrics.meters['com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError'].m15_rate | number:'1.0-2'}}\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <h3 jhiTranslate=\"metrics.servicesstats.title\">Services statistics (time in millisecond)</h3>\n    <div class=\"table-responsive\" *ngIf=\"!updatingMetrics\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr>\n                <th jhiTranslate=\"metrics.servicesstats.table.name\">Service name</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.count\">Count</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.mean\">Mean</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.min\">Min</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p50\">p50</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p75\">p75</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p95\">p95</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.p99\">p99</th>\n                <th class=\"text-right\" jhiTranslate=\"metrics.servicesstats.table.max\">Max</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let entry of servicesStats | keys\">\n                <td>{{entry.key}}</td>\n                <td class=\"text-right\">{{entry.value.count}}</td>\n                <td class=\"text-right\">{{entry.value.mean * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.min * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.p50 * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.p75 * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.p95 * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.p99 * 1000 | number:'1.0-0'}}</td>\n                <td class=\"text-right\">{{entry.value.max * 1000 | number:'1.0-0'}}</td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <h3 jhiTranslate=\"metrics.cache.title\">Cache statistics</h3>\n    <div class=\"table-responsive\" *ngIf=\"!updatingMetrics\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr>\n                <th jhiTranslate=\"metrics.cache.cachename\">Cache name</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.hits\">Cache Hits</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.misses\">Cache Misses</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.gets\">Cache Gets</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.puts\">Cache Puts</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.removals\">Cache Removals</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.evictions\">Cache Evictions</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.hitPercent\">Cache Hit %</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.missPercent\">Cache Miss %</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.averageGetTime\">Average get time (µs)</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.averagePutTime\">Average put time (µs)</th>\n                <th class=\"text-right\" data-translate=\"metrics.cache.averageRemoveTime\">Average remove time (µs)</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let entry of cachesStats | keys\">\n                <td>{{entry.key}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-hits'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-misses'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-gets'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-puts'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-removals'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-evictions'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-hit-percentage'].value}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.cache-miss-percentage'].value }}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.average-get-time'].value  | number : '1.2-2' }}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.average-put-time'].value  | number : '1.2-2'}}</td>\n                <td class=\"text-right\">{{metrics.gauges[entry.key + '.average-remove-time'].value | number : '1.2-2' }}</td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <h3 jhiTranslate=\"metrics.datasource.title\" *ngIf=\"metrics.gauges && metrics.gauges['HikariPool-1.pool.TotalConnections'] && metrics.gauges['HikariPool-1.pool.TotalConnections'].value > 0\">DataSource statistics (time in millisecond)</h3>\n    <div class=\"table-responsive\" *ngIf=\"!updatingMetrics && metrics.gauges && metrics.gauges['HikariPool-1.pool.TotalConnections'] && metrics.gauges['HikariPool-1.pool.TotalConnections'].value > 0\">\n        <table class=\"table table-striped\">\n            <thead>\n                <tr>\n                    <th><span jhiTranslate=\"metrics.datasource.usage\">Usage</span> ({{metrics.gauges['HikariPool-1.pool.ActiveConnections'].value}} / {{metrics.gauges['HikariPool-1.pool.TotalConnections'].value}})</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.count\">Count</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.mean\">Mean</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.min\">Min</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p50\">p50</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p75\">p75</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p95\">p95</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.p99\">p99</th>\n                    <th class=\"text-right\" jhiTranslate=\"metrics.datasource.max\">Max</th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr>\n                    <td>\n                        <div class=\"progress progress-striped\">\n                            <ngb-progressbar [max]=\"metrics.gauges['HikariPool-1.pool.TotalConnections'].value\" [value]=\"metrics.gauges['HikariPool-1.pool.ActiveConnections'].value\" [striped]=\"true\" [animated]=\"true\" type=\"success\">\n                                <span>{{metrics.gauges['HikariPool-1.pool.ActiveConnections'].value * 100 / metrics.gauges['HikariPool-1.pool.TotalConnections'].value  | number:'1.0-0'}}%</span>\n                            </ngb-progressbar>\n                        </div>\n                    </td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].count}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].mean | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].min | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p50 | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p75 | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p95 | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].p99 | number:'1.0-2'}}</td>\n                    <td class=\"text-right\">{{metrics.histograms['HikariPool-1.pool.Usage'].max | number:'1.0-2'}}</td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(user.login)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"userManagement.delete.question\" translateValues=\"{login: '{{user.login}}'}\">Are you sure you\n            want to delete this User?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports = "<div *ngIf=\"user\">\n    <h2>\n        <span jhiTranslate=\"userManagement.detail.title\">User</span> [<b>{{user.login}}</b>]\n    </h2>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"userManagement.login\">Login</span></dt>\n        <dd>\n            <span>{{user.login}}</span>\n            <span class=\"badge badge-danger\" *ngIf=\"!user.activated\"\n                  jhiTranslate=\"userManagement.deactivated\">Deactivated</span>\n            <span class=\"badge badge-success\" *ngIf=\"user.activated\"\n                  jhiTranslate=\"userManagement.activated\">Activated</span>\n        </dd>\n        <dt><span jhiTranslate=\"userManagement.firstName\">First Name</span></dt>\n        <dd>{{user.firstName}}</dd>\n        <dt><span jhiTranslate=\"userManagement.lastName\">Last Name</span></dt>\n        <dd>{{user.lastName}}</dd>\n        <dt><span jhiTranslate=\"userManagement.email\">Email</span></dt>\n        <dd>{{user.email}}</dd>\n        <dt><span jhiTranslate=\"userManagement.langKey\">Lang Key</span></dt>\n        <dd>{{user.langKey}}</dd>\n        <dt><span jhiTranslate=\"userManagement.createdBy\">Created By</span></dt>\n        <dd>{{user.createdBy}}</dd>\n        <dt><span jhiTranslate=\"userManagement.createdDate\">Created Date</span></dt>\n        <dd>{{user.createdDate | date:'dd/MM/yy HH:mm' }}</dd>\n        <dt><span jhiTranslate=\"userManagement.lastModifiedBy\">Last Modified By</span></dt>\n        <dd>{{user.lastModifiedBy}}</dd>\n        <dt><span jhiTranslate=\"userManagement.lastModifiedDate\">Last Modified Date</span></dt>\n        <dd>{{user.lastModifiedDate | date:'dd/MM/yy HH:mm'}}</dd>\n        <dt><span jhiTranslate=\"userManagement.profiles\">Profiles</span></dt>\n        <dd>\n            <ul class=\"list-unstyled\">\n                <li *ngFor=\"let authority of user.authorities\">\n                    <span class=\"badge badge-info\">{{authority}}</span>\n                </li>\n            </ul>\n        </dd>\n    </dl>\n    <button type=\"submit\"\n            routerLink=\"/user-management\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n</div>\n"

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myUserLabel\" jhiTranslate=\"userManagement.home.createOrEditLabel\">\n            Create or edit a User</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\">\n            <label jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" name=\"id\"\n                   [(ngModel)]=\"user.id\" readonly>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"userManagement.login\">Login</label>\n            <input type=\"text\" class=\"form-control\" name=\"login\" #loginInput=\"ngModel\"\n                   [(ngModel)]=\"user.login\" required minlength=1 maxlength=50 pattern=\"^[_'.@A-Za-z0-9-]*$\">\n\n            <div *ngIf=\"loginInput.dirty && loginInput.invalid\">\n                <small class=\"form-text text-danger\"\n                       *ngIf=\"loginInput.errors.required\" jhiTranslate=\"entity.validation.required\">\n                    This field is required.\n                </small>\n\n                <small class=\"form-text text-danger\"\n                       *ngIf=\"loginInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\"\n                       translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"userManagement.firstName\">First Name</label>\n            <input type=\"text\" class=\"form-control\" name=\"firstName\" #firstNameInput=\"ngModel\"\n                   [(ngModel)]=\"user.firstName\" maxlength=\"50\">\n\n            <div *ngIf=\"firstNameInput.dirty && firstNameInput.invalid\">\n                <small class=\"form-text text-danger\"\n                       *ngIf=\"firstNameInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\"\n                       translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label jhiTranslate=\"userManagement.lastName\">Last Name</label>\n            <input type=\"text\" class=\"form-control\" name=\"lastName\" #lastNameInput=\"ngModel\"\n                   [(ngModel)]=\"user.lastName\" maxlength=\"50\">\n\n            <div *ngIf=\"lastNameInput.dirty && lastNameInput.invalid\">\n                <small class=\"form-text text-danger\"\n                       *ngIf=\"lastNameInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\"\n                       translate-value-max=\"50\">\n                    This field cannot be longer than 50 characters.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"userManagement.email\">Email</label>\n            <input type=\"email\" class=\"form-control\" name=\"email\" #emailInput=\"ngModel\"\n                   [(ngModel)]=\"user.email\" required maxlength=\"100\">\n\n            <div *ngIf=\"emailInput.dirty && emailInput.invalid\">\n                <small class=\"form-text text-danger\"\n                       *ngIf=\"emailInput.errors.required\" jhiTranslate=\"entity.validation.required\">\n                    This field is required.\n                </small>\n\n                <small class=\"form-text text-danger\"\n                       *ngIf=\"emailInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\"\n                       translate-value-max=\"100\">\n                    This field cannot be longer than 100 characters.\n                </small>\n                <small class=\"form-text text-danger\"\n                       *ngIf=\"emailInput.errors.email\" jhiTranslate=\"global.messages.validate.email.invalid\">\n                    Your e-mail is invalid.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"userManagement.password\">Password</label>\n            <input type=\"text\" class=\"form-control\" name=\"password\" #passwordInput=\"ngModel\"\n                   [(ngModel)]=\"user.password\" maxlength=\"100\" minlength=\"4\">\n\n            <div *ngIf=\"emailInput.dirty && emailInput.invalid\">\n                <small class=\"form-text text-danger\"\n                       *ngIf=\"passwordInput.errors.required\" jhiTranslate=\"entity.validation.required\">\n                    This field is required.\n                </small>\n\n                <small class=\"form-text text-danger\"\n                       *ngIf=\"passwordInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\"\n                       translate-value-max=\"100\">\n                    This field cannot be longer than 100 characters.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-check\">\n            <label class=\"form-check-label\" for=\"activated\">\n                <input class=\"form-check-input\" [disabled]=\"user.id === null\" type=\"checkbox\" id=\"activated\"\n                       name=\"activated\" [(ngModel)]=\"user.activated\">\n                <span jhiTranslate=\"userManagement.activated\">Activated</span>\n            </label>\n        </div>\n\n        <div class=\"form-group\" *ngIf=\"languages && languages.length > 0\">\n            <label jhiTranslate=\"userManagement.langKey\">Lang Key</label>\n            <select class=\"form-control\" id=\"langKey\" name=\"langKey\" [(ngModel)]=\"user.langKey\">\n                <option *ngFor=\"let language of languages\" [value]=\"language\">{{language | findLanguageFromKey}}\n                </option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label jhiTranslate=\"userManagement.profiles\">Profiles</label>\n            <select class=\"form-control\" multiple name=\"authority\" [(ngModel)]=\"user.authorities\">\n                <option *ngFor=\"let authority of authorities\" [value]=\"authority\">{{authority}}</option>\n            </select>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span\n            jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-floppy-o\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"userManagement.home.title\">Users</span>\n        <button class=\"btn btn-primary float-right\"\n                [routerLink]=\"['/', { outlets: { popup: ['user-management-new'] } }]\">\n            <span class=\"fa fa-plus\"></span> <span\n            jhiTranslate=\"userManagement.home.createLabel\">Create a new User</span>\n        </button>\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div class=\"table-responsive\" *ngIf=\"users\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\">\n                <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span><span class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"login\"><span jhiTranslate=\"userManagement.login\">Login</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"email\"><span jhiTranslate=\"userManagement.email\">Email</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th></th>\n                <th jhiSortBy=\"langKey\"><span jhiTranslate=\"userManagement.langKey\">Lang Key</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th><span jhiTranslate=\"userManagement.profiles\">Profiles</span></th>\n                <th jhiSortBy=\"createdDate\"><span jhiTranslate=\"userManagement.createdDate\">Created Date</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"lastModifiedBy\"><span\n                    jhiTranslate=\"userManagement.lastModifiedBy\">Last Modified By</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"lastModifiedDate\"><span\n                    jhiTranslate=\"userManagement.lastModifiedDate\">Last Modified Date</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody *ngIf=\"users\">\n            <tr *ngFor=\"let user of users; trackBy: trackIdentity\">\n                <td><a [routerLink]=\"['../user-management', user.login]\">{{user.id}}</a></td>\n                <td>{{user.login}}</td>\n                <td>{{user.email}}</td>\n                <td>\n                    <span class=\"badge badge-danger hand\" (click)=\"setActive(user, true)\" *ngIf=\"!user.activated\"\n                          jhiTranslate=\"userManagement.deactivated\">Deactivated</span>\n                    <span class=\"badge badge-success hand\" (click)=\"setActive(user, false)\" *ngIf=\"user.activated\"\n                          jhiTranslate=\"userManagement.activated\">Activated</span>\n                </td>\n                <td>{{user.langKey}}</td>\n                <td>\n                    <div *ngFor=\"let authority of user.authorities\">\n                        <span class=\"tag tag-info\">{{ authority }}</span>\n                    </div>\n                </td>\n                <td>{{user.createdDate | date:'dd/MM/yy HH:mm'}}</td>\n                <td>{{user.lastModifiedBy}}</td>\n                <td>{{user.lastModifiedDate | date:'dd/MM/yy HH:mm'}}</td>\n                <td class=\"text-right\">\n                    <div class=\"btn-group flex-btn-group-container\">\n                        <button type=\"submit\"\n                                [routerLink]=\"['../user-management', user.login]\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-eye\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'user-management/'+ user.login + '/edit'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-primary btn-sm\">\n                            <span class=\"fa fa-pencil\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'user-management/'+ user.login + '/delete'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-danger btn-sm\" [disabled]=\"currentAccount.login==user.login\">\n                            <span class=\"fa fa-remove\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n    <div *ngIf=\"users\">\n        <div class=\"row justify-content-center\">\n            <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count>\n        </div>\n        <div class=\"row justify-content-center\">\n            <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\"\n                            (pageChange)=\"loadPage(page)\"></ngb-pagination>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = "<dt>\n    <span *ngIf=\"allDevices\"\n          jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.chart.activatedInfo\"\n          translateValues=\"{activated: '{{activeDevices}}', all: '{{allDevices}}'}\">Aktywowane urządzenia</span>\n\n    <span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.chart.noDevices\" *ngIf=\"!allDevices\"></span>\n</dt>\n<dd class=\"progress\" *ngIf=\"allDevices > 0\">\n\n    <progress class=\"progress progress-success\" [value]=\"activeDevicesPerc\" [max]=\"100\"  style=\"width: 100%;\"><b>{{activeDevicesPerc}}%</b></progress>\n\n</dd>\n"

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row home\" *ngIf=\"seller\">\n    <div class=\"col-md-9\">\n        <h1 class=\"display-4\"><span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.welcome\">Welcome</span>&nbsp;{{seller?.name}}\n        </h1>\n\n    </div>\n    <dl class=\"col-md-6\" [hidden]=\"false\">\n        <!--<jhi-alert></jhi-alert>-->\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.lastModified\">Last modification date</span></dt>\n        <dd>\n            <span>{{seller?.lastModifiedDate  | date:'dd-MM-yyyy HH:mm'}}</span> <button  type=\"button\" class=\"btn btn-secondary\" (click)=\"touch()\"><span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.touch.title\"></span></button>\n        </dd>\n\n        <dt></dt>\n        <dd>\n            <dcs-seller-chart></dcs-seller-chart>\n        </dd>\n        <dt *ngIf=\"seller.shutdown\"><span jhiTranslate=\"deviceConfigurerServiceApp.seller.shutdown\">Shutdown</span></dt>\n        <dd *ngIf=\"seller.shutdown\">\n            <div>\n                <a [routerLink]=\"['/model-image', seller.shutdown?.id]\">{{seller.shutdown?.id}}</a>\n            </div>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.seller.owner\">Owner</span></dt>\n        <dd>\n            {{seller.owner?.firstName}} {{seller.owner?.lastName}}({{seller.owner?.login}})\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.seller.applications\">Applications</span></dt>\n        <dd>\n            <ul *ngIf=\"seller.applications.length > 0\">\n                <li *ngFor=\"let applications of seller.applications; let last = last\">\n                    {{applications.name}} ({{applications.packageName}}){{last\n                    ? '.' : ','}}\n                </li>\n            </ul>\n            <span *ngIf=\"seller.applications.length == 0\"\n                  jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.noApplicationsAssigned\">No applications assigned</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.files\">Files</span></dt>\n        <dd>\n            <ul *ngIf=\"files && files.length > 0\">\n                <li *ngFor=\"let resource of files; let last = last\">\n                    <span data-toggle=\"tooltip\" title=\"Some tooltip text!\"\n                    >{{resource.fileName}}</span>\n                    <span *ngIf=\"resource.file\">({{resource.fileContentType}}, {{byteSize(resource.file)}})</span><a\n                    (click)=\"removeFile(resource)\"><i class=\"fa fa-times red\" aria-hidden=\"true\"></i></a>\n\n                </li>\n            </ul>\n            <button class=\"upload-button upload-new-file\" [hidden]=\"upload\" (click)=\"showUpload()\"\n                    jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.uploadNewFile\">Upload\n                new file\n            </button>\n\n\n            <dcs-seller-file [hidden]=\"!upload\" (notify)='onNotify($event)'></dcs-seller-file>\n        </dd>\n    </dl>\n    <div class=\"row\">\n        <dcs-seller-model *ngFor=\"let model of models\"\n                          [model]=\"model\" class=\"col-lg-9 \" style=\"margin-top: 1rem;\">\n        </dcs-seller-model>\n    </div>\n    <dl>\n        <dt *ngIf=\"seller.layout\"><span jhiTranslate=\"deviceConfigurerServiceApp.seller.layout\">Layout</span></dt>\n        <dd *ngIf=\"seller.layout\">\n            <pre class=\"pre-scrollable\"><code>{{seller.layout}}</code></pre>\n        </dd>\n    </dl>\n</div>\n\n"

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports = "<div class=\"drag-n-drop-container\"\n     tabindex=\"1001\"\n     ngFileDrop\n     [options]=\"options\"\n     (onUpload)=\"handleUpload($event)\"\n     [ngClass]=\"{'file-over': hasBaseDropZoneOver}\"\n     (onFileOver)=\"fileOverBase($event)\">\n    <h4 jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.dragAndDrop\">Drag & Drop</h4>\n    <label class=\"upload-button\">\n        <input type=\"file\"\n               class=\"hidden\"\n               ngFileSelect\n               [options]=\"options\"\n               [events]=\"inputUploadEvents\"\n               (onUpload)=\"handleUpload($event)\"\n               (beforeUpload)=\"beforeUpload($event)\"\n               (change)=\"fileChanged($event)\"\n        >\n        <span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.browse\">Browse</span>\n    </label>\n\n    <p *ngIf=\"fileName\">\n        <span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.fileName\">File name</span>:\n        <code><b>'{{fileName}}'</b></code>\n    </p>\n    <p>\n        <span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.allowedExtensions\">Allowed extensions</span>:\n        <code><b *ngFor=\"let e of options.allowedExtensions\">.{{e}} </b></code>\n    </p>\n\n    <p>\n        <span\n            jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.maxSizeLimit\">Max size limit</span>:\n        <code><b>{{sizeLimit}}MB </b></code>\n    </p>\n\n\n    <div *ngIf=\"progress\">\n        <span>{{ response?.progress?.percent }}%</span>\n        <span>{{ response?.speedAverageHumanized }}</span>\n        <progress class=\"progress progress-success\" [value]=\"response?.progress?.percent\" [max]=\"100\"  style=\"width: 100%;\"></progress>\n    </div>\n\n    <div *ngIf=\"errorMessage\">\n        <code>{{ errorMessage | translate:{'model':model,'sizeLimit':sizeLimit} }}</code>\n    </div>\n\n</div>\n<div class=\"row width-100\">\n    <button type=\"button\" class=\"upload-button\" (click)=\"startUpload()\" [disabled]=\"errorMessage\"\n            jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.startUpload\">Start Upload\n    </button>\n    <button class=\"upload-button\" (click)=\"close()\"\n            jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.cancel\">Cancel\n    </button>\n</div>\n\n"

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = "<div class=\"col-sm-5\" style=\"margin-top: 1rem;\">\n\n    <div class=\"card\" style=\"width: 20rem; padding-top: 1rem; padding-left: 2.3rem;\">\n        <a *ngIf=\"image\" (click)=\"removeImage(image)\" alt=\"remove image\"><i class=\"fa fa-times delete-button\"\n                                                                            aria-hidden=\"true\"></i>&nbsp;<span\n            jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.delete\">Delete</span></a>\n        <img *ngIf=\"image\" class=\"card-img-top img-fluid m-x-auto d-block device-img\"\n             [attr.src]=\"getFile()\" alt=\"Card image cap\">\n        <div *ngIf=\"!image\" class=\"drag-n-drop-container\"\n             ngFileDrop\n             [options]=\"options\"\n             (onUpload)=\"handleUpload($event)\"\n             [ngClass]=\"{'file-over': hasBaseDropZoneOver}\"\n             (onFileOver)=\"fileOverBase($event)\">\n            <h4 jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.dragAndDrop\">Drag &\n                Drop</h4>\n            <label class=\"upload-button\">\n                <input type=\"file\"\n                       class=\"hidden\"\n                       ngFileSelect\n                       [options]=\"options\"\n                       [events]=\"inputUploadEvents\"\n                       (onUpload)=\"handleUpload($event)\"\n                       (onPreviewData)=\"handlePreviewData($event)\"\n                       (beforeUpload)=\"beforeUpload($event)\"\n                       (change)=\"fileChanged($event)\"\n                >\n                <span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.browse\">Browse</span>\n            </label>\n\n            <p>\n                <span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.allowedExtensions\">Allowed extensions</span>:\n                <code><b *ngFor=\"let e of options.allowedExtensions\">.{{e}} </b></code>\n            </p>\n            <p>\n                <span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.maxSizeLimit\">Max size limit</span>:\n                <code><b>{{sizeLimit}}MB </b></code>\n            </p>\n\n\n            <div *ngIf=\"showProgress\">\n                <span>{{ response?.progress?.percent }}%</span>\n                <span>{{ response?.speedAverageHumanized }}</span>\n                <progress class=\"progress progress-success\" [value]=\"response?.progress?.percent\" [max]=\"100\"  style=\"width: 100%;\"></progress>\n            </div>\n\n            <div *ngIf=\"errorMessage\">\n                <code>{{ errorMessage | translate:{'model':model,'sizeLimit':sizeLimit,'imageData':imageData} }}</code>\n            </div>\n\n            <div *ngIf=\"previewData && !response\">\n                <img [src]=\"previewData\">\n            </div>\n        </div>\n        <div class=\"card-block\">\n\n            <h6 *ngIf=\"!image\" jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.upload.noImage\">No\n                Image</h6>\n            <ng-content></ng-content>\n            <!--<a href=\"#\" class=\"card-link\" >Card link</a>-->\n        </div>\n    </div>\n\n</div>\n"

/***/ }),
/* 274 */
/***/ (function(module, exports) {

module.exports = "<div class=\"card\">\n    <div class=\"card-block\">\n        <h4 class=\"card-title\">{{model.name}}</h4>\n        <!--<h6 class=\"card-subtitle mb-2 text-muted\">Card subtitle</h6>-->\n        <!--<p class=\"card-text\">Some quick example text to build on the card title and make up the bulk of the card's-->\n        <!--content.</p>-->\n\n        <ul class=\"list-group list-group-flush\">\n            <li class=\"list-group-item\"><span jhiTranslate=\"deviceConfigurerServiceApp.model.details\"\n                                              class=\"font-weight-bold\">Details</span></li>\n            <li class=\"list-group-item\"><span jhiTranslate=\"deviceConfigurerServiceApp.model.dpi\"\n                                              class=\"bold\">Dpi</span>: <span>{{model.dpi}}</span></li>\n            <li class=\"list-group-item\"><span jhiTranslate=\"deviceConfigurerServiceApp.model.screenResolution\">Screen Resolution</span>:\n                <span>{{model.screenHeight}}x{{model.screenWidth}}</span></li>\n        </ul>\n        <div class=\"row\">\n            <dcs-seller-model-image [image]=\"modelImage?.shutdownscreen\"\n                                    [model]=\"model\"\n                                    [type]=\"'shutdown'\"\n                                    (reload)='onReload($event)' >\n                <h4 class=\"card-title\"><span\n                    jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.shutdownscreen.title\">Shutdown screen</span>\n                </h4>\n                <p class=\"card-text\"><span\n                    jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.shutdownscreen.description\">Shutdown screen</span>\n                </p>\n            </dcs-seller-model-image>\n            <dcs-seller-model-image [image]=\"modelImage?.shutdownscreenNoPower\"\n                                    [model]=\"model\"\n                                    [type]=\"'shutdown2'\"\n                                    (reload)='onReload($event)'>\n                <h4 class=\"card-title\"><span\n                    jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.shutdownscreenNoPower.title\">Shutdown screen</span>\n                </h4>\n                <p class=\"card-text\"><span\n                    jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.shutdownscreenNoPower.description\">Shutdown screen</span>\n                </p>\n            </dcs-seller-model-image>\n            <dcs-seller-model-image [image]=\"getScreensaver()\"\n                                    [model]=\"model\"\n                                    [type]=\"'screensaver'\"\n                                    (reload)='onReload($event)'\n            >\n                <h4 class=\"card-title\"><span\n                    jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.screensaver.title\">Shutdown screen</span>\n                </h4>\n                <p class=\"card-text\"><span\n                    jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.modelImage.screensaver.description\">Shutdown screen</span>\n                </p>\n            </dcs-seller-model-image>\n        </div>\n    </div>\n</div>\n\n\n\n"

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(application.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"deviceConfigurerServiceApp.application.delete.question\" translateValues=\"{id: '{{application.id}}'}\">Are you sure you want to delete this Application?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"application\">\n    <h2><span jhiTranslate=\"deviceConfigurerServiceApp.application.detail.title\">Application</span> {{application.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.application.name\">Name</span></dt>\n        <dd>\n            <span>{{application.name}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.application.packageName\">Package Name</span></dt>\n        <dd>\n            <span>{{application.packageName}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.application.description\">Description</span></dt>\n        <dd>\n            <span>{{application.description}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.application.downloadUrl\">Download Url</span></dt>\n        <dd>\n            <span>{{application.downloadUrl}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.application.md5\">Md 5</span></dt>\n        <dd>\n            <span>{{application.md5}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.application.lastModificationDate\">Last Modification Date</span></dt>\n        <dd>\n            <span>{{application.lastModificationDate | date:'medium'}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.application.hash\">Hash</span></dt>\n        <dd>\n            <span>{{application.hash}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.application.hashType\">Hash Type</span></dt>\n        <dd>\n            <span>{{application.hashType}}</span>\n        </dd>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n    <button type=\"button\"\n            [routerLink]=\"['/', { outlets: { popup: 'application-artatech/'+ application.id + '/edit'} }]\"\n            replaceUrl=\"true\"\n            class=\"btn btn-primary\">\n        <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>\n    </button>\n</div>\n"

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myApplicationLabel\" jhiTranslate=\"deviceConfigurerServiceApp.application.home.createOrEditLabel\">Create or edit a Application</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\" [hidden]=\"!application.id\">\n            <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                   [(ngModel)]=\"application.id\" readonly />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.application.name\" for=\"field_name\">Name</label>\n            <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\"\n                [(ngModel)]=\"application.name\"\n            required />\n            <div [hidden]=\"!(editForm.controls.name?.dirty && editForm.controls.name?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.name?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.application.packageName\" for=\"field_packageName\">Package Name</label>\n            <input type=\"text\" class=\"form-control\" name=\"packageName\" id=\"field_packageName\"\n                [(ngModel)]=\"application.packageName\"\n            required />\n            <div [hidden]=\"!(editForm.controls.packageName?.dirty && editForm.controls.packageName?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.packageName?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.application.description\" for=\"field_description\">Description</label>\n            <input type=\"text\" class=\"form-control\" name=\"description\" id=\"field_description\"\n                [(ngModel)]=\"application.description\"\n             />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.application.downloadUrl\" for=\"field_downloadUrl\">Download Url</label>\n            <input type=\"text\" class=\"form-control\" name=\"downloadUrl\" id=\"field_downloadUrl\"\n                [(ngModel)]=\"application.downloadUrl\"\n             />\n        </div>\n        <div class=\"form-group\" *ngIf=\"localFiles\">\n            <label jhiTranslate=\"deviceConfigurerServiceApp.device.application.local\" for=\"field_local\">Seller</label>\n            <select class=\"form-control\" id=\"field_local\" name=\"local\" [(ngModel)]=\"selected\" (change)=\"onSelectLocal($event.target.value)\">\n                <option [ngValue]=\"null\"></option>\n                <option [ngValue]=\"localFile\"\n                        *ngFor=\"let localFile of localFiles\">{{localFile.downloadUrl}}\n                </option>\n            </select>\n        </div>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"deviceConfigurerServiceApp.application.home.title\">Applications</span>\n        <button class=\"btn btn-primary float-right create-application-artatech\" [routerLink]=\"['/', { outlets: { popup: ['application-artatech-new'] } }]\">\n            <span class=\"fa fa-plus\"></span>\n            <span class=\"hidden-sm-down\"  jhiTranslate=\"deviceConfigurerServiceApp.application.home.createLabel\">\n            Create new Application\n            </span>\n        </button>\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div class=\"row\">\n        <div class=\"col-sm-12 no-padding-right\">\n            <form name=\"searchForm\" class=\"form-inline\">\n                <div class=\"input-group w-100 mt-3\">\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'deviceConfigurerServiceApp.application.home.search' | translate }}\">\n                    <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\">\n                        <span class=\"fa fa-search\"></span>\n                    </button>\n                    <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\">\n                        <span class=\"fa fa-trash-o\"></span>\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n    <br/>\n    <div class=\"table-responsive\" *ngIf=\"applications\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"reset.bind(this)\">\n            <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"name\"><span jhiTranslate=\"deviceConfigurerServiceApp.application.name\">Name</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"packageName\"><span jhiTranslate=\"deviceConfigurerServiceApp.application.packageName\">Package Name</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"lastModificationDate\"><span jhiTranslate=\"deviceConfigurerServiceApp.application.lastModificationDate\">Last Modification Date</span> <span class=\"fa fa-sort\"></span></th>\n            <th></th>\n            </tr>\n            </thead>\n            <tbody infinite-scroll (scrolled)=\"loadPage(page + 1)\" [infiniteScrollDisabled]=\"page >= links['last']\" [infiniteScrollDistance]=\"0\">\n            <tr *ngFor=\"let application of applications ;trackBy: trackId\">\n                <td><a [routerLink]=\"['../application-artatech', application.id ]\">{{application.id}}</a></td>\n                <td>{{application.name}}</td>\n                <td>{{application.packageName}}</td>\n                <td>{{application.lastModificationDate | date:'medium'}}</td>\n                <td class=\"text-right\">\n                    <div class=\"btn-group flex-btn-group-container\">\n                        <button type=\"submit\"\n                                [routerLink]=\"['../application-artatech', application.id ]\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-eye\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'application-artatech/'+ application.id + '/edit'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-primary btn-sm\">\n                            <span class=\"fa fa-pencil\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'application-artatech/'+ application.id + '/delete'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-danger btn-sm\">\n                            <span class=\"fa fa-remove\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 279 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(device.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"deviceConfigurerServiceApp.device.delete.question\" translateValues=\"{id: '{{device.id}}'}\">Are you sure you want to delete this Device?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 280 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"device\">\n    <h2><span jhiTranslate=\"deviceConfigurerServiceApp.device.detail.title\">Device</span> {{device.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.device.sn\">Sn</span></dt>\n        <dd>\n            <span>{{device.sn}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.device.activated\">Activated</span></dt>\n        <dd>\n            <span>{{device.activated}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.device.activationDate\">Activation Date</span></dt>\n        <dd>\n            <span>{{device.activationDate | date:'medium'}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.device.activatedFromIp\">Activated From Ip</span></dt>\n        <dd>\n            <span>{{device.activatedFromIp}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.device.seller\">Seller</span></dt>\n        <dd>\n            <div *ngIf=\"device.seller\">\n                <a [routerLink]=\"['/seller', device.seller?.id]\">{{device.seller?.id}}</a>\n            </div>\n        </dd>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n    <button type=\"button\"\n            [routerLink]=\"['/', { outlets: { popup: 'device/'+ device.id + '/edit'} }]\"\n            replaceUrl=\"true\"\n            class=\"btn btn-primary\">\n        <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>\n    </button>\n</div>\n"

/***/ }),
/* 281 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myDeviceLabel\" jhiTranslate=\"deviceConfigurerServiceApp.device.home.createOrEditLabel\">Create or edit a Device</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\" [hidden]=\"!device.id\">\n            <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                   [(ngModel)]=\"device.id\" readonly />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.device.sn\" for=\"field_sn\">Sn</label>\n            <input type=\"text\" class=\"form-control\" name=\"sn\" id=\"field_sn\"\n                [(ngModel)]=\"device.sn\"\n            required />\n            <div [hidden]=\"!(editForm.controls.sn?.dirty && editForm.controls.sn?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.sn?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label jhiTranslate=\"deviceConfigurerServiceApp.device.seller\" for=\"field_seller\">Seller</label>\n            <select class=\"form-control\" id=\"field_seller\" name=\"seller\" [(ngModel)]=\"device.seller\" >\n                <option [ngValue]=\"null\"></option>\n                <option [ngValue]=\"sellerOption.id === device.seller?.id ? device.seller : sellerOption\"\n                        *ngFor=\"let sellerOption of sellers; trackBy: trackSellerById\">{{sellerOption.name}}\n                </option>\n            </select>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"col-md-8 offset-md-2\">\n            <h2>{{'deviceConfigurerServiceApp.device.home.'+type + 'Label' | translate}}</h2>\n\n            <form name=\"importForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #importForm=\"ngForm\">\n\n                <div class=\"form-group row\" *ngIf=\"reports && reports.length > 0\">\n                    <div class=\"col-12 col-md-6\"  *ngFor=\"let report of reports\">\n                        <ngb-alert [type]=\"report.status\">\n                            {{report.sn}} - {{'deviceConfigurerServiceApp.device.report.'+ report.message | translate }}\n                        </ngb-alert>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.device.sn\"\n                           for=\"field_sn\">Sn</label>\n                        <textarea rows=\"20\" class=\"form-control\" name=\"sn\" id=\"field_sn\"\n                                  [(ngModel)]=\"devices.sn\"\n                                  required>\n                            </textarea>\n                    <div [hidden]=\"!(importForm.controls.sn?.dirty && importForm.controls.sn?.invalid)\">\n                        <small class=\"form-text text-danger\"\n                               [hidden]=\"!importForm.controls.sn?.errors?.required\"\n                               jhiTranslate=\"entity.validation.required\">\n                            This field is required.\n                        </small>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" *ngIf=\"type !== 'delete'\">\n                    <label jhiTranslate=\"deviceConfigurerServiceApp.device.seller\" for=\"field_seller\">Seller</label>\n                    <select class=\"form-control\" id=\"field_seller\" name=\"seller\"\n                            [(ngModel)]=\"devices.seller\" required>\n                        <option [ngValue]=\"null\"></option>\n                        <option [ngValue]=\"sellerOption\"\n                                *ngFor=\"let sellerOption of sellers; trackBy: trackSellerById\">{{sellerOption.name}}\n                        </option>\n                    </select>\n                    <div [hidden]=\"!(importForm.controls.seller?.dirty && importForm.controls.seller?.invalid)\">\n                        <small class=\"form-text text-danger\"\n                               [hidden]=\"!importForm.controls.seller?.errors?.required\"\n                               jhiTranslate=\"entity.validation.required\">\n                            This field is required.\n                        </small>\n                    </div>\n                </div>\n\n                <div class=\"form-group\">\n                    <label jhiTranslate=\"deviceConfigurerServiceApp.device.force\" for=\"field_force\">Force</label>\n                    <input type=\"checkbox\" class=\"form-control\" id=\"field_force\" name=\"force\"\n                           [(ngModel)]=\"devices.force\"/>\n\n                </div>\n                <div class=\"modal-footer\">\n                    <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n                        <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n                    </button>\n                    <button type=\"submit\" [disabled]=\"importForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n                        <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"deviceConfigurerServiceApp.device.home.title\">Devices</span>\n\n\n        <button class=\"btn btn-primary float-right create-device button-margin\"\n                [routerLink]=\"['import' ]\">\n            <span class=\"fa fa-plus\"></span>\n            <span jhiTranslate=\"deviceConfigurerServiceApp.device.home.importLabel\">\n            Import Many Devices\n            </span>\n        </button>\n        <button class=\"btn btn-primary float-right create-device button-margin\"\n                [routerLink]=\"['delete' ]\">\n            <span class=\"fa fa-trash\"></span>\n            <span jhiTranslate=\"deviceConfigurerServiceApp.device.home.deleteLabel\">\n            Delete Many Devices\n            </span>\n        </button>\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div class=\"row\">\n        <div class=\"col-sm-12 no-padding-right\">\n            <form name=\"searchForm\" class=\"form-inline\">\n                <div class=\"input-group w-100 mt-3\">\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'deviceConfigurerServiceApp.device.home.search' | translate }}\">\n                    <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\">\n                        <span class=\"fa fa-search\"></span>\n                    </button>\n                    <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\">\n                        <span class=\"fa fa-trash-o\"></span>\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n    <br/>\n    <div class=\"table-responsive\" *ngIf=\"devices\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"reset.bind(this)\">\n            <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"sn\"><span jhiTranslate=\"deviceConfigurerServiceApp.device.sn\">Sn</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"activated\"><span jhiTranslate=\"deviceConfigurerServiceApp.device.activated\">Activated</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"activationDate\"><span jhiTranslate=\"deviceConfigurerServiceApp.device.activationDate\">Activation Date</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"activatedFromIp\"><span jhiTranslate=\"deviceConfigurerServiceApp.device.activatedFromIp\">Activated From Ip</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"seller.id\"><span jhiTranslate=\"deviceConfigurerServiceApp.device.seller\">Seller</span> <span class=\"fa fa-sort\"></span></th>\n            <th></th>\n            </tr>\n            </thead>\n            <tbody infinite-scroll (scrolled)=\"loadPage(page + 1)\" [infiniteScrollDisabled]=\"page >= links['last']\" [infiniteScrollDistance]=\"0\">\n            <tr *ngFor=\"let device of devices ;trackBy: trackId\">\n                <td><a [routerLink]=\"['../device', device.id ]\">{{device.id}}</a></td>\n                <td>{{device.sn}}</td>\n                <td>{{device.activated}}</td>\n                <td>{{device.activationDate | date:'medium'}}</td>\n                <td>{{device.activatedFromIp}}</td>\n                <td>\n                    <div *ngIf=\"device.seller\">\n                        <a [routerLink]=\"['../seller', device.seller?.id ]\">{{device.seller?.name}}</a>\n                    </div>\n                </td>\n                <td class=\"text-right\">\n                    <div class=\"btn-group flex-btn-group-container\">\n                        <button type=\"submit\"\n                                [routerLink]=\"['../device', device.id ]\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-eye\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'device/'+ device.id + '/edit'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-primary btn-sm\">\n                            <span class=\"fa fa-pencil\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'device/'+ device.id + '/delete'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-danger btn-sm\">\n                            <span class=\"fa fa-remove\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 284 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(feed.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"deviceConfigurerServiceApp.feed.delete.question\" translateValues=\"{id: '{{feed.id}}'}\">Are you sure you want to delete this Feed?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"feed\">\n    <h2><span jhiTranslate=\"deviceConfigurerServiceApp.feed.detail.title\">Feed</span> {{feed.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.feed.name\">Name</span></dt>\n        <dd>\n            <span>{{feed.name}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.feed.location\">Location</span></dt>\n        <dd>\n            <span>{{feed.location}}</span>\n        </dd>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n    <button type=\"button\"\n            [routerLink]=\"['/', { outlets: { popup: 'feed/'+ feed.id + '/edit'} }]\"\n            replaceUrl=\"true\"\n            class=\"btn btn-primary\">\n        <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>\n    </button>\n</div>\n"

/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myFeedLabel\" jhiTranslate=\"deviceConfigurerServiceApp.feed.home.createOrEditLabel\">Create or edit a Feed</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\" [hidden]=\"!feed.id\">\n            <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                   [(ngModel)]=\"feed.id\" readonly />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.feed.name\" for=\"field_name\">Name</label>\n            <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\"\n                [(ngModel)]=\"feed.name\" required minlength=\"3\" />\n            <div [hidden]=\"!(editForm.controls.name?.dirty && editForm.controls.name?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.name?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.name?.errors?.minlength\" jhiTranslate=\"entity.validation.minlength\" translateValues=\"{ min: 3 }\">\n                   This field is required to be at least 3 characters.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.feed.location\" for=\"field_location\">Location</label>\n            <input type=\"text\" class=\"form-control\" name=\"location\" id=\"field_location\"\n                [(ngModel)]=\"feed.location\" required  />\n            <div [hidden]=\"!(editForm.controls.location?.dirty && editForm.controls.location?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.location?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n                <small class=\"form-text text-danger\"\n                    [hidden]=\"!editForm.controls.location?.errors?.pattern\" jhiTranslate=\"entity.validation.pattern\" translateValues=\"{ pattern: 'Location' }\">\n                    This field should follow pattern for \"Location\".\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.feed.index\" for=\"field_index\">Index</label>\n            <input type=\"number\" class=\"form-control\" name=\"index\" id=\"field_index\"\n                   [(ngModel)]=\"feed.index\" required />\n            <div [hidden]=\"!(editForm.controls.index?.dirty && editForm.controls.index?.invalid)\">\n                <small class=\"form-text text-danger\"\n                       [hidden]=\"!editForm.controls.index?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                    This field is required.\n                </small>\n            </div>\n        </div>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"deviceConfigurerServiceApp.feed.home.title\">Feeds</span>\n        <button class=\"btn btn-primary float-right create-feed\" [routerLink]=\"['/', { outlets: { popup: ['feed-new'] } }]\">\n            <span class=\"fa fa-plus\"></span>\n            <span class=\"hidden-sm-down\"  jhiTranslate=\"deviceConfigurerServiceApp.feed.home.createLabel\">\n            Create new Feed\n            </span>\n        </button>\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <form name=\"searchForm\" class=\"form-inline\">\n                <div class=\"input-group w-100 mt-3\">\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'deviceConfigurerServiceApp.feed.home.search' | translate }}\">\n                    <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\">\n                        <span class=\"fa fa-search\"></span>\n                    </button>\n                    <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\">\n                        <span class=\"fa fa-trash-o\"></span>\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n    <br/>\n    <div class=\"table-responsive\" *ngIf=\"feeds\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"reset.bind(this)\">\n            <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"name\"><span jhiTranslate=\"deviceConfigurerServiceApp.feed.name\">Name</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"location\"><span jhiTranslate=\"deviceConfigurerServiceApp.feed.location\">Location</span> <span class=\"fa fa-sort\"></span></th>\n            <th></th>\n            </tr>\n            </thead>\n            <tbody infinite-scroll (scrolled)=\"loadPage(page + 1)\" [infiniteScrollDisabled]=\"page >= links['last']\" [infiniteScrollDistance]=\"0\">\n            <tr *ngFor=\"let feed of feeds ;trackBy: trackId\">\n                <td><a [routerLink]=\"['../feed', feed.id ]\">{{feed.id}}</a></td>\n                <td>{{feed.name}}</td>\n                <td>{{feed.location}}</td>\n                <td class=\"text-right\">\n                    <div class=\"btn-group flex-btn-group-container\">\n                        <button type=\"submit\"\n                                [routerLink]=\"['../feed', feed.id ]\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-eye\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'feed/'+ feed.id + '/edit'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-primary btn-sm\">\n                            <span class=\"fa fa-pencil\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'feed/'+ feed.id + '/delete'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-danger btn-sm\">\n                            <span class=\"fa fa-remove\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n"

/***/ }),
/* 288 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(imageResource.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"deviceConfigurerServiceApp.imageResource.delete.question\" translateValues=\"{id: '{{imageResource.id}}'}\">Are you sure you want to delete this Image Resource?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 289 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"imageResource\">\n    <h2><span jhiTranslate=\"deviceConfigurerServiceApp.imageResource.detail.title\">Image Resource</span> {{imageResource.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.imageResource.file\">File</span></dt>\n        <dd>\n            <div *ngIf=\"imageResource.file\">\n                <a (click)=\"openFile(imageResource.fileContentType, imageResource.file)\" jhiTranslate=\"entity.action.open\">open</a>\n                {{imageResource.fileContentType}}, {{byteSize(imageResource.file)}}\n            </div>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.imageResource.fileName\">File Name</span></dt>\n        <dd>\n            <span>{{imageResource.fileName}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.imageResource.fileSize\">File Size</span></dt>\n        <dd>\n            <span>{{imageResource.fileSize}}</span>\n        </dd>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n    <button type=\"button\"\n            [routerLink]=\"['/', { outlets: { popup: 'image-resource/'+ imageResource.id + '/edit'} }]\"\n            replaceUrl=\"true\"\n            class=\"btn btn-primary\">\n        <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>\n    </button>\n</div>\n"

/***/ }),
/* 290 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myImageResourceLabel\" jhiTranslate=\"deviceConfigurerServiceApp.imageResource.home.createOrEditLabel\">Create or edit a Image Resource</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\" [hidden]=\"!imageResource.id\">\n            <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                   [(ngModel)]=\"imageResource.id\" readonly />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.imageResource.file\" for=\"field_file\">File</label>\n            <div>\n                <div *ngIf=\"imageResource.file\" class=\"form-text text-danger clearfix\">\n                    <a class=\"pull-left\" (click)=\"openFile(imageResource.fileContentType, imageResource.file)\" jhiTranslate=\"entity.action.open\">open</a><br>\n                    <span class=\"pull-left\">{{imageResource.fileContentType}}, {{byteSize(imageResource.file)}}</span>\n                    <button type=\"button\" (click)=\"imageResource.file=null;imageResource.fileContentType=null;\"\n                            class=\"btn btn-default btn-xs pull-right\">\n                        <span class=\"fa fa-times\"></span>\n                    </button>\n                </div>\n                <input type=\"file\" (change)=\"setFileData($event, imageResource, 'file', false)\" jhiTranslate=\"entity.action.addblob\"/>\n            </div>\n            <input type=\"hidden\" class=\"form-control\" name=\"file\" id=\"field_file\"\n                [(ngModel)]=\"imageResource.file\"\n            required />\n            <input type=\"hidden\" class=\"form-control\" name=\"fileContentType\" id=\"field_fileContentType\"\n                [(ngModel)]=\"imageResource.fileContentType\" />\n            <div [hidden]=\"!(editForm.controls.file?.dirty && editForm.controls.file?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.file?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.imageResource.fileName\" for=\"field_fileName\">File Name</label>\n            <input type=\"text\" class=\"form-control\" name=\"fileName\" id=\"field_fileName\"\n                [(ngModel)]=\"imageResource.fileName\"\n            required />\n            <div [hidden]=\"!(editForm.controls.fileName?.dirty && editForm.controls.fileName?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.fileName?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.imageResource.fileSize\" for=\"field_fileSize\">File Size</label>\n            <input type=\"number\" class=\"form-control\" name=\"fileSize\" id=\"field_fileSize\"\n                [(ngModel)]=\"imageResource.fileSize\"\n            required />\n            <div [hidden]=\"!(editForm.controls.fileSize?.dirty && editForm.controls.fileSize?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.fileSize?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n                <small class=\"form-text text-danger\"\n                    [hidden]=\"!editForm.controls.fileSize?.errors?.number\" jhiTranslate=\"entity.validation.number\">\n                    This field should be a number.\n                </small>\n            </div>\n        </div>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"deviceConfigurerServiceApp.imageResource.home.title\">Image Resources</span>\n        <button class=\"btn btn-primary float-right create-image-resource\" [routerLink]=\"['/', { outlets: { popup: ['image-resource-new'] } }]\">\n            <span class=\"fa fa-plus\"></span>\n            <span class=\"hidden-sm-down\"  jhiTranslate=\"deviceConfigurerServiceApp.imageResource.home.createLabel\">\n            Create new Image Resource\n            </span>\n        </button>\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div class=\"row\">\n        <div class=\"col-sm-12 no-padding-right\">\n            <form name=\"searchForm\" class=\"form-inline\">\n                <div class=\"input-group w-100 mt-3\">\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'deviceConfigurerServiceApp.imageResource.home.search' | translate }}\">\n                    <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\">\n                        <span class=\"fa fa-search\"></span>\n                    </button>\n                    <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\">\n                        <span class=\"fa fa-trash-o\"></span>\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n    <br/>\n    <div class=\"table-responsive\" *ngIf=\"imageResources\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\">\n            <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"file\"><span jhiTranslate=\"deviceConfigurerServiceApp.imageResource.file\">File</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"fileName\"><span jhiTranslate=\"deviceConfigurerServiceApp.imageResource.fileName\">File Name</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"fileSize\"><span jhiTranslate=\"deviceConfigurerServiceApp.imageResource.fileSize\">File Size</span> <span class=\"fa fa-sort\"></span></th>\n            <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let imageResource of imageResources ;trackBy: trackId\">\n                <td><a [routerLink]=\"['../image-resource', imageResource.id ]\">{{imageResource.id}}</a></td>\n                <td>\n                    <a *ngIf=\"imageResource.file\" (click)=\"openFile(imageResource.fileContentType, imageResource.file)\" jhiTranslate=\"entity.action.open\">open</a>\n                    <span *ngIf=\"imageResource.file\">{{imageResource.fileContentType}}, {{byteSize(imageResource.file)}}</span>\n                </td>\n                <td>{{imageResource.fileName}}</td>\n                <td>{{imageResource.fileSize}}</td>\n                <td class=\"text-right\">\n                    <div class=\"btn-group flex-btn-group-container\">\n                        <button type=\"submit\"\n                                [routerLink]=\"['../image-resource', imageResource.id ]\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-eye\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'image-resource/'+ imageResource.id + '/edit'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-primary btn-sm\">\n                            <span class=\"fa fa-pencil\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'image-resource/'+ imageResource.id + '/delete'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-danger btn-sm\">\n                            <span class=\"fa fa-remove\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n        <div *ngIf=\"imageResources && imageResources.length\">\n            <div class=\"row justify-content-center\">\n                <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count>\n            </div>\n            <div class=\"row justify-content-center\">\n                <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination>\n            </div>\n        </div>\n</div>\n"

/***/ }),
/* 292 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(log.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"deviceConfigurerServiceApp.log.delete.question\" translateValues=\"{id: '{{log.id}}'}\">Are you sure you want to delete this Log?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 293 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"log\">\n    <h2><span jhiTranslate=\"deviceConfigurerServiceApp.log.detail.title\">Log</span> {{log.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.log.value\">Value</span></dt>\n        <dd>\n            <span>{{log.value}}</span>\n        </dd>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n    <button type=\"button\"\n            [routerLink]=\"['/', { outlets: { popup: 'log/'+ log.id + '/edit'} }]\"\n            replaceUrl=\"true\"\n            class=\"btn btn-primary\">\n        <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>\n    </button>\n</div>\n"

/***/ }),
/* 294 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myLogLabel\" jhiTranslate=\"deviceConfigurerServiceApp.log.home.createOrEditLabel\">Create or edit a Log</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\" [hidden]=\"!log.id\">\n            <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                   [(ngModel)]=\"log.id\" readonly />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.log.value\" for=\"field_value\">Value</label>\n            <input type=\"text\" class=\"form-control\" name=\"value\" id=\"field_value\"\n                [(ngModel)]=\"log.value\"\n            required />\n            <div [hidden]=\"!(editForm.controls.value?.dirty && editForm.controls.value?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.value?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n            </div>\n        </div>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 295 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"deviceConfigurerServiceApp.log.home.title\">Logs</span>\n        <button class=\"btn btn-primary float-right create-log\" [routerLink]=\"['/', { outlets: { popup: ['log-new'] } }]\">\n            <span class=\"fa fa-plus\"></span>\n            <span class=\"hidden-sm-down\"  jhiTranslate=\"deviceConfigurerServiceApp.log.home.createLabel\">\n            Create new Log\n            </span>\n        </button>\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div class=\"row\">\n        <div class=\"col-sm-12 no-padding-right\">\n            <form name=\"searchForm\" class=\"form-inline\">\n                <div class=\"input-group w-100 mt-3\">\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'deviceConfigurerServiceApp.log.home.search' | translate }}\">\n                    <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\">\n                        <span class=\"fa fa-search\"></span>\n                    </button>\n                    <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\">\n                        <span class=\"fa fa-trash-o\"></span>\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n    <br/>\n    <div class=\"table-responsive\" *ngIf=\"logs\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\">\n            <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"value\"><span jhiTranslate=\"deviceConfigurerServiceApp.log.value\">Value</span> <span class=\"fa fa-sort\"></span></th>\n            <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let log of logs ;trackBy: trackId\">\n                <td><a [routerLink]=\"['../log', log.id ]\">{{log.id}}</a></td>\n                <td>{{log.value}}</td>\n                <td class=\"text-right\">\n                    <div class=\"btn-group flex-btn-group-container\">\n                        <button type=\"submit\"\n                                [routerLink]=\"['../log', log.id ]\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-eye\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'log/'+ log.id + '/edit'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-primary btn-sm\">\n                            <span class=\"fa fa-pencil\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'log/'+ log.id + '/delete'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-danger btn-sm\">\n                            <span class=\"fa fa-remove\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n        <div *ngIf=\"logs && logs.length\">\n            <div class=\"row justify-content-center\">\n                <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count>\n            </div>\n            <div class=\"row justify-content-center\">\n                <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination>\n            </div>\n        </div>\n</div>\n"

/***/ }),
/* 296 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(modelImage.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"deviceConfigurerServiceApp.modelImage.delete.question\" translateValues=\"{id: '{{modelImage.id}}'}\">Are you sure you want to delete this Model Image?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"modelImage\">\n    <h2><span jhiTranslate=\"deviceConfigurerServiceApp.modelImage.detail.title\">Model Image</span> {{modelImage.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.modelImage.shutdownscreen\">Shutdownscreen</span></dt>\n        <dd>\n            <div *ngIf=\"modelImage.shutdownscreen\">\n                <a [routerLink]=\"['/image-resource', modelImage.shutdownscreen?.id]\">{{modelImage.shutdownscreen?.id}}</a>\n            </div>\n        </dd>\n        <dt><span\n            jhiTranslate=\"deviceConfigurerServiceApp.modelImage.shutdownscreenNoPower\">Shutdownscreen No Power</span>\n        </dt>\n        <dd>\n            <div *ngIf=\"modelImage.shutdownscreenNoPower\">\n                <a [routerLink]=\"['/image-resource', modelImage.shutdownscreenNoPower?.id]\">{{modelImage.shutdownscreenNoPower?.id}}</a>\n            </div>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.modelImage.seller\">Seller</span></dt>\n        <dd>\n            <div *ngIf=\"modelImage.seller\">\n                <a [routerLink]=\"['/seller', modelImage.seller?.id]\">{{modelImage.seller?.id}}</a>\n            </div>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.modelImage.model\">Model</span></dt>\n        <dd>\n            <div *ngIf=\"modelImage.model\">\n                <a [routerLink]=\"['/model', modelImage.model?.id]\">{{modelImage.model?.id}}</a>\n            </div>\n        </dd>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n    <button type=\"button\"\n            [routerLink]=\"['/', { outlets: { popup: 'model-image/'+ modelImage.id + '/edit'} }]\"\n            replaceUrl=\"true\"\n            class=\"btn btn-primary\">\n        <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>\n    </button>\n</div>\n"

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myModelImageLabel\" jhiTranslate=\"deviceConfigurerServiceApp.modelImage.home.createOrEditLabel\">Create or edit a Model Image</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\" [hidden]=\"!modelImage.id\">\n            <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                   [(ngModel)]=\"modelImage.id\" readonly />\n        </div>\n\n        <div class=\"form-group\">\n            <label jhiTranslate=\"deviceConfigurerServiceApp.modelImage.shutdownscreen\" for=\"field_shutdownscreen\">Shutdownscreen</label>\n            <select class=\"form-control\" id=\"field_shutdownscreen\" name=\"shutdownscreen\"\n                    [(ngModel)]=\"modelImage.shutdownscreen\">\n                <option [ngValue]=\"null\"></option>\n                <option\n                    [ngValue]=\"imageResourceOption.id === modelImage.shutdownscreen?.id ? modelImage.shutdownscreen : imageResourceOption\"\n                    *ngFor=\"let imageResourceOption of shutdownscreens; trackBy: trackImageResourceById\">\n                    {{imageResourceOption.id}}\n                </option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label jhiTranslate=\"deviceConfigurerServiceApp.modelImage.shutdownscreenNoPower\"\n                   for=\"field_shutdownscreenNoPower\">Shutdownscreen No Power</label>\n            <select class=\"form-control\" id=\"field_shutdownscreenNoPower\" name=\"shutdownscreenNoPower\"\n                    [(ngModel)]=\"modelImage.shutdownscreenNoPower\">\n                <option [ngValue]=\"null\"></option>\n                <option\n                    [ngValue]=\"imageResourceOption.id === modelImage.shutdownscreenNoPower?.id ? modelImage.shutdownscreenNoPower : imageResourceOption\"\n                    *ngFor=\"let imageResourceOption of shutdownscreennopowers; trackBy: trackImageResourceById\">\n                    {{imageResourceOption.id}}\n                </option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label jhiTranslate=\"deviceConfigurerServiceApp.modelImage.seller\" for=\"field_seller\">Seller</label>\n            <select class=\"form-control\" id=\"field_seller\" name=\"seller\" [(ngModel)]=\"modelImage.seller\" >\n                <option [ngValue]=\"null\"></option>\n                <option [ngValue]=\"sellerOption.id === modelImage.seller?.id ? modelImage.seller : sellerOption\" *ngFor=\"let sellerOption of sellers; trackBy: trackSellerById\">{{sellerOption.id}}</option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label jhiTranslate=\"deviceConfigurerServiceApp.modelImage.model\" for=\"field_model\">Model</label>\n            <select class=\"form-control\" id=\"field_model\" name=\"model\" [(ngModel)]=\"modelImage.model\" >\n                <option [ngValue]=\"null\"></option>\n                <option [ngValue]=\"modelOption.id === modelImage.model?.id ? modelImage.model : modelOption\" *ngFor=\"let modelOption of models; trackBy: trackModelById\">{{modelOption.id}}</option>\n            </select>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"deviceConfigurerServiceApp.modelImage.home.title\">Model Images</span>\n        <button class=\"btn btn-primary float-right create-model-image\" [routerLink]=\"['/', { outlets: { popup: ['model-image-new'] } }]\">\n            <span class=\"fa fa-plus\"></span>\n            <span class=\"hidden-sm-down\"  jhiTranslate=\"deviceConfigurerServiceApp.modelImage.home.createLabel\">\n            Create new Model Image\n            </span>\n        </button>\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div class=\"row\">\n        <div class=\"col-sm-12 no-padding-right\">\n            <form name=\"searchForm\" class=\"form-inline\">\n                <div class=\"input-group w-100 mt-3\">\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'deviceConfigurerServiceApp.modelImage.home.search' | translate }}\">\n                    <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\">\n                        <span class=\"fa fa-search\"></span>\n                    </button>\n                    <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\">\n                        <span class=\"fa fa-trash-o\"></span>\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n    <br/>\n    <div class=\"table-responsive\" *ngIf=\"modelImages\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\">\n            <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"shutdownscreen.id\"><span\n                    jhiTranslate=\"deviceConfigurerServiceApp.modelImage.shutdownscreen\">Shutdownscreen</span> <span\n                    class=\"fa fa-sort\"></span></th>\n                <th jhiSortBy=\"shutdownscreenNoPower.id\"><span\n                    jhiTranslate=\"deviceConfigurerServiceApp.modelImage.shutdownscreenNoPower\">Shutdownscreen No Power</span>\n                    <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"seller.id\"><span jhiTranslate=\"deviceConfigurerServiceApp.modelImage.seller\">Seller</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"model.id\"><span jhiTranslate=\"deviceConfigurerServiceApp.modelImage.model\">Model</span> <span class=\"fa fa-sort\"></span></th>\n            <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let modelImage of modelImages ;trackBy: trackId\">\n                <td><a [routerLink]=\"['../model-image', modelImage.id ]\">{{modelImage.id}}</a></td>\n                <td>\n                    <div *ngIf=\"modelImage.shutdownscreen\">\n                        <a [routerLink]=\"['../image-resource', modelImage.shutdownscreen?.id ]\">{{modelImage.shutdownscreen?.id}}</a>\n                    </div>\n                </td>\n                <td>\n                    <div *ngIf=\"modelImage.shutdownscreenNoPower\">\n                        <a [routerLink]=\"['../image-resource', modelImage.shutdownscreenNoPower?.id ]\">{{modelImage.shutdownscreenNoPower?.id}}</a>\n                    </div>\n                </td>\n                <td>\n                    <div *ngIf=\"modelImage.seller\">\n                        <a [routerLink]=\"['../seller', modelImage.seller?.id ]\" >{{modelImage.seller?.id}}</a>\n                    </div>\n                </td>\n                <td>\n                    <div *ngIf=\"modelImage.model\">\n                        <a [routerLink]=\"['../model', modelImage.model?.id ]\" >{{modelImage.model?.id}}</a>\n                    </div>\n                </td>\n                <td class=\"text-right\">\n                    <div class=\"btn-group flex-btn-group-container\">\n                        <button type=\"submit\"\n                                [routerLink]=\"['../model-image', modelImage.id ]\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-eye\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'model-image/'+ modelImage.id + '/edit'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-primary btn-sm\">\n                            <span class=\"fa fa-pencil\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'model-image/'+ modelImage.id + '/delete'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-danger btn-sm\">\n                            <span class=\"fa fa-remove\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n        <div *ngIf=\"modelImages && modelImages.length\">\n            <div class=\"row justify-content-center\">\n                <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count>\n            </div>\n            <div class=\"row justify-content-center\">\n                <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination>\n            </div>\n        </div>\n</div>\n"

/***/ }),
/* 300 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(model.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"deviceConfigurerServiceApp.model.delete.question\" translateValues=\"{id: '{{model.id}}'}\">Are you sure you want to delete this Model?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 301 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"model\">\n    <h2><span jhiTranslate=\"deviceConfigurerServiceApp.model.detail.title\">Model</span> {{model.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.model.name\">Name</span></dt>\n        <dd>\n            <span>{{model.name}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.model.serilNumerShortcut\">Seril Numer Shortcut</span></dt>\n        <dd>\n            <span>{{model.serilNumerShortcut}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.model.dpi\">Dpi</span></dt>\n        <dd>\n            <span>{{model.dpi}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.model.screenHeight\">Screen Height</span></dt>\n        <dd>\n            <span>{{model.screenHeight}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.model.screenWidth\">Screen Width</span></dt>\n        <dd>\n            <span>{{model.screenWidth}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.model.shutdownAnimationDescFile\">Shutdown Animation Desc File</span></dt>\n        <dd>\n            <span>{{model.shutdownAnimationDescFile}}</span>\n        </dd>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n    <button type=\"button\"\n            [routerLink]=\"['/', { outlets: { popup: 'model/'+ model.id + '/edit'} }]\"\n            replaceUrl=\"true\"\n            class=\"btn btn-primary\">\n        <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>\n    </button>\n</div>\n"

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myModelLabel\" jhiTranslate=\"deviceConfigurerServiceApp.model.home.createOrEditLabel\">Create or edit a Model</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\" [hidden]=\"!model.id\">\n            <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                   [(ngModel)]=\"model.id\" readonly />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.model.name\" for=\"field_name\">Name</label>\n            <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\"\n                [(ngModel)]=\"model.name\"\n            required />\n            <div [hidden]=\"!(editForm.controls.name?.dirty && editForm.controls.name?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.name?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.model.serilNumerShortcut\" for=\"field_serilNumerShortcut\">Seril Numer Shortcut</label>\n            <input type=\"text\" class=\"form-control\" name=\"serilNumerShortcut\" id=\"field_serilNumerShortcut\"\n                [(ngModel)]=\"model.serilNumerShortcut\"\n            required maxlength=\"100\" />\n            <div [hidden]=\"!(editForm.controls.serilNumerShortcut?.dirty && editForm.controls.serilNumerShortcut?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.serilNumerShortcut?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.serilNumerShortcut?.errors?.maxlength\" jhiTranslate=\"entity.validation.maxlength\" translateValues=\"{ max: 100 }\">\n                   This field cannot be longer than 100 characters.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.model.dpi\" for=\"field_dpi\">Dpi</label>\n            <input type=\"number\" class=\"form-control\" name=\"dpi\" id=\"field_dpi\"\n                [(ngModel)]=\"model.dpi\"\n             />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.model.screenHeight\" for=\"field_screenHeight\">Screen Height</label>\n            <input type=\"number\" class=\"form-control\" name=\"screenHeight\" id=\"field_screenHeight\"\n                [(ngModel)]=\"model.screenHeight\"\n            required />\n            <div [hidden]=\"!(editForm.controls.screenHeight?.dirty && editForm.controls.screenHeight?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.screenHeight?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n                <small class=\"form-text text-danger\"\n                    [hidden]=\"!editForm.controls.screenHeight?.errors?.number\" jhiTranslate=\"entity.validation.number\">\n                    This field should be a number.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.model.screenWidth\" for=\"field_screenWidth\">Screen Width</label>\n            <input type=\"number\" class=\"form-control\" name=\"screenWidth\" id=\"field_screenWidth\"\n                [(ngModel)]=\"model.screenWidth\"\n            required />\n            <div [hidden]=\"!(editForm.controls.screenWidth?.dirty && editForm.controls.screenWidth?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.screenWidth?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n                <small class=\"form-text text-danger\"\n                    [hidden]=\"!editForm.controls.screenWidth?.errors?.number\" jhiTranslate=\"entity.validation.number\">\n                    This field should be a number.\n                </small>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.model.shutdownAnimationDescFile\" for=\"field_shutdownAnimationDescFile\">Shutdown Animation Desc File</label>\n            <textarea  class=\"form-control\" name=\"shutdownAnimationDescFile\" id=\"field_shutdownAnimationDescFile\"\n                [(ngModel)]=\"model.shutdownAnimationDescFile\"\n            required rows=\"4\"></textarea>\n            <div [hidden]=\"!(editForm.controls.shutdownAnimationDescFile?.dirty && editForm.controls.shutdownAnimationDescFile?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.shutdownAnimationDescFile?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n            </div>\n        </div>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"deviceConfigurerServiceApp.model.home.title\">Models</span>\n        <button class=\"btn btn-primary float-right create-model\" [routerLink]=\"['/', { outlets: { popup: ['model-new'] } }]\">\n            <span class=\"fa fa-plus\"></span>\n            <span class=\"hidden-sm-down\"  jhiTranslate=\"deviceConfigurerServiceApp.model.home.createLabel\">\n            Create new Model\n            </span>\n        </button>\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div class=\"row\">\n        <div class=\"col-sm-12 no-padding-right\">\n            <form name=\"searchForm\" class=\"form-inline\">\n                <div class=\"input-group w-100 mt-3\">\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'deviceConfigurerServiceApp.model.home.search' | translate }}\">\n                    <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\">\n                        <span class=\"fa fa-search\"></span>\n                    </button>\n                    <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\">\n                        <span class=\"fa fa-trash-o\"></span>\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n    <br/>\n    <div class=\"table-responsive\" *ngIf=\"models\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\">\n            <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"name\"><span jhiTranslate=\"deviceConfigurerServiceApp.model.name\">Name</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"serilNumerShortcut\"><span jhiTranslate=\"deviceConfigurerServiceApp.model.serilNumerShortcut\">Seril Numer Shortcut</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"dpi\"><span jhiTranslate=\"deviceConfigurerServiceApp.model.dpi\">Dpi</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"screenHeight\"><span jhiTranslate=\"deviceConfigurerServiceApp.model.screenHeight\">Screen Height</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"screenWidth\"><span jhiTranslate=\"deviceConfigurerServiceApp.model.screenWidth\">Screen Width</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"shutdownAnimationDescFile\"><span jhiTranslate=\"deviceConfigurerServiceApp.model.shutdownAnimationDescFile\">Shutdown Animation Desc File</span> <span class=\"fa fa-sort\"></span></th>\n            <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let model of models ;trackBy: trackId\">\n                <td><a [routerLink]=\"['../model', model.id ]\">{{model.id}}</a></td>\n                <td>{{model.name}}</td>\n                <td>{{model.serilNumerShortcut}}</td>\n                <td>{{model.dpi}}</td>\n                <td>{{model.screenHeight}}</td>\n                <td>{{model.screenWidth}}</td>\n                <td>{{model.shutdownAnimationDescFile}}</td>\n                <td class=\"text-right\">\n                    <div class=\"btn-group flex-btn-group-container\">\n                        <button type=\"submit\"\n                                [routerLink]=\"['../model', model.id ]\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-eye\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'model/'+ model.id + '/edit'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-primary btn-sm\">\n                            <span class=\"fa fa-pencil\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'model/'+ model.id + '/delete'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-danger btn-sm\">\n                            <span class=\"fa fa-remove\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n        <div *ngIf=\"models && models.length\">\n            <div class=\"row justify-content-center\">\n                <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count>\n            </div>\n            <div class=\"row justify-content-center\">\n                <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination>\n            </div>\n        </div>\n</div>\n"

/***/ }),
/* 304 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(resource.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"deviceConfigurerServiceApp.resource.delete.question\" translateValues=\"{id: '{{resource.id}}'}\">Are you sure you want to delete this Resource?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"resource\">\n    <h2><span jhiTranslate=\"deviceConfigurerServiceApp.resource.detail.title\">Resource</span> {{resource.id}}</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.resource.file\">File</span></dt>\n        <dd>\n            <div *ngIf=\"resource.file\">\n                <a (click)=\"openFile(resource.fileContentType, resource.file)\" jhiTranslate=\"entity.action.open\">open</a>\n                {{resource.fileContentType}}, {{byteSize(resource.file)}}\n            </div>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.resource.seller\">Seller</span></dt>\n        <dd>\n            <div *ngIf=\"resource.seller\">\n                <a [routerLink]=\"['/seller', resource.seller?.id]\">{{resource.seller?.id}}</a>\n            </div>\n        </dd>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n    <button type=\"button\"\n            [routerLink]=\"['/', { outlets: { popup: 'resource/'+ resource.id + '/edit'} }]\"\n            replaceUrl=\"true\"\n            class=\"btn btn-primary\">\n        <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>\n    </button>\n</div>\n"

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"myResourceLabel\" jhiTranslate=\"deviceConfigurerServiceApp.resource.home.createOrEditLabel\">Create or edit a Resource</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\" [hidden]=\"!resource.id\">\n            <label for=\"id\" jhiTranslate=\"global.field.id\">ID</label>\n            <input type=\"text\" class=\"form-control\" id=\"id\" name=\"id\"\n                   [(ngModel)]=\"resource.id\" readonly />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.resource.file\" for=\"field_file\">File</label>\n            <div>\n                <div *ngIf=\"resource.file\" class=\"form-text text-danger clearfix\">\n                    <a class=\"pull-left\" (click)=\"openFile(resource.fileContentType, resource.file)\" jhiTranslate=\"entity.action.open\">open</a><br>\n                    <span class=\"pull-left\">{{resource.fileContentType}}, {{byteSize(resource.file)}}</span>\n                    <button type=\"button\" (click)=\"resource.file=null;resource.fileContentType=null;\"\n                            class=\"btn btn-default btn-xs pull-right\">\n                        <span class=\"fa fa-times\"></span>\n                    </button>\n                </div>\n                <input type=\"file\" (change)=\"setFileData($event, resource, 'file', false)\" jhiTranslate=\"entity.action.addblob\"/>\n            </div>\n            <input type=\"hidden\" class=\"form-control\" name=\"file\" id=\"field_file\"\n                [(ngModel)]=\"resource.file\"\n            required />\n            <input type=\"hidden\" class=\"form-control\" name=\"fileContentType\" id=\"field_fileContentType\"\n                [(ngModel)]=\"resource.fileContentType\" />\n            <div [hidden]=\"!(editForm.controls.file?.dirty && editForm.controls.file?.invalid)\">\n                <small class=\"form-text text-danger\"\n                   [hidden]=\"!editForm.controls.file?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                   This field is required.\n                </small>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label jhiTranslate=\"deviceConfigurerServiceApp.resource.seller\" for=\"field_seller\">Seller</label>\n            <select class=\"form-control\" id=\"field_seller\" name=\"seller\" [(ngModel)]=\"resource.seller\" >\n                <option [ngValue]=\"null\"></option>\n                <option [ngValue]=\"sellerOption.id === resource.seller?.id ? resource.seller : sellerOption\" *ngFor=\"let sellerOption of sellers; trackBy: trackSellerById\">{{sellerOption.id}}</option>\n            </select>\n        </div>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"deviceConfigurerServiceApp.resource.home.title\">Resources</span>\n        <button class=\"btn btn-primary float-right create-resource\" [routerLink]=\"['/', { outlets: { popup: ['resource-new'] } }]\">\n            <span class=\"fa fa-plus\"></span>\n            <span class=\"hidden-sm-down\"  jhiTranslate=\"deviceConfigurerServiceApp.resource.home.createLabel\">\n            Create new Resource\n            </span>\n        </button>\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div class=\"row\">\n        <div class=\"col-sm-12 no-padding-right\">\n            <form name=\"searchForm\" class=\"form-inline\">\n                <div class=\"input-group w-100 mt-3\">\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'deviceConfigurerServiceApp.resource.home.search' | translate }}\">\n                    <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\">\n                        <span class=\"fa fa-search\"></span>\n                    </button>\n                    <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\">\n                        <span class=\"fa fa-trash-o\"></span>\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n    <br/>\n    <div class=\"table-responsive\" *ngIf=\"resources\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\">\n            <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"file\"><span jhiTranslate=\"deviceConfigurerServiceApp.resource.file\">File</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"seller.id\"><span jhiTranslate=\"deviceConfigurerServiceApp.resource.seller\">Seller</span> <span class=\"fa fa-sort\"></span></th>\n            <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let resource of resources ;trackBy: trackId\">\n                <td><a [routerLink]=\"['../resource', resource.id ]\">{{resource.id}}</a></td>\n                <td>\n                    <a *ngIf=\"resource.file\" (click)=\"openFile(resource.fileContentType, resource.file)\" jhiTranslate=\"entity.action.open\">open</a>\n                    <span *ngIf=\"resource.file\">{{resource.fileContentType}}, {{byteSize(resource.file)}}</span>\n                </td>\n                <td>\n                    <div *ngIf=\"resource.seller\">\n                        <a [routerLink]=\"['../seller', resource.seller?.id ]\" >{{resource.seller?.id}}</a>\n                    </div>\n                </td>\n                <td class=\"text-right\">\n                    <div class=\"btn-group flex-btn-group-container\">\n                        <button type=\"submit\"\n                                [routerLink]=\"['../resource', resource.id ]\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-eye\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'resource/'+ resource.id + '/edit'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-primary btn-sm\">\n                            <span class=\"fa fa-pencil\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'resource/'+ resource.id + '/delete'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-danger btn-sm\">\n                            <span class=\"fa fa-remove\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n        <div *ngIf=\"resources && resources.length\">\n            <div class=\"row justify-content-center\">\n                <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count>\n            </div>\n            <div class=\"row justify-content-center\">\n                <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination>\n            </div>\n        </div>\n</div>\n"

/***/ }),
/* 308 */
/***/ (function(module, exports) {

module.exports = "<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"mySellerLabel\" jhiTranslate=\"deviceConfigurerServiceApp.seller.home.createLabel\">\n            Create Seller</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.seller.name\" for=\"field_name\">Name</label>\n            <input type=\"text\" class=\"form-control\" name=\"name\" id=\"field_name\"\n                   [(ngModel)]=\"seller.name\"\n                   required/>\n            <div [hidden]=\"!(editForm.controls.name?.dirty && editForm.controls.name?.invalid)\">\n                <small class=\"form-text text-danger\"\n                       [hidden]=\"!editForm.controls.name?.errors?.required\" jhiTranslate=\"entity.validation.required\">\n                    This field is required.\n                </small>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <div class=\"form-group\">\n                <label class=\"form-control-label\" jhiTranslate=\"userManagement.login\">Login</label>\n                <input type=\"text\" class=\"form-control\" name=\"login\" #loginInput=\"ngModel\"\n                       [(ngModel)]=\"seller.owner.login\" required minlength=1 maxlength=50 pattern=\"^[_'.@A-Za-z0-9-]*$\">\n\n                <div *ngIf=\"loginInput.dirty && loginInput.invalid\">\n                    <small class=\"form-text text-danger\"\n                           *ngIf=\"loginInput.errors.required\" jhiTranslate=\"entity.validation.required\">\n                        This field is required.\n                    </small>\n\n                    <small class=\"form-text text-danger\"\n                           *ngIf=\"loginInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\"\n                           translate-value-max=\"50\">\n                        This field cannot be longer than 50 characters.\n                    </small>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"form-control-label\" jhiTranslate=\"userManagement.firstName\">First Name</label>\n                <input type=\"text\" class=\"form-control\" name=\"firstName\" #firstNameInput=\"ngModel\"\n                       [(ngModel)]=\"seller.owner.firstName\" maxlength=\"50\">\n\n                <div *ngIf=\"firstNameInput.dirty && firstNameInput.invalid\">\n                    <small class=\"form-text text-danger\"\n                           *ngIf=\"firstNameInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\"\n                           translate-value-max=\"50\">\n                        This field cannot be longer than 50 characters.\n                    </small>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label jhiTranslate=\"userManagement.lastName\">Last Name</label>\n                <input type=\"text\" class=\"form-control\" name=\"lastName\" #lastNameInput=\"ngModel\"\n                       [(ngModel)]=\"seller.owner.lastName\" maxlength=\"50\">\n\n                <div *ngIf=\"lastNameInput.dirty && lastNameInput.invalid\">\n                    <small class=\"form-text text-danger\"\n                           *ngIf=\"lastNameInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\"\n                           translate-value-max=\"50\">\n                        This field cannot be longer than 50 characters.\n                    </small>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label class=\"form-control-label\" jhiTranslate=\"userManagement.email\">Email</label>\n                <input type=\"email\" class=\"form-control\" name=\"email\" #emailInput=\"ngModel\"\n                       [(ngModel)]=\"seller.owner.email\" required maxlength=\"100\">\n\n                <div *ngIf=\"emailInput.dirty && emailInput.invalid\">\n                    <small class=\"form-text text-danger\"\n                           *ngIf=\"emailInput.errors.required\" jhiTranslate=\"entity.validation.required\">\n                        This field is required.\n                    </small>\n\n                    <small class=\"form-text text-danger\"\n                           *ngIf=\"emailInput.errors.maxlength\" jhiTranslate=\"entity.validation.maxlength\"\n                           translate-value-max=\"100\">\n                        This field cannot be longer than 100 characters.\n                    </small>\n                    <small class=\"form-text text-danger\"\n                           *ngIf=\"emailInput.errors.email\" jhiTranslate=\"global.messages.validate.email.invalid\">\n                        Your e-mail is invalid.\n                    </small>\n                </div>\n            </div>\n            <div class=\"form-group\" *ngIf=\"languages && languages.length > 0\">\n                <label jhiTranslate=\"userManagement.langKey\">Lang Key</label>\n                <select class=\"form-control\" id=\"langKey\" name=\"langKey\" [(ngModel)]=\"seller.owner.langKey\">\n                    <option *ngFor=\"let language of languages\" [value]=\"language\">{{language | findLanguageFromKey}}\n                    </option>\n                </select>\n            </div>\n        </div>\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = "<form name=\"deleteForm\" (ngSubmit)=\"confirmDelete(seller.id)\">\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" jhiTranslate=\"entity.delete.title\">Confirm delete operation</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <p jhiTranslate=\"deviceConfigurerServiceApp.seller.delete.question\" translateValues=\"{id: '{{seller.id}}'}\">Are you sure you want to delete this Seller?</p>\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-secondary\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" class=\"btn btn-danger\">\n            <span class=\"fa fa-remove\"></span>&nbsp;<span jhiTranslate=\"entity.action.delete\">Delete</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = "\n<div *ngIf=\"seller\">\n    <h2><span jhiTranslate=\"deviceConfigurerServiceApp.seller.detail.title\">Seller</span> <b>{{seller.name}}</b>\n        ({{seller.id}})</h2>\n    <hr>\n    <jhi-alert-error></jhi-alert-error>\n    <dl class=\"row-md jh-entity-details\">\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.seller.createDate\">Create Date</span></dt>\n        <dd>\n            <span>{{seller.createDate | date:'medium'}}</span>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.seller.lastModified\">Last modified Date</span></dt>\n        <dd>\n            <span>{{seller?.lastModifiedDate  | date:'dd-MM-yyyy HH:mm'}}</span> <button  type=\"button\" class=\"btn btn-secondary\" (click)=\"touch()\"><span jhiTranslate=\"deviceConfigurerServiceApp.seller.dashboard.touch.title\"></span></button>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.seller.layout\">Layout</span></dt>\n        <dd>\n            <pre class=\"pre-scrollable\"><code>{{seller.layout}}</code></pre>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.seller.shutdown\">Shutdown</span></dt>\n        <dd>\n            <div *ngIf=\"seller.shutdown\">\n                <a [routerLink]=\"['/model-image', seller.shutdown?.id]\">{{seller.shutdown?.id}}</a>\n            </div>\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.seller.owner\">Owner</span></dt>\n        <dd>\n            {{seller.owner?.firstName}} {{seller.owner?.lastName}}({{seller.owner?.login}})\n        </dd>\n        <dt><span jhiTranslate=\"deviceConfigurerServiceApp.seller.applications\">Applications</span></dt>\n        <dd>\n            <ul>\n                <li *ngFor=\"let applications of seller.applications; let last = last\">\n                    <a [routerLink]=\"['/application-artatech', applications?.id ]\">{{applications.name}}({{applications.packageName}})</a>{{last\n                    ? '' : ', '}}\n                </li>\n            </ul>\n        </dd>\n    </dl>\n\n    <button type=\"submit\"\n            (click)=\"previousState()\"\n            class=\"btn btn-info\">\n        <span class=\"fa fa-arrow-left\"></span>&nbsp;<span jhiTranslate=\"entity.action.back\"> Back</span>\n    </button>\n\n    <button type=\"button\"\n            [routerLink]=\"['/', { outlets: { popup: 'seller/'+ seller.id + '/edit'} }]\"\n            replaceUrl=\"true\"\n            class=\"btn btn-primary\">\n        <span class=\"fa fa-pencil\"></span>&nbsp;<span jhiTranslate=\"entity.action.edit\"> Edit</span>\n    </button>\n</div>\n"

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports = "\n\n<form name=\"editForm\" role=\"form\" novalidate (ngSubmit)=\"save()\" #editForm=\"ngForm\">\n\n    <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"mySellerLabel\" jhiTranslate=\"deviceConfigurerServiceApp.seller.home.editLabel\"\n            translateValues=\"{name: '{{seller.name}}'}\">Create or edit a Seller</h4>\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\"\n                (click)=\"clear()\">&times;</button>\n    </div>\n    <div class=\"modal-body\">\n        <jhi-alert-error></jhi-alert-error>\n        <div class=\"form-group\" [hidden]=\"!seller.id\">\n            <input type=\"hidden\" class=\"form-control\" id=\"id\" name=\"id\"\n                   [(ngModel)]=\"seller.id\" readonly />\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.seller.layout\" for=\"field_layout\">Layout</label>\n            <textarea class=\"form-control\" name=\"layout\" id=\"field_layout\"\n                [(ngModel)]=\"seller.layout\"  ></textarea>\n        </div>\n\n        <div class=\"form-group\">\n            <label jhiTranslate=\"deviceConfigurerServiceApp.seller.applications\" for=\"field_applications\">Applications</label>\n            <select class=\"form-control\" id=\"field_applications\" multiple name=\"applications\"\n                    [(ngModel)]=\"seller.applications\">\n                <option [ngValue]=\"getSelected(seller.applications, applicationOption)\"\n                        *ngFor=\"let applicationOption of applications; trackBy: trackApplicationById\">\n                    {{applicationOption.name}}({{applicationOption.packageName}})\n                </option>\n            </select>\n\n\n            <div class=\"col-sm-6\">\n                <div class=\"panel panel-success\">\n                    <div class=\"panel-heading\">\n                        Wybrane aplikacje\n                    </div>\n                    <div class=\"panel-body\">\n                        <ul class=\"list-group\" >\n                            <li *ngFor=\"let item of seller.applications; let i = index\" class=\"list-group-item\">\n                                =&nbsp;{{item.name}}\n                            </li>\n                        </ul>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"form-group\">\n            <label class=\"custom-control custom-checkbox\">\n                <input type=\"checkbox\" class=\"custom-control-input\"  name=\"cleanApplications\" id=\"field_cleanApplications\"\n                       [(ngModel)]=\"seller.cleanApplications\" >\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\" jhiTranslate=\"deviceConfigurerServiceApp.seller.cleanApplications\">Check this custom checkbox</span>\n            </label>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.seller.tutorialPackage\" for=\"field_tutorialPackage\">Tutorial Package</label>\n            <input  class=\"form-control\" name=\"tutorialPackage\" id=\"field_tutorialPackage\"\n                      [(ngModel)]=\"seller.tutorialPackage\"  >\n\n        </div>\n\n        <div class=\"form-group\" *ngIf=\"applications\">\n            <select class=\"form-control\"   [(ngModel)]=\"tutorial\" name=\"tutorial\" (change)=\"onSelectTutorial($event.target.value)\">\n                <option [ngValue]=\"null\"></option>\n                <option [ngValue]=\"applicationOption\"\n                        *ngFor=\"let applicationOption of applications\"> {{applicationOption.name}}({{applicationOption.packageName}})\n                </option>\n            </select>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"form-control-label\" jhiTranslate=\"deviceConfigurerServiceApp.seller.tutorialParam\" for=\"field_tutorialParam\">Tutorial Param</label>\n            <input class=\"form-control\" name=\"tutorialParam\" id=\"field_tutorialParam\"\n                      [(ngModel)]=\"seller.tutorialParam\"  >\n        </div>\n        <div class=\"form-group\">\n            <label class=\"custom-control custom-checkbox\">\n                <input type=\"checkbox\" class=\"custom-control-input\"  name=\"libraryMode\" id=\"field_libraryMode\"\n                       [(ngModel)]=\"seller.libraryMode\" >\n                <span class=\"custom-control-indicator\"></span>\n                <span class=\"custom-control-description\" jhiTranslate=\"deviceConfigurerServiceApp.seller.libraryMode\">Check this custom checkbox</span>\n            </label>\n        </div>\n\n        <!--<h4>Drag-and-Drop - Shopping basket</h4>-->\n        <!--<div class=\"row\">-->\n\n            <!--<div class=\"col-sm-3\">-->\n                <!--<div class=\"panel panel-success\">-->\n                    <!--<div class=\"panel-heading\">Available products</div>-->\n                    <!--<div class=\"panel-body\">-->\n                        <!--<div *ngFor=\"let product of applications\" class=\"panel panel-default\"-->\n                             <!--dnd-draggable [dragEnabled]=\"product.quantity>0\" [dragData]=\"product\" (onDragSuccess)=\"orderedProduct($event)\" [dropZones]=\"['demo1']\">-->\n                            <!--<div class=\"panel-body\">-->\n                                <!--<div [hidden]=\"product.quantity===0\">{{product.name}} - \\${{product.cost}}<br>(available: {{product.quantity}})</div>-->\n                                <!--<div [hidden]=\"product.quantity>0\"><del>{{product.name}}</del><br>(NOT available)</div>-->\n                            <!--</div>-->\n                        <!--</div>-->\n                    <!--</div>-->\n                <!--</div>-->\n            <!--</div>-->\n            <!--<div class=\"col-sm-3\">-->\n                <!--<div dnd-droppable (onDropSuccess)=\"addToBasket($event)\" [dropZones]=\"['demo1']\" class=\"panel panel-info\">-->\n                    <!--<div class=\"panel-heading\">Shopping Basket<br>(to pay: \\${{totalCost()}})</div>-->\n                    <!--<div class=\"panel-body\">-->\n                        <!--<div *ngFor=\"let product of shoppingBasket\" class=\"panel panel-default\">-->\n                            <!--<div class=\"panel-body\">-->\n                                <!--{{product.name}}<br>(ordered: {{product.quantity}}<br>cost: \\${{product.cost * product.quantity}})-->\n                            <!--</div>-->\n                        <!--</div>-->\n                    <!--</div>-->\n                <!--</div>-->\n            <!--</div>-->\n        <!--</div>-->\n\n    </div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\" (click)=\"clear()\">\n            <span class=\"fa fa-ban\"></span>&nbsp;<span jhiTranslate=\"entity.action.cancel\">Cancel</span>\n        </button>\n        <button type=\"submit\" [disabled]=\"editForm.form.invalid || isSaving\" class=\"btn btn-primary\">\n            <span class=\"fa fa-save\"></span>&nbsp;<span jhiTranslate=\"entity.action.save\">Save</span>\n        </button>\n    </div>\n</form>\n"

/***/ }),
/* 312 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <h2>\n        <span jhiTranslate=\"deviceConfigurerServiceApp.seller.home.title\">Sellers</span>\n        <button class=\"btn btn-primary float-right create-seller\" [routerLink]=\"['/', { outlets: { popup: ['seller-new'] } }]\">\n            <span class=\"fa fa-plus\"></span>\n            <span class=\"hidden-sm-down\"  jhiTranslate=\"deviceConfigurerServiceApp.seller.home.createLabel\">\n            Create new Seller\n            </span>\n        </button>\n    </h2>\n    <jhi-alert></jhi-alert>\n    <div class=\"row\">\n        <div class=\"col-sm-12 no-padding-right\">\n            <form name=\"searchForm\" class=\"form-inline\">\n                <div class=\"input-group w-100 mt-3\">\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"currentSearch\" id=\"currentSearch\" name=\"currentSearch\" placeholder=\"{{ 'deviceConfigurerServiceApp.seller.home.search' | translate }}\">\n                    <button class=\"input-group-addon btn btn-info\" (click)=\"search(currentSearch)\">\n                        <span class=\"fa fa-search\"></span>\n                    </button>\n                    <button class=\"input-group-addon btn btn-danger\" (click)=\"clear()\" *ngIf=\"currentSearch\">\n                        <span class=\"fa fa-trash-o\"></span>\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n    <br/>\n    <div class=\"table-responsive\" *ngIf=\"sellers\">\n        <table class=\"table table-striped\">\n            <thead>\n            <tr jhiSort [(predicate)]=\"predicate\" [(ascending)]=\"reverse\" [callback]=\"transition.bind(this)\">\n            <th jhiSortBy=\"id\"><span jhiTranslate=\"global.field.id\">ID</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"name\"><span jhiTranslate=\"deviceConfigurerServiceApp.seller.name\">Name</span> <span class=\"fa fa-sort\"></span></th>\n            <th jhiSortBy=\"owner.id\"><span jhiTranslate=\"deviceConfigurerServiceApp.seller.owner\">Owner</span> <span class=\"fa fa-sort\"></span></th>\n            <th ><span jhiTranslate=\"deviceConfigurerServiceApp.seller.lastModificationDate\">Owner</span> </th>\n            <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr *ngFor=\"let seller of sellers ;trackBy: trackId\">\n                <td><a [routerLink]=\"['../seller', seller.id ]\">{{seller.id}}</a></td>\n                <td>{{seller.name}}</td>\n\n                <td>\n                    {{seller.owner?.firstName}} {{seller.owner?.lastName}}({{seller.owner?.login}})\n                </td>\n                <td>\n                    <span>{{seller?.lastModifiedDate  | date:'dd-MM-yyyy HH:mm'}}</span>\n                </td>\n                <td class=\"text-right\">\n                    <div class=\"btn-group flex-btn-group-container\">\n                        <button type=\"submit\"\n                                [routerLink]=\"['../seller', seller.id ]\"\n                                class=\"btn btn-info btn-sm\">\n                            <span class=\"fa fa-eye\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.view\">View</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'seller/'+ seller.id + '/edit'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-primary btn-sm\">\n                            <span class=\"fa fa-pencil\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.edit\">Edit</span>\n                        </button>\n                        <button type=\"submit\"\n                                [routerLink]=\"['/', { outlets: { popup: 'seller/'+ seller.id + '/delete'} }]\"\n                                replaceUrl=\"true\"\n                                class=\"btn btn-danger btn-sm\">\n                            <span class=\"fa fa-remove\"></span>\n                            <span class=\"hidden-md-down\" jhiTranslate=\"entity.action.delete\">Delete</span>\n                        </button>\n                    </div>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n        <div *ngIf=\"sellers && sellers.length\">\n            <div class=\"row justify-content-center\">\n                <jhi-item-count [page]=\"page\" [total]=\"queryCount\" [itemsPerPage]=\"itemsPerPage\"></jhi-item-count>\n            </div>\n            <div class=\"row justify-content-center\">\n                <ngb-pagination [collectionSize]=\"totalItems\" [(page)]=\"page\" (pageChange)=\"loadPage(page)\"></ngb-pagination>\n            </div>\n        </div>\n</div>\n"

/***/ }),
/* 313 */
/***/ (function(module, exports) {

module.exports = "<div class=\"row home\" [ngSwitch]=\"isAuthenticated()\">\n\n    <div class=\"col-md-9\" *ngSwitchCase=\"false\">\n        <h1 class=\"display-4\" jhiTranslate=\"home.title\">Welcome, Java Hipster!</h1>\n        <!--<p class=\"lead\" jhiTranslate=\"home.subtitle\">This is your homepage</p>-->\n    </div>\n    <div class=\"col-md-9\" *ngSwitchCase=\"true\">\n        <dcs-seller-dashboard *dcsHasAnyAuthority=\"'ROLE_SELLER'\"></dcs-seller-dashboard>\n\n    </div>\n</div>\n"

/***/ }),
/* 314 */
/***/ (function(module, exports) {

module.exports = "<div>\n    <div class=\"row\">\n        <div class=\"col-md-4\">\n            <span class=\"hipster img-fluid img-rounded\"></span>\n        </div>\n        <div class=\"col-md-8\">\n            <h1 jhiTranslate=\"error.title\">Error Page!</h1>\n\n            <div [hidden]=\"!errorMessage\">\n                <div class=\"alert alert-danger\">{{errorMessage}}\n                </div>\n            </div>\n            <div [hidden]=\"!error403\" class=\"alert alert-danger\" jhiTranslate=\"error.403\">You are not authorized to access the page.\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "<footer class=\"footer\" [hidden]=\"true\">\n\n    <div class=\"animated container\">\n        <ul class=\"text-center footer-social\">\n            <li><a href=\"https://twitter.com/\"><i class=\"fa fa-twitter\"></i> <span class=\"sr-only\">Twitter</span>\n            </a></li>\n            <li><a href=\"https://www.facebook.com/\"><i class=\"fa fa-facebook\"></i> <span\n                class=\"sr-only\">Facebook</span> </a></li>\n            <li><a href=\"https://www.youtube.com/channel/\"><i class=\"fa fa-youtube\"></i> <span\n                class=\"sr-only\">YouTube</span> </a></li>\n            <li><a href=\"https://www.linkedin.com/company/\"><i class=\"fa fa-linkedin\"></i> <span\n                class=\"sr-only\">LinkedIn</span> </a></li>\n        </ul>\n        <div class=\"row\">\n\n            <div class=\"col-sm-6 col-md-3 col-lg-2 col-lg-offset-2 footer-link-holder\"><h3 class=\"footer-link-title\">\n                Products</h3>\n                <ul class=\"animated footer-links\">\n                    <li><a  routerLinkActive=\"active\" routerLink=\"/faq\"><span jhiTranslate=\"landing.footer.faq\">FAQ</span></a></li>\n                    <li><a href=\"/\">Enterprise Edition</a></li>\n                    <li><a href=\"/\">Info</a></li>\n                    <li><a href=\"/\">another info</a></li>\n                </ul>\n            </div>\n            <div class=\"col-sm-6 col-md-3 col-lg-2 footer-link-holder\"><h3 class=\"footer-link-title\">\n                Products</h3>\n                <ul class=\"animated footer-links\">\n                    <li><a  routerLinkActive=\"active\" routerLink=\"/faq\"><span jhiTranslate=\"landing.footer.faq\">FAQ</span></a></li>\n                    <li><a href=\"/\">Enterprise Edition</a></li>\n                    <li><a href=\"/\">Info</a></li>\n                    <li><a href=\"/\">another info</a></li>\n                </ul>\n            </div>\n            <div class=\"col-sm-6 col-md-3 col-lg-2 footer-link-holder\"><h3 class=\"footer-link-title\">\n                Products</h3>\n                <ul class=\"animated footer-links\">\n                    <li><a  routerLinkActive=\"active\" routerLink=\"/faq\"><span jhiTranslate=\"landing.footer.faq\">FAQ</span></a></li>\n                    <li><a href=\"/\">Enterprise Edition</a></li>\n                    <li><a href=\"/\">Info</a></li>\n                    <li><a href=\"/\">another info</a></li>\n                </ul>\n            </div>\n            <div class=\"col-sm-6 col-md-3 col-lg-2 footer-link-holder\"><h3 class=\"footer-link-title\">\n                Products</h3>\n                <ul class=\"animated footer-links\">\n                    <li><a  routerLinkActive=\"active\" routerLink=\"/faq\"><span jhiTranslate=\"landing.footer.faq\">FAQ</span></a></li>\n                    <li><a href=\"/\">Enterprise Edition</a></li>\n                    <li><a href=\"/\">Info</a></li>\n                    <li><a href=\"/\">another info</a></li>\n                </ul>\n            </div>\n\n\n\n        </div>\n\n\n    </div>\n</footer>\n<template ngbModalContainer></template>\n\n\n"

/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = "<dcs-page-ribbon></dcs-page-ribbon>\n<div>\n    <router-outlet name=\"navbar\"></router-outlet>\n</div>\n<div class=\"container-fluid\">\n    <div class=\"card jh-card\">\n        <router-outlet></router-outlet>\n        <router-outlet name=\"popup\"></router-outlet>\n    </div>\n    <dcs-footer></dcs-footer>\n</div>\n"

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"navbar navbar-inverse navbar-toggleable-md jh-navbar\">\n    <div class=\"jh-logo-container float-left\">\n        <a class=\"jh-navbar-toggler hidden-lg-up float-right\" href=\"javascript:void(0);\" data-toggle=\"collapse\" data-target=\"#navbarResponsive\" aria-controls=\"navbarResponsive\" aria-expanded=\"false\" aria-label=\"Toggle navigation\" (click)=\"toggleNavbar()\">\n            <i class=\"fa fa-bars\"></i>\n        </a>\n        <a class=\"navbar-brand logo float-left\" routerLink=\"/\" (click)=\"collapseNavbar()\">\n            <span class=\"logo-img\"><img style=\"width: 140px; height: 30px\" src=\"https://static.wixstatic.com/media/d62b24_c1be852c6b9343dd99df2b0a526a2ad9.png/v1/fill/w_510,h_98,al_c,usm_0.66_1.00_0.01/d62b24_c1be852c6b9343dd99df2b0a526a2ad9.png\"/></span>\n            <span jhiTranslate=\"global.title\" class=\"navbar-title\">DeviceConfigurerService</span> <span class=\"navbar-version\">{{version}}</span>\n        </a>\n    </div>\n    <div class=\"navbar-collapse collapse\" id=\"navbarResponsive\" [ngbCollapse]=\"isNavbarCollapsed\" [ngSwitch]=\"isAuthenticated()\">\n        <ul class=\"navbar-nav ml-auto\">\n            <li class=\"nav-item\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{exact: true}\">\n                <a class=\"nav-link\" routerLink=\"/\" (click)=\"collapseNavbar()\" [ngSwitch]=\"isAuthenticated()\">\n                    <i class=\"fa fa-home\" aria-hidden=\"true\"></i>\n                    <span jhiTranslate=\"global.menu.home\">Home</span>\n                </a>\n            </li>\n            <!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here -->\n            <li *dcsHasAnyAuthority=\"'ROLE_ADMIN'\" ngbDropdown class=\"nav-item dropdown pointer\">\n                <a class=\"nav-link dropdown-toggle\" routerLinkActive=\"active\" ngbDropdownToggle href=\"javascript:void(0);\" id=\"entity-menu\">\n                    <span>\n                        <i class=\"fa fa-th-list\" aria-hidden=\"true\"></i>\n                        <span jhiTranslate=\"global.menu.entities.main\">\n                            Entities\n                        </span>\n                        <b class=\"caret\"></b>\n                    </span>\n                </a>\n                <ul class=\"dropdown-menu\" ngbDropdownMenu>\n                    <!--<li uiSrefActive=\"active\">-->\n                    <!--<a class=\"dropdown-item\" routerLink=\"log\" (click)=\"collapseNavbar()\">-->\n                    <!--<i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i>-->\n                    <!--<span jhiTranslate=\"global.menu.entities.log\">Log</span>-->\n                    <!--</a>-->\n                    <!--</li>-->\n                    <li uiSrefActive=\"active\">\n                        <a class=\"dropdown-item\" routerLink=\"application-artatech\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.entities.applicationArtatech\">Application</span>\n                        </a>\n                    </li>\n                    <li uiSrefActive=\"active\">\n                        <a class=\"dropdown-item\" routerLink=\"device\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.entities.device\">Device</span>\n                        </a>\n                    </li>\n                    <li uiSrefActive=\"active\">\n                        <a class=\"dropdown-item\" routerLink=\"image-resource\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.entities.imageResource\">Image Resource</span>\n                        </a>\n                    </li>\n                    <li uiSrefActive=\"active\">\n                        <a class=\"dropdown-item\" routerLink=\"model\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.entities.model\">Model</span>\n                        </a>\n                    </li>\n                    <li uiSrefActive=\"active\">\n                        <a class=\"dropdown-item\" routerLink=\"model-image\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.entities.modelImage\">Model Image</span>\n                        </a>\n                    </li>\n                    <li uiSrefActive=\"active\">\n                        <a class=\"dropdown-item\" routerLink=\"resource\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.entities.resource\">Resource</span>\n                        </a>\n                    </li>\n                    <li uiSrefActive=\"active\">\n                        <a class=\"dropdown-item\" routerLink=\"seller\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.entities.seller\">Seller</span>\n                        </a>\n                    </li>\n                    <li>\n                        <a class=\"dropdown-item\" routerLink=\"feed\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-asterisk\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.entities.feed\">Feed</span>\n                        </a>\n                    </li>\n                    <!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here -->\n                </ul>\n            </li>\n            <li *dcsHasAnyAuthority=\"'ROLE_ADMIN'\" ngbDropdown class=\"nav-item dropdown pointer\">\n                <a class=\"nav-link dropdown-toggle\" ngbDropdownToggle href=\"javascript:void(0);\" id=\"admin-menu\">\n                    <span>\n                        <i class=\"fa fa-user-plus\" aria-hidden=\"true\"></i>\n                        <span jhiTranslate=\"global.menu.admin.main\">Administration</span>\n                        <b class=\"caret\"></b>\n                    </span>\n                </a>\n                <ul class=\"dropdown-menu\" ngbDropdownMenu>\n                    <li>\n                        <a class=\"dropdown-item\" routerLink=\"user-management\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-user\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.admin.userManagement\">User management</span>\n                        </a>\n                    </li>\n                    <li>\n                        <a class=\"dropdown-item\" routerLink=\"dcs-metrics\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-tachometer\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.admin.metrics\">Metrics</span>\n                        </a>\n                    </li>\n                    <li>\n                        <a class=\"dropdown-item\" routerLink=\"dcs-health\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-heart\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.admin.health\">Health</span>\n                        </a>\n                    </li>\n                    <li>\n                        <a class=\"dropdown-item\" routerLink=\"dcs-configuration\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-list\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.admin.configuration\">Configuration</span>\n                        </a>\n                    </li>\n                    <li>\n                        <a class=\"dropdown-item\" routerLink=\"audits\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-bell\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.admin.audits\">Audits</span>\n                        </a>\n                    </li>\n                    <li>\n                        <a class=\"dropdown-item\" routerLink=\"logs\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-tasks\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.admin.logs\">Logs</span>\n                        </a>\n                    </li>\n                    <li *ngIf=\"swaggerEnabled\">\n                        <a class=\"dropdown-item\" routerLink=\"docs\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-book\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.admin.apidocs\">API</span>\n                        </a>\n                    </li>\n                    <!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here -->\n                    <li *ngIf=\"!inProduction\">\n                        <a class=\"dropdown-item\" href='/h2-console' target=\"_tab\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-hdd-o\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.admin.database\">Database</span>\n                        </a>\n                    </li>\n                </ul>\n            </li>\n            <li ngbDropdown class=\"nav-item dropdown pointer\" *ngIf=\"languages\">\n                <a class=\"nav-link dropdown-toggle\" ngbDropdownToggle href=\"javascript:void(0);\" id=\"languagesnavBarDropdown\" *ngIf=\"languages.length > 1\">\n                    <span>\n                        <i class=\"fa fa-flag\" aria-hidden=\"true\"></i>\n                        <span jhiTranslate=\"global.menu.language\">Language</span>\n                        <b class=\"caret\"></b>\n                    </span>\n                </a>\n                <ul class=\"dropdown-menu\" ngbDropdownMenu *ngIf=\"languages.length > 1\">\n                    <li *ngFor=\"let language of languages\">\n                        <a class=\"dropdown-item\" [dcsActiveMenu]=\"language\" href=\"javascript:void(0);\" (click)=\"changeLanguage(language);collapseNavbar();\">{{language | findLanguageFromKey}}</a>\n                    </li>\n                </ul>\n            </li>\n            <li ngbDropdown class=\"nav-item dropdown pointer\">\n                <a class=\"nav-link dropdown-toggle\" ngbDropdownToggle href=\"javascript:void(0);\" id=\"account-menu\">\n                  <span *ngSwitchCase=\"false\">\n                    <i class=\"fa fa-user\" aria-hidden=\"true\" *ngIf=\"!getImageUrl()\"></i>\n                    <span jhiTranslate=\"global.menu.account.main\">\n                      Account\n                    </span>\n                    <b class=\"caret\"></b>\n                  </span>\n                  <span *ngIf=\"account\">\n                    <i class=\"fa fa-user\" aria-hidden=\"true\" *ngIf=\"!getImageUrl()\"></i>\n                    <span>\n                      {{account.login}}\n                    </span>\n                    <b class=\"caret\"></b>\n                  </span>\n\n                  <span *ngIf=\"getImageUrl()\">\n                      <img [src]=\"getImageUrl()\" class=\"profile-image img-circle\" alt=\"Avatar\">\n                  </span>\n                </a>\n                <ul class=\"dropdown-menu dropdown-menu-right\" ngbDropdownMenu>\n                    <li *ngSwitchCase=\"true\">\n                        <a class=\"dropdown-item\" routerLink=\"settings\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-wrench\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.account.settings\">Settings</span>\n                        </a>\n                    </li>\n                    <li *ngSwitchCase=\"true\">\n                        <a class=\"dropdown-item\" routerLink=\"password\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-clock-o\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.account.password\">Password</span>\n                        </a>\n                    </li>\n                    <li *ngSwitchCase=\"true\">\n                        <a class=\"dropdown-item\" routerLink=\"sessions\" routerLinkActive=\"active\" (click)=\"collapseNavbar()\">\n                            <i class=\"fa fa-fw fa-cloud\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.account.sessions\">Sessions</span>\n                        </a>\n                    </li>\n                    <li *ngSwitchCase=\"true\">\n                        <a class=\"dropdown-item\" (click)=\"logout()\" id=\"logout\">\n                            <i class=\"fa fa-fw fa-sign-out\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.account.logout\">Sign out</span>\n                        </a>\n                    </li>\n                    <li *ngSwitchCase=\"false\">\n                        <a class=\"dropdown-item\" (click)=\"login()\" id=\"login\">\n                            <i class=\"fa fa-fw fa-sign-in\" aria-hidden=\"true\"></i>\n                            <span jhiTranslate=\"global.menu.account.login\">Sign in</span>\n                        </a>\n                    </li>\n                </ul>\n            </li>\n        </ul>\n    </div>\n</nav>\n"

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\">\n    <h4 class=\"modal-title\" jhiTranslate=\"login.title\">Sign in</h4>\n    <button aria-label=\"Close\" data-dismiss=\"modal\" class=\"close\" type=\"button\" (click)=\"activeModal.dismiss('closed')\"><span aria-hidden=\"true\">x</span>\n    </button>\n</div>\n<div class=\"modal-body\">\n    <div class=\"row\">\n        <div class=\"col-md-4 offset-md-4\">\n            <h1 jhiTranslate=\"login.title\">Sign in</h1>\n        </div>\n        <div class=\"col-md-8 offset-md-2\">\n            <div class=\"alert alert-danger\" *ngIf=\"authenticationError\" jhiTranslate=\"login.messages.error.authentication\">\n                <strong>Failed to sign in!</strong> Please check your credentials and try again.\n            </div>\n        </div>\n        <div class=\"col-md-8 offset-md-2\">\n            <form class=\"form\" role=\"form\" (ngSubmit)=\"login()\">\n                <div class=\"form-group\">\n                    <label for=\"username\" jhiTranslate=\"global.form.username\">Login</label>\n                    <input type=\"text\" class=\"form-control\" name=\"username\" id=\"username\" placeholder=\"{{'global.form.username.placeholder' | translate}}\"\n                    [(ngModel)]=\"username\">\n                </div>\n                <div class=\"form-group\">\n                    <label for=\"password\" jhiTranslate=\"login.form.password\">Password</label>\n                    <input type=\"password\" class=\"form-control\" name=\"password\" id=\"password\" placeholder=\"{{'login.form.password.placeholder' | translate}}\"\n                           [(ngModel)]=\"password\">\n                </div>\n                <div class=\"form-check\">\n                    <label class=\"form-check-label\" for=\"rememberMe\">\n                        <input class=\"form-check-input\" type=\"checkbox\" name=\"rememberMe\" id=\"rememberMe\" [(ngModel)]=\"rememberMe\" checked>\n                        <span jhiTranslate=\"login.form.rememberme\">Remember me</span>\n                    </label>\n                </div>\n                <button type=\"submit\" class=\"btn btn-primary\" jhiTranslate=\"login.form.button\">Sign in</button>\n            </form>\n            <p></p>\n            <div class=\"alert alert-warning\">\n                <a class=\"alert-link\" (click)=\"requestResetPassword()\" jhiTranslate=\"login.password.forgot\">Did you forget your password?</a>\n            </div>\n        </div>\n    </div>\n</div>\n"

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(240);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(241);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(242);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__(243);

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(163);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(29);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(566);

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(567);

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(571);

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(6))(686);

/***/ }),
/* 329 */,
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var platform_browser_dynamic_1 = __webpack_require__(164);
var prod_config_1 = __webpack_require__(160);
var app_module_1 = __webpack_require__(159);
prod_config_1.ProdConfig();
if (false) {
    module['hot'].accept();
}
platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.DeviceConfigurerServiceAppModule);


/***/ })
],[330]);


// WEBPACK FOOTER //
// a8a5fd13f808511fa8c1.main.bundle.js